
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1PKHz", function(module, exports) {

$parcel$export(module.exports, "useDarkMode", () => $155ec7e24694ba2f$export$4673cbff94e146e2);
$parcel$export(module.exports, "default", () => $155ec7e24694ba2f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $155ec7e24694ba2f$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $155ec7e24694ba2f$var$DarkModeContext = /*#__PURE__*/ (0, $acw62.createContext)({
    darkMode: false
});
function $155ec7e24694ba2f$export$4673cbff94e146e2() {
    return (0, $acw62.useContext)($155ec7e24694ba2f$var$DarkModeContext);
}
function $155ec7e24694ba2f$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    var _b = $155ec7e24694ba2f$var$__read((0, $acw62.useState)(false), 2), darkMode = _b[0], setDarkMode = _b[1];
    (0, $acw62.useEffect)(function() {
        if (!window.matchMedia) return;
        setDarkMode(window.matchMedia("(prefers-color-scheme: dark)").matches);
        var listener = function(event) {
            setDarkMode(event.matches);
        };
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", listener);
        return function() {
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener("change", listener);
        };
    }, []);
    (0, $acw62.useEffect)(function() {
        if (darkMode) document.documentElement.classList.add("dark");
        else document.documentElement.classList.remove("dark");
    }, [
        darkMode
    ]);
    return (0, $ayMG0.jsx)($155ec7e24694ba2f$var$DarkModeContext.Provider, {
        value: {
            darkMode: darkMode
        },
        children: children
    });
}

});

parcelRegister("hpDFD", function(module, exports) {

$parcel$export(module.exports, "usePreload", () => $cad38b2f2da305ae$export$3aec65c515447115);
$parcel$export(module.exports, "PreloadProvider", () => $cad38b2f2da305ae$export$17df00296c3d65f2);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $cad38b2f2da305ae$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $cad38b2f2da305ae$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $cad38b2f2da305ae$var$HeaderContext = /*#__PURE__*/ (0, $acw62.createContext)({
    preload: function(as) {
        var links = [];
        for(var _i = 1; _i < arguments.length; _i++)links[_i - 1] = arguments[_i];
    }
});
function $cad38b2f2da305ae$export$3aec65c515447115() {
    return (0, $acw62.useContext)($cad38b2f2da305ae$var$HeaderContext).preload;
}
function $cad38b2f2da305ae$export$17df00296c3d65f2(_a) {
    var children = _a.children;
    var _b = $cad38b2f2da305ae$var$__read((0, $acw62.useState)([]), 2), linksToPreload = _b[0], setLinksToPreload = _b[1];
    var _c = $cad38b2f2da305ae$var$__read((0, $acw62.useState)([]), 2), completedPreloads = _c[0], setCompletedPreloads = _c[1];
    var completedPreloadsRef = (0, $acw62.useRef)(completedPreloads);
    completedPreloadsRef.current = completedPreloads;
    var next = linksToPreload[0];
    var preload = (0, $acw62.useCallback)(function(as) {
        var links = [];
        for(var _i = 1; _i < arguments.length; _i++)links[_i - 1] = arguments[_i];
        links = links.filter(function(link) {
            return !completedPreloadsRef.current.includes(link);
        });
        setLinksToPreload(function(existing) {
            return $cad38b2f2da305ae$var$__spreadArray($cad38b2f2da305ae$var$__spreadArray([], $cad38b2f2da305ae$var$__read(links.map(function(link) {
                return [
                    as,
                    link
                ];
            })), false), $cad38b2f2da305ae$var$__read(existing.filter(function(_a) {
                var _b = $cad38b2f2da305ae$var$__read(_a, 2), _ = _b[0], link = _b[1];
                return !links.includes(link);
            })), false);
        });
    }, []);
    var onLoad = (0, $acw62.useCallback)(function() {
        if (!next) return;
        setCompletedPreloads(function(existing) {
            return $cad38b2f2da305ae$var$__spreadArray([
                next[1]
            ], $cad38b2f2da305ae$var$__read(existing), false);
        });
        setLinksToPreload(function(existing) {
            return existing.slice(1);
        });
    }, [
        next
    ]);
    return (0, $ayMG0.jsxs)($cad38b2f2da305ae$var$HeaderContext.Provider, {
        value: {
            preload: preload
        },
        children: [
            children,
            (next === null || next === void 0 ? void 0 : next[0]) === "fetch" && /*#__PURE__*/ (0, $1u0KT.createPortal)((0, $ayMG0.jsx)("link", {
                rel: "preload",
                crossOrigin: "",
                href: next[1],
                as: next[0],
                onLoad: onLoad
            }), document.head),
            (next === null || next === void 0 ? void 0 : next[0]) === "video" && (0, $ayMG0.jsx)("video", {
                src: next[1],
                onCanPlay: onLoad,
                preload: "auto",
                className: "absolute hidden w-1 h-1 pointer-events-none"
            })
        ]
    });
}

});

parcelRegister("f72r9", function(module, exports) {

$parcel$export(module.exports, "useStripe", () => $b0096664407c7e90$export$cef05aaebd2acb04);
$parcel$export(module.exports, "StripeProvider", () => $b0096664407c7e90$export$4a5161423fcbf279);

var $ayMG0 = parcelRequire("ayMG0");

var $3knZs = parcelRequire("3knZs");

var $acw62 = parcelRequire("acw62");
var $b0096664407c7e90$var$__assign = undefined && undefined.__assign || function() {
    $b0096664407c7e90$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b0096664407c7e90$var$__assign.apply(this, arguments);
};
var $b0096664407c7e90$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b0096664407c7e90$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $b0096664407c7e90$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b0096664407c7e90$var$StripeContext = /*#__PURE__*/ (0, $acw62.createContext)({
    getStripe: function(apiKey) {
        return Promise.resolve(undefined);
    }
});
function $b0096664407c7e90$export$cef05aaebd2acb04() {
    return (0, $acw62.useContext)($b0096664407c7e90$var$StripeContext);
}
function $b0096664407c7e90$export$4a5161423fcbf279(_a) {
    var _this = this;
    var children = _a.children;
    var _b = $b0096664407c7e90$var$__read((0, $acw62.useState)({}), 2), stripeInstances = _b[0], setStripeInstances = _b[1];
    var getStripe = (0, $acw62.useCallback)(function(apiKey) {
        return $b0096664407c7e90$var$__awaiter(_this, void 0, Promise, function() {
            var stripe;
            return $b0096664407c7e90$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (stripeInstances[apiKey]) return [
                            2 /*return*/ ,
                            stripeInstances[apiKey]
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $3knZs.loadStripe)(apiKey)
                        ];
                    case 1:
                        stripe = _a.sent();
                        if (!stripe) return [
                            2 /*return*/ 
                        ];
                        setStripeInstances(function(stripeInstances) {
                            var _a;
                            return $b0096664407c7e90$var$__assign($b0096664407c7e90$var$__assign({}, stripeInstances), (_a = {}, _a[apiKey] = stripe, _a));
                        });
                        return [
                            2 /*return*/ ,
                            stripe
                        ];
                }
            });
        });
    }, [
        stripeInstances
    ]);
    return (0, $ayMG0.jsx)($b0096664407c7e90$var$StripeContext.Provider, {
        value: {
            getStripe: getStripe
        },
        children: children
    });
}

});
parcelRegister("3knZs", function(module, exports) {

$parcel$export(module.exports, "loadStripe", () => $26c5d94e8cfa4743$export$de80f7562c3fd6b1);
var $26c5d94e8cfa4743$var$V3_URL = "https://js.stripe.com/v3";
var $26c5d94e8cfa4743$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $26c5d94e8cfa4743$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($26c5d94e8cfa4743$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$26c5d94e8cfa4743$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $26c5d94e8cfa4743$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($26c5d94e8cfa4743$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $26c5d94e8cfa4743$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "1.54.2",
        startTime: startTime
    });
};
var $26c5d94e8cfa4743$var$stripePromise = null;
var $26c5d94e8cfa4743$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($26c5d94e8cfa4743$var$stripePromise !== null) return $26c5d94e8cfa4743$var$stripePromise;
    $26c5d94e8cfa4743$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $26c5d94e8cfa4743$var$findScript();
            if (script && params) console.warn($26c5d94e8cfa4743$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $26c5d94e8cfa4743$var$injectScript(params);
            script.addEventListener("load", function() {
                if (window.Stripe) resolve(window.Stripe);
                else reject(new Error("Stripe.js not available"));
            });
            script.addEventListener("error", function() {
                reject(new Error("Failed to load Stripe.js"));
            });
        } catch (error) {
            reject(error);
            return;
        }
    });
    return $26c5d94e8cfa4743$var$stripePromise;
};
var $26c5d94e8cfa4743$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $26c5d94e8cfa4743$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// own script injection.
var $26c5d94e8cfa4743$var$stripePromise$1 = Promise.resolve().then(function() {
    return $26c5d94e8cfa4743$var$loadScript(null);
});
var $26c5d94e8cfa4743$var$loadCalled = false;
$26c5d94e8cfa4743$var$stripePromise$1["catch"](function(err) {
    if (!$26c5d94e8cfa4743$var$loadCalled) console.warn(err);
});
var $26c5d94e8cfa4743$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $26c5d94e8cfa4743$var$loadCalled = true;
    var startTime = Date.now();
    return $26c5d94e8cfa4743$var$stripePromise$1.then(function(maybeStripe) {
        return $26c5d94e8cfa4743$var$initStripe(maybeStripe, args, startTime);
    });
};

});


parcelRegister("5jxhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3de88b6b80c5d70d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NoPermission", () => $3de88b6b80c5d70d$export$5946e841896fa02f);
$parcel$export(module.exports, "NotFound", () => $3de88b6b80c5d70d$export$271f9f08425019c7);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $eyQyi = parcelRequire("eyQyi");

var $bsRud = parcelRequire("bsRud");

var $jFdmN = parcelRequire("jFdmN");

var $iybwf = parcelRequire("iybwf");

var $gQFmB = parcelRequire("gQFmB");

var $dtKoB = parcelRequire("dtKoB");

var $hmJ39 = parcelRequire("hmJ39");

var $iCMjC = parcelRequire("iCMjC");

var $fdkg2 = parcelRequire("fdkg2");

var $gCE6e = parcelRequire("gCE6e");

var $5aE2v = parcelRequire("5aE2v");

var $iNF3S = parcelRequire("iNF3S");

var $6RTBm = parcelRequire("6RTBm");

var $UNZ1Z = parcelRequire("UNZ1Z");

var $4EnWU = parcelRequire("4EnWU");

var $7xuAh = parcelRequire("7xuAh");

var $dJ9dH = parcelRequire("dJ9dH");
var $3de88b6b80c5d70d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3de88b6b80c5d70d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $3de88b6b80c5d70d$export$2e2bcd8739ae039() {
    return (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
        children: (0, $ayMG0.jsx)((0, $UNZ1Z.SlideOverProvider), {
            children: (0, $ayMG0.jsx)((0, $iNF3S.NotificationsProvider), {
                children: (0, $ayMG0.jsx)((0, $fdkg2.ConfettiProvider), {
                    children: (0, $ayMG0.jsx)((0, $gCE6e.default), {
                        children: (0, $ayMG0.jsx)((0, $eyQyi.default), {
                            children: (0, $ayMG0.jsx)((0, $6RTBm.default), {
                                children: (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                                    fallback: (0, $ayMG0.jsx)((0, $jFdmN.default), {}),
                                    children: (0, $ayMG0.jsx)($3de88b6b80c5d70d$var$DrawRoutes, {})
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
function $3de88b6b80c5d70d$var$DrawRoutes() {
    var _a = (0, $iCMjC.useAuthentication)(), user = _a.user, teams = _a.teams, teamMemberships = _a.teamMemberships;
    var pathname = (0, $lzNIT.useLocation)().pathname;
    var generator = (0, $acw62.useCallback)(function(routePath, route) {
        var _a;
        var Element = route.component;
        var element = (0, $ayMG0.jsx)((0, $dJ9dH.LogRoute), {
            children: (0, $ayMG0.jsx)(Element, {})
        });
        if (route.auth === "guest") {
            if (user) element = (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "up.root",
                    {}
                ]
            });
        } else if (route.auth === "user") {
            if (!user) element = (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "up.auth.loginRedirect",
                    {}
                ]
            });
        } else if (route.auth === "admin") {
            if (!user) element = (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "up.auth.loginRedirect",
                    {}
                ]
            });
            else if (!user.isAdmin) element = (0, $ayMG0.jsx)($3de88b6b80c5d70d$export$5946e841896fa02f, {});
        } else if (route.auth) {
            var auth_1 = route.auth;
            if (!user) element = (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                to: [
                    "up.auth.loginRedirect",
                    {}
                ]
            });
            else if (pathname.includes("/_/")) {
                var teamsWithPermission = teamMemberships.filter(function(m) {
                    return auth_1 === "owner" ? m.isOwner : m.permissions[auth_1];
                }).map(function(t) {
                    return t.team;
                });
                if (teamsWithPermission.length === 0) element = (0, $ayMG0.jsx)($3de88b6b80c5d70d$export$5946e841896fa02f, {});
                else if (teamsWithPermission.length === 1) element = (0, $ayMG0.jsx)((0, $7xuAh.Redirect), {
                    to: pathname.replace("/_/", "/".concat(teamsWithPermission[0].domain, "/"))
                });
                else element = (0, $ayMG0.jsx)($3de88b6b80c5d70d$var$TeamRedirectPicker, {
                    url: pathname,
                    teams: teamsWithPermission
                });
            } else if (!(route.bypassAuthForAdmin && user.isAdmin)) {
                var currentTeam_1 = teams.find(function(t) {
                    return pathname.split("/").includes(t.domain);
                });
                var membership = teamMemberships.find(function(m) {
                    return m.team.id === (currentTeam_1 === null || currentTeam_1 === void 0 ? void 0 : currentTeam_1.id);
                });
                if (route.auth === "owner") {
                    if (!(membership === null || membership === void 0 ? void 0 : membership.isOwner)) element = (0, $ayMG0.jsx)($3de88b6b80c5d70d$export$5946e841896fa02f, {});
                } else if (!(membership === null || membership === void 0 ? void 0 : membership.isOwner) && !(membership === null || membership === void 0 ? void 0 : membership.permissions[route.auth])) element = (0, $ayMG0.jsx)($3de88b6b80c5d70d$export$5946e841896fa02f, {});
            }
        }
        // React router does not support multiple parameters in the same part of the path, or parameters that have
        // a prefix / suffix. We replace them with a generic name to avoid conflicts. Inside the component, we can then
        // deconstruct our multiParameter into the original parameters.
        routePath = routePath.replace(/[^/]+:[^/]+/g, ":multiParameter").replace(/\/:[^/]+-[^/]+/g, "/:multiParameter");
        return (0, $ayMG0.jsx)((0, $aphAM.Route), {
            element: element,
            path: routePath,
            children: ((_a = route.children) !== null && _a !== void 0 ? _a : []).map(function(_a) {
                var _b = $3de88b6b80c5d70d$var$__read(_a, 2), childPath = _b[0], childRoute = _b[1];
                return generator((0, $hmJ39.path).apply(void 0, $3de88b6b80c5d70d$var$__spreadArray([], $3de88b6b80c5d70d$var$__read(childPath), false)), childRoute);
            })
        }, routePath);
    }, [
        user,
        teams,
        teamMemberships,
        pathname
    ]);
    return (0, $ayMG0.jsxs)((0, $aphAM.Routes), {
        children: [
            (0, $4EnWU.getRoutes)().map(function(_a) {
                var _b = $3de88b6b80c5d70d$var$__read(_a, 2), path = _b[0], route = _b[1];
                return generator(path, route);
            }),
            (0, $ayMG0.jsx)((0, $aphAM.Route), {
                path: "*",
                element: (0, $ayMG0.jsx)($3de88b6b80c5d70d$export$271f9f08425019c7, {})
            })
        ]
    });
}
function $3de88b6b80c5d70d$export$5946e841896fa02f() {
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    (0, $acw62.useEffect)(function() {
        addModal({
            title: (0, $dtKoB.default)("Not authorized"),
            content: (0, $dtKoB.default)("You are not authorized to access this page. Please check with your team owner."),
            type: "warning",
            onClick: function() {
                redirect([
                    "up.root",
                    {}
                ]);
            }
        });
    }, [
        addModal,
        redirect
    ]);
    (0, $acw62.useEffect)(function() {
        (0, $dJ9dH.trackEvent)("unauthorized", {
            url: location.href,
            referrer: document.referrer
        });
    }, []);
    return null;
}
function $3de88b6b80c5d70d$export$6e62fb6a3636fbf1() {
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    (0, $acw62.useEffect)(function() {
        addModal({
            title: (0, $dtKoB.default)("You don't have this feature"),
            content: (0, $dtKoB.default)("Your team does not seem to have access to this feature. Get in touch with us if you would like to add this to your plan."),
            type: "warning",
            onClick: function() {
                redirect([
                    "up.root",
                    {}
                ]);
            }
        });
    }, [
        addModal,
        redirect
    ]);
    return null;
}
function $3de88b6b80c5d70d$export$271f9f08425019c7() {
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    (0, $acw62.useEffect)(function() {
        addModal({
            title: (0, $dtKoB.default)("Not found"),
            content: (0, $dtKoB.default)("We could not find this page. Please contact us if you think this is an error."),
            type: "info",
            onClick: function() {
                redirect([
                    "up.root",
                    {}
                ]);
            }
        });
    }, [
        addModal,
        redirect
    ]);
    (0, $acw62.useEffect)(function() {
        (0, $dJ9dH.trackEvent)("not_found", {
            url: location.href,
            referrer: document.referrer
        });
    }, []);
    return null;
}
function $3de88b6b80c5d70d$export$eb32a4ac1a8a35e() {
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    (0, $acw62.useEffect)(function() {
        addModal({
            title: (0, $dtKoB.default)("Wrong link"),
            content: (0, $dtKoB.default)("Sorry, this link was meant for someone else."),
            type: "warning",
            onClick: function() {
                redirect([
                    "up.root",
                    {}
                ]);
            }
        });
    }, [
        addModal,
        redirect
    ]);
    return null;
}
function $3de88b6b80c5d70d$export$98d2077fefc286f4() {
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    (0, $acw62.useEffect)(function() {
        addModal({
            title: (0, $dtKoB.default)("Already logged in"),
            content: (0, $dtKoB.default)("You are already logged in."),
            type: "warning",
            onClick: function() {
                redirect([
                    "up.root",
                    {}
                ]);
            }
        });
    }, [
        addModal,
        redirect
    ]);
    return null;
}
function $3de88b6b80c5d70d$var$TeamRedirectPicker(_a) {
    var teams = _a.teams, url = _a.url;
    var redirect = (0, $7xuAh.default)();
    var onChange = function(teams) {
        if (teams.length > 0) redirect(url.replace("/_/", "/".concat(teams[0], "/")));
    };
    return (0, $ayMG0.jsx)((0, $bsRud.default), {
        children: (0, $ayMG0.jsxs)((0, $gQFmB.default), {
            children: [
                (0, $ayMG0.jsx)((0, $gQFmB.default).Title, {
                    children: (0, $dtKoB.default)("Choose a team")
                }),
                (0, $ayMG0.jsx)((0, $iybwf.default), {
                    options: teams.map(function(t) {
                        return {
                            id: t.domain,
                            content: t.domain
                        };
                    }),
                    onChange: onChange
                })
            ]
        })
    });
}

});
parcelRegister("iybwf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81456700a7fed39$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $01O3F = parcelRequire("01O3F");
var $d81456700a7fed39$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d81456700a7fed39$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $d81456700a7fed39$export$2e2bcd8739ae039(_a) {
    var allowUnselect = _a.allowUnselect, firstOptionSeparator = _a.firstOptionSeparator, multiple = _a.multiple, name = _a.name, onChange = _a.onChange, options = _a.options, propSelected = _a.selected, topOption = _a.topOption;
    multiple = multiple !== null && multiple !== void 0 ? multiple : false;
    allowUnselect = allowUnselect !== null && allowUnselect !== void 0 ? allowUnselect : false;
    var _b = $d81456700a7fed39$var$__read((0, $acw62.useState)([]), 2), selected = _b[0], setSelected = _b[1];
    var _c = $d81456700a7fed39$var$__read((0, $acw62.useState)(false), 2), changed = _c[0], setChanged = _c[1];
    function makeOnSelect(id) {
        return function(evt) {
            evt.preventDefault();
            setChanged(true);
            if (selected.includes(id)) {
                if (allowUnselect || selected.length > 1) setSelected(selected.filter(function(s) {
                    return s !== id;
                }));
            } else if (multiple) setSelected($d81456700a7fed39$var$__spreadArray($d81456700a7fed39$var$__spreadArray([], $d81456700a7fed39$var$__read(selected), false), [
                id
            ], false));
            else setSelected([
                id
            ]);
        };
    }
    (0, $acw62.useEffect)(function() {
        if (changed) onChange === null || onChange === void 0 || onChange(selected);
    }, [
        selected,
        changed,
        onChange
    ]);
    (0, $acw62.useEffect)(function() {
        if (propSelected) setSelected(propSelected);
    }, [
        propSelected
    ]);
    if (topOption) options = $d81456700a7fed39$var$__spreadArray([], $d81456700a7fed39$var$__read(options), false).sort(function(a) {
        return a.id === topOption ? -1 : 1;
    });
    return (0, $ayMG0.jsxs)("div", {
        className: "space-y-3",
        children: [
            (0, $ayMG0.jsx)("input", {
                name: name,
                type: "hidden",
                value: selected.join(",")
            }),
            options.map(function(option, index) {
                return (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        (0, $ayMG0.jsx)("a", {
                            className: (0, $01O3F.classNames)("flex text-sm", "block cursor-pointer rounded-lg border dark:border-slate-700 bg-white hover:bg-gray-50 dark:bg-slate-800\n              dark:hover:bg-slate-900 px-4 py-3 shadow-sm focus:outline-none sm:flex sm:justify-between", selected.includes(option.id) && "border-primary dark:border-primary-100 ring-1 dark:ring-2 ring-primary dark:ring-primary-100"),
                            onClick: makeOnSelect(option.id),
                            children: option.content
                        }),
                        index === 0 && options.length > 0 && firstOptionSeparator
                    ]
                }, option.id);
            })
        ]
    });
}
$d81456700a7fed39$export$2e2bcd8739ae039.Icon = function Icon(_a) {
    var children = _a.children;
    return (0, $ayMG0.jsx)("div", {
        className: "flex shrink items-center pr-2",
        children: children
    });
};
$d81456700a7fed39$export$2e2bcd8739ae039.Left = function Left(_a) {
    var children = _a.children;
    return (0, $ayMG0.jsx)("div", {
        className: "grow",
        children: children
    });
};
$d81456700a7fed39$export$2e2bcd8739ae039.Right = function Right(_a) {
    var children = _a.children;
    return (0, $ayMG0.jsx)("div", {
        className: "text-right",
        children: children
    });
};
$d81456700a7fed39$export$2e2bcd8739ae039.Primary = function Secondary(_a) {
    var children = _a.children;
    return (0, $ayMG0.jsx)("div", {
        className: "font-semibold text-gray-800 dark:text-gray-200",
        children: children
    });
};
$d81456700a7fed39$export$2e2bcd8739ae039.Secondary = function Secondary(_a) {
    var children = _a.children;
    return (0, $ayMG0.jsx)("div", {
        className: "mt-1 font-normal text-gray-500",
        children: children
    });
};

});

parcelRegister("fdkg2", function(module, exports) {

$parcel$export(module.exports, "ConfettiProvider", () => $b137c8a5bf383859$export$17b969214eae8633);
$parcel$export(module.exports, "useConfetti", () => $b137c8a5bf383859$export$7afd5d02ec38ddc6);
$parcel$export(module.exports, "Confetti", () => $b137c8a5bf383859$export$7ebdff423c107240);

var $ayMG0 = parcelRequire("ayMG0");

var $82f7M = parcelRequire("82f7M");

var $acw62 = parcelRequire("acw62");

var $1mf8x = parcelRequire("1mf8x");

var $lzNIT = parcelRequire("lzNIT");
var $b137c8a5bf383859$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $b137c8a5bf383859$var$ConfettiContext = /*#__PURE__*/ (0, $acw62.createContext)({
    enabled: false,
    setEnabled: function(enabled) {}
});
function $b137c8a5bf383859$export$17b969214eae8633(_a) {
    var children = _a.children;
    var _b = $b137c8a5bf383859$var$__read((0, $acw62.useState)(false), 2), enabled = _b[0], setEnabled = _b[1];
    return (0, $ayMG0.jsx)($b137c8a5bf383859$var$ConfettiContext.Provider, {
        value: {
            enabled: enabled,
            setEnabled: setEnabled
        },
        children: children
    });
}
function $b137c8a5bf383859$export$7afd5d02ec38ddc6() {
    var setEnabled = (0, $acw62.useContext)($b137c8a5bf383859$var$ConfettiContext).setEnabled;
    var triggerConfetti = (0, $acw62.useCallback)(function() {
        setEnabled(true);
    }, [
        setEnabled
    ]);
    return triggerConfetti;
}
function $b137c8a5bf383859$export$7ebdff423c107240() {
    var _a = (0, $acw62.useContext)($b137c8a5bf383859$var$ConfettiContext), enabled = _a.enabled, setEnabled = _a.setEnabled;
    var _b = (0, $82f7M.useWindowSize)(), width = _b.width, height = _b.height;
    var location = (0, $lzNIT.useLocation)();
    var _c = $b137c8a5bf383859$var$__read((0, $acw62.useState)(false), 2), throwingConfetti = _c[0], setThrowingConfetti = _c[1];
    var onConfettiComplete = (0, $acw62.useCallback)(function() {
        setEnabled(false);
    }, [
        setEnabled
    ]);
    var clearing = enabled && !throwingConfetti;
    (0, $acw62.useEffect)(function() {
        if (enabled) setThrowingConfetti(true);
    }, [
        enabled
    ]);
    (0, $acw62.useEffect)(function() {
        setThrowingConfetti(false);
    }, [
        location
    ]);
    return enabled && (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1mf8x))), {
        run: enabled,
        width: width,
        height: height,
        numberOfPieces: 60,
        gravity: clearing ? 0.5 : 0.04,
        className: "!z-50",
        recycle: throwingConfetti,
        onConfettiComplete: onConfettiComplete
    });
}

});
parcelRegister("1mf8x", function(module, exports) {

!function(t, e) {
    module.exports = e((parcelRequire("acw62")));
}("undefined" != typeof self ? self : module.exports, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ReactConfetti", function() {
                return Q;
            });
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = "number" == typeof l ? u(-l, l) : u(l.min, l.max), this.vy = "number" == typeof p ? u(-p, 0) : u(p.min, p.max), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? y(Object(n), !0).forEach(function(e) {
                        g(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function b(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function g(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var O = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, w = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), g(this, "canvas", void 0), g(this, "context", void 0), g(this, "_options", void 0), g(this, "generator", void 0), g(this, "rafId", void 0), g(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = d(d(d({}, e), O), t), Object.assign(r, t.confettiSource);
                    }), g(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), g(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), g(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], b(e.prototype, n), r && b(e, r), t;
            }();
            function m(t) {
                return function(t) {
                    if (Array.isArray(t)) return C(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                }(t) || S(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(t) {
                return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function P() {
                return (P = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function j(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function M(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? j(Object(n), !0).forEach(function(e) {
                        T(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function I(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || S(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function S(t, e) {
                if (t) {
                    if ("string" == typeof t) return C(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? C(t, e) : void 0;
                }
            }
            function C(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function D(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function E(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _(t, e) {
                return (_ = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function R(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = F(t);
                    if (e) {
                        var i = F(this).constructor;
                        n = Reflect.construct(r, arguments, i);
                    } else n = r.apply(this, arguments);
                    return k(this, n);
                };
            }
            function k(t, e) {
                return !e || "object" !== x(e) && "function" != typeof e ? A(t) : e;
            }
            function A(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function F(t) {
                return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function T(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var B = a.a.createRef(), N = function(t) {
                !function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _(t, e);
                }(o, t);
                var e, n, r, i = R(o);
                function o(t) {
                    var e;
                    D(this, o);
                    for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)r[c - 1] = arguments[c];
                    return T(A(e = i.call.apply(i, [
                        this,
                        t
                    ].concat(r))), "canvas", a.a.createRef()), T(A(e), "confetti", void 0), e.canvas = t.canvasRef || B, e;
                }
                return e = o, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = q(this.props)[0];
                                this.confetti = new w(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            var t = q(this.props)[0];
                            this.confetti && (this.confetti.options = t);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = I(q(this.props), 2), e = t[0], n = t[1], r = M({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", P({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], E(e.prototype, n), r && E(e, r), o;
            }(o.Component);
            function q(t) {
                var e = {}, n = {}, r = [].concat(m(Object.keys(O)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            T(N, "defaultProps", M({}, O)), T(N, "displayName", "ReactConfetti");
            var Q = a.a.forwardRef(function(t, e) {
                return a.a.createElement(N, P({
                    canvasRef: e
                }, t));
            });
            e.default = Q;
        }
    ]).default;
});

});


parcelRegister("gCE6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $c19f4cde104a114b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $iCMjC = parcelRequire("iCMjC");

var $7WpdU = parcelRequire("7WpdU");

var $g96xj = parcelRequire("g96xj");
function $c19f4cde104a114b$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    var pathname = (0, $lzNIT.useLocation)().pathname;
    var user = (0, $iCMjC.useAuthentication)().user;
    var forceAuthLayout = pathname.startsWith("/join/");
    var noLayout = /^\/\d{6}$/.test(pathname) || // Do not show any layout for extension pages
    pathname.startsWith("/extension/") || // Do not show any layout for extension pages
    pathname === "/auth/tokens/new" || // Do not show any layout for the personal auth token page
    pathname === "/email_notification" || // Do not show any layout for notification confirmation
    pathname.split("/")[1] === "embed" || // Do not show any layout when the app is embedded
    pathname.startsWith("/quote/"); // Do not show any layout public quote pages
    if (!forceAuthLayout) {
        if (noLayout) return (0, $ayMG0.jsx)("div", {
            className: "flex min-h-screen flex-col",
            children: children
        });
        if (user) return (0, $ayMG0.jsx)((0, $7WpdU.default), {
            children: children
        });
        // Allow access to the installation page without authentication
        if (pathname.startsWith("/welcome") || location.hostname.includes("livedocument")) return children;
    }
    return (0, $ayMG0.jsx)((0, $g96xj.default), {
        children: children
    });
}

});
parcelRegister("7WpdU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c818407395d8a8e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useApplicationLayout", () => $5c818407395d8a8e$export$9ba3e6654342c07d);

var $ayMG0 = parcelRequire("ayMG0");

var $2bwVh = parcelRequire("2bwVh");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $3eox8 = parcelRequire("3eox8");

var $3AV6E = parcelRequire("3AV6E");

var $dtKoB = parcelRequire("dtKoB");

var $hmJ39 = parcelRequire("hmJ39");

var $hW7sX = parcelRequire("hW7sX");

var $4eFVO = parcelRequire("4eFVO");

var $7xuAh = parcelRequire("7xuAh");

var $iCMjC = parcelRequire("iCMjC");

var $5aE2v = parcelRequire("5aE2v");

var $iNF3S = parcelRequire("iNF3S");

var $1eU4T = parcelRequire("1eU4T");

var $hXhdh = parcelRequire("hXhdh");
var $5c818407395d8a8e$var$__assign = undefined && undefined.__assign || function() {
    $5c818407395d8a8e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c818407395d8a8e$var$__assign.apply(this, arguments);
};
var $5c818407395d8a8e$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5c818407395d8a8e$var$ApplicationLayoutContext = /*#__PURE__*/ (0, $acw62.createContext)({
    configureLayout: function(options) {},
    currentProduct: undefined
});
function $5c818407395d8a8e$export$2e2bcd8739ae039(_a) {
    var _b, _c;
    var children = _a.children;
    var _d = $5c818407395d8a8e$var$__read((0, $acw62.useState)({}), 2), applicationLayoutOptions = _d[0], setApplicationLayoutOptions = _d[1];
    var _e = $5c818407395d8a8e$var$__read((0, $acw62.useState)({}), 2), applicationLayoutOptionsDebounced = _e[0], setApplicationLayoutOptionsDebounced = _e[1];
    var _f = (0, $iCMjC.useAuthentication)(), adminRoles = _f.adminRoles, logout = _f.logout, promptForMfa = _f.promptForMfa, promptForPassword = _f.promptForPassword, teamMemberships = _f.teamMemberships, teams = _f.teams, user = _f.user;
    var notifications = (0, $iNF3S.useNotifications)();
    var addModal = (0, $5aE2v.useModal)().addModal;
    var location = (0, $lzNIT.useLocation)();
    var redirect = (0, $7xuAh.default)();
    var route = (0, $aphAM.useMatch)(location.pathname);
    var configureApplicationLayout = (0, $acw62.useCallback)(function(options) {
        setTimeout(function() {
            // Cannot be called synchronously, otherwise it will cause a re-render loop
            setApplicationLayoutOptions(function(previousOptions) {
                if ((0, $f1q41.isEqual)($5c818407395d8a8e$var$__assign($5c818407395d8a8e$var$__assign({}, previousOptions), options), previousOptions)) return previousOptions;
                return $5c818407395d8a8e$var$__assign($5c818407395d8a8e$var$__assign({}, previousOptions), options);
            });
        });
    }, []);
    (0, $acw62.useEffect)(function() {
        setApplicationLayoutOptions({});
    }, [
        route
    ]);
    (0, $acw62.useEffect)(function() {
        if (location.pathname === (0, $hmJ39.path)("up.auth.mfa.enable")) return;
        if (promptForMfa) addModal({
            content: (0, $dtKoB.default)("Please set up your MFA before continuing."),
            onClick: function() {
                redirect([
                    "up.auth.mfa.enable"
                ]);
            },
            title: (0, $dtKoB.default)("MFA setup required")
        });
    }, [
        promptForMfa,
        addModal,
        redirect,
        location
    ]);
    (0, $2bwVh.useDebouncedEffect)(function() {
        setApplicationLayoutOptionsDebounced(applicationLayoutOptions);
    }, [
        applicationLayoutOptions
    ], 200);
    var currentTeamId = (_b = (0, $4eFVO.useCurrentTeamId)(true)) !== null && _b !== void 0 ? _b : undefined;
    var currentProduct = (0, $acw62.useMemo)(function() {
        return (0, $1eU4T.getCurrentProduct)({
            currentTeamId: currentTeamId,
            hostName: window.location.host,
            teams: teams
        });
    }, [
        teams,
        currentTeamId
    ]);
    var game = (0, $hW7sX.useApiData)("global.gamification.show").game;
    var topBar = (0, $hXhdh.default)({
        currentProduct: currentProduct !== null && currentProduct !== void 0 ? currentProduct : null,
        currentRoute: (_c = applicationLayoutOptionsDebounced.currentRoute) !== null && _c !== void 0 ? _c : null
    });
    var primaryNavigationItems = (0, $1eU4T.usePrimaryNavigation)({
        currentProduct: currentProduct,
        currentRoute: applicationLayoutOptionsDebounced.currentRoute,
        currentTeamId: currentTeamId,
        isAdmin: user.isAdmin,
        teamMemberships: teamMemberships
    });
    var hqNavigationItems = (0, $1eU4T.useHqNaviation)({
        adminRoles: adminRoles,
        currentRoute: applicationLayoutOptionsDebounced.currentRoute
    });
    var secondaryNavigationItems = (0, $1eU4T.useSecondaryNavigation)({
        currentProduct: currentProduct,
        currentTeamId: currentTeamId,
        primaryNavigation: primaryNavigationItems,
        teams: teams
    });
    var availableProducts = (0, $acw62.useMemo)(function() {
        return new Set(teams.map(function(t) {
            return t.product;
        }).filter(function(p) {
            return p !== currentProduct;
        }));
    }, [
        teams,
        currentProduct
    ]);
    return (0, $ayMG0.jsxs)($5c818407395d8a8e$var$ApplicationLayoutContext.Provider, {
        value: {
            configureLayout: configureApplicationLayout,
            currentProduct: currentProduct
        },
        children: [
            promptForPassword && (0, $ayMG0.jsx)((0, $3AV6E.default), {}),
            (0, $ayMG0.jsx)((0, $3eox8.default), {
                auth: {
                    email: user.email
                },
                availableProducts: availableProducts,
                currentTitle: applicationLayoutOptionsDebounced.currentTitle,
                fixedHeight: applicationLayoutOptionsDebounced.fixedHeight,
                gamification: currentProduct === "helloscreen" ? game : null,
                hiddenSidebar: applicationLayoutOptionsDebounced.hiddenSidebar,
                notifications: notifications,
                onLogout: logout,
                primaryNavigation: hqNavigationItems.length > 0 ? {
                    items: hqNavigationItems
                } : {
                    items: primaryNavigationItems
                },
                product: currentProduct,
                secondaryNavigation: secondaryNavigationItems ? {
                    items: secondaryNavigationItems,
                    title: "Teams"
                } : undefined,
                topBar: topBar,
                children: children
            })
        ]
    });
}
function $5c818407395d8a8e$export$9ba3e6654342c07d() {
    return (0, $acw62.useContext)($5c818407395d8a8e$var$ApplicationLayoutContext);
}

});
parcelRegister("2bwVh", function(module, exports) {

$parcel$export(module.exports, "useDebouncedEffect", () => $197625aa74a7d7f9$export$44b55d93c84df466);

var $acw62 = parcelRequire("acw62");

var $8IdGw = parcelRequire("8IdGw");
function $197625aa74a7d7f9$export$44b55d93c84df466(callback, deps, delay, maxWait = 0) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)((0, $8IdGw.useDebouncedCallback)(callback, deps, delay, maxWait), deps);
}

});
parcelRegister("8IdGw", function(module, exports) {

$parcel$export(module.exports, "useDebouncedCallback", () => $657d0c5074661c4a$export$e70e6da722faba05);

var $acw62 = parcelRequire("acw62");

var $dqQVQ = parcelRequire("dqQVQ");
function $657d0c5074661c4a$export$e70e6da722faba05(callback, deps, delay, maxWait = 0) {
    const timeout = (0, $acw62.useRef)(undefined);
    const waitTimeout = (0, $acw62.useRef)(undefined);
    const cb = (0, $acw62.useRef)(callback);
    const lastCall = (0, $acw62.useRef)(undefined);
    const clear = ()=>{
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
        if (waitTimeout.current) {
            clearTimeout(waitTimeout.current);
            waitTimeout.current = undefined;
        }
    };
    // Cancel scheduled execution on unmount
    (0, $dqQVQ.useUnmountEffect)(clear);
    (0, $acw62.useEffect)(()=>{
        cb.current = callback;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    return (0, $acw62.useMemo)(()=>{
        const execute = ()=>{
            clear();
            if (!lastCall.current) return;
            const context = lastCall.current;
            lastCall.current = undefined;
            cb.current.apply(context.this, context.args);
        };
        const wrapped = function(...args) {
            if (timeout.current) clearTimeout(timeout.current);
            lastCall.current = {
                args: args,
                this: this
            };
            // Plan regular execution
            timeout.current = setTimeout(execute, delay);
            // Plan maxWait execution if required
            if (maxWait > 0 && !waitTimeout.current) waitTimeout.current = setTimeout(execute, maxWait);
        };
        Object.defineProperties(wrapped, {
            length: {
                value: callback.length
            },
            name: {
                value: `${callback.name || "anonymous"}__debounced__${delay}`
            }
        });
        return wrapped;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        delay,
        maxWait,
        ...deps
    ]);
}

});


parcelRegister("3eox8", function(module, exports) {

$parcel$export(module.exports, "default", () => $25a5b5b75830b979$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $ZZYjn = parcelRequire("ZZYjn");
var $j1dT5 = parcelRequire("j1dT5");
var $hjSjq = parcelRequire("hjSjq");
var $cVodR = parcelRequire("cVodR");

var $dvhfX = parcelRequire("dvhfX");
var $4rPgj = parcelRequire("4rPgj");

var $82f7M = parcelRequire("82f7M");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $lzNIT = parcelRequire("lzNIT");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $fdkg2 = parcelRequire("fdkg2");

var $hNovL = parcelRequire("hNovL");

var $01O3F = parcelRequire("01O3F");

var $iBEMP = parcelRequire("iBEMP");

var $33lpL = parcelRequire("33lpL");

var $iL5oi = parcelRequire("iL5oi");

var $doin4 = parcelRequire("doin4");

var $l4KeD = parcelRequire("l4KeD");

var $5goL7 = parcelRequire("5goL7");

var $iEjTt = parcelRequire("iEjTt");

var $1T737 = parcelRequire("1T737");
var $25a5b5b75830b979$var$__assign = undefined && undefined.__assign || function() {
    $25a5b5b75830b979$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $25a5b5b75830b979$var$__assign.apply(this, arguments);
};
var $25a5b5b75830b979$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25a5b5b75830b979$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $25a5b5b75830b979$export$2e2bcd8739ae039(props) {
    var _a = $25a5b5b75830b979$var$__read((0, $acw62.useState)(false), 2), desktopSidebarOpen = _a[0], setDesktopSidebarOpen = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var pathname = (0, $lzNIT.useLocation)().pathname;
    (0, $acw62.useEffect)(function() {
        setDesktopSidebarOpen(false);
    }, [
        pathname
    ]);
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: (0, $ayMG0.jsxs)("div", {
            className: (0, $01O3F.classNames)("bg-gray-50 dark:bg-gray-900 flex flex-col", props.fixedHeight ? "h-screen" : "min-h-screen"),
            children: [
                (0, $ayMG0.jsx)((0, $fdkg2.Confetti), {}),
                props.topBar && (0, $ayMG0.jsx)($25a5b5b75830b979$var$TopBar, $25a5b5b75830b979$var$__assign({}, props, {
                    topBar: props.topBar
                })),
                (0, $ayMG0.jsx)($25a5b5b75830b979$var$MobileNavigation, $25a5b5b75830b979$var$__assign({}, props)),
                (0, $ayMG0.jsx)($25a5b5b75830b979$var$DesktopNavigation, $25a5b5b75830b979$var$__assign({}, props, {
                    desktopSideBarOpen: desktopSidebarOpen,
                    setDesktopSidebarOpen: setDesktopSidebarOpen
                })),
                (0, $ayMG0.jsx)("main", {
                    className: (0, $01O3F.classNames)("divide-y divide-gray-200 dark:divide-gray-800 lg:transition-all ease-linear duration-300 relative flex-1 flex flex-col", props.hiddenSidebar ? "lg:ml-10" : "lg:ml-72"),
                    children: props.children
                })
            ]
        })
    });
}
function $25a5b5b75830b979$var$TopBar(props) {
    return (0, $ayMG0.jsxs)("div", {
        className: "bg-primary-500 dark:bg-primary-200 z-60 top-0 flex min-h-12 flex-col gap-2 overflow-auto p-2 text-center sm:px-3.5\n        md:sticky md:flex-row md:items-center md:justify-between md:px-4 md:text-left",
        children: [
            (0, $ayMG0.jsx)("p", {
                className: "flex-1 text-sm font-semibold text-white md:leading-6 dark:text-black",
                children: props.topBar.content
            }),
            props.topBar.cta && ("to" in props.topBar.cta ? (0, $ayMG0.jsx)((0, $doin4.default), {
                size: "sm",
                to: props.topBar.cta.to,
                children: props.topBar.cta.label
            }) : (0, $ayMG0.jsx)((0, $iL5oi.default), {
                size: "sm",
                onClick: props.topBar.cta.onClick,
                children: props.topBar.cta.label
            }))
        ]
    });
}
function $25a5b5b75830b979$var$MobileNavigation(props) {
    var _a;
    var _b = $25a5b5b75830b979$var$__read((0, $acw62.useState)(false), 2), sidebarOpen = _b[0], setSidebarOpen = _b[1];
    /* eslint-disable react-hooks/rules-of-hooks */ var pathname = (0, $lzNIT.useLocation)().pathname;
    /* eslint-enable react-hooks/rules-of-hooks */ var getSupport = (0, $hNovL.default)().getSupport;
    (0, $acw62.useEffect)(function() {
        setSidebarOpen(false);
    }, [
        pathname
    ]);
    var currentPageName = (0, $acw62.useMemo)(function() {
        var _a, _b, _c;
        if (props.currentTitle) return props.currentTitle;
        var primaryName = (_a = props.primaryNavigation.items.filter(function(i) {
            return i.current;
        })[0]) === null || _a === void 0 ? void 0 : _a.name;
        var secondaryName = (_c = (_b = props.secondaryNavigation) === null || _b === void 0 ? void 0 : _b.items.filter(function(i) {
            return i.current;
        })[0]) === null || _c === void 0 ? void 0 : _c.name;
        return secondaryName ? "".concat(primaryName, " \xbb ").concat(secondaryName) : primaryName;
    }, [
        props.currentTitle,
        props.primaryNavigation.items,
        (_a = props.secondaryNavigation) === null || _a === void 0 ? void 0 : _a.items
    ]);
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsxs)("div", {
                className: "sticky top-0 z-50 flex h-14 items-center gap-x-6 bg-white px-4 shadow-sm sm:px-6 lg:hidden dark:bg-gray-900",
                children: [
                    (0, $ayMG0.jsxs)("button", {
                        type: "button",
                        className: "-m-2.5 p-2.5 text-gray-700 lg:hidden dark:text-gray-300",
                        onClick: function() {
                            return setSidebarOpen(true);
                        },
                        "data-role": "sidebar-toggle-mobile",
                        children: [
                            (0, $ayMG0.jsx)("span", {
                                className: "sr-only",
                                children: (0, $dtKoB.default)("Open sidebar")
                            }),
                            (0, $ayMG0.jsx)((0, $ZZYjn.default), {
                                className: "size-6",
                                "aria-hidden": "true"
                            })
                        ]
                    }),
                    (0, $ayMG0.jsx)("div", {
                        className: "flex-1 truncate text-sm font-semibold leading-6 text-gray-900 dark:text-white",
                        children: currentPageName
                    }),
                    props.notifications && (0, $ayMG0.jsx)($25a5b5b75830b979$var$Notifications, $25a5b5b75830b979$var$__assign({}, props.notifications)),
                    (0, $ayMG0.jsx)((0, $l4KeD.default), {
                        links: [
                            {
                                name: (0, $dtKoB.default)("Account settings"),
                                to: [
                                    "up.settings.personal"
                                ]
                            },
                            {
                                name: (0, $dtKoB.default)("Manage teams"),
                                to: [
                                    "up.settings.manageTeams",
                                    {}
                                ]
                            },
                            {
                                name: (0, $dtKoB.default)("Support"),
                                onClick: getSupport
                            },
                            {
                                name: (0, $dtKoB.default)("Sign out"),
                                onClick: props.onLogout,
                                className: "text-red-700"
                            }
                        ],
                        children: (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                (0, $ayMG0.jsx)("span", {
                                    className: "sr-only",
                                    children: (0, $dtKoB.default)("Your profile")
                                }),
                                (0, $ayMG0.jsx)((0, $4rPgj.default), {
                                    className: "size-6 cursor-pointer text-slate-500 dark:text-gray-400"
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                show: sidebarOpen,
                as: (0, $acw62.Fragment),
                children: (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
                    as: "div",
                    className: "z-60 relative lg:hidden",
                    onClose: setSidebarOpen,
                    children: [
                        (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                            as: (0, $acw62.Fragment),
                            enter: "transition-opacity ease-linear duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity ease-linear duration-300",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: (0, $ayMG0.jsx)("div", {
                                className: "fixed inset-0 bg-gray-900/80"
                            })
                        }),
                        (0, $ayMG0.jsx)("div", {
                            className: "fixed inset-0 flex",
                            children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                                as: (0, $acw62.Fragment),
                                enter: "transition ease-in-out duration-300 transform",
                                enterFrom: "-translate-x-full",
                                enterTo: "translate-x-0",
                                leave: "transition ease-in-out duration-300 transform",
                                leaveFrom: "translate-x-0",
                                leaveTo: "-translate-x-full",
                                children: (0, $ayMG0.jsxs)((0, $lLzDP.DialogPanel), {
                                    className: "relative mr-16 flex w-full max-w-xs flex-1",
                                    children: [
                                        (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                                            as: (0, $acw62.Fragment),
                                            enter: "ease-in-out duration-300",
                                            enterFrom: "opacity-0",
                                            enterTo: "opacity-100",
                                            leave: "ease-in-out duration-300",
                                            leaveFrom: "opacity-100",
                                            leaveTo: "opacity-0",
                                            children: (0, $ayMG0.jsx)("div", {
                                                className: "absolute left-full top-0 flex w-16 justify-center pt-5",
                                                children: (0, $ayMG0.jsxs)("button", {
                                                    type: "button",
                                                    className: "-m-2.5 p-2.5",
                                                    onClick: function() {
                                                        return setSidebarOpen(false);
                                                    },
                                                    children: [
                                                        (0, $ayMG0.jsx)("span", {
                                                            className: "sr-only",
                                                            children: (0, $dtKoB.default)("Close sidebar")
                                                        }),
                                                        (0, $ayMG0.jsx)((0, $cVodR.default), {
                                                            className: "size-6 text-white",
                                                            "aria-hidden": "true"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        (0, $ayMG0.jsxs)("div", {
                                            className: "flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2 dark:bg-gray-900",
                                            children: [
                                                (0, $ayMG0.jsx)($25a5b5b75830b979$var$ProductSwitcher, {
                                                    product: props.product,
                                                    switchOptions: props.availableProducts
                                                }),
                                                (0, $ayMG0.jsx)("nav", {
                                                    className: "flex flex-1 flex-col",
                                                    children: (0, $ayMG0.jsxs)("ul", {
                                                        role: "list",
                                                        className: "flex flex-1 flex-col gap-y-7",
                                                        children: [
                                                            (0, $ayMG0.jsx)("li", {
                                                                children: (0, $ayMG0.jsx)("ul", {
                                                                    role: "list",
                                                                    className: "-mx-2 space-y-1",
                                                                    children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$NavigationItems, {
                                                                        items: props.primaryNavigation.items
                                                                    })
                                                                })
                                                            }),
                                                            props.secondaryNavigation && (0, $ayMG0.jsxs)("li", {
                                                                children: [
                                                                    (0, $ayMG0.jsx)("div", {
                                                                        className: "text-xs font-semibold leading-6 text-gray-400",
                                                                        children: props.secondaryNavigation.title
                                                                    }),
                                                                    (0, $ayMG0.jsx)("ul", {
                                                                        role: "list",
                                                                        className: "-mx-2 mt-2 space-y-1",
                                                                        children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$NavigationItems, {
                                                                            items: props.secondaryNavigation.items
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function $25a5b5b75830b979$var$DesktopNavigation(props) {
    var hiddenSidebar = props.hiddenSidebar, setDesktopSidebarOpen = props.setDesktopSidebarOpen;
    function openSidebar(evt) {
        evt.preventDefault();
        setDesktopSidebarOpen(true);
    }
    (0, $acw62.useEffect)(function() {
        if (hiddenSidebar) setDesktopSidebarOpen(false);
    }, [
        hiddenSidebar,
        setDesktopSidebarOpen
    ]);
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                show: !props.hiddenSidebar,
                as: (0, $acw62.Fragment),
                children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                    as: (0, $acw62.Fragment),
                    enter: "transition ease-in-out duration-300 transform",
                    enterFrom: "-translate-x-full",
                    enterTo: "translate-x-0",
                    leave: "transition ease-in-out duration-300 transform",
                    leaveFrom: "translate-x-0",
                    leaveTo: "!-translate-x-full",
                    children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$DesktopSidebar, $25a5b5b75830b979$var$__assign({}, props))
                })
            }, "visible-sidebar"),
            props.hiddenSidebar && (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                        show: props.desktopSideBarOpen,
                        as: (0, $acw62.Fragment),
                        children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                            as: (0, $acw62.Fragment),
                            enter: "transition ease-in-out duration-300 transform",
                            enterFrom: "-translate-x-full",
                            enterTo: "translate-x-0",
                            leave: "transition ease-in-out duration-300 transform",
                            leaveFrom: "translate-x-0",
                            leaveTo: "!-translate-x-full",
                            children: (0, $ayMG0.jsx)((0, $lLzDP.Dialog), {
                                as: (0, $acw62.Fragment),
                                onClose: props.setDesktopSidebarOpen,
                                children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$DesktopSidebar, $25a5b5b75830b979$var$__assign({}, props, {
                                    hiddenSidebar: false,
                                    className: "dark:bg-slate-900"
                                }))
                            })
                        })
                    }, "hidden-sidebar--sidebar"),
                    (0, $ayMG0.jsx)((0, $iymfR.Transition), {
                        show: props.desktopSideBarOpen,
                        as: (0, $acw62.Fragment),
                        children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                            as: (0, $acw62.Fragment),
                            enter: "transition-opacity ease-linear duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "transition-opacity ease-linear duration-300",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: (0, $ayMG0.jsx)("div", {
                                className: "fixed inset-0 z-50 bg-gray-900/90"
                            })
                        })
                    }, "hidden-sidebar--toggle")
                ]
            }),
            (0, $ayMG0.jsxs)("a", {
                className: (0, $01O3F.classNames)("hidden lg:flex fixed inset-y-0 w-10 items-start justify-center bg-gray-50 border-r border-gray-200 dark:border-gray-800\n          dark:bg-gray-900 cursor-pointer pt-4 transition-all ease-linear duration-300", props.topBar && "mt-12", !props.hiddenSidebar && "opacity-0"),
                onClick: openSidebar,
                "data-role": "sidebar-toggle-desktop",
                children: [
                    (0, $ayMG0.jsx)("span", {
                        className: "sr-only",
                        children: (0, $dtKoB.default)("Open sidebar")
                    }),
                    (0, $ayMG0.jsx)((0, $iBEMP.default), {
                        height: 24,
                        className: "text-slate-700 dark:text-white/70"
                    })
                ]
            })
        ]
    });
}
var $25a5b5b75830b979$var$DesktopSidebar = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var getSupport = (0, $hNovL.default)().getSupport;
    return (0, $ayMG0.jsx)("div", {
        className: (0, $01O3F.classNames)("hidden fixed inset-y-0 z-50 lg:flex w-72 flex-col overflow-y-auto", props.topBar && "mt-12", props.hiddenSidebar && "-translate-x-full", props.className),
        ref: ref,
        children: (0, $ayMG0.jsxs)("div", {
            className: "flex grow cursor-default flex-col gap-y-5 border-r border-gray-200 bg-white px-6 dark:border-gray-800 dark:bg-black/20",
            children: [
                (0, $ayMG0.jsx)($25a5b5b75830b979$var$ProductSwitcher, {
                    product: props.product,
                    switchOptions: props.availableProducts,
                    notifications: props.notifications
                }),
                (0, $ayMG0.jsx)("nav", {
                    className: "flex flex-1 flex-col",
                    children: (0, $ayMG0.jsxs)("ul", {
                        role: "list",
                        className: "flex flex-1 flex-col gap-y-7",
                        children: [
                            (0, $ayMG0.jsx)("li", {
                                children: (0, $ayMG0.jsx)("ul", {
                                    role: "list",
                                    className: "-mx-2 space-y-1",
                                    children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$NavigationItems, {
                                        items: props.primaryNavigation.items
                                    })
                                })
                            }),
                            props.secondaryNavigation && (0, $ayMG0.jsxs)("li", {
                                children: [
                                    (0, $ayMG0.jsx)("div", {
                                        className: "text-xs font-semibold leading-6 text-gray-400",
                                        children: props.secondaryNavigation.title
                                    }),
                                    (0, $ayMG0.jsx)("ul", {
                                        role: "list",
                                        className: "-mx-2 mt-2 space-y-1",
                                        children: (0, $ayMG0.jsx)($25a5b5b75830b979$var$NavigationItems, {
                                            items: props.secondaryNavigation.items
                                        })
                                    })
                                ]
                            }),
                            (0, $ayMG0.jsxs)("li", {
                                className: "mt-auto shrink-0",
                                children: [
                                    (0, $ayMG0.jsx)((0, $1T737.default), {
                                        currentProduct: props.product,
                                        game: (0, $01O3F.presence)(props.gamification)
                                    }),
                                    (0, $ayMG0.jsxs)("div", {
                                        className: "mb-3 flex items-center justify-between",
                                        children: [
                                            (0, $ayMG0.jsxs)("div", {
                                                className: "w-full",
                                                children: [
                                                    (0, $ayMG0.jsx)("p", {
                                                        className: "text-sm text-gray-500 dark:text-gray-400",
                                                        children: (0, $dtKoB.default)("Signed in as")
                                                    }),
                                                    (0, $ayMG0.jsx)("p", {
                                                        className: "truncate text-sm text-gray-900 dark:text-white",
                                                        children: props.auth.email
                                                    })
                                                ]
                                            }),
                                            (0, $ayMG0.jsx)((0, $l4KeD.default), {
                                                links: [
                                                    {
                                                        name: (0, $dtKoB.default)("Account settings"),
                                                        to: [
                                                            "up.settings.personal"
                                                        ]
                                                    },
                                                    {
                                                        name: (0, $dtKoB.default)("Manage teams"),
                                                        to: [
                                                            "up.settings.manageTeams",
                                                            {}
                                                        ]
                                                    },
                                                    {
                                                        name: (0, $dtKoB.default)("Support"),
                                                        onClick: getSupport
                                                    },
                                                    {
                                                        name: (0, $dtKoB.default)("Sign out"),
                                                        onClick: props.onLogout,
                                                        color: "red"
                                                    }
                                                ],
                                                children: (0, $ayMG0.jsx)("div", {
                                                    className: "size-6 cursor-pointer rounded-full text-slate-500 hover:text-slate-900 dark:hover:text-slate-200",
                                                    children: (0, $ayMG0.jsx)((0, $j1dT5.default), {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
});
function $25a5b5b75830b979$var$NavigationItems(_a) {
    var items = _a.items;
    return (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: items.map(function(item) {
            var _a;
            return (0, $ayMG0.jsx)("li", {
                children: (0, $ayMG0.jsxs)((0, $5goL7.default), {
                    to: item.to,
                    className: (0, $01O3F.classNames)(item.current ? "bg-primary-100 dark:bg-gray-800 text-primary-600 dark:text-gray-200" : "text-gray-700 dark:text-gray-100 hover:text-primary-600 hover:bg-primary-100 dark:hover:text-gray-200\n                  dark:hover:bg-gray-800", "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold truncate active:scale-95 transition-transform"),
                    children: [
                        item.icon ? (0, $ayMG0.jsx)(item.icon, {
                            className: (0, $01O3F.classNames)(item.current ? "text-primary-600 dark:text-gray-200" : "text-gray-400 dark:text-gray-400 group-hover:text-primary-600 dark:group-hover:text-gray-200", "h-6 w-6 shrink-0"),
                            "aria-hidden": "true"
                        }) : (0, $ayMG0.jsx)("span", {
                            className: (0, $01O3F.classNames)(item.current ? "text-primary-600 border-primary-600 dark:text-white dark:border-gray-700 dark:bg-gray-800" : "text-gray-400 border-gray-200 dark:border-gray-600 group-hover:border-primary-600 group-hover:text-primary-600\n                      dark:group-hover:border-gray-700 dark:group-hover:text-white", "flex h-6 w-6 shrink-0 items-center justify-center rounded-lg border text-[0.625rem] font-semibold bg-white\n                  dark:bg-gray-900"),
                            children: (_a = item.name[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()
                        }),
                        item.name,
                        typeof item.count === "number" ? (0, $ayMG0.jsx)("span", {
                            className: (0, $01O3F.classNames)("ml-auto w-9 min-w-max whitespace-nowrap rounded-full px-2.5 py-0.5 text-center text-xs leading-5 border", item.countColor === "red" ? "bg-red-100 dark:bg-red-700 text-red-800 dark:text-red-100 border-red-700/50" : "bg-gray-100 dark:bg-gray-600 text-gray-600 dark:text-gray-100 border-gray-700/50"),
                            "aria-hidden": "true",
                            children: item.count
                        }) : null
                    ]
                })
            }, item.name);
        })
    });
}
function $25a5b5b75830b979$var$productRoot(product) {
    return product ? ({
        userview: [
            "uv.root",
            {}
        ],
        helloscreen: [
            "hs.root",
            {}
        ],
        cobrowsingapi: [
            "co.root",
            {}
        ],
        livedocument: [
            "ld.root",
            {}
        ]
    })[product] : [
        "up.root",
        {}
    ];
}
function $25a5b5b75830b979$var$ProductSwitcher(_a) {
    var product = _a.product, switchOptions = _a.switchOptions, notifications = _a.notifications;
    if (!switchOptions || switchOptions.size === 0) return (0, $ayMG0.jsxs)("div", {
        className: "mt-3 flex shrink-0 items-center justify-between",
        children: [
            (0, $ayMG0.jsx)((0, $5goL7.default), {
                to: $25a5b5b75830b979$var$productRoot(product),
                children: (0, $ayMG0.jsx)((0, $33lpL.default), {
                    product: product,
                    className: "text-black dark:text-white"
                })
            }),
            notifications && (0, $ayMG0.jsx)($25a5b5b75830b979$var$Notifications, $25a5b5b75830b979$var$__assign({}, notifications))
        ]
    });
    var options = Array.from(switchOptions).map(function(p) {
        return {
            name: (0, $4Q1tF.productName)(p),
            to: $25a5b5b75830b979$var$productRoot(p)
        };
    });
    return (0, $ayMG0.jsxs)("div", {
        className: "mt-3 flex shrink-0 items-center justify-between",
        children: [
            (0, $ayMG0.jsx)((0, $5goL7.default), {
                to: $25a5b5b75830b979$var$productRoot(product),
                children: (0, $ayMG0.jsx)((0, $33lpL.default), {
                    product: product,
                    className: "text-black dark:text-white"
                })
            }),
            (0, $ayMG0.jsxs)("div", {
                className: "flex items-center gap-3",
                children: [
                    (0, $ayMG0.jsx)((0, $l4KeD.default), {
                        links: options,
                        children: (0, $ayMG0.jsx)("div", {
                            className: "size-6 cursor-pointer rounded-full text-slate-500 hover:text-slate-900 dark:hover:text-slate-200",
                            children: (0, $ayMG0.jsx)((0, $hjSjq.default), {})
                        })
                    }),
                    notifications && (0, $ayMG0.jsx)($25a5b5b75830b979$var$Notifications, $25a5b5b75830b979$var$__assign({}, notifications))
                ]
            })
        ]
    });
}
function $25a5b5b75830b979$var$Notifications(_a) {
    var _b;
    var notifications = _a.notifications, onLoadMore = _a.onLoadMore, clearNotifications = _a.clearNotifications, props = $25a5b5b75830b979$var$__rest(_a, [
        "notifications",
        "onLoadMore",
        "clearNotifications"
    ]);
    var _c = $25a5b5b75830b979$var$__read((0, $acw62.useState)({
        top: 0,
        left: 0
    }), 2), position = _c[0], setPosition = _c[1];
    var windowSize = (0, $82f7M.useWindowSize)();
    var buttonRef = (0, $acw62.useRef)(null);
    var listRef = (0, $acw62.useRef)(null);
    var _d = $25a5b5b75830b979$var$__read((0, $acw62.useState)(false), 2), notificationsOpen = _d[0], setNotificationsOpen = _d[1];
    (0, $acw62.useEffect)(function() {
        if (!buttonRef.current) return;
        var rect = buttonRef.current.getBoundingClientRect();
        if (windowSize.width < 1024) {
            // lg:
            setPosition({
                top: rect.bottom + 4,
                right: 0
            });
            return;
        }
        setPosition({
            top: rect.bottom + 4,
            left: rect.right
        });
    }, [
        windowSize,
        notificationsOpen
    ]);
    (0, $acw62.useEffect)(function() {
        setNotificationsOpen(false);
    }, [
        windowSize
    ]);
    (0, $acw62.useEffect)(function() {
        if (notificationsOpen) {
            clearNotifications();
            onLoadMore();
        }
    }, [
        notificationsOpen,
        onLoadMore,
        clearNotifications
    ]);
    (0, $acw62.useEffect)(function() {
        if (!notificationsOpen) return;
        var clickListener = function(e) {
            var _a, _b, _c;
            if (!((_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) && !((_c = (_b = listRef.current) === null || _b === void 0 ? void 0 : _b.querySelector('[data-role="notifications-list"]')) === null || _c === void 0 ? void 0 : _c.contains(e.target))) setNotificationsOpen(false);
        };
        var keydownListener = function(e) {
            if (e.key === "Escape") setNotificationsOpen(false);
        };
        document.addEventListener("click", clickListener);
        document.addEventListener("keydown", keydownListener);
        return function() {
            document.removeEventListener("click", clickListener);
            document.removeEventListener("keydown", keydownListener);
        };
    }, [
        notificationsOpen
    ]);
    var onReachEnd = (0, $acw62.useCallback)(function() {
        onLoadMore();
    }, [
        onLoadMore
    ]);
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsxs)("div", {
                className: "relative cursor-pointer",
                ref: buttonRef,
                onClick: function() {
                    return setNotificationsOpen(function(open) {
                        return !open;
                    });
                },
                children: [
                    typeof props.notificationsCount === "number" && props.notificationsCount > 0 && (0, $ayMG0.jsx)("div", {
                        className: "absolute -right-0.5 -top-0.5 size-2 rounded-full bg-red-500 ring-2 ring-white dark:bg-red-400 dark:ring-gray-900"
                    }),
                    (0, $ayMG0.jsx)((0, $dvhfX.default), {
                        className: "size-5 cursor-pointer text-gray-400 hover:text-gray-900 dark:text-gray-500 dark:hover:text-gray-200"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1u0KT.createPortal)((0, $ayMG0.jsx)("div", {
                className: "z-60 fixed w-96 max-w-full",
                style: position,
                ref: listRef,
                children: (0, $ayMG0.jsx)((0, $iEjTt.default), {
                    notifications: notifications !== null && notifications !== void 0 ? notifications : [],
                    hasMore: (_b = props.hasMore) !== null && _b !== void 0 ? _b : false,
                    loadingMore: props.loadingMore,
                    onReachEnd: onReachEnd,
                    onAction: props.onAction,
                    open: notificationsOpen
                })
            }, "notifications-container"), document.body)
        ]
    });
}

});
parcelRegister("ZZYjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ba5c4ec0e202528$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $0ba5c4ec0e202528$var$Bars3Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    }));
}
const $0ba5c4ec0e202528$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($0ba5c4ec0e202528$var$Bars3Icon);
var $0ba5c4ec0e202528$export$2e2bcd8739ae039 = $0ba5c4ec0e202528$var$ForwardRef;

});

parcelRegister("j1dT5", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd88e2148a16500e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $dd88e2148a16500e$var$EllipsisVerticalIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    }));
}
const $dd88e2148a16500e$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($dd88e2148a16500e$var$EllipsisVerticalIcon);
var $dd88e2148a16500e$export$2e2bcd8739ae039 = $dd88e2148a16500e$var$ForwardRef;

});

parcelRegister("hjSjq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9be574abcd4bde3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $c9be574abcd4bde3$var$Squares2X2Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
    }));
}
const $c9be574abcd4bde3$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($c9be574abcd4bde3$var$Squares2X2Icon);
var $c9be574abcd4bde3$export$2e2bcd8739ae039 = $c9be574abcd4bde3$var$ForwardRef;

});

parcelRegister("cVodR", function(module, exports) {

$parcel$export(module.exports, "default", () => $968d99013e9e02bc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $968d99013e9e02bc$var$XMarkIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18 18 6M6 6l12 12"
    }));
}
const $968d99013e9e02bc$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($968d99013e9e02bc$var$XMarkIcon);
var $968d99013e9e02bc$export$2e2bcd8739ae039 = $968d99013e9e02bc$var$ForwardRef;

});

parcelRegister("dvhfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4b8e63a6a013b4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9d4b8e63a6a013b4$var$BellIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
        clipRule: "evenodd"
    }));
}
const $9d4b8e63a6a013b4$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($9d4b8e63a6a013b4$var$BellIcon);
var $9d4b8e63a6a013b4$export$2e2bcd8739ae039 = $9d4b8e63a6a013b4$var$ForwardRef;

});

parcelRegister("4rPgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d1729e3a51308c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $33d1729e3a51308c$var$UserCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
        clipRule: "evenodd"
    }));
}
const $33d1729e3a51308c$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($33d1729e3a51308c$var$UserCircleIcon);
var $33d1729e3a51308c$export$2e2bcd8739ae039 = $33d1729e3a51308c$var$ForwardRef;

});

parcelRegister("iBEMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8bb520f34c3bb82$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
var $d8bb520f34c3bb82$var$LogoSquare = function(_a) {
    var height = _a.height, className = _a.className;
    return (0, $ayMG0.jsx)("svg", {
        className: "w-auto ".concat(className !== null && className !== void 0 ? className : ""),
        viewBox: "0 0 128 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            height: "".concat(height !== null && height !== void 0 ? height : 20, "px")
        },
        children: (0, $ayMG0.jsx)("path", {
            d: "M64,0 C99.346224,0 128,28.653776 128,64 C128,99.346224 99.346224,128 64,128 C28.653776,128 0,99.346224 0,64 C0,28.653776 28.653776,0 64,0 Z M64,20.5714286 C40.0150623,20.5714286 20.5714286,40.0150623 20.5714286,64 C20.5714286,87.9849377 40.0150623,107.428571 64,107.428571 C87.9849377,107.428571 107.428571,87.9849377 107.428571,64 C107.428571,40.0150623 87.9849377,20.5714286 64,20.5714286 Z M64,45.7142857 C74.0989211,45.7142857 82.2857143,53.9010789 82.2857143,64 C82.2857143,74.0989211 74.0989211,82.2857143 64,82.2857143 C53.9010789,82.2857143 45.7142857,74.0989211 45.7142857,64 C45.7142857,53.9010789 53.9010789,45.7142857 64,45.7142857 Z M57.1428571,52.5714286 C54.6181269,52.5714286 52.5714286,54.6181269 52.5714286,57.1428571 C52.5714286,59.6675874 54.6181269,61.7142857 57.1428571,61.7142857 C59.6675874,61.7142857 61.7142857,59.6675874 61.7142857,57.1428571 C61.7142857,54.6181269 59.6675874,52.5714286 57.1428571,52.5714286 Z",
            id: "not_active_light",
            fill: "currentColor"
        })
    });
};
var $d8bb520f34c3bb82$export$2e2bcd8739ae039 = $d8bb520f34c3bb82$var$LogoSquare;

});

parcelRegister("33lpL", function(module, exports) {

$parcel$export(module.exports, "default", () => $239243618d62f2c8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $4Q1tF = parcelRequire("4Q1tF");

var $lunKN = parcelRequire("lunKN");
function $239243618d62f2c8$export$2e2bcd8739ae039(_a) {
    var product = _a.product, className = _a.className;
    if (!product) return (0, $ayMG0.jsx)("div", {
        className: "my-3",
        children: (0, $ayMG0.jsx)((0, $lunKN.default), {
            height: 20,
            className: className
        })
    });
    return (0, $ayMG0.jsxs)("div", {
        className: "cursor-default ".concat(className !== null && className !== void 0 ? className : ""),
        children: [
            (0, $ayMG0.jsx)("div", {
                className: "text-xl font-semibold",
                children: (0, $4Q1tF.productName)(product)
            }),
            (0, $ayMG0.jsxs)("div", {
                className: "flex items-center space-x-1 text-sm opacity-40",
                children: [
                    (0, $ayMG0.jsx)("span", {
                        children: "by"
                    }),
                    " ",
                    (0, $ayMG0.jsx)((0, $lunKN.default), {
                        height: 10
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("lunKN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4ed350008367a8$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
var $fa4ed350008367a8$var$Logo = function(_a) {
    var height = _a.height, className = _a.className;
    return (0, $ayMG0.jsxs)("svg", {
        className: "w-auto ".concat(className !== null && className !== void 0 ? className : ""),
        viewBox: "0 0 108 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            height: "".concat(height !== null && height !== void 0 ? height : 20, "px")
        },
        children: [
            (0, $ayMG0.jsx)("path", {
                d: "M3.61 0H0v12c0 4.8 4.813 6 7.22 6s7.22-1.2 7.22-6V0h-3.61v12c0 1.8-1.504 3.3-3.61 3.3S3.61 13.8 3.61 12V0Z",
                fill: "currentColor"
            }),
            (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.652 0v18h3.309v-6.3h3.159c3.24 0 5.866-2.62 5.866-5.85C30.986 2.62 28.36 0 25.12 0h-6.468Zm3.309 8.7h3.159a2.854 2.854 0 0 0 2.858-2.85c0-1.574-1.28-2.85-2.858-2.85h-3.16v5.7Zm49.638.3c0 1.491-1.212 2.7-2.708 2.7A2.704 2.704 0 0 1 66.184 9c0-1.491 1.212-2.7 2.707-2.7A2.704 2.704 0 0 1 71.6 9Zm-2.708-.75a.751.751 0 1 1-1.502-.002.751.751 0 0 1 1.502.002Z",
                fill: "currentColor"
            }),
            (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M77.916 9c0 4.97-4.04 9-9.025 9-4.984 0-9.025-4.03-9.025-9s4.041-9 9.025-9c4.985 0 9.025 4.03 9.025 9Zm-3.008 0c0 3.314-2.694 6-6.017 6-3.323 0-6.016-2.686-6.016-6s2.693-6 6.016-6 6.017 2.686 6.017 6Z",
                fill: "currentColor"
            }),
            (0, $ayMG0.jsx)("path", {
                d: "M95.365 18H108l-.602-2.7h-8.724v-5.1h6.618l-.601-2.7h-6.017V2.7h7.822l-.602-2.7h-10.53v18Z",
                fill: "currentColor"
            }),
            (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M83.332 18h-3.31V0h6.468c3.24 0 5.867 2.62 5.867 5.85 0 3.23-2.627 5.85-5.867 5.85h-3.158V18Zm3.158-9.3h-3.158V3h3.158a2.854 2.854 0 0 1 2.858 2.85c0 1.574-1.28 2.85-2.858 2.85Z",
                fill: "currentColor"
            }),
            (0, $ayMG0.jsx)("path", {
                d: "M38.507 0c3.008 0 4.763 1 5.265 1.5l-1.053 2.55c-2.858-1.5-4.778-1.26-5.566-.75-2.58 1.672 1.035 3.676 3.54 5.064.416.23.802.444 1.123.636 2.256 1.35 3.008 2.4 3.008 4.5S42.87 18 38.809 18c-3.25 0-5.265-1-5.867-1.5l.903-2.55c3.85 1.68 5.898 1.2 6.92.45 1.934-1.421-.47-2.763-2.731-4.025-.841-.47-1.663-.928-2.234-1.375-1.203-.9-3.008-2.7-3.008-4.5 0-2.25 1.956-4.5 5.716-4.5ZM54.36 0c3.212 0 4.809 1 5.206 1.5l-1.042 2.1c-6.9-2.76-8.626 2.45-8.626 5.4s1.725 8.16 8.626 5.4l1.041 2.1c-.396.5-1.992 1.5-5.205 1.5-3.57 0-8.031-2.7-8.031-9s4.462-9 8.031-9Z",
                fill: "currentColor"
            })
        ]
    });
};
var $fa4ed350008367a8$export$2e2bcd8739ae039 = $fa4ed350008367a8$var$Logo;

});


parcelRegister("doin4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bfbc45be0f5c8a9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $01O3F = parcelRequire("01O3F");

var $iL5oi = parcelRequire("iL5oi");

var $5goL7 = parcelRequire("5goL7");
var $9bfbc45be0f5c8a9$var$ButtonLink = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var to = _a.to, disabled = _a.disabled, children = _a.children, variant = _a.variant, size = _a.size, className = _a.className, newTab = _a.newTab, color = _a.color;
    disabled !== null && disabled !== void 0 ? disabled : disabled = false;
    size !== null && size !== void 0 ? size : size = "md";
    variant !== null && variant !== void 0 ? variant : variant = "primary";
    newTab !== null && newTab !== void 0 ? newTab : newTab = false;
    function onClick(event) {
        if (disabled) event.preventDefault();
    }
    return (0, $ayMG0.jsx)((0, $5goL7.default), {
        ref: ref,
        to: to,
        onClick: onClick,
        className: (0, $iL5oi.buttonClassName)({
            loading: false,
            size: size,
            variant: variant,
            className: className,
            color: color
        }),
        newTab: newTab,
        children: (0, $01O3F.wrapText)(children)
    });
});
var $9bfbc45be0f5c8a9$export$2e2bcd8739ae039 = $9bfbc45be0f5c8a9$var$ButtonLink;

});
parcelRegister("5goL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d51a6f7f6fd95dc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "NavLink", () => $3d51a6f7f6fd95dc$export$b0d92dbee9b5b60d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $hmJ39 = parcelRequire("hmJ39");

var $iCMjC = parcelRequire("iCMjC");
var $3d51a6f7f6fd95dc$var$__assign = undefined && undefined.__assign || function() {
    $3d51a6f7f6fd95dc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3d51a6f7f6fd95dc$var$__assign.apply(this, arguments);
};
var $3d51a6f7f6fd95dc$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3d51a6f7f6fd95dc$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3d51a6f7f6fd95dc$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3d51a6f7f6fd95dc$var$Link = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var to = _a.to, children = _a.children, newTab = _a.newTab, untrusted = _a.untrusted, onClick = _a.onClick, props = $3d51a6f7f6fd95dc$var$__rest(_a, [
        "to",
        "children",
        "newTab",
        "untrusted",
        "onClick"
    ]);
    var user = (0, $iCMjC.useAuthentication)().user;
    var needsServerResponse = typeof to === "string" || Object.keys((0, $hmJ39.serverResponsePaths)).includes(to[0]) || !user && to[0].endsWith(".root");
    var destination = typeof to === "string" ? to : (0, $hmJ39.path).apply(void 0, $3d51a6f7f6fd95dc$var$__spreadArray([], $3d51a6f7f6fd95dc$var$__read(to), false));
    // Use <a> for external links and links that need a server response
    var LinkElement = needsServerResponse || !destination.startsWith("/") ? "a" : (0, $lzNIT.Link);
    var anchorProps = (0, $acw62.useMemo)(function() {
        if (LinkElement !== "a") return {};
        return {
            href: destination,
            onClick: function(event) {
                onClick === null || onClick === void 0 || onClick(event);
                if (event.defaultPrevented) return;
                if (destination.startsWith(location.origin) || typeof to === "string" || !destination.startsWith("http") || to[0].startsWith("up.") || !user) return;
                event.preventDefault();
                location.href = (0, $hmJ39.path)("up.auth.loginRedirect", {
                    redirectUrl: destination
                });
            }
        };
    }, [
        user,
        LinkElement,
        destination,
        to,
        onClick
    ]);
    newTab !== null && newTab !== void 0 ? newTab : newTab = false;
    untrusted !== null && untrusted !== void 0 ? untrusted : untrusted = false;
    return (0, $ayMG0.jsx)(LinkElement, $3d51a6f7f6fd95dc$var$__assign({}, props, {
        onClick: onClick,
        ref: ref
    }, anchorProps, {
        to: destination,
        target: newTab ? "_blank" : undefined,
        rel: newTab && untrusted ? "noopener noreferrer" : undefined,
        children: children
    }));
});
var $3d51a6f7f6fd95dc$export$2e2bcd8739ae039 = $3d51a6f7f6fd95dc$var$Link;
var $3d51a6f7f6fd95dc$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_a, ref) {
    var to = _a.to, children = _a.children, newTab = _a.newTab, className = _a.className, props = $3d51a6f7f6fd95dc$var$__rest(_a, [
        "to",
        "children",
        "newTab",
        "className"
    ]);
    var needsServerResponse = typeof to === "string" || Object.keys((0, $hmJ39.serverResponsePaths)).includes(to[0]);
    var destination = typeof to === "string" ? to : (0, $hmJ39.path).apply(void 0, $3d51a6f7f6fd95dc$var$__spreadArray([], $3d51a6f7f6fd95dc$var$__read(to), false));
    // Use <a> for external links and links that need a server response
    var LinkElement = needsServerResponse || !destination.startsWith("/") ? "a" : (0, $lzNIT.NavLink);
    newTab !== null && newTab !== void 0 ? newTab : newTab = false;
    if (LinkElement === "a") return (0, $ayMG0.jsx)(LinkElement, $3d51a6f7f6fd95dc$var$__assign({}, props, {
        ref: ref,
        href: destination,
        target: newTab ? "_blank" : undefined,
        className: className === null || className === void 0 ? void 0 : className({
            isActive: false
        }),
        children: children
    }));
    return (0, $ayMG0.jsx)(LinkElement, $3d51a6f7f6fd95dc$var$__assign({}, props, {
        ref: ref,
        to: destination,
        target: newTab ? "_blank" : undefined,
        className: className,
        end: true,
        children: children
    }));
});

});


parcelRegister("l4KeD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57dd6052cb942c6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownIcon", () => $f57dd6052cb942c6$export$fae4d9254a21fe54);

var $ayMG0 = parcelRequire("ayMG0");

var $hjTZz = parcelRequire("hjTZz");
var $iymfR = parcelRequire("iymfR");

var $j1dT5 = parcelRequire("j1dT5");

var $3ktwa = parcelRequire("3ktwa");
var $82f7M = parcelRequire("82f7M");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $01O3F = parcelRequire("01O3F");

var $5goL7 = parcelRequire("5goL7");
var $f57dd6052cb942c6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $f57dd6052cb942c6$var$classNames() {
    var classes = [];
    for(var _i = 0; _i < arguments.length; _i++)classes[_i] = arguments[_i];
    return classes.filter(Boolean).join(" ");
}
function $f57dd6052cb942c6$export$2e2bcd8739ae039(_a) {
    var children = _a.children, links = _a.links, title = _a.title, dontRenderOnEmpty = _a.dontRenderOnEmpty;
    var _b = $f57dd6052cb942c6$var$__read((0, $acw62.useState)({
        x: 0,
        y: 0
    }), 2), mousePosition = _b[0], setMousePosition = _b[1];
    var _c = $f57dd6052cb942c6$var$__read((0, $acw62.useState)({}), 2), dropDownPosition = _c[0], setDropDownPosition = _c[1];
    var _d = $f57dd6052cb942c6$var$__read((0, $3ktwa.useMeasure)(), 2), dropdownSize = _d[0], dropDownRef = _d[1];
    var _e = (0, $82f7M.useWindowSize)(), windowWidth = _e.width, windowHeight = _e.height;
    var menuRef = (0, $acw62.useRef)(null);
    function onButtonClick(e) {
        setMousePosition({
            x: e.clientX,
            y: e.clientY
        });
    }
    (0, $acw62.useEffect)(function() {
        if (!dropdownSize) return;
        var top, right, bottom, left;
        if (mousePosition.x + dropdownSize.width > windowWidth) right = "".concat(windowWidth - mousePosition.x, "px");
        else left = "".concat(mousePosition.x, "px");
        if (mousePosition.y + dropdownSize.height > windowHeight) bottom = "".concat(windowHeight - mousePosition.y, "px");
        else top = "".concat(mousePosition.y, "px");
        var transformOrigin = "".concat(left ? "left" : "right", " ").concat(top ? "top" : "bottom");
        var zIndex = menuRef.current ? (0, $01O3F.totalZIndex)(menuRef.current) + 1 : 0;
        setDropDownPosition({
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            transformOrigin: transformOrigin,
            zIndex: zIndex
        });
    }, [
        dropdownSize,
        mousePosition,
        windowWidth,
        windowHeight,
        menuRef
    ]);
    if (dontRenderOnEmpty && links.length === 0) return;
    return (0, $ayMG0.jsx)((0, $hjTZz.Menu), {
        as: "div",
        ref: menuRef,
        className: "inline",
        children: function(_a) {
            var open = _a.open, close = _a.close;
            return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    (0, $ayMG0.jsx)((0, $hjTZz.MenuButton), {
                        onClick: open ? undefined : onButtonClick,
                        as: "span",
                        role: "button",
                        children: children
                    }),
                    /*#__PURE__*/ (0, $1u0KT.createPortal)((0, $ayMG0.jsx)((0, $iymfR.Transition), {
                        as: (0, $acw62.Fragment),
                        enter: "transition ease-out duration-100",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                        children: (0, $ayMG0.jsxs)((0, $hjTZz.MenuItems), {
                            className: "fixed mt-2 w-56 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none\n                  dark:bg-gray-800",
                            style: dropDownPosition,
                            ref: dropDownRef,
                            children: [
                                title && (0, $ayMG0.jsx)("div", {
                                    className: "border-b bg-gray-100 px-4 py-2 dark:border-gray-900 dark:bg-gray-700",
                                    role: "none",
                                    children: (0, $ayMG0.jsx)("p", {
                                        className: "text-sm font-semibold text-gray-500 dark:text-gray-300",
                                        role: "none",
                                        children: title
                                    })
                                }),
                                (0, $ayMG0.jsx)("div", {
                                    className: "py-1",
                                    children: links.map(function(link) {
                                        return (0, $ayMG0.jsx)((0, $hjTZz.MenuItem), {
                                            children: function(_a) {
                                                var active = _a.active;
                                                return "to" in link ? (0, $ayMG0.jsxs)((0, $5goL7.default), {
                                                    to: link.to,
                                                    className: $f57dd6052cb942c6$var$classNames(active ? "bg-gray-100 dark:bg-white/5" : "opacity-80", link.color === "red" ? "text-red-700 dark:text-red-500" : "text-gray-700 dark:text-white", "block px-4 py-2 text-sm", link.className),
                                                    newTab: link.newTab,
                                                    children: [
                                                        link.icon,
                                                        link.name
                                                    ]
                                                }) : (0, $ayMG0.jsxs)("a", {
                                                    href: "#",
                                                    className: $f57dd6052cb942c6$var$classNames(active ? "bg-gray-100 dark:bg-white/5" : "opacity-80", link.color === "red" ? "text-red-700 dark:text-red-500" : "text-gray-700 dark:text-white", "block px-4 py-2 text-sm", link.className),
                                                    onClick: function(evt) {
                                                        evt.preventDefault();
                                                        evt.stopPropagation();
                                                        link.onClick();
                                                        close();
                                                    },
                                                    children: [
                                                        link.icon,
                                                        link.name
                                                    ]
                                                });
                                            }
                                        }, link.name);
                                    })
                                })
                            ]
                        })
                    }), document.body)
                ]
            });
        }
    });
}
function $f57dd6052cb942c6$export$fae4d9254a21fe54() {
    return (0, $ayMG0.jsx)("div", {
        className: "shrink-0 cursor-pointer rounded-full border border-gray-200 p-0.5 hover:bg-gray-100 dark:border-gray-600\n        dark:hover:bg-gray-700",
        "data-role": "dropdown-icon",
        children: (0, $ayMG0.jsx)((0, $j1dT5.default), {
            className: "size-4"
        })
    });
}

});
parcelRegister("hjTZz", function(module, exports) {

$parcel$export(module.exports, "MenuButton", () => $c9bfa4e2da6232f7$export$266a769812832828);
$parcel$export(module.exports, "MenuItems", () => $c9bfa4e2da6232f7$export$15a41fea157b048a);
$parcel$export(module.exports, "MenuItem", () => $c9bfa4e2da6232f7$export$2ce376c2cc3355c8);
$parcel$export(module.exports, "Menu", () => $c9bfa4e2da6232f7$export$d9b273488cd8ce6f);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cE9hP = parcelRequire("cE9hP");

var $hd1nN = parcelRequire("hd1nN");

var $5Ai9V = parcelRequire("5Ai9V");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $8KgIp = parcelRequire("8KgIp");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $gm4XX = parcelRequire("gm4XX");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $jN7sP = parcelRequire("jN7sP");

var $ipity = parcelRequire("ipity");

var $bdknl = parcelRequire("bdknl");

var $1nOiu = parcelRequire("1nOiu");

var $34Str = parcelRequire("34Str");

var $auuNT = parcelRequire("auuNT");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $c9bfa4e2da6232f7$var$qe = ((r)=>(r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r))($c9bfa4e2da6232f7$var$qe || {}), $c9bfa4e2da6232f7$var$ze = ((r)=>(r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r))($c9bfa4e2da6232f7$var$ze || {}), $c9bfa4e2da6232f7$var$Ye = ((a)=>(a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a[a.SetButtonElement = 7] = "SetButtonElement", a[a.SetItemsElement = 8] = "SetItemsElement", a))($c9bfa4e2da6232f7$var$Ye || {});
function $c9bfa4e2da6232f7$var$j(e, n = (r)=>r) {
    let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, l = (0, $hsQxB.sortByDomNode)(n(e.items.slice()), (u)=>u.dataRef.current.domRef.current), o = r ? l.indexOf(r) : null;
    return o === -1 && (o = null), {
        items: l,
        activeItemIndex: o
    };
}
let $c9bfa4e2da6232f7$var$Ze = {
    [1] (e) {
        return e.menuState === 1 ? e : {
            ...e,
            activeItemIndex: null,
            menuState: 1
        };
    },
    [0] (e) {
        return e.menuState === 0 ? e : {
            ...e,
            __demoMode: !1,
            menuState: 0
        };
    },
    [2]: (e, n)=>{
        var u, p, s, m, a;
        if (e.menuState === 1) return e;
        let r = {
            ...e,
            searchQuery: "",
            activationTrigger: (u = n.trigger) != null ? u : 1,
            __demoMode: !1
        };
        if (n.focus === (0, $fLrGx.Focus).Nothing) return {
            ...r,
            activeItemIndex: null
        };
        if (n.focus === (0, $fLrGx.Focus).Specific) return {
            ...r,
            activeItemIndex: e.items.findIndex((t)=>t.id === n.id)
        };
        if (n.focus === (0, $fLrGx.Focus).Previous) {
            let t = e.activeItemIndex;
            if (t !== null) {
                let d = e.items[t].dataRef.current.domRef, f = (0, $fLrGx.calculateActiveIndex)(n, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (c)=>c.id,
                    resolveDisabled: (c)=>c.dataRef.current.disabled
                });
                if (f !== null) {
                    let c = e.items[f].dataRef.current.domRef;
                    if (((p = d.current) == null ? void 0 : p.previousElementSibling) === c.current || ((s = c.current) == null ? void 0 : s.previousElementSibling) === null) return {
                        ...r,
                        activeItemIndex: f
                    };
                }
            }
        } else if (n.focus === (0, $fLrGx.Focus).Next) {
            let t = e.activeItemIndex;
            if (t !== null) {
                let d = e.items[t].dataRef.current.domRef, f = (0, $fLrGx.calculateActiveIndex)(n, {
                    resolveItems: ()=>e.items,
                    resolveActiveIndex: ()=>e.activeItemIndex,
                    resolveId: (c)=>c.id,
                    resolveDisabled: (c)=>c.dataRef.current.disabled
                });
                if (f !== null) {
                    let c = e.items[f].dataRef.current.domRef;
                    if (((m = d.current) == null ? void 0 : m.nextElementSibling) === c.current || ((a = c.current) == null ? void 0 : a.nextElementSibling) === null) return {
                        ...r,
                        activeItemIndex: f
                    };
                }
            }
        }
        let l = $c9bfa4e2da6232f7$var$j(e), o = (0, $fLrGx.calculateActiveIndex)(n, {
            resolveItems: ()=>l.items,
            resolveActiveIndex: ()=>l.activeItemIndex,
            resolveId: (t)=>t.id,
            resolveDisabled: (t)=>t.dataRef.current.disabled
        });
        return {
            ...r,
            ...l,
            activeItemIndex: o
        };
    },
    [3]: (e, n)=>{
        let l = e.searchQuery !== "" ? 0 : 1, o = e.searchQuery + n.value.toLowerCase(), p = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + l).concat(e.items.slice(0, e.activeItemIndex + l)) : e.items).find((m)=>{
            var a;
            return ((a = m.dataRef.current.textValue) == null ? void 0 : a.startsWith(o)) && !m.dataRef.current.disabled;
        }), s = p ? e.items.indexOf(p) : -1;
        return s === -1 || s === e.activeItemIndex ? {
            ...e,
            searchQuery: o
        } : {
            ...e,
            searchQuery: o,
            activeItemIndex: s,
            activationTrigger: 1
        };
    },
    [4] (e) {
        return e.searchQuery === "" ? e : {
            ...e,
            searchQuery: "",
            searchActiveItemIndex: null
        };
    },
    [5]: (e, n)=>{
        let r = $c9bfa4e2da6232f7$var$j(e, (l)=>[
                ...l,
                {
                    id: n.id,
                    dataRef: n.dataRef
                }
            ]);
        return {
            ...e,
            ...r
        };
    },
    [6]: (e, n)=>{
        let r = $c9bfa4e2da6232f7$var$j(e, (l)=>{
            let o = l.findIndex((u)=>u.id === n.id);
            return o !== -1 && l.splice(o, 1), l;
        });
        return {
            ...e,
            ...r,
            activationTrigger: 1
        };
    },
    [7]: (e, n)=>e.buttonElement === n.element ? e : {
            ...e,
            buttonElement: n.element
        },
    [8]: (e, n)=>e.itemsElement === n.element ? e : {
            ...e,
            itemsElement: n.element
        }
}, $c9bfa4e2da6232f7$var$Q = (0, $acw62.createContext)(null);
$c9bfa4e2da6232f7$var$Q.displayName = "MenuContext";
function $c9bfa4e2da6232f7$var$w(e) {
    let n = (0, $acw62.useContext)($c9bfa4e2da6232f7$var$Q);
    if (n === null) {
        let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(r, $c9bfa4e2da6232f7$var$w), r;
    }
    return n;
}
function $c9bfa4e2da6232f7$var$et(e, n) {
    return (0, $6Ngq1.match)(n.type, $c9bfa4e2da6232f7$var$Ze, e, n);
}
let $c9bfa4e2da6232f7$var$tt = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$nt(e, n) {
    let { __demoMode: r = !1, ...l } = e, o = (0, $acw62.useReducer)($c9bfa4e2da6232f7$var$et, {
        __demoMode: r,
        menuState: r ? 0 : 1,
        buttonElement: null,
        itemsElement: null,
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), [{ menuState: u, itemsElement: p, buttonElement: s }, m] = o, a = (0, $6mpbl.useSyncRefs)(n);
    (0, $23pTr.useOutsideClick)(u === 0, [
        s,
        p
    ], (b, S)=>{
        m({
            type: 1
        }), (0, $hsQxB.isFocusableElement)(S, (0, $hsQxB.FocusableMode).Loose) || (b.preventDefault(), s == null || s.focus());
    });
    let d = (0, $114Mg.useEvent)(()=>{
        m({
            type: 1
        });
    }), f = (0, $acw62.useMemo)(()=>({
            open: u === 0,
            close: d
        }), [
        u,
        d
    ]), c = {
        ref: a
    }, A = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c9bfa4e2da6232f7$var$Q.Provider, {
        value: o
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(u, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, A({
        ourProps: c,
        theirProps: l,
        slot: f,
        defaultTag: $c9bfa4e2da6232f7$var$tt,
        name: "Menu"
    }))));
}
let $c9bfa4e2da6232f7$var$rt = "button";
function $c9bfa4e2da6232f7$var$ot(e, n) {
    var h;
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-button-${r}`, disabled: o = !1, autoFocus: u = !1, ...p } = e, [s, m] = $c9bfa4e2da6232f7$var$w("Menu.Button"), a = (0, $34Str.useFloatingReferenceProps)(), t = (0, $6mpbl.useSyncRefs)(n, (0, $34Str.useFloatingReference)(), (0, $114Mg.useEvent)((T)=>m({
            type: 7,
            element: T
        }))), d = (0, $114Mg.useEvent)((T)=>{
        switch(T.key){
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).Enter:
            case (0, $6AKlm.Keys).ArrowDown:
                T.preventDefault(), T.stopPropagation(), (0, $1u0KT.flushSync)(()=>m({
                        type: 0
                    })), m({
                    type: 2,
                    focus: (0, $fLrGx.Focus).First
                });
                break;
            case (0, $6AKlm.Keys).ArrowUp:
                T.preventDefault(), T.stopPropagation(), (0, $1u0KT.flushSync)(()=>m({
                        type: 0
                    })), m({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Last
                });
                break;
        }
    }), f = (0, $114Mg.useEvent)((T)=>{
        switch(T.key){
            case (0, $6AKlm.Keys).Space:
                T.preventDefault();
                break;
        }
    }), c = (0, $114Mg.useEvent)((T)=>{
        var F;
        if ((0, $5fYEB.isDisabledReactIssue7711)(T.currentTarget)) return T.preventDefault();
        o || (s.menuState === 0 ? ((0, $1u0KT.flushSync)(()=>m({
                type: 1
            })), (F = s.buttonElement) == null || F.focus({
            preventScroll: !0
        })) : (T.preventDefault(), m({
            type: 0
        })));
    }), { isFocusVisible: A, focusProps: b } = (0, $kd7LS.useFocusRing)({
        autoFocus: u
    }), { isHovered: S, hoverProps: D } = (0, $6o6B3.useHover)({
        isDisabled: o
    }), { pressed: M, pressProps: P } = (0, $cE9hP.useActivePress)({
        disabled: o
    }), v = (0, $acw62.useMemo)(()=>({
            open: s.menuState === 0,
            active: M || s.menuState === 0,
            disabled: o,
            hover: S,
            focus: A,
            autofocus: u
        }), [
        s,
        S,
        A,
        M,
        o,
        u
    ]), C = (0, $ebRQH.mergeProps)(a(), {
        ref: t,
        id: l,
        type: (0, $gm4XX.useResolveButtonType)(e, s.buttonElement),
        "aria-haspopup": "menu",
        "aria-controls": (h = s.itemsElement) == null ? void 0 : h.id,
        "aria-expanded": s.menuState === 0,
        disabled: o || void 0,
        autoFocus: u,
        onKeyDown: d,
        onKeyUp: f,
        onClick: c
    }, b, D, P);
    return (0, $ebRQH.useRender)()({
        ourProps: C,
        theirProps: p,
        slot: v,
        defaultTag: $c9bfa4e2da6232f7$var$rt,
        name: "Menu.Button"
    });
}
let $c9bfa4e2da6232f7$var$at = "div", $c9bfa4e2da6232f7$var$lt = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $c9bfa4e2da6232f7$var$it(e, n) {
    var J, V;
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-items-${r}`, anchor: o, portal: u = !1, modal: p = !0, transition: s = !1, ...m } = e, a = (0, $34Str.useResolvedAnchor)(o), [t, d] = $c9bfa4e2da6232f7$var$w("Menu.Items"), [f, c] = (0, $34Str.useFloatingPanel)(a), A = (0, $34Str.useFloatingPanelProps)(), [b, S] = (0, $acw62.useState)(null), D = (0, $6mpbl.useSyncRefs)(n, a ? f : null, (0, $114Mg.useEvent)((i)=>d({
            type: 8,
            element: i
        })), S), M = (0, $5IEAk.useOwnerDocument)(t.itemsElement);
    a && (u = !0);
    let P = (0, $auuNT.useOpenClosed)(), [v, C] = (0, $bdknl.useTransition)(s, b, P !== null ? (P & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : t.menuState === 0);
    (0, $dcp2r.useOnDisappear)(v, t.buttonElement, ()=>{
        d({
            type: 1
        });
    });
    let O = t.__demoMode ? !1 : p && t.menuState === 0;
    (0, $hZodg.useScrollLock)(O, M);
    let h = t.__demoMode ? !1 : p && t.menuState === 0;
    (0, $keKjn.useInertOthers)(h, {
        allowed: (0, $acw62.useCallback)(()=>[
                t.buttonElement,
                t.itemsElement
            ], [
            t.buttonElement,
            t.itemsElement
        ])
    });
    let T = t.menuState !== 0, K = (0, $hd1nN.useDidElementMove)(T, t.buttonElement) ? !1 : v;
    (0, $acw62.useEffect)(()=>{
        let i = t.itemsElement;
        i && t.menuState === 0 && i !== (M == null ? void 0 : M.activeElement) && i.focus({
            preventScroll: !0
        });
    }, [
        t.menuState,
        t.itemsElement,
        M
    ]), (0, $1nOiu.useTreeWalker)(t.menuState === 0, {
        container: t.itemsElement,
        accept (i) {
            return i.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : i.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (i) {
            i.setAttribute("role", "none");
        }
    });
    let I = (0, $5Ai9V.useDisposables)(), G = (0, $114Mg.useEvent)((i)=>{
        var X, $, q;
        switch(I.dispose(), i.key){
            case (0, $6AKlm.Keys).Space:
                if (t.searchQuery !== "") return i.preventDefault(), i.stopPropagation(), d({
                    type: 3,
                    value: i.key
                });
            case (0, $6AKlm.Keys).Enter:
                if (i.preventDefault(), i.stopPropagation(), d({
                    type: 1
                }), t.activeItemIndex !== null) {
                    let { dataRef: ue } = t.items[t.activeItemIndex];
                    ($ = (X = ue.current) == null ? void 0 : X.domRef.current) == null || $.click();
                }
                (0, $hsQxB.restoreFocusIfNecessary)(t.buttonElement);
                break;
            case (0, $6AKlm.Keys).ArrowDown:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Next
                });
            case (0, $6AKlm.Keys).ArrowUp:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Previous
                });
            case (0, $6AKlm.Keys).Home:
            case (0, $6AKlm.Keys).PageUp:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).First
                });
            case (0, $6AKlm.Keys).End:
            case (0, $6AKlm.Keys).PageDown:
                return i.preventDefault(), i.stopPropagation(), d({
                    type: 2,
                    focus: (0, $fLrGx.Focus).Last
                });
            case (0, $6AKlm.Keys).Escape:
                i.preventDefault(), i.stopPropagation(), (0, $1u0KT.flushSync)(()=>d({
                        type: 1
                    })), (q = t.buttonElement) == null || q.focus({
                    preventScroll: !0
                });
                break;
            case (0, $6AKlm.Keys).Tab:
                i.preventDefault(), i.stopPropagation(), (0, $1u0KT.flushSync)(()=>d({
                        type: 1
                    })), (0, $hsQxB.focusFrom)(t.buttonElement, i.shiftKey ? (0, $hsQxB.Focus).Previous : (0, $hsQxB.Focus).Next);
                break;
            default:
                i.key.length === 1 && (d({
                    type: 3,
                    value: i.key
                }), I.setTimeout(()=>d({
                        type: 4
                    }), 350));
                break;
        }
    }), ae = (0, $114Mg.useEvent)((i)=>{
        switch(i.key){
            case (0, $6AKlm.Keys).Space:
                i.preventDefault();
                break;
        }
    }), le = (0, $acw62.useMemo)(()=>({
            open: t.menuState === 0
        }), [
        t.menuState
    ]), ie = (0, $ebRQH.mergeProps)(a ? A() : {}, {
        "aria-activedescendant": t.activeItemIndex === null || (J = t.items[t.activeItemIndex]) == null ? void 0 : J.id,
        "aria-labelledby": (V = t.buttonElement) == null ? void 0 : V.id,
        id: l,
        onKeyDown: G,
        onKeyUp: ae,
        role: "menu",
        tabIndex: t.menuState === 0 ? 0 : void 0,
        ref: D,
        style: {
            ...m.style,
            ...c,
            "--button-width": (0, $dfvrc.useElementSize)(t.buttonElement, !0).width
        },
        ...(0, $bdknl.transitionDataAttributes)(C)
    }), se = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: u ? e.static || v : !1
    }, se({
        ourProps: ie,
        theirProps: m,
        slot: le,
        defaultTag: $c9bfa4e2da6232f7$var$at,
        features: $c9bfa4e2da6232f7$var$lt,
        visible: K,
        name: "Menu.Items"
    }));
}
let $c9bfa4e2da6232f7$var$st = (0, $acw62.Fragment);
function $c9bfa4e2da6232f7$var$ut(e, n) {
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-item-${r}`, disabled: o = !1, ...u } = e, [p, s] = $c9bfa4e2da6232f7$var$w("Menu.Item"), m = p.activeItemIndex !== null ? p.items[p.activeItemIndex].id === l : !1, a = (0, $acw62.useRef)(null), t = (0, $6mpbl.useSyncRefs)(n, a);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!p.__demoMode && p.menuState === 0 && m && p.activationTrigger !== 0) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            var I, G;
            (G = (I = a.current) == null ? void 0 : I.scrollIntoView) == null || G.call(I, {
                block: "nearest"
            });
        });
    }, [
        p.__demoMode,
        a,
        m,
        p.menuState,
        p.activationTrigger,
        p.activeItemIndex
    ]);
    let d = (0, $jN7sP.useTextValue)(a), f = (0, $acw62.useRef)({
        disabled: o,
        domRef: a,
        get textValue () {
            return d();
        }
    });
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        f.current.disabled = o;
    }, [
        f,
        o
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>(s({
            type: 5,
            id: l,
            dataRef: f
        }), ()=>s({
                type: 6,
                id: l
            })), [
        f,
        l
    ]);
    let c = (0, $114Mg.useEvent)(()=>{
        s({
            type: 1
        });
    }), A = (0, $114Mg.useEvent)((I)=>{
        if (o) return I.preventDefault();
        s({
            type: 1
        }), (0, $hsQxB.restoreFocusIfNecessary)(p.buttonElement);
    }), b = (0, $114Mg.useEvent)(()=>{
        if (o) return s({
            type: 2,
            focus: (0, $fLrGx.Focus).Nothing
        });
        s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l
        });
    }), S = (0, $ipity.useTrackedPointer)(), D = (0, $114Mg.useEvent)((I)=>{
        S.update(I), !o && (m || s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l,
            trigger: 0
        }));
    }), M = (0, $114Mg.useEvent)((I)=>{
        S.wasMoved(I) && (o || m || s({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            id: l,
            trigger: 0
        }));
    }), P = (0, $114Mg.useEvent)((I)=>{
        S.wasMoved(I) && (o || m && s({
            type: 2,
            focus: (0, $fLrGx.Focus).Nothing
        }));
    }), [v, C] = (0, $5qg9U.useLabels)(), [O, h] = (0, $iGb09.useDescriptions)(), T = (0, $acw62.useMemo)(()=>({
            active: m,
            focus: m,
            disabled: o,
            close: c
        }), [
        m,
        o,
        c
    ]), F = {
        id: l,
        ref: t,
        role: "menuitem",
        tabIndex: o === !0 ? void 0 : -1,
        "aria-disabled": o === !0 ? !0 : void 0,
        "aria-labelledby": v,
        "aria-describedby": O,
        disabled: void 0,
        onClick: A,
        onFocus: b,
        onPointerEnter: D,
        onMouseEnter: D,
        onPointerMove: M,
        onMouseMove: M,
        onPointerLeave: P,
        onMouseLeave: P
    }, K = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(h, null, K({
        ourProps: F,
        theirProps: u,
        slot: T,
        defaultTag: $c9bfa4e2da6232f7$var$st,
        name: "Menu.Item"
    })));
}
let $c9bfa4e2da6232f7$var$pt = "div";
function $c9bfa4e2da6232f7$var$mt(e, n) {
    let [r, l] = (0, $5qg9U.useLabels)(), o = e, u = {
        ref: n,
        "aria-labelledby": r,
        role: "group"
    }, p = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(l, null, p({
        ourProps: u,
        theirProps: o,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$pt,
        name: "Menu.Section"
    }));
}
let $c9bfa4e2da6232f7$var$dt = "header";
function $c9bfa4e2da6232f7$var$ct(e, n) {
    let r = (0, $acw62.useId)(), { id: l = `headlessui-menu-heading-${r}`, ...o } = e, u = (0, $5qg9U.useLabelContext)();
    (0, $8KgIp.useIsoMorphicEffect)(()=>u.register(l), [
        l,
        u.register
    ]);
    let p = {
        id: l,
        ref: n,
        role: "presentation",
        ...u.props
    };
    return (0, $ebRQH.useRender)()({
        ourProps: p,
        theirProps: o,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$dt,
        name: "Menu.Heading"
    });
}
let $c9bfa4e2da6232f7$var$ft = "div";
function $c9bfa4e2da6232f7$var$Tt(e, n) {
    let r = e, l = {
        ref: n,
        role: "separator"
    };
    return (0, $ebRQH.useRender)()({
        ourProps: l,
        theirProps: r,
        slot: {},
        defaultTag: $c9bfa4e2da6232f7$var$ft,
        name: "Menu.Separator"
    });
}
let $c9bfa4e2da6232f7$var$yt = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$nt), $c9bfa4e2da6232f7$export$266a769812832828 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ot), $c9bfa4e2da6232f7$export$15a41fea157b048a = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$it), $c9bfa4e2da6232f7$export$2ce376c2cc3355c8 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ut), $c9bfa4e2da6232f7$export$4b1545b4f2016d26 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$mt), $c9bfa4e2da6232f7$export$ef9631cf12896f8 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$ct), $c9bfa4e2da6232f7$export$1cec7dcdd713e220 = (0, $ebRQH.forwardRefWithAs)($c9bfa4e2da6232f7$var$Tt), $c9bfa4e2da6232f7$export$d9b273488cd8ce6f = Object.assign($c9bfa4e2da6232f7$var$yt, {
    Button: $c9bfa4e2da6232f7$export$266a769812832828,
    Items: $c9bfa4e2da6232f7$export$15a41fea157b048a,
    Item: $c9bfa4e2da6232f7$export$2ce376c2cc3355c8,
    Section: $c9bfa4e2da6232f7$export$4b1545b4f2016d26,
    Heading: $c9bfa4e2da6232f7$export$ef9631cf12896f8,
    Separator: $c9bfa4e2da6232f7$export$1cec7dcdd713e220
});

});
parcelRegister("kd7LS", function(module, exports) {

$parcel$export(module.exports, "useFocusRing", () => $eb6b0cc1c3f8613d$export$4e328f61c538687f);

var $fVRQv = parcelRequire("fVRQv");
var $jexLh = parcelRequire("jexLh");
var $3oYR0 = parcelRequire("3oYR0");

var $acw62 = parcelRequire("acw62");
function $eb6b0cc1c3f8613d$export$4e328f61c538687f(props = {}) {
    let { autoFocus: autoFocus = false, isTextInput: isTextInput, within: within } = props;
    let state = (0, $acw62.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, $fVRQv.isFocusVisible)()
    });
    let [isFocused, setFocused] = (0, $acw62.useState)(false);
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(()=>state.current.isFocused && state.current.isFocusVisible);
    let updateState = (0, $acw62.useCallback)(()=>setFocusVisible(state.current.isFocused && state.current.isFocusVisible), []);
    let onFocusChange = (0, $acw62.useCallback)((isFocused)=>{
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, $fVRQv.useFocusVisibleListener)((isFocusVisible)=>{
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    let { focusProps: focusProps } = (0, $jexLh.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    });
    let { focusWithinProps: focusWithinProps } = (0, $3oYR0.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    });
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}

});
parcelRegister("fVRQv", function(module, exports) {

$parcel$export(module.exports, "isFocusVisible", () => $b995f28c9a72ee4c$export$b9b3dfddab17db27);
$parcel$export(module.exports, "useFocusVisibleListener", () => $b995f28c9a72ee4c$export$ec71b4b83ac08ec3);

var $kvYeA = parcelRequire("kvYeA");
var $fOgJj = parcelRequire("fOgJj");
var $dS2bP = parcelRequire("dS2bP");

var $acw62 = parcelRequire("acw62");

var $bVPQr = parcelRequire("bVPQr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = null;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b995f28c9a72ee4c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $fOgJj.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $dS2bP.isVirtualClick)(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b995f28c9a72ee4c$export$d90243b58daecda7.get((0, $kvYeA.getOwnerWindow)(element))) return;
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b995f28c9a72ee4c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $kvYeA.getOwnerWindow)(element);
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b995f28c9a72ee4c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b995f28c9a72ee4c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b995f28c9a72ee4c$export$d90243b58daecda7.delete(windowObject);
};
function $b995f28c9a72ee4c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $kvYeA.getOwnerDocument)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b995f28c9a72ee4c$export$2f1888112f558a7d();
function $b995f28c9a72ee4c$export$b9b3dfddab17db27() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b995f28c9a72ee4c$export$630ff653c5ada6a9() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality;
}
function $b995f28c9a72ee4c$export$8397ddfc504fdb9a(modality) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b995f28c9a72ee4c$export$98e20ec92f614cfe() {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $bVPQr.useIsSSR)() ? null : modality;
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $kvYeA.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b995f28c9a72ee4c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b995f28c9a72ee4c$export$b9b3dfddab17db27());
    $b995f28c9a72ee4c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b995f28c9a72ee4c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b995f28c9a72ee4c$export$b9b3dfddab17db27());
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}

});
parcelRegister("kvYeA", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", () => $eef56d26e56a84a0$export$b204af158042fbac);
$parcel$export(module.exports, "getOwnerWindow", () => $eef56d26e56a84a0$export$f21a1ffae260145a);
const $eef56d26e56a84a0$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $eef56d26e56a84a0$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $eef56d26e56a84a0$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

});

parcelRegister("fOgJj", function(module, exports) {

$parcel$export(module.exports, "isMac", () => $b82880ba168cba95$export$9ac100e40613ea10);
$parcel$export(module.exports, "isAndroid", () => $b82880ba168cba95$export$a11b0059900ceec8);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$cached(fn) {
    let res = null;
    return ()=>{
        if (res == null) res = fn();
        return res;
    };
}
const $b82880ba168cba95$export$9ac100e40613ea10 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
});
const $b82880ba168cba95$export$186c6964ca17d99 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
});
const $b82880ba168cba95$export$7bef049ce92e4224 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b82880ba168cba95$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
});
const $b82880ba168cba95$export$fedb369cb70207f1 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$186c6964ca17d99() || $b82880ba168cba95$export$7bef049ce92e4224();
});
const $b82880ba168cba95$export$e1865c3bedcd822b = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$export$9ac100e40613ea10() || $b82880ba168cba95$export$fedb369cb70207f1();
});
const $b82880ba168cba95$export$78551043582a6a98 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$b82880ba168cba95$export$6446a186d09e379e();
});
const $b82880ba168cba95$export$6446a186d09e379e = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
});
const $b82880ba168cba95$export$a11b0059900ceec8 = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
});
const $b82880ba168cba95$export$b7d78993b74f766d = $b82880ba168cba95$var$$c87311424ea30a05$var$cached(function() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
});

});

parcelRegister("dS2bP", function(module, exports) {

$parcel$export(module.exports, "isVirtualClick", () => $a192045deeaea2b6$export$60278871457622de);

var $fOgJj = parcelRequire("fOgJj");
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a192045deeaea2b6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $fOgJj.isAndroid)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a192045deeaea2b6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $fOgJj.isAndroid)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}

});

parcelRegister("bVPQr", function(module, exports) {

$parcel$export(module.exports, "useIsSSR", () => $8afd3bdc2bd65163$export$535bd6ca7f90a273);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}

});


parcelRegister("jexLh", function(module, exports) {

$parcel$export(module.exports, "useFocus", () => $e009837ee384a76a$export$f8168d8dd8fd66e6);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");

var $kvYeA = parcelRequire("kvYeA");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e009837ee384a76a$export$f8168d8dd8fd66e6(props) {
    let { isDisabled: isDisabled, onFocus: onFocusProp, onBlur: onBlurProp, onFocusChange: onFocusChange } = props;
    const onBlur = (0, $acw62.useCallback)((e)=>{
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    const onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    const onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        const ownerDocument = (0, $kvYeA.getOwnerDocument)(e.target);
        if (e.target === e.currentTarget && ownerDocument.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}

});
parcelRegister("1s9dc", function(module, exports) {

$parcel$export(module.exports, "useSyntheticBlurEvent", () => $10ef8d441d7454cf$export$715c682d09d639cc);

var $acw62 = parcelRequire("acw62");

var $369I5 = parcelRequire("369I5");
var $4AOPT = parcelRequire("4AOPT");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ class $10ef8d441d7454cf$export$905e7fc544a71f36 {
    isDefaultPrevented() {
        return this.nativeEvent.defaultPrevented;
    }
    preventDefault() {
        this.defaultPrevented = true;
        this.nativeEvent.preventDefault();
    }
    stopPropagation() {
        this.nativeEvent.stopPropagation();
        this.isPropagationStopped = ()=>true;
    }
    isPropagationStopped() {
        return false;
    }
    persist() {}
    constructor(type, nativeEvent){
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
}
function $10ef8d441d7454cf$export$715c682d09d639cc(onBlur) {
    let stateRef = (0, $acw62.useRef)({
        isFocused: false,
        observer: null
    });
    (0, $4AOPT.useLayoutEffect)(()=>{
        const state = stateRef.current;
        return ()=>{
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    let dispatchBlur = (0, $369I5.useEffectEvent)((e)=>{
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, $acw62.useCallback)((e)=>{
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            let target = e.target;
            let onBlurHandler = (e)=>{
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $10ef8d441d7454cf$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(()=>{
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    let relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}

});
parcelRegister("369I5", function(module, exports) {

$parcel$export(module.exports, "useEffectEvent", () => $241976d88b767e6b$export$7f54fc3180508a52);

var $4AOPT = parcelRequire("4AOPT");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $241976d88b767e6b$export$7f54fc3180508a52(fn) {
    const ref = (0, $acw62.useRef)(null);
    (0, $4AOPT.useLayoutEffect)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, $acw62.useCallback)((...args)=>{
        const f = ref.current;
        return f === null || f === void 0 ? void 0 : f(...args);
    }, []);
}

});
parcelRegister("4AOPT", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $3581f530a27f457c$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3581f530a27f457c$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};

});




parcelRegister("3oYR0", function(module, exports) {

$parcel$export(module.exports, "useFocusWithin", () => $27a2d14f8c063b81$export$420e68273165f4ec);

var $1s9dc = parcelRequire("1s9dc");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $27a2d14f8c063b81$export$420e68273165f4ec(props) {
    let { isDisabled: isDisabled, onBlurWithin: onBlurWithin, onFocusWithin: onFocusWithin, onFocusWithinChange: onFocusWithinChange } = props;
    let state = (0, $acw62.useRef)({
        isFocusWithin: false
    });
    let onBlur = (0, $acw62.useCallback)((e)=>{
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    let onSyntheticFocus = (0, $1s9dc.useSyntheticBlurEvent)(onBlur);
    let onFocus = (0, $acw62.useCallback)((e)=>{
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}

});


parcelRegister("6o6B3", function(module, exports) {

$parcel$export(module.exports, "useHover", () => $4a6a19e952a3e910$export$ae780daf29e6d456);

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
let $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount = 0;
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount++;
    return ()=>{
        $4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount--;
        if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $4a6a19e952a3e910$var$$6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $4a6a19e952a3e910$var$$6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $4a6a19e952a3e910$export$ae780daf29e6d456(props) {
    let { onHoverStart: onHoverStart, onHoverChange: onHoverChange, onHoverEnd: onHoverEnd, isDisabled: isDisabled } = props;
    let [isHovered, setHovered] = (0, $acw62.useState)(false);
    let state = (0, $acw62.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, $acw62.useEffect)($4a6a19e952a3e910$var$$6179b936705e76d3$var$setupGlobalTouchEvents, []);
    let { hoverProps: hoverProps, triggerHoverEnd: triggerHoverEnd } = (0, $acw62.useMemo)(()=>{
        let triggerHoverStart = (event, pointerType)=>{
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            let target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        let triggerHoverEnd = (event, pointerType)=>{
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            let target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        let hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = (e)=>{
                if ($4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = ()=>{
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = (e)=>{
                if (!state.ignoreEmulatedMouseEvents && !$4a6a19e952a3e910$var$$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = (e)=>{
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]);
    (0, $acw62.useEffect)(()=>{
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}

});

parcelRegister("cE9hP", function(module, exports) {

$parcel$export(module.exports, "useActivePress", () => $93506c8f84360949$export$73224eeef4bbe873);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");
function $93506c8f84360949$var$E(e) {
    let t = e.width / 2, n = e.height / 2;
    return {
        top: e.clientY - n,
        right: e.clientX + t,
        bottom: e.clientY + n,
        left: e.clientX - t
    };
}
function $93506c8f84360949$var$P(e, t) {
    return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function $93506c8f84360949$export$73224eeef4bbe873({ disabled: e = !1 } = {}) {
    let t = (0, $acw62.useRef)(null), [n, l] = (0, $acw62.useState)(!1), r = (0, $5Ai9V.useDisposables)(), o = (0, $114Mg.useEvent)(()=>{
        t.current = null, l(!1), r.dispose();
    }), f = (0, $114Mg.useEvent)((s)=>{
        if (r.dispose(), t.current === null) {
            t.current = s.currentTarget, l(!0);
            {
                let i = (0, $gxwGc.getOwnerDocument)(s.currentTarget);
                r.addEventListener(i, "pointerup", o, !1), r.addEventListener(i, "pointermove", (c)=>{
                    if (t.current) {
                        let p = $93506c8f84360949$var$E(c);
                        l($93506c8f84360949$var$P(p, t.current.getBoundingClientRect()));
                    }
                }, !1), r.addEventListener(i, "pointercancel", o, !1);
            }
        }
    });
    return {
        pressed: n,
        pressProps: e ? {} : {
            onPointerDown: f,
            onPointerUp: o,
            onClick: o
        }
    };
}

});

parcelRegister("hd1nN", function(module, exports) {

$parcel$export(module.exports, "useDidElementMove", () => $c874b9231cf882e4$export$d0b9dbca977c73d5);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $c874b9231cf882e4$export$d0b9dbca977c73d5(n, t) {
    let e = (0, $acw62.useRef)({
        left: 0,
        top: 0
    });
    if ((0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!t) return;
        let r = t.getBoundingClientRect();
        r && (e.current = r);
    }, [
        n,
        t
    ]), t == null || !n || t === document.activeElement) return !1;
    let o = t.getBoundingClientRect();
    return o.top !== e.current.top || o.left !== e.current.left;
}

});

parcelRegister("dfvrc", function(module, exports) {

$parcel$export(module.exports, "useElementSize", () => $9a550ff5f236cb70$export$2b86bedf890eab8);

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");
function $9a550ff5f236cb70$var$f(e) {
    if (e === null) return {
        width: 0,
        height: 0
    };
    let { width: t, height: r } = e.getBoundingClientRect();
    return {
        width: t,
        height: r
    };
}
function $9a550ff5f236cb70$export$2b86bedf890eab8(e, t = !1) {
    let [r, u] = (0, $acw62.useReducer)(()=>({}), {}), i = (0, $acw62.useMemo)(()=>$9a550ff5f236cb70$var$f(e), [
        e,
        r
    ]);
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let n = new ResizeObserver(u);
        return n.observe(e), ()=>{
            n.disconnect();
        };
    }, [
        e
    ]), t ? {
        width: `${i.width}px`,
        height: `${i.height}px`
    } : i;
}

});

parcelRegister("gm4XX", function(module, exports) {

$parcel$export(module.exports, "useResolveButtonType", () => $be828d8bf9bb25ca$export$53652b2b272efe9c);

var $acw62 = parcelRequire("acw62");
function $be828d8bf9bb25ca$export$53652b2b272efe9c(t, u) {
    return (0, $acw62.useMemo)(()=>{
        var n;
        if (t.type) return t.type;
        let r = (n = t.as) != null ? n : "button";
        if (typeof r == "string" && r.toLowerCase() === "button" || (u == null ? void 0 : u.tagName) === "BUTTON" && !u.hasAttribute("type")) return "button";
    }, [
        t.type,
        t.as,
        u
    ]);
}

});

parcelRegister("jN7sP", function(module, exports) {

$parcel$export(module.exports, "useTextValue", () => $e688621b6eb177ca$export$f6862afd851a1cf4);

var $acw62 = parcelRequire("acw62");

var $dAaur = parcelRequire("dAaur");

var $114Mg = parcelRequire("114Mg");
function $e688621b6eb177ca$export$f6862afd851a1cf4(c) {
    let t = (0, $acw62.useRef)(""), r = (0, $acw62.useRef)("");
    return (0, $114Mg.useEvent)(()=>{
        let e = c.current;
        if (!e) return "";
        let u = e.innerText;
        if (t.current === u) return r.current;
        let n = (0, $dAaur.getTextValue)(e).trim().toLowerCase();
        return t.current = u, r.current = n, n;
    });
}

});
parcelRegister("dAaur", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $9e36c641751eb2c7$export$6ca03cb7b75bfa13);
let $9e36c641751eb2c7$var$a = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function $9e36c641751eb2c7$var$o(e) {
    var r, i;
    let n = (r = e.innerText) != null ? r : "", t = e.cloneNode(!0);
    if (!(t instanceof HTMLElement)) return n;
    let u = !1;
    for (let f of t.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))f.remove(), u = !0;
    let l = u ? (i = t.innerText) != null ? i : "" : n;
    return $9e36c641751eb2c7$var$a.test(l) && (l = l.replace($9e36c641751eb2c7$var$a, "")), l;
}
function $9e36c641751eb2c7$export$6ca03cb7b75bfa13(e) {
    let n = e.getAttribute("aria-label");
    if (typeof n == "string") return n.trim();
    let t = e.getAttribute("aria-labelledby");
    if (t) {
        let u = t.split(" ").map((l)=>{
            let r = document.getElementById(l);
            if (r) {
                let i = r.getAttribute("aria-label");
                return typeof i == "string" ? i.trim() : $9e36c641751eb2c7$var$o(r).trim();
            }
            return null;
        }).filter(Boolean);
        if (u.length > 0) return u.join(", ");
    }
    return $9e36c641751eb2c7$var$o(e).trim();
}

});


parcelRegister("ipity", function(module, exports) {

$parcel$export(module.exports, "useTrackedPointer", () => $d668e4b1d0c2f85c$export$24ebee078bde85c3);

var $acw62 = parcelRequire("acw62");
function $d668e4b1d0c2f85c$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $d668e4b1d0c2f85c$export$24ebee078bde85c3() {
    let e = (0, $acw62.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $d668e4b1d0c2f85c$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $d668e4b1d0c2f85c$var$t(r);
        }
    };
}

});

parcelRegister("1nOiu", function(module, exports) {

$parcel$export(module.exports, "useTreeWalker", () => $101ef4628501ab0d$export$b0abce39eb34b36);

var $acw62 = parcelRequire("acw62");

var $gxwGc = parcelRequire("gxwGc");

var $8KgIp = parcelRequire("8KgIp");
function $101ef4628501ab0d$export$b0abce39eb34b36(c, { container: e, accept: t, walk: r }) {
    let o = (0, $acw62.useRef)(t), l = (0, $acw62.useRef)(r);
    (0, $acw62.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e || !c) return;
        let n = (0, $gxwGc.getOwnerDocument)(e);
        if (!n) return;
        let f = o.current, p = l.current, i = Object.assign((m)=>f(m), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, i, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}

});

parcelRegister("34Str", function(module, exports) {

$parcel$export(module.exports, "useResolvedAnchor", () => $23dc003753f08df2$export$ee5342e485f0bdb0);
$parcel$export(module.exports, "useFloatingReference", () => $23dc003753f08df2$export$916a28f343467e85);
$parcel$export(module.exports, "useFloatingReferenceProps", () => $23dc003753f08df2$export$c7931d5027a8ead4);
$parcel$export(module.exports, "useFloatingPanelProps", () => $23dc003753f08df2$export$106e71f938eae412);
$parcel$export(module.exports, "useFloatingPanel", () => $23dc003753f08df2$export$aff4be9ef2a28e43);
$parcel$export(module.exports, "FloatingProvider", () => $23dc003753f08df2$export$e473aa84737d3250);

var $618j3 = parcelRequire("618j3");
var $kYdT9 = parcelRequire("kYdT9");
var $hgsFP = parcelRequire("hgsFP");
var $kYdT9 = parcelRequire("kYdT9");

var $acw62 = parcelRequire("acw62");

var $5Ai9V = parcelRequire("5Ai9V");

var $114Mg = parcelRequire("114Mg");

var $8KgIp = parcelRequire("8KgIp");
let $23dc003753f08df2$var$y = (0, $acw62.createContext)({
    styles: void 0,
    setReference: ()=>{},
    setFloating: ()=>{},
    getReferenceProps: ()=>({}),
    getFloatingProps: ()=>({}),
    slot: {}
});
$23dc003753f08df2$var$y.displayName = "FloatingContext";
let $23dc003753f08df2$var$H = (0, $acw62.createContext)(null);
$23dc003753f08df2$var$H.displayName = "PlacementContext";
function $23dc003753f08df2$export$ee5342e485f0bdb0(e) {
    return (0, $acw62.useMemo)(()=>e ? typeof e == "string" ? {
            to: e
        } : e : null, [
        e
    ]);
}
function $23dc003753f08df2$export$916a28f343467e85() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).setReference;
}
function $23dc003753f08df2$export$c7931d5027a8ead4() {
    return (0, $acw62.useContext)($23dc003753f08df2$var$y).getReferenceProps;
}
function $23dc003753f08df2$export$106e71f938eae412() {
    let { getFloatingProps: e, slot: t } = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useCallback)((...n)=>Object.assign({}, e(...n), {
            "data-anchor": t.anchor
        }), [
        e,
        t
    ]);
}
function $23dc003753f08df2$export$aff4be9ef2a28e43(e = null) {
    e === !1 && (e = null), typeof e == "string" && (e = {
        to: e
    });
    let t = (0, $acw62.useContext)($23dc003753f08df2$var$H), n = (0, $acw62.useMemo)(()=>e, [
        JSON.stringify(e, (r, o)=>{
            var u;
            return (u = o == null ? void 0 : o.outerHTML) != null ? u : o;
        })
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        t == null || t(n != null ? n : null);
    }, [
        t,
        n
    ]);
    let l = (0, $acw62.useContext)($23dc003753f08df2$var$y);
    return (0, $acw62.useMemo)(()=>[
            l.setFloating,
            e ? l.styles : {}
        ], [
        l.setFloating,
        e,
        l.styles
    ]);
}
let $23dc003753f08df2$var$q = 4;
function $23dc003753f08df2$export$e473aa84737d3250({ children: e, enabled: t = !0 }) {
    let [n, l] = (0, $acw62.useState)(null), [r, o] = (0, $acw62.useState)(0), u = (0, $acw62.useRef)(null), [f, s] = (0, $acw62.useState)(null);
    $23dc003753f08df2$var$pe(f);
    let i = t && n !== null && f !== null, { to: F = "bottom", gap: E = 0, offset: v = 0, padding: c = 0, inner: P } = $23dc003753f08df2$var$ce(n, f), [a, p = "center"] = F.split(" ");
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        i && o(0);
    }, [
        i
    ]);
    let { refs: b, floatingStyles: w, context: g } = (0, $hgsFP.useFloating)({
        open: i,
        placement: a === "selection" ? p === "center" ? "bottom" : `bottom-${p}` : p === "center" ? `${a}` : `${a}-${p}`,
        strategy: "absolute",
        transform: !1,
        middleware: [
            (0, $kYdT9.offset)({
                mainAxis: a === "selection" ? 0 : E,
                crossAxis: v
            }),
            (0, $kYdT9.shift)({
                padding: c
            }),
            a !== "selection" && (0, $kYdT9.flip)({
                padding: c
            }),
            a === "selection" && P ? (0, $hgsFP.inner)({
                ...P,
                padding: c,
                overflowRef: u,
                offset: r,
                minItemsVisible: $23dc003753f08df2$var$q,
                referenceOverflowThreshold: c,
                onFallbackChange (h) {
                    var O, W;
                    if (!h) return;
                    let d = g.elements.floating;
                    if (!d) return;
                    let T = parseFloat(getComputedStyle(d).scrollPaddingBottom) || 0, $ = Math.min($23dc003753f08df2$var$q, d.childElementCount), L = 0, N = 0;
                    for (let m of (W = (O = g.elements.floating) == null ? void 0 : O.childNodes) != null ? W : [])if (m instanceof HTMLElement) {
                        let x = m.offsetTop, k = x + m.clientHeight + T, S = d.scrollTop, U = S + d.clientHeight;
                        if (x >= S && k <= U) $--;
                        else {
                            N = Math.max(0, Math.min(k, U) - Math.max(x, S)), L = m.clientHeight;
                            break;
                        }
                    }
                    $ >= 1 && o((m)=>{
                        let x = L * $ - N + T;
                        return m >= x ? m : x;
                    });
                }
            }) : null,
            (0, $kYdT9.size)({
                padding: c,
                apply ({ availableWidth: h, availableHeight: d, elements: T }) {
                    Object.assign(T.floating.style, {
                        overflow: "auto",
                        maxWidth: `${h}px`,
                        maxHeight: `min(var(--anchor-max-height, 100vh), ${d}px)`
                    });
                }
            })
        ].filter(Boolean),
        whileElementsMounted: (0, $618j3.autoUpdate)
    }), [I = a, B = p] = g.placement.split("-");
    a === "selection" && (I = "selection");
    let G = (0, $acw62.useMemo)(()=>({
            anchor: [
                I,
                B
            ].filter(Boolean).join(" ")
        }), [
        I,
        B
    ]), K = (0, $hgsFP.useInnerOffset)(g, {
        overflowRef: u,
        onChange: o
    }), { getReferenceProps: Q, getFloatingProps: X } = (0, $hgsFP.useInteractions)([
        K
    ]), Y = (0, $114Mg.useEvent)((h)=>{
        s(h), b.setFloating(h);
    });
    return $acw62.createElement($23dc003753f08df2$var$H.Provider, {
        value: l
    }, $acw62.createElement($23dc003753f08df2$var$y.Provider, {
        value: {
            setFloating: Y,
            setReference: b.setReference,
            styles: w,
            getReferenceProps: Q,
            getFloatingProps: X,
            slot: G
        }
    }, e));
}
function $23dc003753f08df2$var$pe(e) {
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e) return;
        let t = new MutationObserver(()=>{
            let n = window.getComputedStyle(e).maxHeight, l = parseFloat(n);
            if (isNaN(l)) return;
            let r = parseInt(n);
            isNaN(r) || l !== r && (e.style.maxHeight = `${Math.ceil(l)}px`);
        });
        return t.observe(e, {
            attributes: !0,
            attributeFilter: [
                "style"
            ]
        }), ()=>{
            t.disconnect();
        };
    }, [
        e
    ]);
}
function $23dc003753f08df2$var$ce(e, t) {
    var o, u, f;
    let n = $23dc003753f08df2$var$V((o = e == null ? void 0 : e.gap) != null ? o : "var(--anchor-gap, 0)", t), l = $23dc003753f08df2$var$V((u = e == null ? void 0 : e.offset) != null ? u : "var(--anchor-offset, 0)", t), r = $23dc003753f08df2$var$V((f = e == null ? void 0 : e.padding) != null ? f : "var(--anchor-padding, 0)", t);
    return {
        ...e,
        gap: n,
        offset: l,
        padding: r
    };
}
function $23dc003753f08df2$var$V(e, t, n) {
    let l = (0, $5Ai9V.useDisposables)(), r = (0, $114Mg.useEvent)((s, i)=>{
        if (s == null) return [
            n,
            null
        ];
        if (typeof s == "number") return [
            s,
            null
        ];
        if (typeof s == "string") {
            if (!i) return [
                n,
                null
            ];
            let F = $23dc003753f08df2$var$J(s, i);
            return [
                F,
                (E)=>{
                    let v = $23dc003753f08df2$var$D(s);
                    {
                        let c = v.map((P)=>window.getComputedStyle(i).getPropertyValue(P));
                        l.requestAnimationFrame(function P() {
                            l.nextFrame(P);
                            let a = !1;
                            for (let [b, w] of v.entries()){
                                let g = window.getComputedStyle(i).getPropertyValue(w);
                                if (c[b] !== g) {
                                    c[b] = g, a = !0;
                                    break;
                                }
                            }
                            if (!a) return;
                            let p = $23dc003753f08df2$var$J(s, i);
                            F !== p && (E(p), F = p);
                        });
                    }
                    return l.dispose;
                }
            ];
        }
        return [
            n,
            null
        ];
    }), o = (0, $acw62.useMemo)(()=>r(e, t)[0], [
        e,
        t
    ]), [u = o, f] = (0, $acw62.useState)();
    return (0, $8KgIp.useIsoMorphicEffect)(()=>{
        let [s, i] = r(e, t);
        if (f(s), !!i) return i(f);
    }, [
        e,
        t
    ]), u;
}
function $23dc003753f08df2$var$D(e) {
    let t = /var\((.*)\)/.exec(e);
    if (t) {
        let n = t[1].indexOf(",");
        if (n === -1) return [
            t[1]
        ];
        let l = t[1].slice(0, n).trim(), r = t[1].slice(n + 1).trim();
        return r ? [
            l,
            ...$23dc003753f08df2$var$D(r)
        ] : [
            l
        ];
    }
    return [];
}
function $23dc003753f08df2$var$J(e, t) {
    let n = document.createElement("div");
    t.appendChild(n), n.style.setProperty("margin-top", "0px", "important"), n.style.setProperty("margin-top", e, "important");
    let l = parseFloat(window.getComputedStyle(n).marginTop) || 0;
    return t.removeChild(n), l;
}

});
parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $461947879dcdbcd4$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $461947879dcdbcd4$export$cc800923e997bb8);
$parcel$export(module.exports, "autoPlacement", () => $461947879dcdbcd4$export$91fb6ecbd551914);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "hide", () => $461947879dcdbcd4$export$fe8985bb6374093c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $461947879dcdbcd4$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === "rtl") x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === "fixed" || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== "body" || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === "static";
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === "rtl";
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === "left";
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $238ac70369f38756$export$af51f0f06c0f328a);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== "undefined";
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($238ac70369f38756$export$651544f548703224(element));
}
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("kYdT9", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $f4442f36a78bf363$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "offset", () => $f4442f36a78bf363$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $f4442f36a78bf363$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $f4442f36a78bf363$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $f4442f36a78bf363$export$346677f925de839c);

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $f4442f36a78bf363$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f4442f36a78bf363$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f4442f36a78bf363$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f4442f36a78bf363$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f4442f36a78bf363$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f4442f36a78bf363$var$roundByDPR(element, value) {
    const dpr = $f4442f36a78bf363$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f4442f36a78bf363$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $f4442f36a78bf363$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $f4442f36a78bf363$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$f4442f36a78bf363$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $acw62.useState(null);
    const [_floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $f4442f36a78bf363$var$useLatestRef(whileElementsMounted);
    const platformRef = $f4442f36a78bf363$var$useLatestRef(platform);
    const openRef = $f4442f36a78bf363$var$useLatestRef(open);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$f4442f36a78bf363$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $f4442f36a78bf363$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $f4442f36a78bf363$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f4442f36a78bf363$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $acw62.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f4442f36a78bf363$var$roundByDPR(elements.floating, data.x);
        const y = $f4442f36a78bf363$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f4442f36a78bf363$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f4442f36a78bf363$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f4442f36a78bf363$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $618j3.offset)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f4442f36a78bf363$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $618j3.shift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f4442f36a78bf363$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $618j3.limitShift)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f4442f36a78bf363$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $618j3.flip)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f4442f36a78bf363$export$346677f925de839c = (options, deps)=>({
        ...(0, $618j3.size)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f4442f36a78bf363$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $618j3.autoPlacement)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f4442f36a78bf363$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $618j3.hide)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f4442f36a78bf363$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $618j3.inline)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f4442f36a78bf363$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$f4442f36a78bf363$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });

});

parcelRegister("hgsFP", function(module, exports) {

$parcel$export(module.exports, "useFloating", () => $c91a2c4695b36516$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useInteractions", () => $c91a2c4695b36516$export$a519f7794e446ddd);
$parcel$export(module.exports, "inner", () => $c91a2c4695b36516$export$4ae363f1d88fb658);
$parcel$export(module.exports, "useInnerOffset", () => $c91a2c4695b36516$export$3d74b0dda7cc82ff);
$parcel$export(module.exports, "offset", () => (parcelRequire("kYdT9")).offset);

var $acw62 = parcelRequire("acw62");

var $2Yoyg = parcelRequire("2Yoyg");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");

var $e8HHX = parcelRequire("e8HHX");

var $1u0KT = parcelRequire("1u0KT");

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");
var $kYdT9 = parcelRequire("kYdT9");
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $c91a2c4695b36516$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === "function") ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $c91a2c4695b36516$var$SafeReact = {
    ...$acw62
};
const $c91a2c4695b36516$var$useInsertionEffect = $c91a2c4695b36516$var$SafeReact.useInsertionEffect;
const $c91a2c4695b36516$var$useSafeInsertionEffect = $c91a2c4695b36516$var$useInsertionEffect || ((fn)=>fn());
function $c91a2c4695b36516$var$useEffectEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $c91a2c4695b36516$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
const $c91a2c4695b36516$var$ARROW_UP = "ArrowUp";
const $c91a2c4695b36516$var$ARROW_DOWN = "ArrowDown";
const $c91a2c4695b36516$var$ARROW_LEFT = "ArrowLeft";
const $c91a2c4695b36516$var$ARROW_RIGHT = "ArrowRight";
function $c91a2c4695b36516$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $c91a2c4695b36516$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $c91a2c4695b36516$var$getMinIndex(listRef, disabledIndices) {
    return $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $c91a2c4695b36516$var$getMaxIndex(listRef, disabledIndices) {
    return $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $c91a2c4695b36516$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && $c91a2c4695b36516$var$isDisabled(list, index, disabledIndices));
    return index;
}
function $c91a2c4695b36516$var$getGridNavigatedIndex(elementsRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $c91a2c4695b36516$var$ARROW_UP) {
        stop && (0, $2Yoyg.stopEvent)(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($c91a2c4695b36516$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $c91a2c4695b36516$var$ARROW_DOWN) {
        stop && (0, $2Yoyg.stopEvent)(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($c91a2c4695b36516$var$isIndexOutOfBounds(elementsRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === "both") {
        const prevRow = (0, $1obCQ.floor)(prevIndex / cols);
        if (event.key === $c91a2c4695b36516$var$ARROW_RIGHT) {
            stop && (0, $2Yoyg.stopEvent)(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $c91a2c4695b36516$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($c91a2c4695b36516$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === $c91a2c4695b36516$var$ARROW_LEFT) {
            stop && (0, $2Yoyg.stopEvent)(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $c91a2c4695b36516$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($c91a2c4695b36516$var$isDifferentRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $1obCQ.floor)(maxIndex / cols) === prevRow;
        if ($c91a2c4695b36516$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === $c91a2c4695b36516$var$ARROW_LEFT ? maxIndex : $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $c91a2c4695b36516$var$buildCellMap(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $c91a2c4695b36516$var$getCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $c91a2c4695b36516$var$getCellIndices(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $c91a2c4695b36516$var$isDisabled(list, index, disabledIndices) {
    if (disabledIndices) return disabledIndices.includes(index);
    const element = list[index];
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
let $c91a2c4695b36516$var$rafId = 0;
function $c91a2c4695b36516$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($c91a2c4695b36516$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $c91a2c4695b36516$var$rafId = requestAnimationFrame(exec);
}
var $c91a2c4695b36516$var$index = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $c91a2c4695b36516$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
function $c91a2c4695b36516$var$areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) return false;
    for (const [key, value] of map1.entries()){
        if (value !== map2.get(key)) return false;
    }
    return true;
}
const $c91a2c4695b36516$var$FloatingListContext = /*#__PURE__*/ $acw62.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $c91a2c4695b36516$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [map, setMap] = $acw62.useState(()=>new Map());
    const register = $acw62.useCallback((node)=>{
        setMap((prevMap)=>new Map(prevMap).set(node, null));
    }, []);
    const unregister = $acw62.useCallback((node)=>{
        setMap((prevMap)=>{
            const map = new Map(prevMap);
            map.delete(node);
            return map;
        });
    }, []);
    $c91a2c4695b36516$var$index(()=>{
        const newMap = new Map(map);
        const nodes = Array.from(newMap.keys()).sort($c91a2c4695b36516$var$sortByDocumentPosition);
        nodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        if (!$c91a2c4695b36516$var$areMapsEqual(map, newMap)) setMap(newMap);
    }, [
        map
    ]);
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FloatingListContext.Provider, {
        value: $acw62.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ])
    }, children);
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $c91a2c4695b36516$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $acw62.useContext($c91a2c4695b36516$var$FloatingListContext);
    const [index$1, setIndex] = $acw62.useState(null);
    const componentRef = $acw62.useRef(null);
    const ref = $acw62.useCallback((node)=>{
        componentRef.current = node;
        if (index$1 !== null) {
            elementsRef.current[index$1] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index$1] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index$1,
        elementsRef,
        labelsRef,
        label
    ]);
    $c91a2c4695b36516$var$index(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    $c91a2c4695b36516$var$index(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $acw62.useMemo(()=>({
            ref: ref,
            index: index$1 == null ? -1 : index$1
        }), [
        index$1,
        ref
    ]);
}
function $c91a2c4695b36516$var$renderJsx(render, computedProps) {
    if (typeof render === "function") return render(computedProps);
    if (render) return /*#__PURE__*/ $acw62.cloneElement(render, computedProps);
    return /*#__PURE__*/ $acw62.createElement("div", computedProps);
}
const $c91a2c4695b36516$var$CompositeContext = /*#__PURE__*/ $acw62.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $c91a2c4695b36516$var$horizontalKeys = [
    $c91a2c4695b36516$var$ARROW_LEFT,
    $c91a2c4695b36516$var$ARROW_RIGHT
];
const $c91a2c4695b36516$var$verticalKeys = [
    $c91a2c4695b36516$var$ARROW_UP,
    $c91a2c4695b36516$var$ARROW_DOWN
];
const $c91a2c4695b36516$var$allKeys = [
    ...$c91a2c4695b36516$var$horizontalKeys,
    ...$c91a2c4695b36516$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $c91a2c4695b36516$export$43586241d9db0c6d = /*#__PURE__*/ $acw62.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = "both", loop: loop = true, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false, ...domProps } = props;
    const [internalActiveIndex, internalSetActiveIndex] = $acw62.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = $c91a2c4695b36516$var$useEffectEvent(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $acw62.useRef([]);
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const contextValue = $acw62.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$c91a2c4695b36516$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = $c91a2c4695b36516$var$getMinIndex(elementsRef, disabledIndices);
        const maxIndex = $c91a2c4695b36516$var$getMaxIndex(elementsRef, disabledIndices);
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $c91a2c4695b36516$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$c91a2c4695b36516$var$isDisabled(elementsRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$c91a2c4695b36516$var$isDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[$c91a2c4695b36516$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $c91a2c4695b36516$var$getCellIndices([
                    ...disabledIndices || elementsRef.current.map((_, index)=>$c91a2c4695b36516$var$isDisabled(elementsRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $c91a2c4695b36516$var$getCellIndexOfCorner(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $c91a2c4695b36516$var$ARROW_DOWN ? "bl" : event.key === $c91a2c4695b36516$var$ARROW_RIGHT ? "tr" : "tl")
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                $c91a2c4695b36516$var$ARROW_RIGHT
            ],
            vertical: [
                $c91a2c4695b36516$var$ARROW_DOWN
            ],
            both: [
                $c91a2c4695b36516$var$ARROW_RIGHT,
                $c91a2c4695b36516$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                $c91a2c4695b36516$var$ARROW_LEFT
            ],
            vertical: [
                $c91a2c4695b36516$var$ARROW_UP
            ],
            both: [
                $c91a2c4695b36516$var$ARROW_LEFT,
                $c91a2c4695b36516$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $c91a2c4695b36516$var$allKeys : ({
            horizontal: $c91a2c4695b36516$var$horizontalKeys,
            vertical: $c91a2c4695b36516$var$verticalKeys,
            both: $c91a2c4695b36516$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = $c91a2c4695b36516$var$findNonDisabledIndex(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !$c91a2c4695b36516$var$isIndexOutOfBounds(elementsRef, nextIndex)) {
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            // Wait for FocusManager `returnFocus` to execute.
            queueMicrotask(()=>{
                $c91a2c4695b36516$var$enqueueFocus(elementsRef.current[nextIndex]);
            });
        }
    }
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: forwardedRef,
        "aria-orientation": orientation === "both" ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    };
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$CompositeContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$export$ffe15b0e64951704, {
        elementsRef: elementsRef
    }, $c91a2c4695b36516$var$renderJsx(render, computedProps)));
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $c91a2c4695b36516$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $acw62.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render, ...domProps } = props;
    const renderElementProps = render && typeof render !== "function" ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $acw62.useContext($c91a2c4695b36516$var$CompositeContext);
    const { ref: ref, index: index } = $c91a2c4695b36516$export$dcdc7ff5149f7d1a();
    const mergedRef = $c91a2c4695b36516$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = {
        ...domProps,
        ...renderElementProps,
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        "data-active": isActive ? "" : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    };
    return $c91a2c4695b36516$var$renderJsx(render, computedProps);
});
function $c91a2c4695b36516$var$_extends() {
    $c91a2c4695b36516$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c91a2c4695b36516$var$_extends.apply(this, arguments);
}
let $c91a2c4695b36516$var$serverHandoffComplete = false;
let $c91a2c4695b36516$var$count = 0;
const $c91a2c4695b36516$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $c91a2c4695b36516$var$count++;
function $c91a2c4695b36516$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$c91a2c4695b36516$var$serverHandoffComplete ? $c91a2c4695b36516$var$genId() : undefined);
    $c91a2c4695b36516$var$index(()=>{
        if (id == null) setId($c91a2c4695b36516$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        $c91a2c4695b36516$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $c91a2c4695b36516$var$useReactId = $c91a2c4695b36516$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $c91a2c4695b36516$export$f680877a34711e37 = $c91a2c4695b36516$var$useReactId || $c91a2c4695b36516$var$useFloatingId;
let $c91a2c4695b36516$var$devMessageSet;
function $c91a2c4695b36516$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet = $c91a2c4695b36516$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $c91a2c4695b36516$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $c91a2c4695b36516$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(" ");
    if (!((_devMessageSet3 = $c91a2c4695b36516$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $c91a2c4695b36516$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $c91a2c4695b36516$export$33511391554732bc = /*#__PURE__*/ $acw62.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform, ...restStyle } = {}, ...rest } = props;
    const clipPathId = $c91a2c4695b36516$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $acw62.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    $c91a2c4695b36516$var$index(()=>{
        if (!floating) return;
        const isRTL = (0, $33bLr.getComputedStyle)(floating).direction === "rtl";
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split("-");
    const isVerticalSide = side === "top" || side === "bottom";
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
    let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === "end" ? "left" : "right";
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : "";
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : "";
    const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
    const rotation = {
        top: isCustomShape ? "rotate(180deg)" : "",
        left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
        bottom: isCustomShape ? "" : "rotate(180deg)",
        right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
    }[side];
    return /*#__PURE__*/ $acw62.createElement("svg", $c91a2c4695b36516$var$_extends({}, rest, {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: {
            position: "absolute",
            pointerEvents: "none",
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(" "),
            ...restStyle
        }
    }), computedStrokeWidth > 0 && /*#__PURE__*/ $acw62.createElement("path", {
        clipPath: "url(#" + clipPathId + ")",
        fill: "none",
        stroke: stroke,
        strokeWidth: computedStrokeWidth + (d ? 0 : 1),
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("path", {
        stroke: computedStrokeWidth && !d ? rest.fill : "none",
        d: dValue
    }), /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + computedStrokeWidth,
        height: width
    })));
});
function $c91a2c4695b36516$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            var _map$get2;
            map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l)=>l !== listener)) || []);
        }
    };
}
const $c91a2c4695b36516$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $c91a2c4695b36516$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $c91a2c4695b36516$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($c91a2c4695b36516$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $c91a2c4695b36516$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($c91a2c4695b36516$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c91a2c4695b36516$export$9b136e0e758a42f4(customParentId) {
    const id = $c91a2c4695b36516$export$f680877a34711e37();
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    const reactParentId = $c91a2c4695b36516$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $c91a2c4695b36516$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c91a2c4695b36516$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $c91a2c4695b36516$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $c91a2c4695b36516$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$c91a2c4695b36516$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ])
    }, children);
}
function $c91a2c4695b36516$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $c91a2c4695b36516$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $c91a2c4695b36516$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $c91a2c4695b36516$var$safePolygonIdentifier = /*#__PURE__*/ $c91a2c4695b36516$var$createAttribute("safe-polygon");
function $c91a2c4695b36516$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $2Yoyg.isMouseLikePointerType)(pointerType)) return 0;
    if (typeof value === "number") return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $c91a2c4695b36516$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    const parentId = $c91a2c4695b36516$export$165209eae06d3488();
    const handleCloseRef = $c91a2c4695b36516$var$useLatestRef(handleClose);
    const delayRef = $c91a2c4695b36516$var$useLatestRef(delay);
    const openRef = $c91a2c4695b36516$var$useLatestRef(open);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef(-1);
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef(-1);
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
    }, [
        dataRef
    ]);
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                clearTimeout(timeoutRef.current);
                clearTimeout(restTimeoutRef.current);
                blockMouseMoveRef.current = true;
            }
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, "hover");
        }
        const html = (0, $2Yoyg.getDocument)(elements.floating).documentElement;
        html.addEventListener("mouseleave", onLeave);
        return ()=>{
            html.removeEventListener("mouseleave", onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = "hover";
        const closeDelay = $c91a2c4695b36516$var$getDelay(delayRef.current, "close", pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $c91a2c4695b36516$var$useEffectEvent(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = $c91a2c4695b36516$var$useEffectEvent(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $2Yoyg.getDocument)(elements.floating).body;
            body.style.pointerEvents = "";
            body.removeAttribute($c91a2c4695b36516$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                "click",
                "mousedown"
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $2Yoyg.isMouseLikePointerType)(pointerTypeRef.current) || restMs > 0 && !$c91a2c4695b36516$var$getDelay(delayRef.current, "open")) return;
            const openDelay = $c91a2c4695b36516$var$getDelay(delayRef.current, "open", pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, "hover");
            }, openDelay);
            else onOpenChange(true, event, "hover");
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = (0, $2Yoyg.getDocument)(elements.floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...dataRef.current.floatingContext,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay(event, true, "safe-polygon");
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener("mousemove", handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener("mousemove", handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === "touch" ? !(0, $2Yoyg.contains)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...dataRef.current.floatingContext,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay(event);
                }
            })(event);
        }
        if ((0, $33bLr.isElement)(elements.domReference)) {
            var _elements$floating;
            const ref = elements.domReference;
            open && ref.addEventListener("mouseleave", onScrollMouseLeave);
            (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
            move && ref.addEventListener("mousemove", onMouseEnter, {
                once: true
            });
            ref.addEventListener("mouseenter", onMouseEnter);
            ref.addEventListener("mouseleave", onMouseLeave);
            return ()=>{
                var _elements$floating2;
                open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
                (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
                move && ref.removeEventListener("mousemove", onMouseEnter);
                ref.removeEventListener("mouseenter", onMouseEnter);
                ref.removeEventListener("mouseleave", onMouseLeave);
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $c91a2c4695b36516$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $33bLr.isElement)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $2Yoyg.getDocument)(elements.floating).body;
                body.setAttribute($c91a2c4695b36516$var$safePolygonIdentifier, "");
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = "";
                body.style.pointerEvents = "none";
                ref.style.pointerEvents = "auto";
                floatingEl.style.pointerEvents = "auto";
                return ()=>{
                    body.style.pointerEvents = "";
                    ref.style.pointerEvents = "";
                    floatingEl.style.pointerEvents = "";
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, "hover");
                }
                if (mouseOnly && !(0, $2Yoyg.isMouseLikePointerType)(pointerTypeRef.current)) return;
                if (open || restMs === 0) return;
                clearTimeout(restTimeoutRef.current);
                if (pointerTypeRef.current === "touch") handleMouseMove();
                else restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMs
    ]);
    const floating = $acw62.useMemo(()=>({
            onMouseEnter () {
                clearTimeout(timeoutRef.current);
            },
            onMouseLeave (event) {
                closeWithDelay(event.nativeEvent, false);
            }
        }), [
        closeWithDelay
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
const $c91a2c4695b36516$var$NOOP = ()=>{};
const $c91a2c4695b36516$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $c91a2c4695b36516$var$NOOP,
    setState: $c91a2c4695b36516$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $c91a2c4695b36516$export$e2411914b150383d = ()=>$acw62.useContext($c91a2c4695b36516$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $c91a2c4695b36516$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $c91a2c4695b36516$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ])
    }, children);
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $c91a2c4695b36516$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $c91a2c4695b36516$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    $c91a2c4695b36516$var$index(()=>{
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $c91a2c4695b36516$var$getDelay(initialDelay, "close")
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $c91a2c4695b36516$var$index(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (setCurrentId === $c91a2c4695b36516$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
function $c91a2c4695b36516$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $c91a2c4695b36516$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    });
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        });
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $c91a2c4695b36516$var$getDeepestNode(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $c91a2c4695b36516$var$getChildren(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
let $c91a2c4695b36516$var$counterMap = /*#__PURE__*/ new WeakMap();
let $c91a2c4695b36516$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $c91a2c4695b36516$var$markerMap = {};
let $c91a2c4695b36516$var$lockCount$1 = 0;
const $c91a2c4695b36516$var$supportsInert = ()=>typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
const $c91a2c4695b36516$var$unwrapHost = (node)=>node && (node.host || $c91a2c4695b36516$var$unwrapHost(node.parentNode));
const $c91a2c4695b36516$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $c91a2c4695b36516$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $c91a2c4695b36516$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = "data-floating-ui-inert";
    const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    const avoidElements = $c91a2c4695b36516$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$c91a2c4695b36516$var$markerMap[markerName]) $c91a2c4695b36516$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $c91a2c4695b36516$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $33bLr.getNodeName)(node) === "script") return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== "false";
                const counterValue = ($c91a2c4695b36516$var$counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                $c91a2c4695b36516$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $c91a2c4695b36516$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, "");
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, "true");
            }
        });
    }
    $c91a2c4695b36516$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterValue = ($c91a2c4695b36516$var$counterMap.get(element) || 0) - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            $c91a2c4695b36516$var$counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$c91a2c4695b36516$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $c91a2c4695b36516$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $c91a2c4695b36516$var$lockCount$1--;
        if (!$c91a2c4695b36516$var$lockCount$1) {
            $c91a2c4695b36516$var$counterMap = new WeakMap();
            $c91a2c4695b36516$var$counterMap = new WeakMap();
            $c91a2c4695b36516$var$uncontrolledElementsSet = new WeakSet();
            $c91a2c4695b36516$var$markerMap = {};
        }
    };
}
function $c91a2c4695b36516$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = (0, $2Yoyg.getDocument)(avoidElements[0]).body;
    return $c91a2c4695b36516$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
const $c91a2c4695b36516$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
    });
function $c91a2c4695b36516$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $e8HHX.tabbable)(container, $c91a2c4695b36516$var$getTabbableOptions());
    if (direction === "prev") allTabbable.reverse();
    const activeIndex = allTabbable.indexOf((0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $c91a2c4695b36516$var$getNextTabbable() {
    return $c91a2c4695b36516$var$getTabbableIn(document.body, "next");
}
function $c91a2c4695b36516$var$getPreviousTabbable() {
    return $c91a2c4695b36516$var$getTabbableIn(document.body, "prev");
}
function $c91a2c4695b36516$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !(0, $2Yoyg.contains)(containerElement, relatedTarget);
}
function $c91a2c4695b36516$var$disableFocusInside(container) {
    const tabbableElements = (0, $e8HHX.tabbable)(container, $c91a2c4695b36516$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function $c91a2c4695b36516$var$enableFocusInside(container) {
    const elements = container.querySelectorAll("[data-tabindex]");
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $c91a2c4695b36516$var$HIDDEN_STYLES = {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "fixed",
    whiteSpace: "nowrap",
    width: "1px",
    top: 0,
    left: 0
};
let $c91a2c4695b36516$var$timeoutId;
function $c91a2c4695b36516$var$setActiveElementOnTab(event) {
    if (event.key === "Tab") {
        event.target;
        clearTimeout($c91a2c4695b36516$var$timeoutId);
    }
}
const $c91a2c4695b36516$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $acw62.useState();
    $c91a2c4695b36516$var$index(()=>{
        if ((0, $2Yoyg.isSafari)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole("button");
        document.addEventListener("keydown", $c91a2c4695b36516$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener("keydown", $c91a2c4695b36516$var$setActiveElementOnTab);
        };
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        "aria-hidden": role ? undefined : true,
        [$c91a2c4695b36516$var$createAttribute("focus-guard")]: "",
        style: $c91a2c4695b36516$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ $acw62.createElement("span", $c91a2c4695b36516$var$_extends({}, props, restProps));
});
const $c91a2c4695b36516$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $c91a2c4695b36516$var$attr = /*#__PURE__*/ $c91a2c4695b36516$var$createAttribute("portal");
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $c91a2c4695b36516$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $c91a2c4695b36516$export$f680877a34711e37();
    const portalContext = $c91a2c4695b36516$var$usePortalContext();
    const [portalNode, setPortalNode] = $acw62.useState(null);
    const portalNodeRef = $acw62.useRef(null);
    $c91a2c4695b36516$var$index(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    $c91a2c4695b36516$var$index(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($c91a2c4695b36516$var$attr, "");
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $33bLr.isElement)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement("div");
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement("div");
        subRoot.id = uniqueId;
        subRoot.setAttribute($c91a2c4695b36516$var$attr, "");
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $c91a2c4695b36516$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $c91a2c4695b36516$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $c91a2c4695b36516$var$isOutsideEvent(event)) {
                const focusing = event.type === "focusin";
                const manageFocus = focusing ? $c91a2c4695b36516$var$enableFocusInside : $c91a2c4695b36516$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener("focusin", onFocus, true);
        portalNode.addEventListener("focusout", onFocus, true);
        return ()=>{
            portalNode.removeEventListener("focusin", onFocus, true);
            portalNode.removeEventListener("focusout", onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $acw62.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        $c91a2c4695b36516$var$enableFocusInside(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($c91a2c4695b36516$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $c91a2c4695b36516$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $c91a2c4695b36516$var$HIDDEN_STYLES
    }), portalNode && /*#__PURE__*/ $1u0KT.createPortal(children, portalNode), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($c91a2c4695b36516$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $c91a2c4695b36516$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
            }
        }
    }));
}
const $c91a2c4695b36516$var$usePortalContext = ()=>$acw62.useContext($c91a2c4695b36516$var$PortalContext);
const $c91a2c4695b36516$var$FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function $c91a2c4695b36516$var$getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($c91a2c4695b36516$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $c91a2c4695b36516$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
const $c91a2c4695b36516$var$LIST_LIMIT = 20;
let $c91a2c4695b36516$var$previouslyFocusedElements = [];
function $c91a2c4695b36516$var$addPreviouslyFocusedElement(element) {
    $c91a2c4695b36516$var$previouslyFocusedElements = $c91a2c4695b36516$var$previouslyFocusedElements.filter((el)=>el.isConnected);
    let tabbableEl = element;
    if (!tabbableEl || (0, $33bLr.getNodeName)(tabbableEl) === "body") return;
    if (!(0, $e8HHX.isTabbable)(tabbableEl, $c91a2c4695b36516$var$getTabbableOptions())) {
        const tabbableChild = (0, $e8HHX.tabbable)(tabbableEl, $c91a2c4695b36516$var$getTabbableOptions())[0];
        if (tabbableChild) tabbableEl = tabbableChild;
    }
    $c91a2c4695b36516$var$previouslyFocusedElements.push(tabbableEl);
    if ($c91a2c4695b36516$var$previouslyFocusedElements.length > $c91a2c4695b36516$var$LIST_LIMIT) $c91a2c4695b36516$var$previouslyFocusedElements = $c91a2c4695b36516$var$previouslyFocusedElements.slice(-$c91a2c4695b36516$var$LIST_LIMIT);
}
function $c91a2c4695b36516$var$getPreviouslyFocusedElement() {
    return $c91a2c4695b36516$var$previouslyFocusedElements.slice().reverse().find((el)=>el.isConnected);
}
const $c91a2c4695b36516$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $c91a2c4695b36516$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $c91a2c4695b36516$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $c91a2c4695b36516$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        "content"
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = props;
    const { open: open, refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, floatingId: floatingId, elements: { domReference: domReference, floating: floating } } = context;
    const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $2Yoyg.isTypeableCombobox)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const guards = $c91a2c4695b36516$var$supportsInert() ? _guards : true;
    const orderRef = $c91a2c4695b36516$var$useLatestRef(order);
    const initialFocusRef = $c91a2c4695b36516$var$useLatestRef(initialFocus);
    const returnFocusRef = $c91a2c4695b36516$var$useLatestRef(returnFocus);
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    const portalContext = $c91a2c4695b36516$var$usePortalContext();
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const isPointerDownRef = $acw62.useRef(false);
    const tabbableIndexRef = $acw62.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = $c91a2c4695b36516$var$getFloatingFocusElement(floating);
    const getTabbableContent = $c91a2c4695b36516$var$useEffectEvent(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $e8HHX.tabbable)(container, $c91a2c4695b36516$var$getTabbableOptions()) : [];
    });
    const getTabbableElements = $c91a2c4695b36516$var$useEffectEvent((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === "reference") return domReference;
            if (floatingFocusElement && type === "floating") return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $acw62.useEffect(()=>{
        preventReturnFocusRef.current = false;
    }, [
        disabled
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === "Tab") {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $2Yoyg.contains)(floatingFocusElement, (0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $2Yoyg.stopEvent)(event);
                const els = getTabbableElements();
                const target = (0, $2Yoyg.getTarget)(event);
                if (orderRef.current[0] === "reference" && target === domReference) {
                    (0, $2Yoyg.stopEvent)(event);
                    if (event.shiftKey) $c91a2c4695b36516$var$enqueueFocus(els[els.length - 1]);
                    else $c91a2c4695b36516$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
                    (0, $2Yoyg.stopEvent)(event);
                    $c91a2c4695b36516$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $2Yoyg.getDocument)(floatingFocusElement);
        doc.addEventListener("keydown", onKeyDown);
        return ()=>{
            doc.removeEventListener("keydown", onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $2Yoyg.getTarget)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener("focusin", handleFocusIn);
        return ()=>{
            floating.removeEventListener("focusin", handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            queueMicrotask(()=>{
                const movedToUnrelatedNode = !((0, $2Yoyg.contains)(domReference, relatedTarget) || (0, $2Yoyg.contains)(floating, relatedTarget) || (0, $2Yoyg.contains)(relatedTarget, floating) || (0, $2Yoyg.contains)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($c91a2c4695b36516$var$createAttribute("focus-guard")) || tree && ($c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $2Yoyg.contains)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $2Yoyg.contains)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || $c91a2c4695b36516$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4;
                    return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
                })));
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && movedToUnrelatedNode && (0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(floatingFocusElement)) === (0, $2Yoyg.getDocument)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $33bLr.isHTMLElement)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $33bLr.isHTMLElement)(nodeToFocus)) nodeToFocus.focus();
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $c91a2c4695b36516$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, "focus-out");
                }
            });
        }
        if (floating && (0, $33bLr.isHTMLElement)(domReference)) {
            domReference.addEventListener("focusout", handleFocusOutside);
            domReference.addEventListener("pointerdown", handlePointerDown);
            floating.addEventListener("focusout", handleFocusOutside);
            return ()=>{
                domReference.removeEventListener("focusout", handleFocusOutside);
                domReference.removeEventListener("pointerdown", handlePointerDown);
                floating.removeEventListener("focusout", handleFocusOutside);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        if (disabled) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $c91a2c4695b36516$var$createAttribute("portal") + "]")) || []);
        if (floating) {
            const insideElements = [
                floating,
                ...portalNodes,
                startDismissButtonRef.current,
                endDismissButtonRef.current,
                orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null
            ].filter((x)=>x != null);
            const cleanup = modal || isUntrappedTypeableCombobox ? $c91a2c4695b36516$var$markOthers(insideElements, guards, !guards) : $c91a2c4695b36516$var$markOthers(insideElements);
            return ()=>{
                cleanup();
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (disabled || !(0, $33bLr.isHTMLElement)(floatingFocusElement)) return;
        const doc = (0, $2Yoyg.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $2Yoyg.activeElement)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $2Yoyg.contains)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $c91a2c4695b36516$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (disabled || !floatingFocusElement) return;
        let preventReturnFocusScroll = false;
        const doc = (0, $2Yoyg.getDocument)(floatingFocusElement);
        const previouslyFocusedElement = (0, $2Yoyg.activeElement)(doc);
        const contextData = dataRef.current;
        let openEvent = contextData.openEvent;
        $c91a2c4695b36516$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { open: open, reason: reason, event: event, nested: nested } = _ref;
            if (open) openEvent = event;
            if (reason === "escape-key" && refs.domReference.current) $c91a2c4695b36516$var$addPreviouslyFocusedElement(refs.domReference.current);
            if (reason === "hover" && event.type === "mouseleave") preventReturnFocusRef.current = true;
            if (reason !== "outside-press") return;
            if (nested) {
                preventReturnFocusRef.current = false;
                preventReturnFocusScroll = true;
            } else preventReturnFocusRef.current = !((0, $2Yoyg.isVirtualClick)(event) || (0, $2Yoyg.isVirtualPointerEvent)(event));
        }
        events.on("openchange", onOpenChange);
        const fallbackEl = doc.createElement("span");
        fallbackEl.setAttribute("tabindex", "-1");
        fallbackEl.setAttribute("aria-hidden", "true");
        Object.assign(fallbackEl.style, $c91a2c4695b36516$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement("afterend", fallbackEl);
        return ()=>{
            events.off("openchange", onOpenChange);
            const activeEl = (0, $2Yoyg.activeElement)(doc);
            const isFocusInsideFloatingTree = (0, $2Yoyg.contains)(floating, activeEl) || tree && $c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context5;
                return (0, $2Yoyg.contains)((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
            });
            const shouldFocusReference = isFocusInsideFloatingTree || openEvent && [
                "click",
                "mousedown"
            ].includes(openEvent.type);
            if (shouldFocusReference && refs.domReference.current) $c91a2c4695b36516$var$addPreviouslyFocusedElement(refs.domReference.current);
            const returnElement = $c91a2c4695b36516$var$getPreviouslyFocusedElement() || fallbackEl;
            queueMicrotask(()=>{
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $33bLr.isHTMLElement)(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) returnElement.focus({
                    preventScroll: preventReturnFocusScroll
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        refs,
        events,
        tree,
        nodeId,
        isInsidePortal,
        domReference
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $c91a2c4695b36516$var$index(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            refs: refs
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        refs,
        closeOnFocusOut
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        if (typeof MutationObserver !== "function") return;
        if (ignoreInitialFocus) return;
        const handleMutation = ()=>{
            const tabIndex = floatingFocusElement.getAttribute("tabindex");
            const tabbableContent = getTabbableContent();
            const activeEl = (0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(floating));
            const tabbableIndex = tabbableContent.indexOf(activeEl);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
            if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
                if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
            } else if (tabIndex !== "-1") floatingFocusElement.setAttribute("tabindex", "-1");
        };
        handleMutation();
        const observer = new MutationObserver(handleMutation);
        observer.observe(floatingFocusElement, {
            childList: true,
            subtree: true,
            attributes: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        refs,
        orderRef,
        getTabbableContent,
        ignoreInitialFocus
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$VisuallyHiddenDismiss, {
            ref: location === "start" ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent)
        }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $c91a2c4695b36516$var$enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($c91a2c4695b36516$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $c91a2c4695b36516$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($c91a2c4695b36516$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $c91a2c4695b36516$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                if (closeOnFocusOut) preventReturnFocusRef.current = true;
                if ($c91a2c4695b36516$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $c91a2c4695b36516$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
let $c91a2c4695b36516$var$lockCount = 0;
function $c91a2c4695b36516$var$enableScrollLock() {
    const isIOS = /iP(hone|ad|od)|iOS/.test((0, $2Yoyg.getPlatform)());
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = "hidden";
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: "fixed",
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: "0"
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: "",
            [paddingProp]: ""
        });
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: "",
                top: "",
                left: "",
                right: ""
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $c91a2c4695b36516$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $c91a2c4695b36516$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false, ...rest } = props;
    $c91a2c4695b36516$var$index(()=>{
        if (!lockScroll) return;
        $c91a2c4695b36516$var$lockCount++;
        if ($c91a2c4695b36516$var$lockCount === 1) $c91a2c4695b36516$var$cleanup = $c91a2c4695b36516$var$enableScrollLock();
        return ()=>{
            $c91a2c4695b36516$var$lockCount--;
            if ($c91a2c4695b36516$var$lockCount === 0) $c91a2c4695b36516$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $c91a2c4695b36516$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: "fixed",
            overflow: "auto",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $c91a2c4695b36516$var$isButtonTarget(event) {
    return (0, $33bLr.isHTMLElement)(event.target) && event.target.tagName === "BUTTON";
}
function $c91a2c4695b36516$var$isSpaceIgnored(element) {
    return (0, $2Yoyg.isTypeableElement)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $c91a2c4695b36516$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = "click", toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = props;
    const pointerTypeRef = $acw62.useRef();
    const didKeyDownRef = $acw62.useRef(false);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === "click") return;
                if ((0, $2Yoyg.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) onOpenChange(false, event.nativeEvent, "click");
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $2Yoyg.isMouseLikePointerType)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) onOpenChange(false, event.nativeEvent, "click");
                else onOpenChange(true, event.nativeEvent, "click");
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $c91a2c4695b36516$var$isButtonTarget(event)) return;
                if (event.key === " " && !$c91a2c4695b36516$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if (event.key === "Enter") {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $c91a2c4695b36516$var$isButtonTarget(event) || $c91a2c4695b36516$var$isSpaceIgnored(domReference)) return;
                if (event.key === " " && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, "click");
                    else onOpenChange(true, event.nativeEvent, "click");
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        toggle
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $c91a2c4695b36516$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === "x" || data.axis === "both";
            const isYAxis = data.axis === "y" || data.axis === "both";
            const canTrackCursorOnAutoUpdate = [
                "mouseenter",
                "mousemove"
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || "") && data.pointerType !== "touch";
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === "y" ? domRect.width : 0;
                height = data.axis === "x" ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === "x" ? domRect.height : height;
                width = data.axis === "y" ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $c91a2c4695b36516$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $c91a2c4695b36516$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = "both", x: x = null, y: y = null } = props;
    const initialRef = $acw62.useRef(false);
    const cleanupListenerRef = $acw62.useRef(null);
    const [pointerType, setPointerType] = $acw62.useState();
    const [reactive, setReactive] = $acw62.useState([]);
    const setReference = $c91a2c4695b36516$var$useEffectEvent((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$c91a2c4695b36516$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($c91a2c4695b36516$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $2Yoyg.isMouseLikePointerType)(pointerType) ? floating : open;
    const addListener = $acw62.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $33bLr.getWindow)(floating);
        function handleMouseMove(event) {
            const target = (0, $2Yoyg.getTarget)(event);
            if (!(0, $2Yoyg.contains)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $c91a2c4695b36516$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener("mousemove", handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener("mousemove", handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $acw62.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $acw62.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $acw62.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $acw62.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $c91a2c4695b36516$var$bubbleHandlerKeys = {
    pointerdown: "onPointerDown",
    mousedown: "onMouseDown",
    click: "onClick"
};
const $c91a2c4695b36516$var$captureHandlerKeys = {
    pointerdown: "onPointerDownCapture",
    mousedown: "onMouseDownCapture",
    click: "onClickCapture"
};
const $c91a2c4695b36516$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $c91a2c4695b36516$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = "pointerdown", referencePress: referencePress = false, referencePressEvent: referencePressEvent = "pointerdown", ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    const outsidePressFn = $c91a2c4695b36516$var$useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const endedOrStartedInsideRef = $acw62.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $c91a2c4695b36516$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $c91a2c4695b36516$var$normalizeProp(capture);
    const closeOnEscapeKeyDown = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== "Escape") return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? $c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $2Yoyg.isReactEvent)(event) ? event.nativeEvent : event, "escape-key");
    });
    const closeOnEscapeKeyDownCapture = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $2Yoyg.getTarget)(event)) == null || _getTarget.removeEventListener("keydown", callback);
        };
        (_getTarget2 = (0, $2Yoyg.getTarget)(event)) == null || _getTarget2.addEventListener("keydown", callback);
    });
    const closeOnPressOutside = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = insideReactTreeRef.current;
        insideReactTreeRef.current = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === "click" && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === "function" && !outsidePress(event)) return;
        const target = (0, $2Yoyg.getTarget)(event);
        const inertSelector = "[" + $c91a2c4695b36516$var$createAttribute("inert") + "]";
        const markers = (0, $2Yoyg.getDocument)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $33bLr.isElement)(target) ? target : null;
        while(targetRootAncestor && !(0, $33bLr.isLastTraversableNode)(targetRootAncestor)){
            const nextParent = (0, $33bLr.getParentNode)(targetRootAncestor);
            if ((0, $33bLr.isLastTraversableNode)(nextParent) || !(0, $33bLr.isElement)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $33bLr.isElement)(target) && !(0, $2Yoyg.isRootElement)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $2Yoyg.contains)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $2Yoyg.contains)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $33bLr.isHTMLElement)(target) && floating) {
            // In Firefox, `target.scrollWidth > target.clientWidth` for inline
            // elements.
            const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            let xCond = canScrollY && event.offsetX > target.clientWidth;
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            if (canScrollY) {
                const isRTL = (0, $33bLr.getComputedStyle)(target).direction === "rtl";
                if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
            }
            if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && $c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $2Yoyg.isEventTargetWithin)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $2Yoyg.isEventTargetWithin)(event, elements.floating) || (0, $2Yoyg.isEventTargetWithin)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? $c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, "outside-press");
    });
    const closeOnPressOutsideCapture = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $2Yoyg.getTarget)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $2Yoyg.getTarget)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onScroll(event) {
            onOpenChange(false, event, "ancestor-scroll");
        }
        const doc = (0, $2Yoyg.getDocument)(elements.floating);
        escapeKey && doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $33bLr.isElement)(elements.domReference)) ancestors = (0, $33bLr.getOverflowAncestors)(elements.domReference);
            if ((0, $33bLr.isElement)(elements.floating)) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.floating));
            if (!(0, $33bLr.isElement)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener("scroll", onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener("scroll", onScroll);
            });
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            [$c91a2c4695b36516$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                if (referencePress) onOpenChange(false, event.nativeEvent, "reference-press");
            }
        }), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown () {
                endedOrStartedInsideRef.current = true;
            },
            onMouseUp () {
                endedOrStartedInsideRef.current = true;
            },
            [$c91a2c4695b36516$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                insideReactTreeRef.current = true;
            }
        }), [
        closeOnEscapeKeyDown,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $c91a2c4695b36516$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $c91a2c4695b36516$export$f680877a34711e37();
    const dataRef = $acw62.useRef({});
    const [events] = $acw62.useState(()=>$c91a2c4695b36516$var$createPubSub());
    const nested = $c91a2c4695b36516$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $acw62.useState(elementsProp.reference);
    const onOpenChange = $c91a2c4695b36516$var$useEffectEvent((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit("openchange", {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $acw62.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $acw62.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $acw62.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $c91a2c4695b36516$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $c91a2c4695b36516$export$1df81146f8ad8e4c({
        ...options,
        elements: {
            reference: null,
            floating: null,
            ...options.elements
        }
    });
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $acw62.useState(null);
    const [positionReference, _setPositionReference] = $acw62.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.reference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $acw62.useRef(null);
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    $c91a2c4695b36516$var$index(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $kYdT9.useFloating)({
        ...options,
        elements: {
            ...computedElements,
            ...positionReference && {
                reference: positionReference
            }
        }
    });
    const setPositionReference = $acw62.useCallback((node)=>{
        const computedPositionReference = (0, $33bLr.isElement)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ((0, $33bLr.isElement)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $33bLr.isElement)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $33bLr.isElement)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $acw62.useMemo(()=>({
            ...position,
            ...rootContext,
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    $c91a2c4695b36516$var$index(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $c91a2c4695b36516$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    const keyboardModalityRef = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $33bLr.getWindow)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $33bLr.isHTMLElement)(elements.domReference) && elements.domReference === (0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        win.addEventListener("blur", onBlur);
        win.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            win.removeEventListener("blur", onBlur);
            win.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === "reference-press" || reason === "escape-key") blockFocusRef.current = true;
        }
        events.on("openchange", onOpenChange);
        return ()=>{
            events.off("openchange", onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const reference = $acw62.useMemo(()=>({
            onPointerDown (event) {
                if ((0, $2Yoyg.isVirtualPointerEvent)(event.nativeEvent)) return;
                keyboardModalityRef.current = false;
            },
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $2Yoyg.getTarget)(event.nativeEvent);
                if (visibleOnly && (0, $33bLr.isElement)(target)) try {
                    // Mac Safari unreliably matches `:focus-visible` on the reference
                    // if focus was outside the page initially - use the fallback
                    // instead.
                    if ((0, $2Yoyg.isSafari)() && (0, $2Yoyg.isMac)()) throw Error();
                    if (!target.matches(":focus-visible")) return;
                } catch (e) {
                    // Old browsers will throw an error when using `:focus-visible`.
                    if (!keyboardModalityRef.current && !(0, $2Yoyg.isTypeableElement)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, "focus");
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $33bLr.isElement)(relatedTarget) && relatedTarget.hasAttribute($c91a2c4695b36516$var$createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $2Yoyg.activeElement)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $2Yoyg.contains)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $2Yoyg.contains)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, "focus");
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $c91a2c4695b36516$var$ACTIVE_KEY = "active";
const $c91a2c4695b36516$var$SELECTED_KEY = "selected";
function $c91a2c4695b36516$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === "item";
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$c91a2c4695b36516$var$ACTIVE_KEY]: _, [$c91a2c4695b36516$var$SELECTED_KEY]: __, ...validProps } = userProps;
        domUserProps = validProps;
    }
    return {
        ...elementKey === "floating" && {
            tabIndex: -1,
            [$c91a2c4695b36516$var$FOCUSABLE_ATTRIBUTE]: ""
        },
        ...domUserProps,
        ...propsList.map((value)=>{
            const propsOrGetProps = value ? value[elementKey] : null;
            if (typeof propsOrGetProps === "function") return userProps ? propsOrGetProps(userProps) : null;
            return propsOrGetProps;
        }).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (isItem && [
                    $c91a2c4695b36516$var$ACTIVE_KEY,
                    $c91a2c4695b36516$var$SELECTED_KEY
                ].includes(key)) return;
                if (key.indexOf("on") === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === "function") {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $c91a2c4695b36516$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $acw62.useCallback((userProps)=>$c91a2c4695b36516$var$mergeProps(userProps, propsList, "reference"), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$c91a2c4695b36516$var$mergeProps(userProps, propsList, "floating"), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $acw62.useCallback((userProps)=>$c91a2c4695b36516$var$mergeProps(userProps, propsList, "item"), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
let $c91a2c4695b36516$var$isPreventScrollSupported = false;
function $c91a2c4695b36516$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $c91a2c4695b36516$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $c91a2c4695b36516$var$ARROW_UP || key === $c91a2c4695b36516$var$ARROW_DOWN;
    const horizontal = key === $c91a2c4695b36516$var$ARROW_LEFT || key === $c91a2c4695b36516$var$ARROW_RIGHT;
    return $c91a2c4695b36516$var$doSwitch(orientation, vertical, horizontal);
}
function $c91a2c4695b36516$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $c91a2c4695b36516$var$ARROW_DOWN;
    const horizontal = rtl ? key === $c91a2c4695b36516$var$ARROW_LEFT : key === $c91a2c4695b36516$var$ARROW_RIGHT;
    return $c91a2c4695b36516$var$doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function $c91a2c4695b36516$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $c91a2c4695b36516$var$ARROW_LEFT : key === $c91a2c4695b36516$var$ARROW_RIGHT;
    const horizontal = key === $c91a2c4695b36516$var$ARROW_DOWN;
    return $c91a2c4695b36516$var$doSwitch(orientation, vertical, horizontal);
}
function $c91a2c4695b36516$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $c91a2c4695b36516$var$ARROW_RIGHT : key === $c91a2c4695b36516$var$ARROW_LEFT;
    const horizontal = key === $c91a2c4695b36516$var$ARROW_UP;
    return $c91a2c4695b36516$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $c91a2c4695b36516$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = "auto", focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = "vertical", cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = $c91a2c4695b36516$var$getFloatingFocusElement(elements.floating);
    const floatingFocusElementRef = $c91a2c4695b36516$var$useLatestRef(floatingFocusElement);
    const parentId = $c91a2c4695b36516$export$165209eae06d3488();
    const tree = $c91a2c4695b36516$export$db0c2a7c7a2a4f69();
    const onNavigate = $c91a2c4695b36516$var$useEffectEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousMountedRef = $acw62.useRef(!!elements.floating);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $c91a2c4695b36516$var$useLatestRef(disabledIndices);
    const latestOpenRef = $c91a2c4695b36516$var$useLatestRef(open);
    const scrollItemIntoViewRef = $c91a2c4695b36516$var$useLatestRef(scrollItemIntoView);
    const selectedIndexRef = $c91a2c4695b36516$var$useLatestRef(selectedIndex);
    const [activeId, setActiveId] = $acw62.useState();
    const [virtualId, setVirtualId] = $acw62.useState();
    const focusItem = $c91a2c4695b36516$var$useEffectEvent(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        function runFocus(item) {
            if (virtual) {
                setActiveId(item.id);
                tree == null || tree.events.emit("virtualfocus", item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $c91a2c4695b36516$var$enqueueFocus(item, {
                preventScroll: true,
                // Mac Safari does not move the virtual cursor unless the focus call
                // is sync. However, for the very first focus call, we need to wait
                // for the position to be ready in order to prevent unwanted
                // scrolling. This means the virtual cursor will not move to the first
                // item when first opening the floating element, but will on
                // subsequent calls. `preventScroll` is supported in modern Safari,
                // so we can use that instead.
                // iOS Safari must be async or the first item will not be focused.
                sync: (0, $2Yoyg.isMac)() && (0, $2Yoyg.isSafari)() ? $c91a2c4695b36516$var$isPreventScrollSupported || forceSyncFocus.current : false
            });
        }
        const initialItem = listRef.current[indexRef.current];
        if (initialItem) runFocus(initialItem);
        requestAnimationFrame(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
                block: "nearest",
                inline: "nearest"
            } : scrollIntoViewOptions);
        });
    });
    $c91a2c4695b36516$var$index(()=>{
        document.createElement("div").focus({
            get preventScroll () {
                $c91a2c4695b36516$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $c91a2c4695b36516$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate(selectedIndex);
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $c91a2c4695b36516$var$index(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndexRef.current != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousMountedRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    let runs = 0;
                    const waitForListPopulated = ()=>{
                        if (listRef.current[0] == null) {
                            // Avoid letting the browser paint if possible on the first try,
                            // otherwise use rAF. Don't try more than twice, since something
                            // is wrong otherwise.
                            if (runs < 2) {
                                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                                scheduler(waitForListPopulated);
                            }
                            runs++;
                        } else {
                            indexRef.current = keyRef.current == null || $c91a2c4695b36516$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $c91a2c4695b36516$var$getMinIndex(listRef, disabledIndicesRef.current) : $c91a2c4695b36516$var$getMaxIndex(listRef, disabledIndicesRef.current);
                            keyRef.current = null;
                            onNavigate(indexRef.current);
                        }
                    };
                    waitForListPopulated();
                }
            } else if (!$c91a2c4695b36516$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $c91a2c4695b36516$var$index(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $2Yoyg.activeElement)((0, $2Yoyg.getDocument)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $2Yoyg.contains)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    $c91a2c4695b36516$var$index(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on("virtualfocus", handleVirtualFocus);
        return ()=>{
            tree.events.off("virtualfocus", handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    $c91a2c4695b36516$var$index(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousMountedRef.current = !!elements.floating;
    });
    $c91a2c4695b36516$var$index(()=>{
        if (!open) keyRef.current = null;
    }, [
        open
    ]);
    $c91a2c4695b36516$var$index(()=>{
        previousOpenRef.current = open;
    }, [
        open
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref3) {
                    let { currentTarget: currentTarget } = _ref3;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave (_ref4) {
                    let { pointerType: pointerType } = _ref4;
                    if (!isPointerModalityRef.current || pointerType === "touch") return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    onNavigate(null);
                    if (!virtual) $c91a2c4695b36516$var$enqueueFocus(floatingFocusElementRef.current, {
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        open,
        floatingFocusElementRef,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const commonOnKeyDown = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocus.current = true;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $c91a2c4695b36516$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
            (0, $2Yoyg.stopEvent)(event);
            onOpenChange(false, event.nativeEvent, "list-navigation");
            if ((0, $33bLr.isHTMLElement)(elements.domReference) && !virtual) elements.domReference.focus();
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = $c91a2c4695b36516$var$getMinIndex(listRef, disabledIndices);
        const maxIndex = $c91a2c4695b36516$var$getMaxIndex(listRef, disabledIndices);
        if (event.key === "Home") {
            (0, $2Yoyg.stopEvent)(event);
            indexRef.current = minIndex;
            onNavigate(indexRef.current);
        }
        if (event.key === "End") {
            (0, $2Yoyg.stopEvent)(event);
            indexRef.current = maxIndex;
            onNavigate(indexRef.current);
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = $c91a2c4695b36516$var$buildCellMap(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !$c91a2c4695b36516$var$isDisabled(listRef.current, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !$c91a2c4695b36516$var$isDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[$c91a2c4695b36516$var$getGridNavigatedIndex({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: $c91a2c4695b36516$var$getCellIndices([
                    ...disabledIndices || listRef.current.map((_, index)=>$c91a2c4695b36516$var$isDisabled(listRef.current, index) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: $c91a2c4695b36516$var$getCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $c91a2c4695b36516$var$ARROW_DOWN ? "bl" : event.key === $c91a2c4695b36516$var$ARROW_RIGHT ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(indexRef.current);
            }
            if (orientation === "both") return;
        }
        if ($c91a2c4695b36516$var$isMainOrientationKey(event.key, orientation)) {
            (0, $2Yoyg.stopEvent)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $2Yoyg.activeElement)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $c91a2c4695b36516$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(indexRef.current);
                return;
            }
            if ($c91a2c4695b36516$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, $c91a2c4695b36516$var$findNonDisabledIndex(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ($c91a2c4695b36516$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
            else onNavigate(indexRef.current);
        }
    });
    const ariaActiveDescendantProp = $acw62.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            "aria-orientation": orientation === "both" ? undefined : orientation,
            ...!(0, $2Yoyg.isTypeableCombobox)(elements.domReference) && ariaActiveDescendantProp,
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        };
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        elements.domReference,
        orientation
    ]);
    const reference = $acw62.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && (0, $2Yoyg.isVirtualClick)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && (0, $2Yoyg.isVirtualPointerEvent)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return {
            ...ariaActiveDescendantProp,
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.indexOf("Arrow") === 0;
                const isCrossOpenKey = $c91a2c4695b36516$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $c91a2c4695b36516$var$isCrossOrientationCloseKey(event.key, orientation, rtl);
                const isMainKey = $c91a2c4695b36516$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? $c91a2c4695b36516$var$getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
                    if (isArrowKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent("keydown", {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $2Yoyg.stopEvent)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if (isMainKey && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $2Yoyg.stopEvent)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) keyRef.current = nested && isMainKey ? null : event.key;
                if (nested) {
                    if (isCrossOpenKey) {
                        (0, $2Yoyg.stopEvent)(event);
                        if (open) {
                            indexRef.current = $c91a2c4695b36516$var$getMinIndex(listRef, disabledIndicesRef.current);
                            onNavigate(indexRef.current);
                        } else onOpenChange(true, event.nativeEvent, "list-navigation");
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $2Yoyg.stopEvent)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, "list-navigation");
                    else commonOnKeyDown(event);
                    if (open) onNavigate(indexRef.current);
                }
            },
            onFocus () {
                if (open && !virtual) onNavigate(null);
            },
            onPointerDown: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        activeId,
        ariaActiveDescendantProp,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $c91a2c4695b36516$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $c91a2c4695b36516$export$f66572793fa256a1(context, props) {
    var _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, floatingId: floatingId } = context;
    const { enabled: enabled = true, role: role = "dialog" } = props;
    const ariaRole = (_componentRoleToAriaR = $c91a2c4695b36516$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const referenceId = $c91a2c4695b36516$export$f680877a34711e37();
    const parentId = $c91a2c4695b36516$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $acw62.useMemo(()=>{
        if (ariaRole === "tooltip" || role === "label") return {
            ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : undefined
        };
        return {
            "aria-expanded": open ? "true" : "false",
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-controls": open ? floatingId : undefined,
            ...ariaRole === "listbox" && {
                role: "combobox"
            },
            ...ariaRole === "menu" && {
                id: referenceId
            },
            ...ariaRole === "menu" && isNested && {
                role: "menuitem"
            },
            ...role === "select" && {
                "aria-autocomplete": "none"
            },
            ...role === "combobox" && {
                "aria-autocomplete": "list"
            }
        };
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $acw62.useMemo(()=>{
        const floatingProps = {
            id: floatingId,
            ...ariaRole && {
                role: ariaRole
            }
        };
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return {
            ...floatingProps,
            ...ariaRole === "menu" && {
                "aria-labelledby": referenceId
            }
        };
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $acw62.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = {
            role: "option",
            ...active && {
                id: floatingId + "-option"
            }
        };
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case "select":
                return {
                    ...commonProps,
                    "aria-selected": active && selected
                };
            case "combobox":
                return {
                    ...commonProps,
                    ...active && {
                        "aria-selected": true
                    }
                };
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $c91a2c4695b36516$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? "-" : "") + $.toLowerCase());
function $c91a2c4695b36516$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function $c91a2c4695b36516$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $c91a2c4695b36516$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === "number";
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $acw62.useState("unmounted");
    const isMounted = $c91a2c4695b36516$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === "close") setStatus("unmounted");
    $c91a2c4695b36516$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus("initial");
            const frame = requestAnimationFrame(()=>{
                setStatus("open");
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus("close");
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $c91a2c4695b36516$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split("-")[0];
    const fnArgs = $acw62.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === "number";
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $acw62.useState(()=>({
            ...$c91a2c4695b36516$var$execWithArgsOrReturn(unstable_common, fnArgs),
            ...$c91a2c4695b36516$var$execWithArgsOrReturn(unstable_initial, fnArgs)
        }));
    const { isMounted: isMounted, status: status } = $c91a2c4695b36516$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $c91a2c4695b36516$var$useLatestRef(unstable_initial);
    const openRef = $c91a2c4695b36516$var$useLatestRef(unstable_open);
    const closeRef = $c91a2c4695b36516$var$useLatestRef(unstable_close);
    const commonRef = $c91a2c4695b36516$var$useLatestRef(unstable_common);
    $c91a2c4695b36516$var$index(()=>{
        const initialStyles = $c91a2c4695b36516$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $c91a2c4695b36516$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $c91a2c4695b36516$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $c91a2c4695b36516$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = "";
            return acc;
        }, {});
        if (status === "initial") setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === "open") setStyles({
            transitionProperty: Object.keys(openStyles).map($c91a2c4695b36516$var$camelCaseToKebabCase).join(","),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === "close") {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($c91a2c4695b36516$var$camelCaseToKebabCase).join(","),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $c91a2c4695b36516$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef("");
    const prevIndexRef = $acw62.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $c91a2c4695b36516$var$useEffectEvent(unstable_onMatch);
    const onTypingChange = $c91a2c4695b36516$var$useEffectEvent(unstable_onTypingChange);
    const findMatchRef = $c91a2c4695b36516$var$useLatestRef(findMatch);
    const ignoreKeysRef = $c91a2c4695b36516$var$useLatestRef(ignoreKeys);
    $c91a2c4695b36516$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = "";
        }
    }, [
        open
    ]);
    $c91a2c4695b36516$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === "") {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = $c91a2c4695b36516$var$useEffectEvent((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = $c91a2c4695b36516$var$useEffectEvent((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === " ") (0, $2Yoyg.stopEvent)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            (0, $2Yoyg.stopEvent)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = setTimeout(()=>{
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    const reference = $acw62.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $acw62.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === " ") setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $acw62.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $c91a2c4695b36516$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $c91a2c4695b36516$export$4ae363f1d88fb658 = (props)=>({
        name: "inner",
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(props, state);
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $kYdT9.offset)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const overflow = await (0, $618j3.detectOverflow)($c91a2c4695b36516$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await (0, $618j3.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: "reference"
            });
            const diffY = (0, $1obCQ.max)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = (0, $1obCQ.round)((0, $1obCQ.max)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $1obCQ.max)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.scrollHeight > scrollEl.offsetHeight && scrollEl.offsetHeight < item.offsetHeight * minItemsVisible - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $1u0KT.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await (0, $618j3.detectOverflow)($c91a2c4695b36516$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ function $c91a2c4695b36516$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = $c91a2c4695b36516$var$useEffectEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? "max" : "min";
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $1u0KT.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $2Yoyg.getUserAgent)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener("wheel", onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener("wheel", onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $acw62.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $1u0KT.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $acw62.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $c91a2c4695b36516$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $c91a2c4695b36516$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $c91a2c4695b36516$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    let timeoutId;
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = performance.now();
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = (0, $2Yoyg.getTarget)(event);
            const isLeave = event.type === "mouseleave";
            const isOverFloatingEl = (0, $2Yoyg.contains)(elements.floating, target);
            const isOverReferenceEl = (0, $2Yoyg.contains)(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split("-")[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $c91a2c4695b36516$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $33bLr.isElement)(event.relatedTarget) && (0, $2Yoyg.contains)(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $c91a2c4695b36516$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case "top":
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case "bottom":
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case "left":
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case "right":
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                switch(side){
                    case "top":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "bottom":
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case "left":
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case "right":
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($c91a2c4695b36516$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$c91a2c4695b36516$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutId = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}

});
parcelRegister("2Yoyg", function(module, exports) {

$parcel$export(module.exports, "activeElement", () => $22a43acfc7005550$export$da980962bd2147a4);
$parcel$export(module.exports, "contains", () => $22a43acfc7005550$export$2344b14b097df817);
$parcel$export(module.exports, "getPlatform", () => $22a43acfc7005550$export$867a782338812cb4);
$parcel$export(module.exports, "getUserAgent", () => $22a43acfc7005550$export$7935961ef7719cb0);
$parcel$export(module.exports, "isVirtualClick", () => $22a43acfc7005550$export$60278871457622de);
$parcel$export(module.exports, "isVirtualPointerEvent", () => $22a43acfc7005550$export$29bf1b5f2c56cf63);
$parcel$export(module.exports, "isSafari", () => $22a43acfc7005550$export$95df08bae54cb4df);
$parcel$export(module.exports, "isMac", () => $22a43acfc7005550$export$9ac100e40613ea10);
$parcel$export(module.exports, "isMouseLikePointerType", () => $22a43acfc7005550$export$81cf264172d31e51);
$parcel$export(module.exports, "isReactEvent", () => $22a43acfc7005550$export$94781ce41a161222);
$parcel$export(module.exports, "isRootElement", () => $22a43acfc7005550$export$7b296c28e0fa3aed);
$parcel$export(module.exports, "getDocument", () => $22a43acfc7005550$export$f65ca476c09acec0);
$parcel$export(module.exports, "isEventTargetWithin", () => $22a43acfc7005550$export$43c3154d5bf2c6c2);
$parcel$export(module.exports, "getTarget", () => $22a43acfc7005550$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isTypeableElement", () => $22a43acfc7005550$export$42ad131c32f0fb8d);
$parcel$export(module.exports, "stopEvent", () => $22a43acfc7005550$export$7ae4cd3a66c1e050);
$parcel$export(module.exports, "isTypeableCombobox", () => $22a43acfc7005550$export$259ba5ae38188551);

var $33bLr = parcelRequire("33bLr");
function $22a43acfc7005550$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $22a43acfc7005550$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $33bLr.isShadowRoot)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
// Avoid Chrome DevTools blue warning.
function $22a43acfc7005550$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $22a43acfc7005550$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(" ");
    return navigator.userAgent;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $22a43acfc7005550$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($22a43acfc7005550$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $22a43acfc7005550$export$29bf1b5f2c56cf63(event) {
    if ($22a43acfc7005550$export$c8f880a2d81914c4()) return false;
    return !$22a43acfc7005550$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $22a43acfc7005550$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function $22a43acfc7005550$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $22a43acfc7005550$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($22a43acfc7005550$export$867a782338812cb4()) || re.test($22a43acfc7005550$export$7935961ef7719cb0());
}
function $22a43acfc7005550$export$9ac100e40613ea10() {
    return $22a43acfc7005550$export$867a782338812cb4().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function $22a43acfc7005550$export$c8f880a2d81914c4() {
    return $22a43acfc7005550$export$7935961ef7719cb0().includes("jsdom/");
}
function $22a43acfc7005550$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", undefined);
    return values.includes(pointerType);
}
function $22a43acfc7005550$export$94781ce41a161222(event) {
    return "nativeEvent" in event;
}
function $22a43acfc7005550$export$7b296c28e0fa3aed(element) {
    return element.matches("html,body");
}
function $22a43acfc7005550$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $22a43acfc7005550$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $22a43acfc7005550$export$c22522a4dfa48e9c(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $22a43acfc7005550$export$78b3d091ff376bc = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $22a43acfc7005550$export$42ad131c32f0fb8d(element) {
    return (0, $33bLr.isHTMLElement)(element) && element.matches($22a43acfc7005550$export$78b3d091ff376bc);
}
function $22a43acfc7005550$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $22a43acfc7005550$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && $22a43acfc7005550$export$42ad131c32f0fb8d(element);
}

});

parcelRegister("e8HHX", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $a4b3b7902c9a987d$export$17100aea90429aa7);
$parcel$export(module.exports, "isTabbable", () => $a4b3b7902c9a987d$export$bebd5a1431fec25d);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(",");
var $a4b3b7902c9a987d$var$NoElement = typeof Element === "undefined";
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "hidden";
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === "radio";
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat("iframe").join(",");
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("5fYEB", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", () => $3d3d670dbe2ceed6$export$db61f031a278447c);
function $3d3d670dbe2ceed6$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $3d3d670dbe2ceed6$var$i(l) ? !1 : t;
}
function $3d3d670dbe2ceed6$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("fLrGx", function(module, exports) {

$parcel$export(module.exports, "Focus", () => $b7a0b87cd8a0fa3d$export$807a7eae502106e7);
$parcel$export(module.exports, "calculateActiveIndex", () => $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e);
function $b7a0b87cd8a0fa3d$var$u(l) {
    throw new Error("Unexpected object: " + l);
}
var $b7a0b87cd8a0fa3d$export$807a7eae502106e7 = ((i)=>(i[i.First = 0] = "First", i[i.Previous = 1] = "Previous", i[i.Next = 2] = "Next", i[i.Last = 3] = "Last", i[i.Specific = 4] = "Specific", i[i.Nothing = 5] = "Nothing", i))($b7a0b87cd8a0fa3d$export$807a7eae502106e7 || {});
function $b7a0b87cd8a0fa3d$export$c6b4626b54936d5e(l, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let r = n.resolveActiveIndex(), s = r != null ? r : -1;
    switch(l.focus){
        case 0:
            for(let e = 0; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 1:
            s === -1 && (s = t.length);
            for(let e = s - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 2:
            for(let e = s + 1; e < t.length; ++e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 3:
            for(let e = t.length - 1; e >= 0; --e)if (!n.resolveDisabled(t[e], e, t)) return e;
            return r;
        case 4:
            for(let e = 0; e < t.length; ++e)if (n.resolveId(t[e], e, t) === l.id) return e;
            return r;
        case 5:
            return null;
        default:
            $b7a0b87cd8a0fa3d$var$u(l);
    }
}

});

parcelRegister("5qg9U", function(module, exports) {

$parcel$export(module.exports, "useLabelContext", () => $3f2bea42b2459559$export$feddbbf47baabdb9);
$parcel$export(module.exports, "useLabelledBy", () => $3f2bea42b2459559$export$1f86aee6764cddb2);
$parcel$export(module.exports, "useLabels", () => $3f2bea42b2459559$export$d6875122194c7b44);
$parcel$export(module.exports, "Label", () => $3f2bea42b2459559$export$b04be29aa201d4f5);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $8KgIp = parcelRequire("8KgIp");

var $6mpbl = parcelRequire("6mpbl");

var $brAF4 = parcelRequire("brAF4");

var $jpbxo = parcelRequire("jpbxo");

var $ebRQH = parcelRequire("ebRQH");
"use client";
let $3f2bea42b2459559$var$c = (0, $acw62.createContext)(null);
$3f2bea42b2459559$var$c.displayName = "LabelContext";
function $3f2bea42b2459559$export$feddbbf47baabdb9() {
    let r = (0, $acw62.useContext)($3f2bea42b2459559$var$c);
    if (r === null) {
        let l = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(l, $3f2bea42b2459559$export$feddbbf47baabdb9), l;
    }
    return r;
}
function $3f2bea42b2459559$export$1f86aee6764cddb2(r) {
    var a, e, o;
    let l = (e = (a = (0, $acw62.useContext)($3f2bea42b2459559$var$c)) == null ? void 0 : a.value) != null ? e : void 0;
    return ((o = r == null ? void 0 : r.length) != null ? o : 0) > 0 ? [
        l,
        ...r
    ].filter(Boolean).join(" ") : l;
}
function $3f2bea42b2459559$export$d6875122194c7b44({ inherit: r = !1 } = {}) {
    let l = $3f2bea42b2459559$export$1f86aee6764cddb2(), [a, e] = (0, $acw62.useState)([]), o = r ? [
        l,
        ...a
    ].filter(Boolean) : a;
    return [
        o.length > 0 ? o.join(" ") : void 0,
        (0, $acw62.useMemo)(()=>function(t) {
                let s = (0, $114Mg.useEvent)((i)=>(e((p)=>[
                            ...p,
                            i
                        ]), ()=>e((p)=>{
                            let u = p.slice(), d = u.indexOf(i);
                            return d !== -1 && u.splice(d, 1), u;
                        }))), m = (0, $acw62.useMemo)(()=>({
                        register: s,
                        slot: t.slot,
                        name: t.name,
                        props: t.props,
                        value: t.value
                    }), [
                    s,
                    t.slot,
                    t.name,
                    t.props,
                    t.value
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3f2bea42b2459559$var$c.Provider, {
                    value: m
                }, t.children);
            }, [
            e
        ])
    ];
}
let $3f2bea42b2459559$var$N = "label";
function $3f2bea42b2459559$var$G(r, l) {
    var y;
    let a = (0, $acw62.useId)(), e = $3f2bea42b2459559$export$feddbbf47baabdb9(), o = (0, $jpbxo.useProvidedId)(), g = (0, $brAF4.useDisabled)(), { id: t = `headlessui-label-${a}`, htmlFor: s = o != null ? o : (y = e.props) == null ? void 0 : y.htmlFor, passive: m = !1, ...i } = r, p = (0, $6mpbl.useSyncRefs)(l);
    (0, $8KgIp.useIsoMorphicEffect)(()=>e.register(t), [
        t,
        e.register
    ]);
    let u = (0, $114Mg.useEvent)((L)=>{
        let b = L.currentTarget;
        if (b instanceof HTMLLabelElement && L.preventDefault(), e.props && "onClick" in e.props && typeof e.props.onClick == "function" && e.props.onClick(L), b instanceof HTMLLabelElement) {
            let n = document.getElementById(b.htmlFor);
            if (n) {
                let E = n.getAttribute("disabled");
                if (E === "true" || E === "") return;
                let x = n.getAttribute("aria-disabled");
                if (x === "true" || x === "") return;
                (n instanceof HTMLInputElement && (n.type === "radio" || n.type === "checkbox") || n.role === "radio" || n.role === "checkbox" || n.role === "switch") && n.click(), n.focus({
                    preventScroll: !0
                });
            }
        }
    }), d = g || !1, C = (0, $acw62.useMemo)(()=>({
            ...e.slot,
            disabled: d
        }), [
        e.slot,
        d
    ]), f = {
        ref: p,
        ...e.props,
        id: t,
        htmlFor: s,
        onClick: u
    };
    return m && ("onClick" in f && (delete f.htmlFor, delete f.onClick), "onClick" in i && delete i.onClick), (0, $ebRQH.useRender)()({
        ourProps: f,
        theirProps: i,
        slot: C,
        defaultTag: s ? $3f2bea42b2459559$var$N : "div",
        name: e.name || "Label"
    });
}
let $3f2bea42b2459559$var$U = (0, $ebRQH.forwardRefWithAs)($3f2bea42b2459559$var$G), $3f2bea42b2459559$export$b04be29aa201d4f5 = Object.assign($3f2bea42b2459559$var$U, {});

});
parcelRegister("jpbxo", function(module, exports) {

$parcel$export(module.exports, "useProvidedId", () => $e2094d3f1733ff55$export$6ba3910d268310db);

var $acw62 = parcelRequire("acw62");
let $e2094d3f1733ff55$var$e = (0, $acw62.createContext)(void 0);
function $e2094d3f1733ff55$export$6ba3910d268310db() {
    return (0, $acw62.useContext)($e2094d3f1733ff55$var$e);
}
function $e2094d3f1733ff55$export$6be90bcb437e928f({ id: t, children: r }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e2094d3f1733ff55$var$e.Provider, {
        value: t
    }, r);
}

});




parcelRegister("iEjTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93b64eb227ec3b2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $iymfR = parcelRequire("iymfR");

var $acw62 = parcelRequire("acw62");

var $dtKoB = parcelRequire("dtKoB");

var $iL5oi = parcelRequire("iL5oi");

var $jFdmN = parcelRequire("jFdmN");
var $d93b64eb227ec3b2$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d93b64eb227ec3b2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $d93b64eb227ec3b2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $d93b64eb227ec3b2$export$2e2bcd8739ae039(_a) {
    var onReachEnd = _a.onReachEnd, props = $d93b64eb227ec3b2$var$__rest(_a, [
        "onReachEnd"
    ]);
    var triggerLoadMoreRef = (0, $acw62.useRef)(null);
    var listRef = (0, $acw62.useRef)(null);
    var _b = $d93b64eb227ec3b2$var$__read((0, $acw62.useState)(false), 2), intersecting = _b[0], setIntersecting = _b[1];
    var _c = $d93b64eb227ec3b2$var$__read((0, $acw62.useState)(0), 2), notificationsHeight = _c[0], setNotificationsHeight = _c[1];
    (0, $acw62.useEffect)(function() {
        if (!props.hasMore || props.loadingMore || !triggerLoadMoreRef.current) return;
        var observer = new IntersectionObserver(function(entries) {
            setIntersecting(entries[0].isIntersecting);
        }, {
            threshold: 0.8,
            root: listRef.current
        });
        observer.observe(triggerLoadMoreRef.current);
        return function() {
            observer.disconnect();
            setIntersecting(false);
        };
    }, [
        props.hasMore,
        props.loadingMore
    ]);
    (0, $acw62.useEffect)(function() {
        if (intersecting && onReachEnd) onReachEnd();
    }, [
        onReachEnd,
        intersecting
    ]);
    (0, $acw62.useEffect)(function() {
        var _a, _b;
        setNotificationsHeight($d93b64eb227ec3b2$var$__spreadArray([], $d93b64eb227ec3b2$var$__read((_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[data-role=notification]")) !== null && _b !== void 0 ? _b : []), false).reduce(function(acc, el) {
            return acc + el.clientHeight;
        }, 0));
    }, [
        props.notifications
    ]);
    return (0, $ayMG0.jsxs)((0, $iymfR.Transition), {
        show: props.open,
        children: [
            (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                children: (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 -z-10 bg-neutral-500/50 transition-opacity ease-in-out data-[closed]:opacity-0 data-[open]:opacity-100\n            dark:bg-neutral-900/50"
                })
            }),
            (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                children: (0, $ayMG0.jsx)("div", {
                    className: "m-2 w-full flex-auto overflow-auto rounded-md bg-white text-sm shadow-lg ring-1 ring-gray-900/5 transition\n            data-[closed]:translate-y-1 data-[closed]:opacity-0 data-[enter]:duration-200 data-[leave]:duration-150\n            data-[enter]:ease-out data-[leave]:ease-in dark:bg-gray-800",
                    "data-role": "notifications-list",
                    style: {
                        maxHeight: "".concat(Math.max(Math.min(384, notificationsHeight + 20), 48), "px")
                    },
                    ref: listRef,
                    children: (0, $ayMG0.jsxs)("div", {
                        className: "divide-y divide-gray-100 overflow-y-auto dark:divide-gray-600",
                        children: [
                            props.notifications.map(function(item) {
                                return (0, $ayMG0.jsxs)("div", {
                                    className: "relative cursor-default p-2",
                                    "data-role": "notification",
                                    children: [
                                        (0, $ayMG0.jsx)("strong", {
                                            className: "font-semibold text-gray-900 dark:text-gray-100",
                                            children: item.title
                                        }),
                                        (0, $ayMG0.jsx)("p", {
                                            className: "mt-1 text-gray-600 dark:text-gray-200",
                                            children: item.content
                                        }),
                                        item.isNew && (0, $ayMG0.jsx)("div", {
                                            className: "bg-secondary absolute right-2 top-2 size-[5px] rounded-full"
                                        }),
                                        item.actions && (0, $ayMG0.jsxs)("div", {
                                            className: "mt-2 flex gap-2",
                                            children: [
                                                item.actions.primary && (0, $ayMG0.jsx)((0, $iL5oi.default), {
                                                    variant: "action",
                                                    size: "sm",
                                                    onClick: function() {
                                                        return props.onAction(item.id, item.actions.primary.onClick);
                                                    },
                                                    disabled: !item.actionable,
                                                    children: item.actions.primary.text
                                                }),
                                                item.actions.secondary && (0, $ayMG0.jsx)((0, $iL5oi.default), {
                                                    className: "opacity-80",
                                                    variant: "action",
                                                    size: "sm",
                                                    onClick: function() {
                                                        return props.onAction(item.id, item.actions.secondary.onClick);
                                                    },
                                                    disabled: !item.actionable,
                                                    children: item.actions.secondary.text
                                                })
                                            ]
                                        })
                                    ]
                                }, item.id);
                            }),
                            props.hasMore && !props.loadingMore && (0, $ayMG0.jsx)("div", {
                                className: "relative p-5",
                                ref: triggerLoadMoreRef
                            }),
                            props.loadingMore && (0, $ayMG0.jsx)("div", {
                                className: "relative h-12",
                                children: (0, $ayMG0.jsx)((0, $jFdmN.default), {})
                            }),
                            props.notifications.length === 0 && !props.loadingMore && !props.hasMore && (0, $ayMG0.jsx)("div", {
                                className: "h-12 text-center leading-[48px] text-gray-500 dark:text-gray-400",
                                "data-role": "notification",
                                children: (0, $dtKoB.default)("No notifications")
                            })
                        ]
                    })
                })
            })
        ]
    });
}

});

parcelRegister("1T737", function(module, exports) {

$parcel$export(module.exports, "default", () => $1600655e073b1ca0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $jJqAu = parcelRequire("jJqAu");

var $V9NIz = parcelRequire("V9NIz");

var $2jyto = parcelRequire("2jyto");
function $1600655e073b1ca0$export$2e2bcd8739ae039(_a) {
    var _b;
    var currentProduct = _a.currentProduct, game = _a.game;
    if (!game || !currentProduct || !((_b = game.allowedProducts) === null || _b === void 0 ? void 0 : _b.includes(currentProduct))) return (0, $ayMG0.jsx)((0, $jJqAu.default), {});
    return (0, $ayMG0.jsx)($1600655e073b1ca0$var$GameWidget, {
        game: game,
        currentProduct: currentProduct
    });
}
function $1600655e073b1ca0$var$GameWidget(_a) {
    var game = _a.game, currentProduct = _a.currentProduct;
    switch(game.id){
        case "confetti_streak":
            return (0, $ayMG0.jsx)((0, $2jyto.default), {
                current: game.currentStreak,
                goal: game.goal,
                children: (0, $dtKoB.default)("Use %{currentProduct} every day for a week, and unlock confetti mode \uD83C\uDF89.", {
                    currentProduct: (0, $4Q1tF.productName)(currentProduct)
                })
            });
        case "g2_review":
            return (0, $ayMG0.jsx)((0, $V9NIz.default), {
                reward: game.reward,
                product: currentProduct
            });
    }
}

});
parcelRegister("jJqAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d6d8056df295d2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $6P5PQ = parcelRequire("6P5PQ");

var $140vn = parcelRequire("140vn");

var $dtKoB = parcelRequire("dtKoB");

var $hmJ39 = parcelRequire("hmJ39");

var $gBSm8 = parcelRequire("gBSm8");
var $e5d6d8056df295d2$var$SEVEN_DAYS = 604800000;
function $e5d6d8056df295d2$export$2e2bcd8739ae039() {
    var _a = (0, $140vn.useLocalStorageValue)("prompts:extension:last-click"), lastClickedOn = _a.value, setLastClickedOn = _a.set;
    var lastClickedOnDate = lastClickedOn ? new Date(lastClickedOn) : null;
    if (document.documentElement.getAttribute("data-upscope-extension-installed")) return null;
    if (lastClickedOnDate && new Date().getTime() - lastClickedOnDate.getTime() < $e5d6d8056df295d2$var$SEVEN_DAYS) return null;
    var isChromeDesktop = navigator.userAgent.match(/Chrome\/[0-9]+/) && !navigator.userAgent.match(/Mobile/);
    var isEdgeDesktop = navigator.userAgent.match(/Edg\/[0-9]+/) && !navigator.userAgent.match(/Mobile/);
    var isFirefoxDesktop = navigator.userAgent.match(/Firefox\/[0-9]+/) && !navigator.userAgent.match(/Mobile/);
    if (!isChromeDesktop && !isEdgeDesktop && !isFirefoxDesktop) return null;
    function onClick() {
        setLastClickedOn(new Date().toISOString());
        window.open((0, $hmJ39.path)("hs.extensionRedirect", {
            utmParams: {
                utmSource: "upscope_app",
                utmContent: "sidebar",
                utmMedium: "inapp",
                utmCampaign: "share_any_site"
            }
        }));
    }
    return (0, $ayMG0.jsxs)((0, $gBSm8.default), {
        onClick: onClick,
        children: [
            (0, $ayMG0.jsx)((0, $6P5PQ.default), {
                className: "text-primary-700 mb-2 size-5"
            }),
            (0, $ayMG0.jsx)("span", {
                children: (0, $dtKoB.default)("Easily share any website with friends or colleagues with our extension.")
            })
        ]
    });
}

});
parcelRegister("6P5PQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7c08395b53fdc4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $4f7c08395b53fdc4$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
        clipRule: "evenodd"
    }));
}
const $4f7c08395b53fdc4$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($4f7c08395b53fdc4$var$SparklesIcon);
var $4f7c08395b53fdc4$export$2e2bcd8739ae039 = $4f7c08395b53fdc4$var$ForwardRef;

});

parcelRegister("140vn", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageValue", () => $0c668e762fcbb7e8$export$70c6bfcb9e828be6);

var $eHhzu = parcelRequire("eHhzu");

var $5T31O = parcelRequire("5T31O");
let $0c668e762fcbb7e8$var$IS_LOCAL_STORAGE_AVAILABLE;
try {
    $0c668e762fcbb7e8$var$IS_LOCAL_STORAGE_AVAILABLE = (0, $5T31O.isBrowser) && Boolean(globalThis.localStorage);
} catch  {
    $0c668e762fcbb7e8$var$IS_LOCAL_STORAGE_AVAILABLE = false;
}
const $0c668e762fcbb7e8$export$70c6bfcb9e828be6 = $0c668e762fcbb7e8$var$IS_LOCAL_STORAGE_AVAILABLE ? (key, options)=>(0, $eHhzu.useStorageValue)(localStorage, key, options) : (_key, _options)=>{
    return {
        value: undefined,
        set: (0, $5T31O.noop),
        remove: (0, $5T31O.noop),
        fetch: (0, $5T31O.noop)
    };
};

});
parcelRegister("eHhzu", function(module, exports) {

$parcel$export(module.exports, "useStorageValue", () => $ab32b62abf12714a$export$c9e55b214488f945);

var $acw62 = parcelRequire("acw62");

var $2DvvU = parcelRequire("2DvvU");

var $7AAnc = parcelRequire("7AAnc");

var $eut6O = parcelRequire("eut6O");

var $2MqvZ = parcelRequire("2MqvZ");

var $5T31O = parcelRequire("5T31O");

var $8y9OS = parcelRequire("8y9OS");

var $4eJRo = parcelRequire("4eJRo");
const $ab32b62abf12714a$var$storageListeners = new Map();
const $ab32b62abf12714a$var$invokeStorageKeyListeners = (s, key, value, skipListener)=>{
    const listeners = $ab32b62abf12714a$var$storageListeners.get(s)?.get(key);
    if (listeners === undefined || listeners.size === 0) return;
    for (const listener of listeners)if (listener !== skipListener) // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    listener(value);
};
const $ab32b62abf12714a$var$storageEventHandler = (evt)=>{
    if (evt.storageArea && evt.key && evt.newValue) $ab32b62abf12714a$var$invokeStorageKeyListeners(evt.storageArea, evt.key, evt.newValue);
};
const $ab32b62abf12714a$var$addStorageListener = (s, key, listener)=>{
    // In case of first listener added within browser environment we
    // want to bind single storage event handler
    if ((0, $5T31O.isBrowser) && $ab32b62abf12714a$var$storageListeners.size === 0) (0, $8y9OS.on)(globalThis, "storage", $ab32b62abf12714a$var$storageEventHandler, {
        passive: true
    });
    let keys = $ab32b62abf12714a$var$storageListeners.get(s);
    if (!keys) {
        keys = new Map();
        $ab32b62abf12714a$var$storageListeners.set(s, keys);
    }
    let listeners = keys.get(key);
    if (!listeners) {
        listeners = new Set();
        keys.set(key, listeners);
    }
    listeners.add(listener);
};
const $ab32b62abf12714a$var$removeStorageListener = (s, key, listener)=>{
    const keys = $ab32b62abf12714a$var$storageListeners.get(s);
    if (!keys) return;
    const listeners = keys.get(key);
    if (!listeners) return;
    listeners.delete(listener);
    if (listeners.size === 0) keys.delete(key);
    if (keys.size === 0) $ab32b62abf12714a$var$storageListeners.delete(s);
    // Unbind storage event handler in browser environment in case there is no
    // storage keys listeners left
    if ((0, $5T31O.isBrowser) && $ab32b62abf12714a$var$storageListeners.size === 0) (0, $8y9OS.off)(globalThis, "storage", $ab32b62abf12714a$var$storageEventHandler);
};
const $ab32b62abf12714a$var$DEFAULT_OPTIONS = {
    defaultValue: null,
    initializeWithValue: true
};
function $ab32b62abf12714a$export$c9e55b214488f945(storage, key, options) {
    const optionsRef = (0, $eut6O.useSyncedRef)({
        ...$ab32b62abf12714a$var$DEFAULT_OPTIONS,
        ...options
    });
    const parse = (str, fallback)=>{
        const parseFunction = optionsRef.current.parse ?? $ab32b62abf12714a$var$defaultParse;
        return parseFunction(str, fallback);
    };
    const stringify = (data)=>{
        const stringifyFunction = optionsRef.current.stringify ?? $ab32b62abf12714a$var$defaultStringify;
        return stringifyFunction(data);
    };
    const storageActions = (0, $eut6O.useSyncedRef)({
        fetchRaw: ()=>storage.getItem(key),
        fetch: ()=>parse(storageActions.current.fetchRaw(), optionsRef.current.defaultValue),
        remove () {
            storage.removeItem(key);
        },
        store (value) {
            const stringified = stringify(value);
            if (stringified !== null) storage.setItem(key, stringified);
            return stringified;
        }
    });
    const isFirstMount = (0, $2DvvU.useFirstMountState)();
    const [state, setState] = (0, $acw62.useState)(optionsRef.current?.initializeWithValue && isFirstMount ? storageActions.current.fetch() : undefined);
    const stateRef = (0, $eut6O.useSyncedRef)(state);
    const stateActions = (0, $eut6O.useSyncedRef)({
        fetch () {
            setState(storageActions.current.fetch());
        },
        setRawVal (value) {
            setState(parse(value, optionsRef.current.defaultValue));
        }
    });
    (0, $2MqvZ.useUpdateEffect)(()=>{
        stateActions.current.fetch();
    }, [
        key
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!optionsRef.current.initializeWithValue) stateActions.current.fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7AAnc.useIsomorphicLayoutEffect)(()=>{
        const handler = stateActions.current.setRawVal;
        $ab32b62abf12714a$var$addStorageListener(storage, key, handler);
        return ()=>{
            $ab32b62abf12714a$var$removeStorageListener(storage, key, handler);
        };
    }, [
        storage,
        key
    ]);
    const actions = (0, $eut6O.useSyncedRef)({
        set (value) {
            if (!(0, $5T31O.isBrowser)) return;
            const s = (0, $4eJRo.resolveHookState)(value, stateRef.current);
            const storeValue = storageActions.current.store(s);
            if (storeValue !== null) $ab32b62abf12714a$var$invokeStorageKeyListeners(storage, key, storeValue);
        },
        delete () {
            if (!(0, $5T31O.isBrowser)) return;
            storageActions.current.remove();
            $ab32b62abf12714a$var$invokeStorageKeyListeners(storage, key, null);
        },
        fetch () {
            if (!(0, $5T31O.isBrowser)) return;
            $ab32b62abf12714a$var$invokeStorageKeyListeners(storage, key, storageActions.current.fetchRaw());
        }
    });
    // Make actions static so developers can pass methods further
    const staticActions = (0, $acw62.useMemo)(()=>({
            set: (v)=>{
                actions.current.set(v);
            },
            remove () {
                actions.current.delete();
            },
            fetch () {
                actions.current.fetch();
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (0, $acw62.useMemo)(()=>({
            value: state,
            ...staticActions
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        state
    ]);
}
const $ab32b62abf12714a$var$defaultStringify = (data)=>{
    if (data === null) return null;
    try {
        return JSON.stringify(data);
    } catch (error) /* v8 ignore next */ {
        // I have absolutely no idea how to cover this, since modern JSON.stringify does not throw on
        // cyclic references anymore
        console.warn(error);
        return null;
    }
};
const $ab32b62abf12714a$var$defaultParse = (str, fallback)=>{
    if (str === null) return fallback;
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(str);
    } catch (error) {
        console.warn(error);
        return fallback;
    }
};

});
parcelRegister("7AAnc", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $58681c21b9d43321$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");

var $5T31O = parcelRequire("5T31O");
const $58681c21b9d43321$export$700979bc83e7db82 = (0, $5T31O.isBrowser) ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});

parcelRegister("2MqvZ", function(module, exports) {

$parcel$export(module.exports, "useUpdateEffect", () => $2064a1cf44b32596$export$496315a1608d9602);

var $acw62 = parcelRequire("acw62");

var $2DvvU = parcelRequire("2DvvU");

var $5T31O = parcelRequire("5T31O");
function $2064a1cf44b32596$export$496315a1608d9602(effect, deps) {
    const isFirstMount = (0, $2DvvU.useFirstMountState)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(isFirstMount ? (0, $5T31O.noop) : effect, deps);
}

});

parcelRegister("8y9OS", function(module, exports) {

$parcel$export(module.exports, "on", () => $63991da85116d43f$export$af631764ddc44097);
$parcel$export(module.exports, "off", () => $63991da85116d43f$export$8c8705df4a2dcec9);
function $63991da85116d43f$export$af631764ddc44097(object, ...args) {
    object?.addEventListener?.(...args);
}
function $63991da85116d43f$export$8c8705df4a2dcec9(object, ...args) {
    object?.removeEventListener?.(...args);
}
const $63991da85116d43f$export$5a15a386532a5ea4 = (object, property)=>Object.hasOwn(object, property);
const $63991da85116d43f$export$93ead1fd1cf49e7d = ()=>true;
const $63991da85116d43f$export$d47141051f75bbe2 = ()=>false;
const $63991da85116d43f$export$fdc1631654156ab = (d1, d2)=>{
    if (d1 === d2) return true;
    if (d1.length !== d2.length) return false;
    for (const [i, element] of d1.entries()){
        if (element !== d2[i]) return false;
    }
    return true;
};

});

parcelRegister("4eJRo", function(module, exports) {

$parcel$export(module.exports, "resolveHookState", () => $315c0b190c176671$export$efbb6b4f12b20b5e);
function $315c0b190c176671$var$initState(initialState) {
    if (typeof initialState === "function") initialState = initialState();
    return initialState;
}
function $315c0b190c176671$var$updateState(nextState, previousState) {
    if (typeof nextState === "function") return nextState(previousState);
    return nextState;
}
function $315c0b190c176671$export$efbb6b4f12b20b5e(...args) {
    if (args.length === 1) return $315c0b190c176671$var$initState(args[0]);
    return $315c0b190c176671$var$updateState(args[0], args[1]);
}

});



parcelRegister("gBSm8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c17a44022ca82a09$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");
function $c17a44022ca82a09$export$2e2bcd8739ae039(_a) {
    var children = _a.children, onClick = _a.onClick, className = _a.className;
    return (0, $ayMG0.jsx)("div", {
        className: (0, $01O3F.classNames)("bg-secondary-100 rounded-lg mb-4 shadow-multi p-2 -mx-2 text-sm text-primary-900 overflow-hidden", onClick && "clickable", className),
        onClick: onClick,
        children: children
    });
}

});


parcelRegister("V9NIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0abced3db43ec249$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $5nOkI = parcelRequire("5nOkI");

var $dtKoB = parcelRequire("dtKoB");

var $5aE2v = parcelRequire("5aE2v");

var $hW7sX = parcelRequire("hW7sX");

var $gBSm8 = parcelRequire("gBSm8");
function $0abced3db43ec249$export$2e2bcd8739ae039(_a) {
    var reward = _a.reward, product = _a.product;
    var addModal = (0, $5aE2v.useModal)().addModal;
    var report = (0, $hW7sX.useApi)("global.gamification.leftReview.report").call;
    function onLeftReview() {
        report();
        addModal({
            title: (0, $dtKoB.default)("Thank you for leaving a review!"),
            content: (0, $dtKoB.default)("Thank you for leaving a review on G2. You have now unlocked confetti mode!"),
            type: "success",
            replace: true
        });
    }
    function onClick() {
        // TODO: Change URL for different products
        window.open("https://www.g2.com/products/helloscreen-by-upscope/reviews/start");
        setTimeout(function() {
            addModal({
                title: (0, $dtKoB.default)("Were you able to leave a review?"),
                content: (0, $dtKoB.default)("Were you able to leave a review on G2? If you need a hand, please let us know!"),
                confirmText: (0, $dtKoB.default)("I left a review"),
                cancelText: (0, $dtKoB.default)("Not yet"),
                onClick: function(leftReview) {
                    if (leftReview) onLeftReview();
                }
            });
        }, 10000);
    }
    return (0, $ayMG0.jsxs)((0, $gBSm8.default), {
        onClick: onClick,
        children: [
            (0, $ayMG0.jsxs)("div", {
                className: "mb-2 flex items-center gap-1",
                children: [
                    (0, $ayMG0.jsx)((0, $5nOkI.default), {
                        className: "w-4"
                    }),
                    (0, $ayMG0.jsx)((0, $5nOkI.default), {
                        className: "w-4"
                    }),
                    (0, $ayMG0.jsx)((0, $5nOkI.default), {
                        className: "w-4"
                    }),
                    (0, $ayMG0.jsx)((0, $5nOkI.default), {
                        className: "w-4"
                    }),
                    (0, $ayMG0.jsx)((0, $5nOkI.default), {
                        className: "w-4"
                    })
                ]
            }),
            (0, $ayMG0.jsx)("span", {
                children: (0, $dtKoB.default)("Leave a quick review of HelloScreen on G2 and unlock confetti mode \uD83C\uDF89.")
            })
        ]
    });
}

});
parcelRegister("5nOkI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb624d3d77edbcf$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3eb624d3d77edbcf$var$StarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401Z",
        clipRule: "evenodd"
    }));
}
const $3eb624d3d77edbcf$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($3eb624d3d77edbcf$var$StarIcon);
var $3eb624d3d77edbcf$export$2e2bcd8739ae039 = $3eb624d3d77edbcf$var$ForwardRef;

});


parcelRegister("2jyto", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af818c07dcb4818$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");

var $gBSm8 = parcelRequire("gBSm8");
function $1af818c07dcb4818$export$2e2bcd8739ae039(_a) {
    var children = _a.children, current = _a.current, goal = _a.goal;
    return (0, $ayMG0.jsxs)((0, $gBSm8.default), {
        children: [
            (0, $ayMG0.jsxs)("div", {
                className: "relative h-12 -ml-2 mb-1",
                children: [
                    (0, $ayMG0.jsx)("div", {
                        className: (0, $01O3F.classNames)("absolute h-0 border-b-2 border-secondary-200 top-1/2", current < 2 && "left-1/2 w-1/4", current === 2 && "left-1/4 w-1/2", current > 2 && current < goal - 2 && "left-0 w-3/4", current === goal - 1 && "left-0 w-3/4", current === goal - 2 && "left-0 w-full", current === goal && "left-0 w-1/2")
                    }),
                    goal > current + 2 && (0, $ayMG0.jsx)("div", {
                        className: "absolute h-0 border-b-2 border-secondary-200 border-dashed top-1/2 right-0 w-1/4"
                    }),
                    current > 2 && (0, $ayMG0.jsx)($1af818c07dcb4818$var$Number, {
                        state: "past",
                        position: "left-0",
                        children: current - 2
                    }),
                    current > 1 && (0, $ayMG0.jsx)($1af818c07dcb4818$var$Number, {
                        state: "past",
                        position: "left-1/4",
                        children: current - 1
                    }),
                    (0, $ayMG0.jsx)($1af818c07dcb4818$var$Number, {
                        state: "current",
                        position: "left-1/2",
                        children: current
                    }),
                    current < goal && (0, $ayMG0.jsx)($1af818c07dcb4818$var$Number, {
                        state: "future",
                        position: "left-3/4",
                        children: current + 1
                    }),
                    current < goal - 1 && (0, $ayMG0.jsx)($1af818c07dcb4818$var$Number, {
                        state: "future",
                        position: "left-full",
                        children: goal
                    })
                ]
            }),
            (0, $ayMG0.jsx)("span", {
                children: children
            })
        ]
    });
}
function $1af818c07dcb4818$var$Number(_a) {
    var children = _a.children, state = _a.state, position = _a.position;
    return (0, $ayMG0.jsx)("div", {
        className: (0, $01O3F.classNames)("absolute h-5 w-5 text-white rounded-full top-1/2 left-0 transform -translate-x-1/2 -translate-y-1/2 flex items-center\n        justify-center", state === "current" ? "ring-2 ring-primary-400 ring-offset-2" : "", state === "future" ? "bg-secondary-200" : "bg-secondary-400", position),
        children: (0, $ayMG0.jsx)("span", {
            className: "text-xs font-semibold",
            children: children
        })
    });
}

});



parcelRegister("3AV6E", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e108022c2e848a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $9A1Zn = parcelRequire("9A1Zn");

var $acw62 = parcelRequire("acw62");

var $dtKoB = parcelRequire("dtKoB");

var $5aE2v = parcelRequire("5aE2v");

var $hW7sX = parcelRequire("hW7sX");

var $kG3Fh = parcelRequire("kG3Fh");

var $cSimh = parcelRequire("cSimh");

var $iL5oi = parcelRequire("iL5oi");
var $29e108022c2e848a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29e108022c2e848a$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $29e108022c2e848a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $29e108022c2e848a$export$2e2bcd8739ae039() {
    var doNotOffer = (0, $9A1Zn.useSessionStorageValue)("doNotOfferPassword", {
        defaultValue: false
    }).value;
    var addModal = (0, $5aE2v.useModal)().addModal;
    (0, $acw62.useEffect)(function() {
        if (doNotOffer) return;
        addModal({
            title: (0, $dtKoB.default)("Set a password"),
            cancelText: (0, $dtKoB.default)("Not now"),
            confirmText: (0, $dtKoB.default)("Set password"),
            content: (0, $ayMG0.jsx)($29e108022c2e848a$var$PasswordModalContent, {})
        });
    }, [
        doNotOffer,
        addModal
    ]);
    return null;
}
var $29e108022c2e848a$var$PasswordModalContent = function() {
    var setDoNotOffer = (0, $9A1Zn.useSessionStorageValue)("doNotOfferPassword", {
        defaultValue: false
    }).set;
    var _a = (0, $5aE2v.useModal)(), addModal = _a.addModal, removeModal = _a.removeModal, bindModalClick = _a.bindModalClick;
    var inputRef = (0, $acw62.useRef)(null);
    var _b = $29e108022c2e848a$var$__read((0, $acw62.useState)(), 2), error = _b[0], setError = _b[1];
    var _c = (0, $hW7sX.useApi)("auth.password.submit"), call = _c.call, isLoading = _c.isLoading;
    var onSubmit = (0, $acw62.useCallback)(function(evt) {
        return $29e108022c2e848a$var$__awaiter(void 0, void 0, void 0, function() {
            var response;
            var _a, _b;
            return $29e108022c2e848a$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        evt === null || evt === void 0 || evt.preventDefault();
                        return [
                            4 /*yield*/ ,
                            call({
                                password: (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : ""
                            })
                        ];
                    case 1:
                        response = _c.sent();
                        if (response.success) {
                            if (evt) removeModal();
                            addModal({
                                type: "success",
                                title: response.preEnabled ? (0, $dtKoB.default)("Password set") : (0, $dtKoB.default)("Please check your email"),
                                content: response.preEnabled ? (0, $dtKoB.default)("Your password has been set. You can now log in with your email and password.") : (0, $dtKoB.default)("We have sent you an email to confirm your password. Follow the link in the email to set your password."),
                                replace: true
                            });
                            return [
                                2 /*return*/ ,
                                true
                            ];
                        } else if (response.error === "validation_error") switch(response.userErrors.password){
                            case "password_not_allowed_by_team":
                                setError((0, $dtKoB.default)("Password not allowed by team"));
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            case "password_minimum_8_characters":
                                setError((0, $dtKoB.default)("Password must be at least 8 characters long"));
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            case "password_must_not_be_a_common_password":
                                setError((0, $dtKoB.default)("Password must not be a common password"));
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                            case "password_must_contain_letters_and_non_letters":
                                setError((0, $dtKoB.default)("Password must contain letters and non letters"));
                                return [
                                    2 /*return*/ ,
                                    false
                                ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        removeModal,
        addModal,
        call
    ]);
    (0, $acw62.useEffect)(function() {
        setTimeout(function() {
            var _a;
            // Wait for modal to open
            (_a = inputRef.current) === null || _a === void 0 || _a.focus();
        }, 100);
    }, [
        inputRef
    ]);
    (0, $acw62.useEffect)(function() {
        bindModalClick(function(confirm) {
            if (confirm) return onSubmit();
            else setDoNotOffer(true);
        });
    }, [
        bindModalClick,
        onSubmit,
        setDoNotOffer
    ]);
    return (0, $ayMG0.jsxs)("form", {
        onSubmit: onSubmit,
        children: [
            (0, $ayMG0.jsx)("p", {
                children: (0, $dtKoB.default)("Setting a password allows you to log into Upscope more quickly and securely.")
            }),
            (0, $ayMG0.jsx)((0, $kG3Fh.default), {
                label: (0, $dtKoB.default)("Password"),
                explanation: (0, $dtKoB.default)("Make sure it is long and secure."),
                className: "!mb-0 !mt-5 text-left",
                error: error,
                children: (0, $ayMG0.jsx)((0, $cSimh.default), {
                    type: "password",
                    ref: inputRef,
                    required: true,
                    autoComplete: "new-password"
                })
            }),
            (0, $ayMG0.jsx)((0, $iL5oi.default), {
                type: "submit",
                className: "hidden",
                loading: isLoading,
                children: "Submit"
            }),
            " "
        ]
    });
};

});
parcelRegister("9A1Zn", function(module, exports) {

$parcel$export(module.exports, "useSessionStorageValue", () => $6f9904d26351af0b$export$509bc8842db77379);

var $eHhzu = parcelRequire("eHhzu");

var $5T31O = parcelRequire("5T31O");
let $6f9904d26351af0b$var$IS_SESSION_STORAGE_AVAILABLE;
try {
    $6f9904d26351af0b$var$IS_SESSION_STORAGE_AVAILABLE = (0, $5T31O.isBrowser) && Boolean(globalThis.sessionStorage);
} catch  {
    $6f9904d26351af0b$var$IS_SESSION_STORAGE_AVAILABLE = false;
}
const $6f9904d26351af0b$export$509bc8842db77379 = $6f9904d26351af0b$var$IS_SESSION_STORAGE_AVAILABLE ? (key, options)=>(0, $eHhzu.useStorageValue)(sessionStorage, key, options) : (_key, _options)=>{
    return {
        value: undefined,
        set: (0, $5T31O.noop),
        remove: (0, $5T31O.noop),
        fetch: (0, $5T31O.noop)
    };
};

});

parcelRegister("cSimh", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f8c4c81f1cda78$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dtKoB = parcelRequire("dtKoB");

var $iZHPA = parcelRequire("iZHPA");

var $kC5VA = parcelRequire("kC5VA");

var $01O3F = parcelRequire("01O3F");

var $cXw8m = parcelRequire("cXw8m");

var $jFdmN = parcelRequire("jFdmN");
var $95f8c4c81f1cda78$var$__assign = undefined && undefined.__assign || function() {
    $95f8c4c81f1cda78$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $95f8c4c81f1cda78$var$__assign.apply(this, arguments);
};
var $95f8c4c81f1cda78$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $95f8c4c81f1cda78$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $95f8c4c81f1cda78$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $95f8c4c81f1cda78$var$Input = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    var _a;
    var prefix = props.prefix, suffix = props.suffix, className = props.className, ignoreValueOnFocus = props.ignoreValueOnFocus, loading = props.loading, _b = props.validationTrigger, validationTrigger = _b === void 0 ? "submit" : _b, onBlur = props.onBlur, onFocus = props.onFocus, inputProps = $95f8c4c81f1cda78$var$__rest(props, [
        "prefix",
        "suffix",
        "className",
        "ignoreValueOnFocus",
        "loading",
        "validationTrigger",
        "onBlur",
        "onFocus"
    ]);
    var stringValueProp = String((_a = props.value) !== null && _a !== void 0 ? _a : "");
    var inputRef = (0, $iZHPA.default)(ref);
    var _c = $95f8c4c81f1cda78$var$__read((0, $acw62.useState)(stringValueProp), 2), currentValue = _c[0], setCurrentValue = _c[1];
    var _d = $95f8c4c81f1cda78$var$__read((0, $acw62.useState)(false), 2), hasFocus = _d[0], setHasFocus = _d[1];
    var _e = $95f8c4c81f1cda78$var$__read((0, $cXw8m.siftClassNames)(className, [
        "margin",
        "layout"
    ]), 2), outerClassName = _e[0], innerClassName = _e[1];
    var prefixLength = (0, $kC5VA.default)("text-sm", prefix);
    var valueProp = ignoreValueOnFocus && hasFocus ? currentValue : props.value;
    var valueLength = (0, $kC5VA.default)("text-sm", (suffix === null || suffix === void 0 ? void 0 : suffix.startsWith(" ")) ? "".concat(valueProp !== null && valueProp !== void 0 ? valueProp : currentValue, " ") : String(valueProp !== null && valueProp !== void 0 ? valueProp : currentValue));
    var resetValidationMessage = (0, $acw62.useCallback)(function() {
        var input = inputRef.current;
        if (!input) return;
        input.setAttribute("pattern", ".*");
        input.setCustomValidity("");
    }, [
        inputRef
    ]);
    (0, $acw62.useEffect)(function() {
        var interval = setInterval(function() {
            if ((!hasFocus || !ignoreValueOnFocus) && inputRef.current && inputRef.current.value !== currentValue) setCurrentValue(inputRef.current.value);
        }, 100);
        return function() {
            return clearInterval(interval);
        };
    }, [
        currentValue,
        inputRef,
        hasFocus,
        ignoreValueOnFocus
    ]);
    var outerOnChange = props.onChange;
    var innerOnChange = (0, $acw62.useCallback)(function(e) {
        resetValidationMessage();
        setCurrentValue(e.target.value);
        outerOnChange === null || outerOnChange === void 0 || outerOnChange(e);
    }, [
        outerOnChange,
        resetValidationMessage
    ]);
    var innerOnBlur = (0, $acw62.useCallback)(function() {
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        setHasFocus(false);
        onBlur === null || onBlur === void 0 || onBlur.apply(void 0, $95f8c4c81f1cda78$var$__spreadArray([], $95f8c4c81f1cda78$var$__read(params), false));
    }, [
        onBlur
    ]);
    var innerOnFocus = (0, $acw62.useCallback)(function() {
        var _a;
        var params = [];
        for(var _i = 0; _i < arguments.length; _i++)params[_i] = arguments[_i];
        if (inputProps.readOnly) {
            (_a = inputRef.current) === null || _a === void 0 || _a.blur();
            return;
        }
        setHasFocus(true);
        onFocus === null || onFocus === void 0 || onFocus.apply(void 0, $95f8c4c81f1cda78$var$__spreadArray([], $95f8c4c81f1cda78$var$__read(params), false));
    }, [
        onFocus,
        inputProps.readOnly,
        inputRef
    ]);
    (0, $acw62.useEffect)(function() {
        var input = inputRef.current;
        if (!input) return;
        if (!hasFocus) {
            var validation = $95f8c4c81f1cda78$var$getValidation({
                type: props.type,
                validation: props.validation
            });
            if (!validation) return;
            $95f8c4c81f1cda78$var$validateInput({
                validation: validation,
                input: input
            });
        }
        if (validationTrigger === "blur") input.reportValidity();
    }, [
        hasFocus,
        validationTrigger,
        inputRef,
        props.type,
        props.validation
    ]);
    (0, $acw62.useEffect)(function() {
        var input = inputRef.current;
        var validation = $95f8c4c81f1cda78$var$getValidation({
            type: props.type,
            validation: props.validation
        });
        if (!validation || !input) return;
        var handleSubmitBefore = function(e) {
            // Only validate if the input belongs to the form being submitted
            if (input.form !== e.target) return;
            if (!$95f8c4c81f1cda78$var$validateInput({
                validation: validation,
                input: input
            })) {
                e.stopPropagation();
                e.preventDefault();
                input.reportValidity();
            }
        };
        document.addEventListener("submit", handleSubmitBefore, true);
        return function() {
            document.removeEventListener("submit", handleSubmitBefore, true);
        };
    }, [
        props.type,
        props.validation,
        inputRef
    ]);
    (0, $acw62.useEffect)(function() {
        if (hasFocus && inputProps.type === "number") {
            var listener_1 = function() {
                var _a;
                (_a = inputRef.current) === null || _a === void 0 || _a.blur();
            };
            document.addEventListener("wheel", listener_1);
            return function() {
                document.removeEventListener("wheel", listener_1);
            };
        }
    }, [
        inputRef,
        hasFocus,
        inputProps.type
    ]);
    var paddingLeft = (0, $acw62.useMemo)(function() {
        if (!prefix) return 16;
        return prefixLength + 16;
    }, [
        prefix,
        prefixLength
    ]);
    return (0, $ayMG0.jsxs)("div", {
        className: (0, $01O3F.classNames)("relative flex rounded-md shadow-sm", outerClassName),
        children: [
            prefix && (0, $ayMG0.jsx)("div", {
                className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4",
                children: (0, $ayMG0.jsx)("span", {
                    className: "text-sm text-gray-500",
                    children: prefix
                })
            }),
            (0, $ayMG0.jsx)("input", $95f8c4c81f1cda78$var$__assign({
                ref: inputRef,
                className: (0, $01O3F.classNames)("block max-w-full grow border border-gray-200 bg-white p-2 px-4 text-sm transition duration-100 ease-in-out rounded-md\n          disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-50 dark:text-white dark:bg-gray-800\n          focus:border-primary dark:focus:border-secondary focus:ring-primary dark:focus:ring-secondary focus:ring-1\n          dark:border-gray-700 group-[.has-error]:border-red-300 group-[.has-error]:pr-10 group-[.has-error]:text-red-900\n          group-[.has-error]:placeholder-red-300 group-[.has-error]:focus:border-red-500 group-[.has-error]:focus:outline-none\n          group-[.has-error]:focus:ring-red-500 group-[.has-error]:dark:border-red-500 group-[.has-error]:dark:text-red-200\n          group-[.has-error]:dark:focus:border-red-500 read-only:cursor-default", innerClassName),
                style: {
                    paddingLeft: paddingLeft
                }
            }, inputProps, {
                onFocus: innerOnFocus,
                onBlur: innerOnBlur,
                value: valueProp,
                onChange: innerOnChange
            })),
            suffix && (0, $ayMG0.jsx)("div", {
                className: "pointer-events-none absolute inset-0 flex items-center overflow-hidden",
                style: {
                    paddingLeft: "".concat(paddingLeft + valueLength + 1, "px")
                },
                children: (0, $ayMG0.jsx)("span", {
                    className: "text-sm text-gray-500",
                    children: suffix
                })
            }),
            !suffix && (0, $ayMG0.jsx)("div", {
                className: "pointer-events-none absolute inset-y-0 right-0 hidden items-center pr-3 group-[.has-error]:flex",
                children: (0, $ayMG0.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "currentColor",
                    className: "size-5 text-red-500",
                    children: (0, $ayMG0.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
                        clipRule: "evenodd"
                    })
                })
            }),
            loading && (0, $ayMG0.jsx)("div", {
                className: "absolute right-2 h-full w-5",
                children: (0, $ayMG0.jsx)((0, $jFdmN.default), {})
            })
        ]
    });
});
function $95f8c4c81f1cda78$var$generateValidation(validation) {
    var regex, message;
    switch(validation){
        case "email":
            regex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
            message = (0, $dtKoB.default)("Please enter a valid email address.");
            break;
        case "name":
            regex = /^[^0-9`!@#$%\^&*<>+_\/=:]+$/;
            message = (0, $dtKoB.default)("Only use letters in your name");
            break;
        case "url":
            regex = /^https?:\/\//;
            message = (0, $dtKoB.default)("Url must start with http:// or https://");
            break;
        case "secretKey":
            regex = /^.{32,}$/i;
            message = (0, $dtKoB.default)("Secret key must be at least 32 characters long");
            break;
        case "phoneNumber":
            regex = /^[0-9+\(\)\s-]*$/;
            message = (0, $dtKoB.default)("Please enter a valid phone number.");
            break;
        case "multiEmail":
            regex = /^([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})(,\s*[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})*$/i;
            message = (0, $dtKoB.default)("Please enter valid email addresses separated by commas.");
            break;
        case "usZipCode":
            regex = /^\d{5}$/i;
            message = (0, $dtKoB.default)("US ZIP code must be 5 digits");
            break;
        default:
            validation;
            throw new Error("unknown validation");
    }
    return {
        message: message,
        regex: regex
    };
}
function $95f8c4c81f1cda78$var$getValidation(_a) {
    var type = _a.type, validation = _a.validation;
    return type === "email" ? "email" : validation;
}
function $95f8c4c81f1cda78$var$validateInput(_a) {
    var input = _a.input, validation = _a.validation;
    var _b = $95f8c4c81f1cda78$var$generateValidation(validation), message = _b.message, regex = _b.regex;
    if (input.value.length > 0 && !regex.test(input.value)) {
        input.setCustomValidity(message);
        input.setAttribute("pattern", "s{0}");
        return false;
    }
    return true;
}
var $95f8c4c81f1cda78$export$2e2bcd8739ae039 = $95f8c4c81f1cda78$var$Input;

});


parcelRegister("4eFVO", function(module, exports) {

$parcel$export(module.exports, "useCurrentTeamId", () => $3158fef039761180$export$792e1d6e44802629);

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $iCMjC = parcelRequire("iCMjC");
function $3158fef039761180$export$792e1d6e44802629(allowNull) {
    if (allowNull === void 0) allowNull = false;
    var teams = (0, $iCMjC.useAuthentication)().teams;
    var pathname = (0, $lzNIT.useLocation)().pathname;
    if (!teams && !allowNull) throw new Error("You can only use useCurrentTeamId without allowing null on authenticated routes");
    var currentTeamId = (0, $acw62.useMemo)(function() {
        var _a;
        return (_a = teams === null || teams === void 0 ? void 0 : teams.find(function(t) {
            return pathname.split("/").includes(t.domain);
        })) === null || _a === void 0 ? void 0 : _a.id;
    }, [
        teams,
        pathname
    ]);
    if (currentTeamId) return currentTeamId;
    if (allowNull) return null;
    throw new Error("User is not member of the team, we are not allowing null, but the router allowed rendering this component");
}

});

parcelRegister("iNF3S", function(module, exports) {

$parcel$export(module.exports, "useNotifications", () => $dafca78dfd8bfe23$export$53d5ca6c3f53e109);
$parcel$export(module.exports, "NotificationsProvider", () => $dafca78dfd8bfe23$export$ca1c7da642902c6e);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hW7sX = parcelRequire("hW7sX");

var $7xuAh = parcelRequire("7xuAh");

var $01O3F = parcelRequire("01O3F");

var $iCMjC = parcelRequire("iCMjC");

var $5aE2v = parcelRequire("5aE2v");
var $dafca78dfd8bfe23$var$__assign = undefined && undefined.__assign || function() {
    $dafca78dfd8bfe23$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dafca78dfd8bfe23$var$__assign.apply(this, arguments);
};
var $dafca78dfd8bfe23$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dafca78dfd8bfe23$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $dafca78dfd8bfe23$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $dafca78dfd8bfe23$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $dafca78dfd8bfe23$var$notificationsContext = /*#__PURE__*/ (0, $acw62.createContext)({
    notificationsCount: undefined,
    loadingMore: false,
    hasMore: false,
    notifications: [],
    onLoadMore: function() {
        return $dafca78dfd8bfe23$var$__awaiter(void 0, void 0, void 0, function() {
            return $dafca78dfd8bfe23$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    },
    clearNotifications: function() {},
    onAction: function(notificationId, actionId) {
        return $dafca78dfd8bfe23$var$__awaiter(void 0, void 0, void 0, function() {
            return $dafca78dfd8bfe23$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    }
});
var $dafca78dfd8bfe23$export$53d5ca6c3f53e109 = function() {
    return (0, $acw62.useContext)($dafca78dfd8bfe23$var$notificationsContext);
};
function $dafca78dfd8bfe23$export$ca1c7da642902c6e(_a) {
    var _this = this;
    var children = _a.children;
    var user = (0, $iCMjC.useAuthentication)().user;
    var _b = (0, $hW7sX.useApiData)("global.notifications.count.show", {
        product: undefined
    }, {
        enable: !!user && !location.pathname.startsWith("/embed")
    }), notificationsCount = _b.notificationsCount, makeSetter = _b.makeSetter;
    var callNotificationsList = (0, $hW7sX.useApi)("global.notifications.list").call;
    var callAction = (0, $hW7sX.useApi)("global.notifications.actions.perform").call;
    var _c = $dafca78dfd8bfe23$var$__read((0, $acw62.useState)([]), 2), notifications = _c[0], setNotifications = _c[1];
    var _d = $dafca78dfd8bfe23$var$__read((0, $acw62.useState)(false), 2), hasMore = _d[0], setHasMore = _d[1];
    var _e = $dafca78dfd8bfe23$var$__read((0, $acw62.useState)(null), 2), previousLastId = _e[0], setPreviousLastId = _e[1];
    var previousLastIdRef = (0, $acw62.useRef)(previousLastId);
    previousLastIdRef.current = previousLastId;
    var _f = $dafca78dfd8bfe23$var$__read((0, $acw62.useState)(false), 2), loadingMore = _f[0], setLoadingMore = _f[1];
    var setNotificationsCount = makeSetter("notificationsCount");
    var addModal = (0, $5aE2v.useModal)().addModal;
    var redirect = (0, $7xuAh.default)();
    var onLoadMore = (0, $acw62.useCallback)(function() {
        return $dafca78dfd8bfe23$var$__awaiter(_this, void 0, void 0, function() {
            var _a, notifications, hasMore, lastId;
            return $dafca78dfd8bfe23$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        setLoadingMore(true);
                        return [
                            4 /*yield*/ ,
                            callNotificationsList({
                                beforeNotificationId: (0, $01O3F.presence)(previousLastIdRef.current)
                            })
                        ];
                    case 1:
                        _a = _b.sent(), notifications = _a.notifications, hasMore = _a.hasMore, lastId = _a.lastId;
                        setNotifications(function(existingNotifications) {
                            var exsitingIds = existingNotifications.map(function(notification) {
                                return notification.id;
                            });
                            return $dafca78dfd8bfe23$var$__spreadArray($dafca78dfd8bfe23$var$__spreadArray([], $dafca78dfd8bfe23$var$__read(existingNotifications), false), $dafca78dfd8bfe23$var$__read(notifications.filter(function(notification) {
                                return !exsitingIds.includes(notification.id);
                            })), false);
                        });
                        setHasMore(hasMore);
                        setPreviousLastId(lastId);
                        setLoadingMore(false);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        callNotificationsList
    ]);
    var clearNotifications = (0, $acw62.useCallback)(function() {
        setNotifications([]);
        setHasMore(false);
        setPreviousLastId(null);
        previousLastIdRef.current = null;
        setNotificationsCount(function(_) {
            return 0;
        });
    }, [
        setNotificationsCount
    ]);
    var onAction = (0, $acw62.useCallback)(function(notificationId, actionId) {
        return $dafca78dfd8bfe23$var$__awaiter(_this, void 0, void 0, function() {
            var notification, confirmation, confirmed, result;
            var _a;
            return $dafca78dfd8bfe23$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        notification = notifications.find(function(notification) {
                            return notification.id === notificationId;
                        });
                        confirmation = (_a = notification.confirmation) === null || _a === void 0 ? void 0 : _a[actionId];
                        confirmed = true;
                        if (!confirmation) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            new Promise(function(resolve) {
                                var _a, _b;
                                addModal({
                                    type: confirmation.danger ? "warning" : "info",
                                    title: "Confirmation",
                                    content: confirmation.message,
                                    confirmText: confirmation.confirmText,
                                    cancelText: (_b = (_a = confirmation.alternative) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : "Cancel",
                                    onClick: resolve
                                });
                            })
                        ];
                    case 1:
                        confirmed = _b.sent();
                        if (!confirmed && !confirmation.alternative) return [
                            2 /*return*/ 
                        ];
                        _b.label = 2;
                    case 2:
                        setNotifications(function(notifications) {
                            return notifications.map(function(notification) {
                                if (notification.id === notificationId) return $dafca78dfd8bfe23$var$__assign($dafca78dfd8bfe23$var$__assign({}, notification), {
                                    actionable: false
                                });
                                return notification;
                            });
                        });
                        return [
                            4 /*yield*/ ,
                            callAction({
                                notificationId: notificationId,
                                actionId: confirmed ? actionId : confirmation.alternative.onClick
                            })
                        ];
                    case 3:
                        result = _b.sent();
                        if (result.success) {
                            if (result.redirectUrl !== false) redirect(result.redirectUrl);
                        } else addModal({
                            type: "warning",
                            title: "Error",
                            content: "There was an error performing the action. Please try again."
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        callAction,
        addModal,
        notifications,
        redirect
    ]);
    return (0, $ayMG0.jsx)($dafca78dfd8bfe23$var$notificationsContext.Provider, {
        value: {
            notificationsCount: notificationsCount,
            hasMore: hasMore,
            loadingMore: loadingMore,
            onAction: onAction,
            onLoadMore: onLoadMore,
            notifications: notifications,
            clearNotifications: clearNotifications
        },
        children: children
    });
}

});

parcelRegister("1eU4T", function(module, exports) {

$parcel$export(module.exports, "getCurrentProduct", () => $0e729924f9844f5d$export$d01408ed6f850a64);
$parcel$export(module.exports, "useHqNaviation", () => $0e729924f9844f5d$export$d713d6f7d631da2d);
$parcel$export(module.exports, "usePrimaryNavigation", () => $0e729924f9844f5d$export$f3f6333ba77d3f3e);
$parcel$export(module.exports, "useSecondaryNavigation", () => $0e729924f9844f5d$export$67438d5f7493f758);

var $2WIQD = parcelRequire("2WIQD");
var $7wTiz = parcelRequire("7wTiz");
var $bOdxy = parcelRequire("bOdxy");
var $7dthk = parcelRequire("7dthk");
var $02S4j = parcelRequire("02S4j");
var $iBsCV = parcelRequire("iBsCV");
var $ihuRA = parcelRequire("ihuRA");
var $eiZBI = parcelRequire("eiZBI");
var $jqZdy = parcelRequire("jqZdy");
var $hQeeG = parcelRequire("hQeeG");
var $fUD1V = parcelRequire("fUD1V");
var $6liAm = parcelRequire("6liAm");
var $cOmZW = parcelRequire("cOmZW");
var $3omLt = parcelRequire("3omLt");
var $adNKW = parcelRequire("adNKW");
var $jvX8j = parcelRequire("jvX8j");
var $1dsap = parcelRequire("1dsap");
var $gxGxG = parcelRequire("gxGxG");
var $8se9p = parcelRequire("8se9p");
var $lDNZN = parcelRequire("lDNZN");
var $golUC = parcelRequire("golUC");
var $h6wOr = parcelRequire("h6wOr");

var $2Qex5 = parcelRequire("2Qex5");

var $doMsc = parcelRequire("doMsc");

var $4Q1tF = parcelRequire("4Q1tF");

var $cLZMe = parcelRequire("cLZMe");

var $dtKoB = parcelRequire("dtKoB");

var $hCSTa = parcelRequire("hCSTa");

var $hmJ39 = parcelRequire("hmJ39");

var $hW7sX = parcelRequire("hW7sX");
var $0e729924f9844f5d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0e729924f9844f5d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $0e729924f9844f5d$export$d01408ed6f850a64(_a) {
    var _b, _c, _d, _e;
    var currentTeamId = _a.currentTeamId, hostName = _a.hostName, teams = _a.teams;
    var currentTeam = currentTeamId ? teams.find(function(t) {
        return t.id === currentTeamId;
    }) : undefined, onlyProduct = new Set(teams.map(function(t) {
        return t.product;
    })).size === 1 ? teams[0].product : undefined;
    if (hostName.includes("hq.upscope")) return;
    if (hostName.includes("cobrowsingapi")) {
        if (((_b = currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.product) !== null && _b !== void 0 ? _b : onlyProduct) === "cobrowsingapi") return "cobrowsingapi";
        if (((_c = currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.product) !== null && _c !== void 0 ? _c : onlyProduct) === "helloscreen") return "helloscreen";
        if (((_d = currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.product) !== null && _d !== void 0 ? _d : onlyProduct) === "userview") return "userview";
        return "cobrowsingapi";
    }
    if (hostName.includes("helloscreen")) return "helloscreen";
    if (hostName.includes("userview")) return "userview";
    if (hostName.includes("livedocument")) return "livedocument";
    return (_e = currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.product) !== null && _e !== void 0 ? _e : onlyProduct;
}
function $0e729924f9844f5d$export$d713d6f7d631da2d(_a) {
    var adminRoles = _a.adminRoles, currentRoute = _a.currentRoute;
    var inHq = location.origin === (0, $hmJ39.getRouteOrigin)("hq.root");
    var _b = (0, $hW7sX.useApiData)("hq.sales.tasks.count", undefined, {
        enable: inHq
    }), tasksDue = _b.due, tasksTotal = _b.total;
    var leads = (0, $hW7sX.useApiData)("hq.sales.leads.list", {
        everyone: !adminRoles.includes("sales_lead_target")
    }, {
        enable: inHq && adminRoles.includes("sales_view")
    }).companies;
    var opportunities = (0, $hW7sX.useApiData)("hq.sales.opportunities.index", undefined, {
        enable: inHq && adminRoles.includes("sales_view")
    }).opportunities;
    if (adminRoles.length === 0 || !inHq) return [];
    var navigationItems = [
        {
            icon: (0, $8se9p.default),
            id: "hq.root",
            name: (0, $dtKoB.default)("Mission Control"),
            to: [
                "hq.root"
            ]
        },
        {
            icon: (0, $6liAm.default),
            id: "hq.customerSuccess",
            name: (0, $dtKoB.default)("Customer Success"),
            to: [
                "hq.customerSuccess.index"
            ]
        },
        {
            count: (opportunities === null || opportunities === void 0 ? void 0 : opportunities.filter(function(o) {
                return o.followUpNeeded;
            }).length) || undefined,
            icon: (0, $jqZdy.default),
            id: "hq.sales.opportunities",
            name: (0, $dtKoB.default)("Opportunities"),
            to: [
                "hq.sales.index"
            ]
        },
        {
            icon: (0, $fUD1V.default),
            id: "hq.sales.quotes",
            name: (0, $dtKoB.default)("Quotes"),
            to: [
                "hq.quotes.index"
            ]
        },
        {
            count: (leads === null || leads === void 0 ? void 0 : leads.length) || undefined,
            icon: (0, $gxGxG.default),
            id: "hq.sales.leads",
            name: (0, $dtKoB.default)("New Leads"),
            to: [
                "hq.sales.leads"
            ]
        },
        {
            count: tasksDue || tasksTotal || undefined,
            countColor: tasksDue ? "red" : undefined,
            icon: (0, $bOdxy.default),
            id: "hq.sales.tasks",
            name: (0, $dtKoB.default)("Tasks"),
            to: [
                "hq.sales.tasks"
            ]
        },
        {
            icon: (0, $02S4j.default),
            id: "hq.accounts",
            name: (0, $dtKoB.default)("Accounts"),
            to: [
                "hq.accounts.index",
                {}
            ]
        },
        {
            icon: (0, $2Qex5.default),
            id: "hq.aiChanges",
            name: (0, $dtKoB.default)("AI Changes"),
            to: [
                "hq.aiChanges"
            ]
        },
        {
            icon: (0, $jvX8j.default),
            id: "hq.dashboards",
            name: (0, $dtKoB.default)("Dashboards"),
            to: "https://metabase.upscope.com"
        },
        {
            icon: (0, $2WIQD.default),
            id: "hq.globalActivityLog",
            name: (0, $dtKoB.default)("Global Activity Log"),
            to: [
                "hq.globalActivityLog",
                {}
            ]
        }
    ];
    return navigationItems.filter(Boolean).map(function(item) {
        var sidebarItem = item;
        sidebarItem.current = item.id === currentRoute;
        return sidebarItem;
    });
}
function $0e729924f9844f5d$export$f3f6333ba77d3f3e(_a) {
    var _b, _c;
    var currentProduct = _a.currentProduct, currentRoute = _a.currentRoute, currentTeamId = _a.currentTeamId, isAdmin = _a.isAdmin, teamMemberships = _a.teamMemberships;
    if (!currentProduct) return $0e729924f9844f5d$var$__spreadArray([
        isAdmin && {
            current: false,
            icon: (0, $8se9p.default),
            id: "hq.root",
            name: (0, $dtKoB.default)("Mission Control"),
            to: [
                "hq.root"
            ]
        }
    ], $0e729924f9844f5d$var$__read((0, $cLZMe.PRODUCTS).map(function(product) {
        return teamMemberships.some(function(membership) {
            return membership.team.product === product;
        }) && {
            current: false,
            id: "".concat((0, $hmJ39.productPrefixes)[product], ".root"),
            name: (0, $4Q1tF.productName)(product),
            to: [
                "".concat((0, $hmJ39.productPrefixes)[product], ".root"),
                {}
            ]
        };
    })), false).filter(Boolean);
    var navTeam = ((_b = teamMemberships.find(function(membership) {
        return membership.team.id === currentTeamId;
    })) === null || _b === void 0 ? void 0 : _b.team) || teamMemberships[0].team;
    // Filter out teams for other products
    teamMemberships = teamMemberships.filter(function(membership) {
        return membership.team.product === currentProduct;
    });
    var teams = teamMemberships.map(function(membership) {
        return membership.team;
    });
    var teamWhere = function(permission, noOnboardingTeams) {
        var teams = teamMemberships.filter(function(m) {
            return m.permissions[permission];
        }).map(function(m) {
            return m.team;
        });
        if (noOnboardingTeams) teams = teams.filter(function(team) {
            return team.onboardingCompleted;
        });
        return teams.find(function(t) {
            return t.id === navTeam.id;
        }) || teams[0];
    };
    var gettingStartedTeam = (_c = teamMemberships.filter(function(m) {
        return !m.team.onboardingCompleted && m.isOwner;
    })[0]) === null || _c === void 0 ? void 0 : _c.team, canUseTeam = teamWhere("canUse"), canAccessSettingsTeam = teamWhere("canAccessSettings"), canManageUsersTeam = teamWhere("canManageUsers"), canManageBillingTeam = teamWhere("canManageBilling"), canManageContentTeam = teamWhere("canManageContent"), canViewReportingTeam = teamWhere("canViewReporting");
    var navigationItems = [
        isAdmin && {
            icon: (0, $8se9p.default),
            id: "hq.root",
            name: (0, $dtKoB.default)("Mission Control"),
            to: [
                "hq.root"
            ]
        },
        gettingStartedTeam && {
            icon: (0, $lDNZN.default),
            id: "up.getting-started",
            name: (0, $dtKoB.default)("Getting started"),
            to: [
                "up.onboarding",
                {
                    teamDomain: gettingStartedTeam.domain
                }
            ]
        },
        currentProduct === "livedocument" && {
            icon: (0, $adNKW.default),
            id: "ld.create",
            name: (0, $dtKoB.default)("New LiveDocument"),
            to: [
                "ld.links.create",
                {
                    teamDomain: navTeam.domain
                }
            ]
        },
        currentProduct === "livedocument" && {
            icon: (0, $gxGxG.default),
            id: "ld.links",
            name: (0, $dtKoB.default)("Links"),
            to: [
                "ld.links.list",
                {
                    teamDomain: navTeam.domain
                }
            ]
        },
        currentProduct === "livedocument" && {
            icon: (0, $doMsc.default),
            id: "ld.leads",
            name: (0, $dtKoB.default)("Leads"),
            to: [
                "ld.leads.index",
                {
                    teamDomain: navTeam.domain
                }
            ]
        },
        currentProduct === "livedocument" && canManageContentTeam && {
            icon: (0, $7dthk.default),
            id: "ld.templates",
            name: (0, $dtKoB.default)("Templates"),
            to: [
                "ld.templates.index",
                {
                    teamDomain: navTeam.domain
                }
            ]
        },
        currentProduct === "helloscreen" && teams.some(function(t) {
            return t.productVariant === "helloscreen_cobrowsing";
        }) && canUseTeam && {
            icon: (0, $hQeeG.default),
            id: "hs.cobrowse",
            name: (0, $dtKoB.default)("Co-browse"),
            to: [
                "hs.visitorsList",
                {}
            ]
        },
        currentProduct === "userview" && canUseTeam && {
            icon: (0, $hQeeG.default),
            id: "uv.cobrowse",
            name: (0, $dtKoB.default)("Co-browse"),
            to: [
                "uv.visitorsList",
                {}
            ]
        },
        (currentRoute !== "up.getting-started" || teams.some(function(team) {
            return team.onboardingCompleted;
        })) && (0, $hCSTa.cobrowseInstallProductVariants).some(function(variant) {
            return teams.some(function(team) {
                return team.product === variant || team.productVariant === variant;
            });
        }) && canAccessSettingsTeam && {
            icon: (0, $iBsCV.default),
            id: "up.install",
            name: (0, $dtKoB.default)("Install"),
            to: [
                "up.onboarding.installCobrowsing",
                {
                    teamDomain: canAccessSettingsTeam.domain,
                    teamUniqueIdentifier: canAccessSettingsTeam.uniqueIdentifier
                }
            ]
        },
        canAccessSettingsTeam && teams.some(function(team) {
            return team.featuresAvailable.includes("cobrowse_rest_api");
        }) && {
            icon: (0, $3omLt.default),
            id: "co.dashboard",
            name: (0, $dtKoB.default)("REST API"),
            to: [
                "co.dashboard",
                {
                    teamDomain: canAccessSettingsTeam.domain
                }
            ]
        },
        canAccessSettingsTeam && (0, $hCSTa.cobrowseIntegrationsProducts).includes(currentProduct) && {
            icon: (0, $1dsap.default),
            id: "up.integrations",
            name: (0, $dtKoB.default)("Integrations"),
            to: [
                "up.integrations",
                {
                    teamDomain: canAccessSettingsTeam.domain
                }
            ]
        },
        (0, $hCSTa.cobrowseProducts).includes(currentProduct) && (canViewReportingTeam || teams.some(function(team) {
            return team.featuresAvailable.includes("cobrowse_session_history_own") && team.agentCanSeeOwnHistory !== "deny";
        })) && {
            icon: (0, $cOmZW.default),
            id: "up.history",
            name: (0, $dtKoB.default)("Co-browsing History"),
            to: [
                "up.history",
                {
                    teamDomain: (canViewReportingTeam || teams.find(function(team) {
                        return team.featuresAvailable.includes("cobrowse_session_history_own") && team.agentCanSeeOwnHistory !== "deny";
                    })).domain
                }
            ]
        },
        canViewReportingTeam && {
            icon: (0, $2WIQD.default),
            id: "up.activityLog",
            name: (0, $dtKoB.default)("Activity Log"),
            to: [
                "up.activity.activityLog",
                {
                    teamDomain: canViewReportingTeam.domain
                }
            ]
        },
        canManageUsersTeam && {
            icon: (0, $h6wOr.default),
            id: "up.team",
            name: (0, $dtKoB.default)("Team"),
            to: [
                "up.settings.team",
                {
                    teamDomain: canManageUsersTeam.domain
                }
            ]
        },
        canViewReportingTeam && (0, $hCSTa.cobrowseProducts).includes(currentProduct) && {
            icon: (0, $7wTiz.default),
            id: "up.reporting.usage",
            name: (0, $dtKoB.default)("Usage"),
            to: [
                "up.reporting.usage",
                {
                    teamDomain: canViewReportingTeam.domain
                }
            ]
        },
        canAccessSettingsTeam && {
            icon: (0, $ihuRA.default),
            id: "up.settings",
            name: (0, $dtKoB.default)("Settings"),
            to: [
                "up.settings.general",
                {
                    teamDomain: canAccessSettingsTeam.domain
                }
            ]
        },
        canManageBillingTeam && {
            count: canManageBillingTeam.delinquentSince ? 1 : undefined,
            countColor: "red",
            icon: (0, $eiZBI.default),
            id: "up.billing",
            name: (0, $dtKoB.default)("Billing"),
            to: [
                "up.settings.billing",
                {
                    teamDomain: canManageBillingTeam.domain
                }
            ]
        },
        canManageContentTeam && (0, $hCSTa.cobrowseVisitorProductVariants).some(function(variant) {
            return teams.some(function(team) {
                return team.product === variant || team.productVariant === variant;
            });
        }) && {
            icon: (0, $golUC.default),
            id: "up.visitorData",
            name: (0, $dtKoB.default)("Delete Visitor Data"),
            to: [
                "up.visitorData",
                {
                    teamDomain: canManageContentTeam.domain
                }
            ]
        }
    ];
    return navigationItems.filter(Boolean).map(function(item) {
        var sidebarItem = item;
        sidebarItem.current = item.id === currentRoute;
        return sidebarItem;
    });
}
function $0e729924f9844f5d$export$67438d5f7493f758(_a) {
    var currentProduct = _a.currentProduct, currentTeamId = _a.currentTeamId, primaryNavigation = _a.primaryNavigation, teams = _a.teams;
    if (!currentProduct) return;
    var currentNavigation = primaryNavigation.find(function(item) {
        return item.current;
    });
    if (typeof (currentNavigation === null || currentNavigation === void 0 ? void 0 : currentNavigation.to[1]) === "undefined" || // It's not a dynamic route
    !Array.isArray(currentNavigation.to) || !("teamDomain" in currentNavigation.to[1])) return;
    // Filter out teams that don't have the current product
    var possibleTeams = teams.filter(function(team) {
        return team.product === currentProduct;
    });
    if (currentNavigation.id === "up.getting-started") possibleTeams = possibleTeams.filter(function(team) {
        return !team.onboardingCompleted;
    });
    if (possibleTeams.length < 2) return;
    return possibleTeams.map(function(team) {
        var sidebarItem = {
            current: team.id === currentTeamId,
            id: team.id,
            name: team.domain,
            to: [
                currentNavigation.to[0],
                {
                    teamDomain: team.domain,
                    teamUniqueIdentifier: team.uniqueIdentifier
                }
            ]
        };
        return sidebarItem;
    });
}

});
parcelRegister("2WIQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2253c970c9b46605$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2253c970c9b46605$var$ArchiveBoxIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m20.25 7.5-.625 10.632a2.25 2.25 0 0 1-2.247 2.118H6.622a2.25 2.25 0 0 1-2.247-2.118L3.75 7.5M10 11.25h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"
    }));
}
const $2253c970c9b46605$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($2253c970c9b46605$var$ArchiveBoxIcon);
var $2253c970c9b46605$export$2e2bcd8739ae039 = $2253c970c9b46605$var$ForwardRef;

});

parcelRegister("7wTiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b66aabe1b6065d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $57b66aabe1b6065d$var$ChartBarSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
    }));
}
const $57b66aabe1b6065d$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($57b66aabe1b6065d$var$ChartBarSquareIcon);
var $57b66aabe1b6065d$export$2e2bcd8739ae039 = $57b66aabe1b6065d$var$ForwardRef;

});

parcelRegister("bOdxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $898ede00ff16e210$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $898ede00ff16e210$var$CheckCircleIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $898ede00ff16e210$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($898ede00ff16e210$var$CheckCircleIcon);
var $898ede00ff16e210$export$2e2bcd8739ae039 = $898ede00ff16e210$var$ForwardRef;

});

parcelRegister("7dthk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5410755ffdb2348c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $5410755ffdb2348c$var$ClipboardDocumentIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"
    }));
}
const $5410755ffdb2348c$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($5410755ffdb2348c$var$ClipboardDocumentIcon);
var $5410755ffdb2348c$export$2e2bcd8739ae039 = $5410755ffdb2348c$var$ForwardRef;

});

parcelRegister("02S4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $00023a56675d4591$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $00023a56675d4591$var$ClipboardDocumentListIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
    }));
}
const $00023a56675d4591$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($00023a56675d4591$var$ClipboardDocumentListIcon);
var $00023a56675d4591$export$2e2bcd8739ae039 = $00023a56675d4591$var$ForwardRef;

});

parcelRegister("iBsCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b1e367f31cd9e8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d8b1e367f31cd9e8$var$CodeBracketSquareIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.25 9.75 16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z"
    }));
}
const $d8b1e367f31cd9e8$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($d8b1e367f31cd9e8$var$CodeBracketSquareIcon);
var $d8b1e367f31cd9e8$export$2e2bcd8739ae039 = $d8b1e367f31cd9e8$var$ForwardRef;

});

parcelRegister("ihuRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f1c1568523d6e5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $d4f1c1568523d6e5$var$Cog6ToothIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
    }), /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }));
}
const $d4f1c1568523d6e5$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($d4f1c1568523d6e5$var$Cog6ToothIcon);
var $d4f1c1568523d6e5$export$2e2bcd8739ae039 = $d4f1c1568523d6e5$var$ForwardRef;

});

parcelRegister("eiZBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6a28911df0f13c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $a6a28911df0f13c8$var$CreditCardIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z"
    }));
}
const $a6a28911df0f13c8$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($a6a28911df0f13c8$var$CreditCardIcon);
var $a6a28911df0f13c8$export$2e2bcd8739ae039 = $a6a28911df0f13c8$var$ForwardRef;

});

parcelRegister("jqZdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e25fee8f938b0904$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e25fee8f938b0904$var$CurrencyDollarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    }));
}
const $e25fee8f938b0904$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($e25fee8f938b0904$var$CurrencyDollarIcon);
var $e25fee8f938b0904$export$2e2bcd8739ae039 = $e25fee8f938b0904$var$ForwardRef;

});

parcelRegister("hQeeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd255f422b4e780$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $cfd255f422b4e780$var$CursorArrowRaysIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
    }));
}
const $cfd255f422b4e780$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($cfd255f422b4e780$var$CursorArrowRaysIcon);
var $cfd255f422b4e780$export$2e2bcd8739ae039 = $cfd255f422b4e780$var$ForwardRef;

});

parcelRegister("fUD1V", function(module, exports) {

$parcel$export(module.exports, "default", () => $b95a5c87ac35777e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $b95a5c87ac35777e$var$DocumentCurrencyDollarIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    }));
}
const $b95a5c87ac35777e$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($b95a5c87ac35777e$var$DocumentCurrencyDollarIcon);
var $b95a5c87ac35777e$export$2e2bcd8739ae039 = $b95a5c87ac35777e$var$ForwardRef;

});

parcelRegister("6liAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e31ee8f7fe3065$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $49e31ee8f7fe3065$var$FaceSmileIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z"
    }));
}
const $49e31ee8f7fe3065$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($49e31ee8f7fe3065$var$FaceSmileIcon);
var $49e31ee8f7fe3065$export$2e2bcd8739ae039 = $49e31ee8f7fe3065$var$ForwardRef;

});

parcelRegister("cOmZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $026831860aec309d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $026831860aec309d$var$FilmIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0 1 18 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0 1 18 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 0 1 6 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5"
    }));
}
const $026831860aec309d$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($026831860aec309d$var$FilmIcon);
var $026831860aec309d$export$2e2bcd8739ae039 = $026831860aec309d$var$ForwardRef;

});

parcelRegister("3omLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $278545915c440640$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $278545915c440640$var$KeyIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
    }));
}
const $278545915c440640$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($278545915c440640$var$KeyIcon);
var $278545915c440640$export$2e2bcd8739ae039 = $278545915c440640$var$ForwardRef;

});

parcelRegister("adNKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7711b6cbab078de7$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $7711b6cbab078de7$var$PaperAirplaneIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
    }));
}
const $7711b6cbab078de7$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($7711b6cbab078de7$var$PaperAirplaneIcon);
var $7711b6cbab078de7$export$2e2bcd8739ae039 = $7711b6cbab078de7$var$ForwardRef;

});

parcelRegister("jvX8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $e34ec8275acc2fbc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $e34ec8275acc2fbc$var$PresentationChartLineIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
    }));
}
const $e34ec8275acc2fbc$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($e34ec8275acc2fbc$var$PresentationChartLineIcon);
var $e34ec8275acc2fbc$export$2e2bcd8739ae039 = $e34ec8275acc2fbc$var$ForwardRef;

});

parcelRegister("1dsap", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2cdab14d786f29$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $0e2cdab14d786f29$var$PuzzlePieceIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.25 6.087c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.036-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .369.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48.39 48.39 0 0 1-4.163-.3c.186 1.613.293 3.25.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.647 1.647 0 0 0-1.003-.349c-1.036 0-1.875 1.007-1.875 2.25s.84 2.25 1.875 2.25c.369 0 .713-.128 1.003-.349.283-.215.604-.401.959-.401v0c.31 0 .555.26.532.57a48.039 48.039 0 0 1-.642 5.056c1.518.19 3.058.309 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.647 1.647 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .369-.128.713-.349 1.003-.215.283-.4.604-.4.959v0c0 .333.277.599.61.58a48.1 48.1 0 0 0 5.427-.63 48.05 48.05 0 0 0 .582-4.717.532.532 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.349-1.003.349-1.035 0-1.875-1.007-1.875-2.25s.84-2.25 1.875-2.25c.37 0 .713.128 1.003.349.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48.422 48.422 0 0 0-.37-5.36c-1.886.342-3.81.574-5.766.689a.578.578 0 0 1-.61-.58v0Z"
    }));
}
const $0e2cdab14d786f29$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($0e2cdab14d786f29$var$PuzzlePieceIcon);
var $0e2cdab14d786f29$export$2e2bcd8739ae039 = $0e2cdab14d786f29$var$ForwardRef;

});

parcelRegister("gxGxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b0ba7201955950$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $c0b0ba7201955950$var$QueueListIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
    }));
}
const $c0b0ba7201955950$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($c0b0ba7201955950$var$QueueListIcon);
var $c0b0ba7201955950$export$2e2bcd8739ae039 = $c0b0ba7201955950$var$ForwardRef;

});

parcelRegister("8se9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $627bea4b1d6d91cc$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $627bea4b1d6d91cc$var$RocketLaunchIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    }));
}
const $627bea4b1d6d91cc$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($627bea4b1d6d91cc$var$RocketLaunchIcon);
var $627bea4b1d6d91cc$export$2e2bcd8739ae039 = $627bea4b1d6d91cc$var$ForwardRef;

});

parcelRegister("lDNZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc1405939c84d0e6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $fc1405939c84d0e6$var$SparklesIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    }));
}
const $fc1405939c84d0e6$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($fc1405939c84d0e6$var$SparklesIcon);
var $fc1405939c84d0e6$export$2e2bcd8739ae039 = $fc1405939c84d0e6$var$ForwardRef;

});

parcelRegister("golUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $beefe28644f6e8ce$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $beefe28644f6e8ce$var$TrashIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
    }));
}
const $beefe28644f6e8ce$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($beefe28644f6e8ce$var$TrashIcon);
var $beefe28644f6e8ce$export$2e2bcd8739ae039 = $beefe28644f6e8ce$var$ForwardRef;

});

parcelRegister("h6wOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c73c731344fe0930$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $c73c731344fe0930$var$UsersIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
    }));
}
const $c73c731344fe0930$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($c73c731344fe0930$var$UsersIcon);
var $c73c731344fe0930$export$2e2bcd8739ae039 = $c73c731344fe0930$var$ForwardRef;

});

parcelRegister("2Qex5", function(module, exports) {

$parcel$export(module.exports, "default", () => $211bb5fefc57afe1$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
var $211bb5fefc57afe1$var$__assign = undefined && undefined.__assign || function() {
    $211bb5fefc57afe1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $211bb5fefc57afe1$var$__assign.apply(this, arguments);
};
var $211bb5fefc57afe1$var$RobotIcon = function(props) {
    return (0, $ayMG0.jsx)("svg", $211bb5fefc57afe1$var$__assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 640 512"
    }, props, {
        children: (0, $ayMG0.jsx)("path", {
            d: "M320 0c8.8 0 16 7.2 16 16v80h112c53 0 96 43 96 96v224c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96h112V16c0-8.8 7.2-16 16-16zM192 128c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H192zm16 256h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM48 224h16v32H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h16v32H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 160c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-16v-32h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16v-32h16z"
        })
    }));
};
var $211bb5fefc57afe1$export$2e2bcd8739ae039 = $211bb5fefc57afe1$var$RobotIcon;

});

parcelRegister("doMsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c131a3040df5513$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $01O3F = parcelRequire("01O3F");
function $9c131a3040df5513$var$TiltedEnvelopeIcon(_a) {
    var className = _a.className;
    return (0, $ayMG0.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        className: (0, $01O3F.classNames)(className, "-rotate-6"),
        children: (0, $ayMG0.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M21.75 9v.906a2.25 2.25 0 0 1-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 0 0 1.183 1.981l6.478 3.488m8.839 2.51-4.66-2.51m0 0-1.023-.55a2.25 2.25 0 0 0-2.134 0l-1.022.55m0 0-4.661 2.51m16.5 1.615a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V8.844a2.25 2.25 0 0 1 1.183-1.981l7.5-4.039a2.25 2.25 0 0 1 2.134 0l7.5 4.039a2.25 2.25 0 0 1 1.183 1.98V19.5Z"
        })
    });
}
var $9c131a3040df5513$export$2e2bcd8739ae039 = $9c131a3040df5513$var$TiltedEnvelopeIcon;

});

parcelRegister("cLZMe", function(module, exports) {

$parcel$export(module.exports, "planMonthsInPeriod", () => $94c9cb72f0ed168b$export$8bb7d6d2bcf8299b);
$parcel$export(module.exports, "FEATURES", () => $94c9cb72f0ed168b$export$d6a5c11f04f75862);
$parcel$export(module.exports, "PRODUCTS", () => $94c9cb72f0ed168b$export$4f02bea739260915);
$parcel$export(module.exports, "PLAN_PERIODS", () => $94c9cb72f0ed168b$export$21b200febc69ac7f);
function $94c9cb72f0ed168b$export$8bb7d6d2bcf8299b(period) {
    switch(period){
        case "year":
            return 12;
        case "month":
            return 1;
        case "quarter":
            return 3;
        case "six_month":
            return 6;
        case "two_month":
            return 2;
    }
}
var $94c9cb72f0ed168b$export$d6a5c11f04f75862 = [
    "helloscreen_extension",
    "helloscreen_presentation_sharing",
    "activity_log",
    "cobrowse",
    "cobrowse_web_sdk",
    "cobrowse_native_sdk",
    "cobrowse_agent_notes",
    "cobrowse_agent_redirect",
    "cobrowse_agent_request_button",
    "cobrowse_agent_share_screen",
    "cobrowse_audio_calls",
    "cobrowse_dev_console",
    "cobrowse_dev_console_control",
    "cobrowse_multi_agent",
    "cobrowse_remote_control",
    "cobrowse_rest_api",
    "cobrowse_session_history",
    "cobrowse_session_history_own",
    "cobrowse_session_recording",
    "cobrowse_user_full_screen",
    "cobrowse_whitelabel",
    "cobrowse_visitor_session_feedback",
    "helloscreen_document_share",
    "helloscreen_document_share_templates",
    "helloscreen_extension_full_screen",
    "helloscreen_extension_multi_viewer",
    "helloscreen_extension_request_viewer_screen",
    "helloscreen_extension_url_whitelist",
    "intercom_session_summary",
    "livedocument_templates",
    "reporting",
    "salesforce_integration",
    "sso",
    "user_roles",
    "userview_screen_tv",
    "cobrowse_browsing_history",
    "cobrowse_browsing_history_automatic_screenshots",
    "zapier_integration"
];
var $94c9cb72f0ed168b$var$allFeaturesCheck = true;
var $94c9cb72f0ed168b$export$4f02bea739260915 = [
    "helloscreen",
    "cobrowsingapi",
    "userview",
    "livedocument"
];
var $94c9cb72f0ed168b$var$allProductsCheck = true;
var $94c9cb72f0ed168b$export$21b200febc69ac7f = [
    "year",
    "month",
    "quarter",
    "six_month",
    "two_month"
];
var $94c9cb72f0ed168b$var$allPeriodsCheck = true;

});

parcelRegister("hCSTa", function(module, exports) {

$parcel$export(module.exports, "cobrowseProducts", () => $cd50900ff27176d4$export$b0bfb47f943cca12);
$parcel$export(module.exports, "cobrowseIntegrationsProducts", () => $cd50900ff27176d4$export$a2d77fc30879898);
$parcel$export(module.exports, "cobrowseVisitorProductVariants", () => $cd50900ff27176d4$export$95af5a2c62660b8c);
$parcel$export(module.exports, "cobrowseInstallProductVariants", () => $cd50900ff27176d4$export$43b567d9be7163c);
$parcel$export(module.exports, "cobrowsePrefixes", () => $cd50900ff27176d4$export$18abac663cb0cd0b);
var $cd50900ff27176d4$export$b0bfb47f943cca12 = [
    "helloscreen",
    "userview",
    "cobrowsingapi"
];
var $cd50900ff27176d4$export$a2d77fc30879898 = [
    "helloscreen",
    "userview"
];
var $cd50900ff27176d4$export$95af5a2c62660b8c = [
    "helloscreen_cobrowsing",
    "userview",
    "cobrowsingapi"
];
var $cd50900ff27176d4$export$43b567d9be7163c = [
    "helloscreen_cobrowsing",
    "helloscreen_presentation_sharing",
    "userview",
    "cobrowsingapi"
];
var $cd50900ff27176d4$export$18abac663cb0cd0b = {
    cobrowsingapi: "co",
    helloscreen: "hs",
    userview: "uv"
};

});


parcelRegister("hXhdh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1254c89ec11ae3b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $4Q1tF = parcelRequire("4Q1tF");

var $dtKoB = parcelRequire("dtKoB");

var $iCMjC = parcelRequire("iCMjC");
function $d1254c89ec11ae3b$export$2e2bcd8739ae039(_a) {
    var currentProduct = _a.currentProduct, currentRoute = _a.currentRoute;
    var _b = (0, $iCMjC.useAuthentication)(), user = _b.user, teams = _b.teams, teamMemberships = _b.teamMemberships, impersonating = _b.impersonating, stopImpersonation = _b.stopImpersonation;
    var pathname = (0, $lzNIT.useLocation)().pathname;
    var purchaseRequiredTeam = (0, $acw62.useMemo)(function() {
        return (teamMemberships === null || teamMemberships === void 0 ? void 0 : teamMemberships.filter(function(m) {
            return m.permissions.canPurchase;
        }).map(function(m) {
            return m.team;
        }).filter(function(t) {
            return !currentProduct || t.product === currentProduct;
        }).find(function(t) {
            return !t.isSubaccount && !t.paying && !t.trialEndsOn && !t.trialAvailable && !t.freeAccount;
        })) || null;
    }, [
        teamMemberships,
        currentProduct
    ]);
    var bannedTeam = (0, $acw62.useMemo)(function() {
        return (teams === null || teams === void 0 ? void 0 : teams.find(function(t) {
            return t.banned;
        })) || null;
    }, [
        teams
    ]);
    var onTrialNoCardTeam = (0, $acw62.useMemo)(function() {
        return (teamMemberships === null || teamMemberships === void 0 ? void 0 : teamMemberships.filter(function(m) {
            return m.permissions.canPurchase;
        }).map(function(m) {
            return m.team;
        }).filter(function(t) {
            return !currentProduct || t.product === currentProduct;
        }).find(function(t) {
            return t.trialEndsOn && !t.trialConvertsAutomatically;
        })) || null;
    }, [
        teamMemberships,
        currentProduct
    ]);
    var delinquentTeam = (0, $acw62.useMemo)(function() {
        return (teamMemberships === null || teamMemberships === void 0 ? void 0 : teamMemberships.filter(function(m) {
            return m.permissions.canManageBilling;
        }).map(function(m) {
            return m.team;
        }).filter(function(t) {
            return !currentProduct || t.product === currentProduct;
        }).find(function(t) {
            return !!t.delinquentSince;
        })) || null;
    }, [
        teamMemberships,
        currentProduct
    ]);
    if (impersonating) return {
        content: "You are currently impersonating ".concat(user.name, "!"),
        cta: {
            label: "Stop impersonating",
            onClick: stopImpersonation
        }
    };
    if (bannedTeam) return {
        content: (0, $dtKoB.default)("Our team has been trying to contact you. Please get in touch to continue using Upscope."),
        cta: {
            label: (0, $dtKoB.default)("Contact us"),
            to: "mailto:team@upscope.com"
        }
    };
    if (purchaseRequiredTeam && currentRoute !== "up.getting-started") return {
        content: (0, $dtKoB.default)("Your free trial has ended. Please purchase a subscription to continue using %{product}", {
            product: (0, $4Q1tF.productName)(purchaseRequiredTeam.product)
        }),
        cta: {
            label: (0, $dtKoB.default)("Purchase"),
            to: [
                "up.onboarding.purchase",
                {
                    teamDomain: purchaseRequiredTeam.domain
                }
            ]
        }
    };
    if (delinquentTeam && currentRoute !== "up.billing" && !pathname.startsWith("/invoice/")) return {
        content: (0, $dtKoB.default)("A recent payment attempt failed. Please make sure you complete the payment to continue using  %{product}.", {
            product: (0, $4Q1tF.productName)(delinquentTeam.product)
        }),
        cta: {
            label: (0, $dtKoB.default)("Complete payment"),
            to: [
                "up.settings.billing",
                {
                    teamDomain: delinquentTeam.domain
                }
            ]
        }
    };
    if (onTrialNoCardTeam && currentRoute !== "up.getting-started") return {
        content: (0, $dtKoB.default)("Your free trial will end on %{formattedDate}. Add a card to continue using %{product}.", {
            product: (0, $4Q1tF.productName)(onTrialNoCardTeam.product),
            formattedDate: onTrialNoCardTeam.trialEndsOn.toLocaleDateString()
        }),
        cta: {
            label: (0, $dtKoB.default)("Add payment method"),
            to: [
                "up.onboarding.purchase",
                {
                    teamDomain: onTrialNoCardTeam.domain
                }
            ]
        }
    };
}

});


parcelRegister("g96xj", function(module, exports) {

$parcel$export(module.exports, "useAuthLayout", () => $bc128e928d6f2e9d$export$d56a02b2ef0fa5e0);
$parcel$export(module.exports, "default", () => $bc128e928d6f2e9d$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $2bwVh = parcelRequire("2bwVh");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $eOrpz = parcelRequire("eOrpz");
var $bc128e928d6f2e9d$var$__assign = undefined && undefined.__assign || function() {
    $bc128e928d6f2e9d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bc128e928d6f2e9d$var$__assign.apply(this, arguments);
};
var $bc128e928d6f2e9d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $bc128e928d6f2e9d$var$AuthLayoutContext = /*#__PURE__*/ (0, $acw62.createContext)({
    configureLayout: function(options) {}
});
function $bc128e928d6f2e9d$export$d56a02b2ef0fa5e0() {
    return (0, $acw62.useContext)($bc128e928d6f2e9d$var$AuthLayoutContext);
}
function $bc128e928d6f2e9d$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    var _b = $bc128e928d6f2e9d$var$__read((0, $acw62.useState)({}), 2), authLayoutOptions = _b[0], setAuthLayoutOptions = _b[1];
    var _c = $bc128e928d6f2e9d$var$__read((0, $acw62.useState)({}), 2), authLayoutOptionsDebounced = _c[0], setAuthLayoutOptionsDebounced = _c[1];
    var location = (0, $lzNIT.useLocation)();
    var route = (0, $aphAM.useMatch)(location.pathname);
    (0, $acw62.useEffect)(function() {
        setAuthLayoutOptions({});
    }, [
        route
    ]);
    (0, $2bwVh.useDebouncedEffect)(function() {
        setAuthLayoutOptionsDebounced(authLayoutOptions);
    }, [
        authLayoutOptions
    ], 50);
    var configureLayout = (0, $acw62.useCallback)(function(options) {
        setTimeout(function() {
            // Cannot be called synchronously, otherwise it will cause a re-render loop
            setAuthLayoutOptions(function(previousOptions) {
                if ((0, $f1q41.isEqual)($bc128e928d6f2e9d$var$__assign($bc128e928d6f2e9d$var$__assign({}, previousOptions), options), previousOptions)) return previousOptions;
                return $bc128e928d6f2e9d$var$__assign($bc128e928d6f2e9d$var$__assign({}, previousOptions), options);
            });
        });
    }, []);
    return (0, $ayMG0.jsx)($bc128e928d6f2e9d$var$AuthLayoutContext.Provider, {
        value: {
            configureLayout: configureLayout
        },
        children: (0, $ayMG0.jsx)((0, $eOrpz.default), $bc128e928d6f2e9d$var$__assign({}, authLayoutOptionsDebounced, {
            children: children
        }))
    });
}

});
parcelRegister("eOrpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac8aff8a9a413953$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $fdkg2 = parcelRequire("fdkg2");

var $33lpL = parcelRequire("33lpL");

var $5goL7 = parcelRequire("5goL7");

function $ac8aff8a9a413953$var$Gradient() {
    return (0, $ayMG0.jsx)("img", {
        src: new URL((parcelRequire("ibmPx"))).href,
        className: "absolute left-0 top-0 w-full select-none dark:hidden",
        draggable: "false"
    });
}
function $ac8aff8a9a413953$export$2e2bcd8739ae039(_a) {
    var children = _a.children, product = _a.product;
    return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $ayMG0.jsx)((0, $fdkg2.Confetti), {}),
            (0, $ayMG0.jsx)("div", {
                className: "flex h-screen w-full flex-row bg-white dark:bg-gray-900",
                children: (0, $ayMG0.jsxs)("div", {
                    className: "flex h-full flex-1 flex-col overflow-y-auto bg-gray-50 dark:bg-gray-900",
                    children: [
                        (0, $ayMG0.jsxs)("div", {
                            className: "mx-auto flex size-full max-w-[440px] flex-col items-start justify-between space-y-10 px-4 py-8",
                            children: [
                                (0, $ayMG0.jsx)((0, $5goL7.default), {
                                    to: [
                                        "up.auth.login",
                                        {
                                            product: product
                                        }
                                    ],
                                    children: (0, $ayMG0.jsx)((0, $33lpL.default), {
                                        product: product,
                                        className: "relative z-10 text-black dark:text-white"
                                    })
                                }),
                                (0, $ayMG0.jsx)("div", {
                                    className: "relative z-10 flex w-full flex-col space-y-6",
                                    children: children
                                }),
                                (0, $ayMG0.jsx)("div", {})
                            ]
                        }),
                        (0, $ayMG0.jsx)($ac8aff8a9a413953$var$Gradient, {})
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("ibmPx", function(module, exports) {
module.exports = new URL("gradient.0ebd9a08.png", import.meta.url).toString();

});




parcelRegister("6RTBm", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $5002d2a71aecc0af$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "default", () => $5002d2a71aecc0af$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ShortcutAction", () => $5002d2a71aecc0af$export$e69a266640b26be0);
$parcel$export(module.exports, "HistoryElement", () => $5002d2a71aecc0af$export$4b9610e47bdf2773);

var $ayMG0 = parcelRequire("ayMG0");

var $65rC1 = parcelRequire("65rC1");
var $jqZdy = parcelRequire("jqZdy");
var $LXdPD = parcelRequire("LXdPD");
var $57e7W = parcelRequire("57e7W");

var $2bwVh = parcelRequire("2bwVh");

var $acw62 = parcelRequire("acw62");

var $6lUYj = parcelRequire("6lUYj");

var $hW7sX = parcelRequire("hW7sX");

var $9HNzc = parcelRequire("9HNzc");

var $7xuAh = parcelRequire("7xuAh");

var $iYJzJ = parcelRequire("iYJzJ");
var $5002d2a71aecc0af$var$__assign = undefined && undefined.__assign || function() {
    $5002d2a71aecc0af$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5002d2a71aecc0af$var$__assign.apply(this, arguments);
};
var $5002d2a71aecc0af$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5002d2a71aecc0af$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $5002d2a71aecc0af$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $5002d2a71aecc0af$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $5002d2a71aecc0af$var$ShortcutsContext = /*#__PURE__*/ (0, $acw62.createContext)({
    addAction: function(shortcut) {},
    removeAction: function(id) {},
    addToHistory: function(historyElement) {},
    removeHistoryItem: function(id) {},
    toggleShortcuts: function() {}
});
function $5002d2a71aecc0af$export$a1ca853c6e4bb6fb() {
    return (0, $acw62.useContext)($5002d2a71aecc0af$var$ShortcutsContext);
}
function $5002d2a71aecc0af$export$2e2bcd8739ae039(_a) {
    var children = _a.children;
    // Only enable shortcuts within HQ
    if (!location.host.startsWith("hq.upscope")) return children;
    return (0, $ayMG0.jsx)($5002d2a71aecc0af$var$HqShortcutsProvider, {
        children: children
    });
}
function $5002d2a71aecc0af$var$HqShortcutsProvider(_a) {
    var _this = this;
    var children = _a.children;
    var redirect = (0, $7xuAh.default)();
    var _b = $5002d2a71aecc0af$var$__read((0, $acw62.useState)([]), 2), actions = _b[0], setActions = _b[1];
    var _c = $5002d2a71aecc0af$var$__read((0, $acw62.useState)([]), 2), results = _c[0], setResults = _c[1];
    var _d = $5002d2a71aecc0af$var$__read((0, $acw62.useState)(false), 2), open = _d[0], setOpen = _d[1];
    var _e = $5002d2a71aecc0af$var$__read((0, $acw62.useState)(false), 2), loading = _e[0], setLoading = _e[1];
    var _f = $5002d2a71aecc0af$var$__read((0, $acw62.useState)(""), 2), query = _f[0], setQuery = _f[1];
    var queryRef = (0, $acw62.useRef)(query);
    queryRef.current = query;
    var _g = $5002d2a71aecc0af$var$__read((0, $iYJzJ.useLocalStorageState)("shortcuts-history", []), 2), historyElements = _g[0], setHistoryElements = _g[1];
    var recentItems = (0, $acw62.useMemo)(function() {
        return historyElements.map(function(element) {
            return $5002d2a71aecc0af$var$historyElementToShortcut(element, redirect);
        });
    }, [
        historyElements,
        redirect
    ]);
    var addAction = (0, $acw62.useCallback)(function(shortcut) {
        setActions(function(actions) {
            return $5002d2a71aecc0af$var$__spreadArray($5002d2a71aecc0af$var$__spreadArray([], $5002d2a71aecc0af$var$__read(actions), false), [
                shortcut
            ], false);
        });
    }, []);
    var removeAction = (0, $acw62.useCallback)(function(id) {
        setActions(function(actions) {
            return actions.filter(function(action) {
                return action.id !== id;
            });
        });
    }, []);
    var addToHistory = (0, $acw62.useCallback)(function(historyElement) {
        setHistoryElements(function(elements) {
            return $5002d2a71aecc0af$var$__spreadArray([
                historyElement
            ], $5002d2a71aecc0af$var$__read(elements.filter(function(_a) {
                var id = _a.id;
                return id !== historyElement.id;
            })), false).slice(0, 5);
        });
    }, [
        setHistoryElements
    ]);
    var toggleShortcuts = (0, $acw62.useCallback)(function() {
        setOpen(function(open) {
            return !open;
        });
    }, []);
    var removeHistoryItem = (0, $acw62.useCallback)(function(id) {
        setHistoryElements(function(elements) {
            return elements.filter(function(element) {
                return element.id !== id;
            });
        });
    }, [
        setHistoryElements
    ]);
    var call = (0, $hW7sX.useApi)("hq.search.list").call;
    (0, $acw62.useEffect)(function() {
        var listener = function(event) {
            if (event.key === "k" && event.metaKey) toggleShortcuts();
        };
        window.addEventListener("keydown", listener);
        return function() {
            window.removeEventListener("keydown", listener);
        };
    }, [
        toggleShortcuts
    ]);
    // Listen for 3 taps on mobile in short succession to open shortcuts
    (0, $acw62.useEffect)(function() {
        var taps = 0;
        var lastTap = 0;
        var listener = function() {
            var now = Date.now();
            if (now - lastTap < 300) taps++;
            else taps = 1;
            lastTap = now;
            if (taps === 3) setTimeout(function() {
                return setOpen(true);
            }, 100);
        };
        window.addEventListener("touchstart", listener);
        return function() {
            window.removeEventListener("touchstart", listener);
        };
    }, []);
    (0, $2bwVh.useDebouncedEffect)(function() {
        return $5002d2a71aecc0af$var$__awaiter(_this, void 0, void 0, function() {
            var response, companies, users, quotes, opportunities;
            return $5002d2a71aecc0af$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!query) return [
                            2 /*return*/ ,
                            setResults([])
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            call({
                                search: query
                            })
                        ];
                    case 2:
                        response = _a.sent();
                        if (response.success) {
                            companies = response.companies, users = response.users, quotes = response.quotes, opportunities = response.opportunities;
                            if (queryRef.current !== query) return [
                                2 /*return*/ 
                            ];
                            if (companies.length + users.length + quotes.length + opportunities.length === 0) return [
                                2 /*return*/ 
                            ];
                            setResults($5002d2a71aecc0af$var$__spreadArray($5002d2a71aecc0af$var$__spreadArray($5002d2a71aecc0af$var$__spreadArray($5002d2a71aecc0af$var$__spreadArray([], $5002d2a71aecc0af$var$__read(companies), false), $5002d2a71aecc0af$var$__read(users), false), $5002d2a71aecc0af$var$__read(quotes), false), $5002d2a71aecc0af$var$__read(opportunities), false).map(function(result) {
                                return $5002d2a71aecc0af$var$__assign($5002d2a71aecc0af$var$__assign({}, $5002d2a71aecc0af$var$searchResultToShortcut(result, redirect)), {
                                    originalQuery: query
                                });
                            }));
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        query
    ], 100);
    (0, $acw62.useEffect)(function() {
        if (!query) return;
        setLoading(true);
    }, [
        query
    ]);
    return (0, $ayMG0.jsxs)($5002d2a71aecc0af$var$ShortcutsContext.Provider, {
        value: {
            addAction: addAction,
            removeAction: removeAction,
            addToHistory: addToHistory,
            toggleShortcuts: toggleShortcuts,
            removeHistoryItem: removeHistoryItem
        },
        children: [
            (0, $ayMG0.jsx)((0, $6lUYj.default), {
                actions: actions,
                open: open,
                setOpen: setOpen,
                query: query,
                setQuery: setQuery,
                recentItems: recentItems,
                results: results,
                loading: loading
            }),
            children
        ]
    });
}
function $5002d2a71aecc0af$export$e69a266640b26be0(props) {
    var _a = (0, $acw62.useContext)($5002d2a71aecc0af$var$ShortcutsContext), addAction = _a.addAction, removeAction = _a.removeAction;
    var cachedProps = (0, $acw62.useRef)(props);
    (0, $acw62.useEffect)(function() {
        var shortcut = cachedProps.current;
        addAction(shortcut);
        return function() {
            removeAction(shortcut.id);
        };
    }, [
        addAction,
        removeAction
    ]);
    return null;
}
function $5002d2a71aecc0af$export$4b9610e47bdf2773(props) {
    var addToHistory = (0, $acw62.useContext)($5002d2a71aecc0af$var$ShortcutsContext).addToHistory;
    var cachedProps = (0, $9HNzc.default)(props);
    (0, $acw62.useEffect)(function() {
        switch(cachedProps.type){
            case "user":
                addToHistory({
                    type: "user",
                    id: cachedProps.id,
                    name: $5002d2a71aecc0af$var$userName(cachedProps)
                });
                break;
            case "company":
                addToHistory({
                    type: "company",
                    id: cachedProps.id,
                    name: $5002d2a71aecc0af$var$companyName(cachedProps)
                });
                break;
            case "quote":
                addToHistory({
                    type: "quote",
                    id: cachedProps.publicKey,
                    name: $5002d2a71aecc0af$var$quoteName(cachedProps)
                });
                break;
            case "sales_opportunity":
                addToHistory({
                    type: "opportunity",
                    id: cachedProps.id,
                    name: $5002d2a71aecc0af$var$opportunityName(cachedProps)
                });
                break;
        }
    }, [
        addToHistory,
        cachedProps
    ]);
    return null;
}
function $5002d2a71aecc0af$var$historyElementToShortcut(historyElement, redirect) {
    switch(historyElement.type){
        case "user":
            return {
                id: historyElement.id,
                name: historyElement.name,
                icon: (0, $57e7W.default),
                verb: "View",
                priority: -1,
                onClick: function() {
                    redirect([
                        "hq.users.show",
                        {
                            userId: historyElement.id
                        }
                    ]);
                }
            };
        case "company":
            return {
                id: historyElement.id,
                name: historyElement.name,
                icon: (0, $65rC1.default),
                verb: "View",
                priority: 2,
                onClick: function() {
                    redirect([
                        "hq.accounts.show",
                        {
                            companyId: historyElement.id
                        }
                    ]);
                }
            };
        case "quote":
            return {
                id: historyElement.id,
                name: historyElement.name,
                icon: (0, $LXdPD.default),
                verb: "View",
                priority: 1,
                onClick: function() {
                    redirect([
                        "hq.quotes.show",
                        {
                            quotePublicKey: historyElement.id
                        }
                    ]);
                }
            };
        case "opportunity":
            return {
                id: historyElement.id,
                name: historyElement.name,
                icon: (0, $jqZdy.default),
                verb: "View",
                priority: 1,
                onClick: function() {
                    redirect([
                        "hq.sales.opportunities.show",
                        {
                            opportunityId: historyElement.id
                        }
                    ]);
                }
            };
    }
}
function $5002d2a71aecc0af$var$searchResultToShortcut(result, redirect) {
    switch(result.type){
        case "user":
            return {
                id: result.id,
                name: $5002d2a71aecc0af$var$userName(result),
                alternativeNames: [
                    result.id,
                    result.name,
                    result.email
                ].filter(Boolean),
                icon: (0, $57e7W.default),
                verb: "View",
                priority: -1,
                onClick: function() {
                    redirect([
                        "hq.users.show",
                        {
                            userId: result.id
                        }
                    ]);
                }
            };
        case "company":
            return {
                id: result.id,
                name: $5002d2a71aecc0af$var$companyName(result),
                alternativeNames: $5002d2a71aecc0af$var$__spreadArray([
                    result.id,
                    result.name
                ], $5002d2a71aecc0af$var$__read(result.domains), false),
                icon: (0, $65rC1.default),
                verb: "View",
                priority: 2,
                onClick: function() {
                    redirect([
                        "hq.accounts.show",
                        {
                            companyId: result.id
                        }
                    ]);
                }
            };
        case "quote":
            return {
                id: result.publicKey,
                name: $5002d2a71aecc0af$var$quoteName(result),
                icon: (0, $LXdPD.default),
                verb: "View",
                priority: 1,
                onClick: function() {
                    redirect([
                        "hq.quotes.show",
                        {
                            quotePublicKey: result.publicKey
                        }
                    ]);
                }
            };
        case "sales_opportunity":
            return {
                id: result.id,
                name: $5002d2a71aecc0af$var$opportunityName(result),
                icon: (0, $LXdPD.default),
                verb: "View",
                priority: 1,
                onClick: function() {
                    redirect([
                        "hq.sales.opportunities.show",
                        {
                            opportunityId: result.id
                        }
                    ]);
                }
            };
    }
}
function $5002d2a71aecc0af$var$companyName(company) {
    return company.name !== company.domains[0] && company.domains.length > 0 ? "".concat(company.name, " (").concat(company.domains[0], ")") : company.name;
}
function $5002d2a71aecc0af$var$quoteName(quote) {
    return quote.company ? "Quote ".concat(quote.publicKey, " for ").concat(quote.company.name) : "Quote ".concat(quote.publicKey);
}
function $5002d2a71aecc0af$var$opportunityName(opportunity) {
    return "Opportunity ".concat(opportunity.id, " for ").concat(opportunity.company.name);
}
function $5002d2a71aecc0af$var$userName(user) {
    return user.name !== undefined ? "".concat(user.name, " (").concat(user.email, ")") : user.email;
}

});
parcelRegister("65rC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $46e8a0e85073302d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $46e8a0e85073302d$var$BuildingOffice2Icon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z"
    }));
}
const $46e8a0e85073302d$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($46e8a0e85073302d$var$BuildingOffice2Icon);
var $46e8a0e85073302d$export$2e2bcd8739ae039 = $46e8a0e85073302d$var$ForwardRef;

});

parcelRegister("LXdPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0902542cd17ebe75$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $0902542cd17ebe75$var$DocumentTextIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
    }));
}
const $0902542cd17ebe75$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($0902542cd17ebe75$var$DocumentTextIcon);
var $0902542cd17ebe75$export$2e2bcd8739ae039 = $0902542cd17ebe75$var$ForwardRef;

});

parcelRegister("57e7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b98908ec262a6b8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3b98908ec262a6b8$var$UserIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    }));
}
const $3b98908ec262a6b8$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($3b98908ec262a6b8$var$UserIcon);
var $3b98908ec262a6b8$export$2e2bcd8739ae039 = $3b98908ec262a6b8$var$ForwardRef;

});

parcelRegister("6lUYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a00e5a7c7d78a9c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $kausY = parcelRequire("kausY");
var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $bo1Qi = parcelRequire("bo1Qi");

var $56ycy = parcelRequire("56ycy");

var $h0N5t = parcelRequire("h0N5t");

var $acw62 = parcelRequire("acw62");

var $01O3F = parcelRequire("01O3F");

var $jFdmN = parcelRequire("jFdmN");
var $4a00e5a7c7d78a9c$var$__assign = undefined && undefined.__assign || function() {
    $4a00e5a7c7d78a9c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4a00e5a7c7d78a9c$var$__assign.apply(this, arguments);
};
var $4a00e5a7c7d78a9c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $4a00e5a7c7d78a9c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4a00e5a7c7d78a9c$var$FUZZY_THRESHOLD = 0.3;
function $4a00e5a7c7d78a9c$export$2e2bcd8739ae039(props) {
    var filteredResults = (0, $acw62.useMemo)(function() {
        return $4a00e5a7c7d78a9c$var$__spreadArray([], $4a00e5a7c7d78a9c$var$__read(props.results), false);
    }, [
        props.results
    ]);
    var filteredRecentItems = (0, $acw62.useMemo)(function() {
        return $4a00e5a7c7d78a9c$var$__spreadArray([], $4a00e5a7c7d78a9c$var$__read(props.recentItems), false).filter(function(item) {
            return !filteredResults.some(function(result) {
                return result.id === item.id;
            });
        });
    }, [
        props.recentItems,
        filteredResults
    ]);
    var filteredActions = (0, $acw62.useMemo)(function() {
        return $4a00e5a7c7d78a9c$var$__spreadArray([], $4a00e5a7c7d78a9c$var$__read(props.actions), false);
    }, [
        props.actions
    ]);
    var aggregateItems = (0, $acw62.useMemo)(function() {
        return $4a00e5a7c7d78a9c$var$__spreadArray($4a00e5a7c7d78a9c$var$__spreadArray($4a00e5a7c7d78a9c$var$__spreadArray([], $4a00e5a7c7d78a9c$var$__read(filteredActions), false), $4a00e5a7c7d78a9c$var$__read(filteredRecentItems), false), $4a00e5a7c7d78a9c$var$__read(filteredResults), false).map(function(item) {
            return [
                item,
                Math.max.apply(Math, $4a00e5a7c7d78a9c$var$__spreadArray([], $4a00e5a7c7d78a9c$var$__read($4a00e5a7c7d78a9c$var$__spreadArray($4a00e5a7c7d78a9c$var$__spreadArray([
                    item.name
                ], $4a00e5a7c7d78a9c$var$__read(item.alternativeNames || []), false), [
                    item.originalQuery
                ], false).filter(Boolean).map(function(name) {
                    return (0, $h0N5t.fuzzy)(props.query, name);
                })), false))
            ];
        }).filter(function(_a) {
            var _b = $4a00e5a7c7d78a9c$var$__read(_a, 2), score = _b[1];
            return score > $4a00e5a7c7d78a9c$var$FUZZY_THRESHOLD;
        }).sort(function(a, b) {
            var _a, _b;
            return ((_a = b[0].priority) !== null && _a !== void 0 ? _a : 0) - ((_b = a[0].priority) !== null && _b !== void 0 ? _b : 0);
        }).sort(function(a, b) {
            return b[1] - a[1];
        }).map(function(_a) {
            var _b = $4a00e5a7c7d78a9c$var$__read(_a, 1), item = _b[0];
            return item;
        });
    }, [
        props.query,
        filteredRecentItems,
        filteredResults,
        filteredActions
    ]);
    return (0, $ayMG0.jsx)((0, $iymfR.Transition), {
        show: props.open,
        as: (0, $acw62.Fragment),
        afterLeave: function() {
            return props.setQuery("");
        },
        appear: true,
        children: (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: "z-60 relative",
            onClose: props.setOpen,
            children: [
                (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                    as: (0, $acw62.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: (0, $ayMG0.jsx)("div", {
                        className: "fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"
                    })
                }),
                (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto p-4 sm:p-6 md:p-20",
                    children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                        as: (0, $acw62.Fragment),
                        enter: "ease-out duration-300",
                        enterFrom: "opacity-0 scale-95",
                        enterTo: "opacity-100 scale-100",
                        leave: "ease-in duration-200",
                        leaveFrom: "opacity-100 scale-100",
                        leaveTo: "opacity-0 scale-95",
                        children: (0, $ayMG0.jsx)((0, $lLzDP.DialogPanel), {
                            className: "mx-auto max-w-2xl divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black\n                ring-opacity-5 transition-all dark:divide-gray-700 dark:bg-gray-900",
                            children: (0, $ayMG0.jsxs)((0, $kausY.Combobox), {
                                onChange: function(item) {
                                    item === null || item === void 0 || item.onClick();
                                    props.setOpen(false);
                                },
                                children: [
                                    (0, $ayMG0.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            (0, $ayMG0.jsx)((0, $bo1Qi.default), {
                                                className: "pointer-events-none absolute left-4 top-3.5 size-5 text-gray-400 dark:text-gray-500",
                                                "aria-hidden": "true"
                                            }),
                                            (0, $ayMG0.jsx)((0, $kausY.ComboboxInput), {
                                                className: "h-12 w-full border-0 bg-transparent pl-11 pr-4 text-sm text-gray-900 placeholder:text-gray-400 focus:ring-0\n                      dark:text-white",
                                                placeholder: "Search...",
                                                onChange: function(event) {
                                                    return props.setQuery(event.target.value);
                                                },
                                                autoFocus: true
                                            })
                                        ]
                                    }),
                                    (0, $ayMG0.jsxs)((0, $kausY.ComboboxOptions), {
                                        static: true,
                                        className: "max-h-80 scroll-py-2 divide-y divide-gray-100 overflow-y-auto dark:divide-gray-700",
                                        children: [
                                            props.query === "" && filteredRecentItems.length > 0 && (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Section, {
                                                title: "Recently viewed",
                                                children: filteredRecentItems.map(function(item) {
                                                    return (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Item, $4a00e5a7c7d78a9c$var$__assign({}, item), item.id);
                                                })
                                            }),
                                            props.query === "" && filteredActions.length > 0 && (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Section, {
                                                children: filteredActions.map(function(item) {
                                                    return (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Item, $4a00e5a7c7d78a9c$var$__assign({}, item), item.id);
                                                })
                                            }),
                                            props.query !== "" && aggregateItems.length > 0 && (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Section, {
                                                children: aggregateItems.map(function(item) {
                                                    return (0, $ayMG0.jsx)($4a00e5a7c7d78a9c$var$Item, $4a00e5a7c7d78a9c$var$__assign({}, item), item.id);
                                                })
                                            })
                                        ]
                                    }),
                                    props.query !== "" && aggregateItems.length === 0 && (props.loading ? (0, $ayMG0.jsx)("div", {
                                        className: "px-6 py-14 sm:px-14",
                                        children: (0, $ayMG0.jsx)((0, $jFdmN.default), {})
                                    }) : (0, $ayMG0.jsxs)("div", {
                                        className: "px-6 py-14 text-center sm:px-14",
                                        children: [
                                            (0, $ayMG0.jsx)((0, $56ycy.default), {
                                                className: "mx-auto size-6 text-gray-400 dark:text-gray-500",
                                                "aria-hidden": "true"
                                            }),
                                            (0, $ayMG0.jsx)("p", {
                                                className: "mt-4 text-sm text-gray-900 dark:text-gray-200",
                                                children: "We couldn't find anything with that term. Please try again."
                                            })
                                        ]
                                    }))
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
function $4a00e5a7c7d78a9c$var$Section(_a) {
    var title = _a.title, children = _a.children;
    return (0, $ayMG0.jsxs)("li", {
        className: "list-none p-2",
        children: [
            title && (0, $ayMG0.jsx)("h2", {
                className: "mb-2 mt-4 px-3 text-xs font-semibold text-gray-500 dark:text-gray-200",
                children: title
            }),
            (0, $ayMG0.jsx)("ul", {
                className: "text-sm text-gray-700 dark:text-gray-400",
                children: children
            })
        ]
    });
}
function $4a00e5a7c7d78a9c$var$Item(item) {
    return (0, $ayMG0.jsx)((0, $kausY.ComboboxOption), {
        value: item,
        className: function(_a) {
            var focus = _a.focus;
            return (0, $01O3F.classNames)("flex cursor-default select-none items-center rounded-md px-3 py-2", focus && "bg-indigo-600 dark:bg-gray-800 text-white");
        },
        children: function(_a) {
            var focus = _a.focus;
            return (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    (0, $ayMG0.jsx)(item.icon, {
                        className: (0, $01O3F.classNames)("h-6 w-6 flex-none", focus ? "text-white" : "text-gray-400 dark:text-gray-500"),
                        "aria-hidden": "true"
                    }),
                    (0, $ayMG0.jsx)("span", {
                        className: "ml-3 flex-auto truncate",
                        children: item.name
                    }),
                    focus && item.verb && (0, $ayMG0.jsx)("span", {
                        className: "ml-3 flex-none text-indigo-100 dark:text-gray-400",
                        children: item.verb
                    })
                ]
            });
        }
    }, item.name);
}

});
parcelRegister("kausY", function(module, exports) {

$parcel$export(module.exports, "ComboboxButton", () => $eaec5fceb04f7d33$export$756fe6c16147e11a);
$parcel$export(module.exports, "ComboboxInput", () => $eaec5fceb04f7d33$export$de5e47f31372e2e3);
$parcel$export(module.exports, "ComboboxOptions", () => $eaec5fceb04f7d33$export$47929aa3fb52fca2);
$parcel$export(module.exports, "ComboboxOption", () => $eaec5fceb04f7d33$export$7ce8df7790337ff4);
$parcel$export(module.exports, "Combobox", () => $eaec5fceb04f7d33$export$27957ad87354dd7e);

var $kd7LS = parcelRequire("kd7LS");

var $6o6B3 = parcelRequire("6o6B3");

var $8EDjv = parcelRequire("8EDjv");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cE9hP = parcelRequire("cE9hP");

var $ePQFN = parcelRequire("ePQFN");

var $h26ct = parcelRequire("h26ct");

var $3X9lW = parcelRequire("3X9lW");

var $5Ai9V = parcelRequire("5Ai9V");

var $dfvrc = parcelRequire("dfvrc");

var $114Mg = parcelRequire("114Mg");

var $acw62 = parcelRequire("acw62");

var $keKjn = parcelRequire("keKjn");

var $8KgIp = parcelRequire("8KgIp");

var $ltgxC = parcelRequire("ltgxC");

var $dcp2r = parcelRequire("dcp2r");

var $23pTr = parcelRequire("23pTr");

var $5IEAk = parcelRequire("5IEAk");

var $a8HmZ = parcelRequire("a8HmZ");

var $gm4XX = parcelRequire("gm4XX");

var $hZodg = parcelRequire("hZodg");

var $6mpbl = parcelRequire("6mpbl");

var $ipity = parcelRequire("ipity");

var $bdknl = parcelRequire("bdknl");

var $1nOiu = parcelRequire("1nOiu");

var $lEQT2 = parcelRequire("lEQT2");

var $brAF4 = parcelRequire("brAF4");

var $34Str = parcelRequire("34Str");

var $dBJH0 = parcelRequire("dBJH0");

var $9UPTU = parcelRequire("9UPTU");

var $jpbxo = parcelRequire("jpbxo");

var $auuNT = parcelRequire("auuNT");

var $2C9FE = parcelRequire("2C9FE");

var $5fYEB = parcelRequire("5fYEB");

var $fLrGx = parcelRequire("fLrGx");

var $1COYr = parcelRequire("1COYr");

var $hsQxB = parcelRequire("hsQxB");

var $6Ngq1 = parcelRequire("6Ngq1");

var $8UjaS = parcelRequire("8UjaS");

var $ebRQH = parcelRequire("ebRQH");

var $iGb09 = parcelRequire("iGb09");

var $6AKlm = parcelRequire("6AKlm");

var $5qg9U = parcelRequire("5qg9U");

var $6stYl = parcelRequire("6stYl");

var $e9NTc = parcelRequire("e9NTc");
"use client";
var $eaec5fceb04f7d33$var$Ct = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($eaec5fceb04f7d33$var$Ct || {}), $eaec5fceb04f7d33$var$Et = ((e)=>(e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))($eaec5fceb04f7d33$var$Et || {}), $eaec5fceb04f7d33$var$St = ((o)=>(o[o.Pointer = 0] = "Pointer", o[o.Focus = 1] = "Focus", o[o.Other = 2] = "Other", o))($eaec5fceb04f7d33$var$St || {}), $eaec5fceb04f7d33$var$It = ((l)=>(l[l.OpenCombobox = 0] = "OpenCombobox", l[l.CloseCombobox = 1] = "CloseCombobox", l[l.GoToOption = 2] = "GoToOption", l[l.SetTyping = 3] = "SetTyping", l[l.RegisterOption = 4] = "RegisterOption", l[l.UnregisterOption = 5] = "UnregisterOption", l[l.SetActivationTrigger = 6] = "SetActivationTrigger", l[l.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", l[l.SetInputElement = 8] = "SetInputElement", l[l.SetButtonElement = 9] = "SetButtonElement", l[l.SetOptionsElement = 10] = "SetOptionsElement", l))($eaec5fceb04f7d33$var$It || {});
function $eaec5fceb04f7d33$var$ve(t, n = (e)=>e) {
    let e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, o = n(t.options.slice()), f = o.length > 0 && o[0].dataRef.current.order !== null ? o.sort((m, d)=>m.dataRef.current.order - d.dataRef.current.order) : (0, $hsQxB.sortByDomNode)(o, (m)=>m.dataRef.current.domRef.current), b = e ? f.indexOf(e) : null;
    return b === -1 && (b = null), {
        options: f,
        activeOptionIndex: b
    };
}
let $eaec5fceb04f7d33$var$Pt = {
    [1] (t) {
        var n;
        return (n = t.dataRef.current) != null && n.disabled || t.comboboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1,
            isTyping: !1,
            activationTrigger: 2,
            __demoMode: !1
        };
    },
    [0] (t) {
        var n, e;
        if ((n = t.dataRef.current) != null && n.disabled || t.comboboxState === 0) return t;
        if ((e = t.dataRef.current) != null && e.value) {
            let o = t.dataRef.current.calculateIndex(t.dataRef.current.value);
            if (o !== -1) return {
                ...t,
                activeOptionIndex: o,
                comboboxState: 0,
                __demoMode: !1
            };
        }
        return {
            ...t,
            comboboxState: 0,
            __demoMode: !1
        };
    },
    [3] (t, n) {
        return t.isTyping === n.isTyping ? t : {
            ...t,
            isTyping: n.isTyping
        };
    },
    [2] (t, n) {
        var b, m, d, x;
        if ((b = t.dataRef.current) != null && b.disabled || t.optionsElement && !((m = t.dataRef.current) != null && m.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        if (t.virtual) {
            let { options: i, disabled: r } = t.virtual, l = n.focus === (0, $fLrGx.Focus).Specific ? n.idx : (0, $fLrGx.calculateActiveIndex)(n, {
                resolveItems: ()=>i,
                resolveActiveIndex: ()=>{
                    var R, s;
                    return (s = (R = t.activeOptionIndex) != null ? R : i.findIndex((D)=>!r(D))) != null ? s : null;
                },
                resolveDisabled: r,
                resolveId () {
                    throw new Error("Function not implemented.");
                }
            }), S = (d = n.trigger) != null ? d : 2;
            return t.activeOptionIndex === l && t.activationTrigger === S ? t : {
                ...t,
                activeOptionIndex: l,
                activationTrigger: S,
                isTyping: !1,
                __demoMode: !1
            };
        }
        let e = $eaec5fceb04f7d33$var$ve(t);
        if (e.activeOptionIndex === null) {
            let i = e.options.findIndex((r)=>!r.dataRef.current.disabled);
            i !== -1 && (e.activeOptionIndex = i);
        }
        let o = n.focus === (0, $fLrGx.Focus).Specific ? n.idx : (0, $fLrGx.calculateActiveIndex)(n, {
            resolveItems: ()=>e.options,
            resolveActiveIndex: ()=>e.activeOptionIndex,
            resolveId: (i)=>i.id,
            resolveDisabled: (i)=>i.dataRef.current.disabled
        }), f = (x = n.trigger) != null ? x : 2;
        return t.activeOptionIndex === o && t.activationTrigger === f ? t : {
            ...t,
            ...e,
            isTyping: !1,
            activeOptionIndex: o,
            activationTrigger: f,
            __demoMode: !1
        };
    },
    [4]: (t, n)=>{
        var b, m, d;
        if ((b = t.dataRef.current) != null && b.virtual) return {
            ...t,
            options: [
                ...t.options,
                n.payload
            ]
        };
        let e = n.payload, o = $eaec5fceb04f7d33$var$ve(t, (x)=>(x.push(e), x));
        t.activeOptionIndex === null && (m = t.dataRef.current) != null && m.isSelected(n.payload.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(e));
        let f = {
            ...t,
            ...o,
            activationTrigger: 2
        };
        return (d = t.dataRef.current) != null && d.__demoMode && t.dataRef.current.value === void 0 && (f.activeOptionIndex = 0), f;
    },
    [5]: (t, n)=>{
        var o;
        if ((o = t.dataRef.current) != null && o.virtual) return {
            ...t,
            options: t.options.filter((f)=>f.id !== n.id)
        };
        let e = $eaec5fceb04f7d33$var$ve(t, (f)=>{
            let b = f.findIndex((m)=>m.id === n.id);
            return b !== -1 && f.splice(b, 1), f;
        });
        return {
            ...t,
            ...e,
            activationTrigger: 2
        };
    },
    [6]: (t, n)=>t.activationTrigger === n.trigger ? t : {
            ...t,
            activationTrigger: n.trigger
        },
    [7]: (t, n)=>{
        var o, f;
        if (t.virtual === null) return {
            ...t,
            virtual: {
                options: n.options,
                disabled: (o = n.disabled) != null ? o : ()=>!1
            }
        };
        if (t.virtual.options === n.options && t.virtual.disabled === n.disabled) return t;
        let e = t.activeOptionIndex;
        if (t.activeOptionIndex !== null) {
            let b = n.options.indexOf(t.virtual.options[t.activeOptionIndex]);
            b !== -1 ? e = b : e = null;
        }
        return {
            ...t,
            activeOptionIndex: e,
            virtual: {
                options: n.options,
                disabled: (f = n.disabled) != null ? f : ()=>!1
            }
        };
    },
    [8]: (t, n)=>t.inputElement === n.element ? t : {
            ...t,
            inputElement: n.element
        },
    [9]: (t, n)=>t.buttonElement === n.element ? t : {
            ...t,
            buttonElement: n.element
        },
    [10]: (t, n)=>t.optionsElement === n.element ? t : {
            ...t,
            optionsElement: n.element
        }
}, $eaec5fceb04f7d33$var$ye = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$ye.displayName = "ComboboxActionsContext";
function $eaec5fceb04f7d33$var$le(t) {
    let n = (0, $acw62.useContext)($eaec5fceb04f7d33$var$ye);
    if (n === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $eaec5fceb04f7d33$var$le), e;
    }
    return n;
}
let $eaec5fceb04f7d33$var$Ne = (0, $acw62.createContext)(null);
function $eaec5fceb04f7d33$var$At(t) {
    let n = $eaec5fceb04f7d33$var$ne("VirtualProvider"), { options: e } = n.virtual, [o, f] = (0, $acw62.useMemo)(()=>{
        let i = n.optionsElement;
        if (!i) return [
            0,
            0
        ];
        let r = window.getComputedStyle(i);
        return [
            parseFloat(r.paddingBlockStart || r.paddingTop),
            parseFloat(r.paddingBlockEnd || r.paddingBottom)
        ];
    }, [
        n.optionsElement
    ]), b = (0, $8EDjv.useVirtualizer)({
        enabled: e.length !== 0,
        scrollPaddingStart: o,
        scrollPaddingEnd: f,
        count: e.length,
        estimateSize () {
            return 40;
        },
        getScrollElement () {
            return n.optionsElement;
        },
        overscan: 12
    }), [m, d] = (0, $acw62.useState)(0);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        d((i)=>i + 1);
    }, [
        e
    ]);
    let x = b.getVirtualItems();
    return x.length === 0 ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$Ne.Provider, {
        value: b
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: "relative",
            width: "100%",
            height: `${b.getTotalSize()}px`
        },
        ref: (i)=>{
            i && n.activationTrigger !== 0 && n.activeOptionIndex !== null && e.length > n.activeOptionIndex && b.scrollToIndex(n.activeOptionIndex);
        }
    }, x.map((i)=>{
        var r;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
            key: i.key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((r = t.children) == null ? void 0 : r.call(t, {
            ...t.slot,
            option: e[i.index]
        }), {
            key: `${m}-${i.key}`,
            "data-index": i.index,
            "aria-setsize": e.length,
            "aria-posinset": i.index + 1,
            style: {
                position: "absolute",
                top: 0,
                left: 0,
                transform: `translateY(${i.start}px)`,
                overflowAnchor: "none"
            }
        }));
    })));
}
let $eaec5fceb04f7d33$var$ae = (0, $acw62.createContext)(null);
$eaec5fceb04f7d33$var$ae.displayName = "ComboboxDataContext";
function $eaec5fceb04f7d33$var$ne(t) {
    let n = (0, $acw62.useContext)($eaec5fceb04f7d33$var$ae);
    if (n === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $eaec5fceb04f7d33$var$ne), e;
    }
    return n;
}
function $eaec5fceb04f7d33$var$Rt(t, n) {
    return (0, $6Ngq1.match)(n.type, $eaec5fceb04f7d33$var$Pt, t, n);
}
let $eaec5fceb04f7d33$var$_t = (0, $acw62.Fragment);
function $eaec5fceb04f7d33$var$ht(t, n) {
    var Oe, Ce;
    let e = (0, $brAF4.useDisabled)(), { value: o, defaultValue: f, onChange: b, form: m, name: d, by: x, disabled: i = e || !1, onClose: r, __demoMode: l = !1, multiple: S = !1, immediate: R = !1, virtual: s = null, nullable: D, ...B } = t, _ = (0, $3X9lW.useDefaultValue)(f), [I = S ? [] : void 0, O] = (0, $h26ct.useControllable)(o, b, _), [P, g] = (0, $acw62.useReducer)($eaec5fceb04f7d33$var$Rt, {
        dataRef: (0, $acw62.createRef)(),
        comboboxState: l ? 0 : 1,
        isTyping: !1,
        options: [],
        virtual: s ? {
            options: s.options,
            disabled: (Oe = s.disabled) != null ? Oe : ()=>!1
        } : null,
        activeOptionIndex: null,
        activationTrigger: 2,
        inputElement: null,
        buttonElement: null,
        optionsElement: null,
        __demoMode: l
    }), V = (0, $acw62.useRef)(!1), w = (0, $acw62.useRef)({
        static: !1,
        hold: !1
    }), T = (0, $ePQFN.useByComparator)(x), $ = (0, $114Mg.useEvent)((p)=>s ? x === null ? s.options.indexOf(p) : s.options.findIndex((v)=>T(v, p)) : P.options.findIndex((v)=>T(v.dataRef.current.value, p))), K = (0, $acw62.useCallback)((p)=>(0, $6Ngq1.match)(u.mode, {
            [1]: ()=>I.some((v)=>T(v, p)),
            [0]: ()=>T(I, p)
        }), [
        I
    ]), Z = (0, $114Mg.useEvent)((p)=>P.activeOptionIndex === $(p)), u = (0, $acw62.useMemo)(()=>({
            ...P,
            immediate: R,
            optionsPropsRef: w,
            value: I,
            defaultValue: _,
            disabled: i,
            mode: S ? 1 : 0,
            virtual: s ? P.virtual : null,
            get activeOptionIndex () {
                if (V.current && P.activeOptionIndex === null && (s ? s.options.length > 0 : P.options.length > 0)) {
                    if (s) {
                        let v = s.options.findIndex((z)=>{
                            var se, Ee;
                            return !((Ee = (se = s.disabled) == null ? void 0 : se.call(s, z)) != null && Ee);
                        });
                        if (v !== -1) return v;
                    }
                    let p = P.options.findIndex((v)=>!v.dataRef.current.disabled);
                    if (p !== -1) return p;
                }
                return P.activeOptionIndex;
            },
            calculateIndex: $,
            compare: T,
            isSelected: K,
            isActive: Z
        }), [
        I,
        _,
        i,
        S,
        l,
        P,
        s
    ]);
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var p;
        s && g({
            type: 7,
            options: s.options,
            disabled: (p = s.disabled) != null ? p : null
        });
    }, [
        s,
        s == null ? void 0 : s.options,
        s == null ? void 0 : s.disabled
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        P.dataRef.current = u;
    }, [
        u
    ]);
    let X = u.comboboxState === 0;
    (0, $23pTr.useOutsideClick)(X, [
        u.buttonElement,
        u.inputElement,
        u.optionsElement
    ], ()=>C.closeCombobox());
    let N = (0, $acw62.useMemo)(()=>{
        var p, v, z;
        return {
            open: u.comboboxState === 0,
            disabled: i,
            activeIndex: u.activeOptionIndex,
            activeOption: u.activeOptionIndex === null ? null : u.virtual ? u.virtual.options[(p = u.activeOptionIndex) != null ? p : 0] : (z = (v = u.options[u.activeOptionIndex]) == null ? void 0 : v.dataRef.current.value) != null ? z : null,
            value: I
        };
    }, [
        u,
        i,
        I
    ]), U = (0, $114Mg.useEvent)(()=>{
        if (u.activeOptionIndex !== null) {
            if (C.setIsTyping(!1), u.virtual) j(u.virtual.options[u.activeOptionIndex]);
            else {
                let { dataRef: p } = u.options[u.activeOptionIndex];
                j(p.current.value);
            }
            C.goToOption((0, $fLrGx.Focus).Specific, u.activeOptionIndex);
        }
    }), y = (0, $114Mg.useEvent)(()=>{
        g({
            type: 0
        }), V.current = !0;
    }), G = (0, $114Mg.useEvent)(()=>{
        g({
            type: 1
        }), V.current = !1, r == null || r();
    }), ue = (0, $114Mg.useEvent)((p)=>{
        g({
            type: 3,
            isTyping: p
        });
    }), Y = (0, $114Mg.useEvent)((p, v, z)=>(V.current = !1, p === (0, $fLrGx.Focus).Specific ? g({
            type: 2,
            focus: (0, $fLrGx.Focus).Specific,
            idx: v,
            trigger: z
        }) : g({
            type: 2,
            focus: p,
            trigger: z
        }))), Q = (0, $114Mg.useEvent)((p, v)=>(g({
            type: 4,
            payload: {
                id: p,
                dataRef: v
            }
        }), ()=>{
            u.isActive(v.current.value) && (V.current = !0), g({
                type: 5,
                id: p
            });
        })), j = (0, $114Mg.useEvent)((p)=>(0, $6Ngq1.match)(u.mode, {
            [0] () {
                return O == null ? void 0 : O(p);
            },
            [1] () {
                let v = u.value.slice(), z = v.findIndex((se)=>T(se, p));
                return z === -1 ? v.push(p) : v.splice(z, 1), O == null ? void 0 : O(v);
            }
        })), h = (0, $114Mg.useEvent)((p)=>{
        g({
            type: 6,
            trigger: p
        });
    }), pe = (0, $114Mg.useEvent)((p)=>{
        g({
            type: 8,
            element: p
        });
    }), a = (0, $114Mg.useEvent)((p)=>{
        g({
            type: 9,
            element: p
        });
    }), k = (0, $114Mg.useEvent)((p)=>{
        g({
            type: 10,
            element: p
        });
    }), C = (0, $acw62.useMemo)(()=>({
            onChange: j,
            registerOption: Q,
            goToOption: Y,
            setIsTyping: ue,
            closeCombobox: G,
            openCombobox: y,
            setActivationTrigger: h,
            selectActiveOption: U,
            setInputElement: pe,
            setButtonElement: a,
            setOptionsElement: k
        }), []), [H, E] = (0, $5qg9U.useLabels)(), L = n === null ? {} : {
        ref: n
    }, J = (0, $acw62.useCallback)(()=>{
        if (_ !== void 0) return O == null ? void 0 : O(_);
    }, [
        O,
        _
    ]), ke = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, {
        value: H,
        props: {
            htmlFor: (Ce = u.inputElement) == null ? void 0 : Ce.id
        },
        slot: {
            open: u.comboboxState === 0,
            disabled: i
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $34Str.FloatingProvider), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ye.Provider, {
        value: C
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ae.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $auuNT.OpenClosedProvider), {
        value: (0, $6Ngq1.match)(u.comboboxState, {
            [0]: (0, $auuNT.State).Open,
            [1]: (0, $auuNT.State).Closed
        })
    }, d != null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dBJH0.FormFields), {
        disabled: i,
        data: I != null ? {
            [d]: I
        } : {},
        form: m,
        onReset: J
    }), ke({
        ourProps: L,
        theirProps: B,
        slot: N,
        defaultTag: $eaec5fceb04f7d33$var$_t,
        name: "Combobox"
    }))))));
}
let $eaec5fceb04f7d33$var$Mt = "input";
function $eaec5fceb04f7d33$var$Dt(t, n) {
    var Y, Q, j, h, pe;
    let e = $eaec5fceb04f7d33$var$ne("Combobox.Input"), o = $eaec5fceb04f7d33$var$le("Combobox.Input"), f = (0, $acw62.useId)(), b = (0, $jpbxo.useProvidedId)(), { id: m = b || `headlessui-combobox-input-${f}`, onChange: d, displayValue: x, disabled: i = e.disabled || !1, autoFocus: r = !1, type: l = "text", ...S } = t, R = (0, $acw62.useRef)(null), s = (0, $6mpbl.useSyncRefs)(R, n, (0, $34Str.useFloatingReference)(), o.setInputElement), D = (0, $5IEAk.useOwnerDocument)(e.inputElement), B = (0, $5Ai9V.useDisposables)(), _ = (0, $114Mg.useEvent)(()=>{
        o.onChange(null), e.optionsElement && (e.optionsElement.scrollTop = 0), o.goToOption((0, $fLrGx.Focus).Nothing);
    }), I = (0, $acw62.useMemo)(()=>{
        var a;
        return typeof x == "function" && e.value !== void 0 ? (a = x(e.value)) != null ? a : "" : typeof e.value == "string" ? e.value : "";
    }, [
        e.value,
        x
    ]);
    (0, $lEQT2.useWatch)(([a, k], [C, H])=>{
        if (e.isTyping) return;
        let E = R.current;
        E && ((H === 0 && k === 1 || a !== C) && (E.value = a), requestAnimationFrame(()=>{
            if (e.isTyping || !E || (D == null ? void 0 : D.activeElement) !== E) return;
            let { selectionStart: L, selectionEnd: J } = E;
            Math.abs((J != null ? J : 0) - (L != null ? L : 0)) === 0 && L === 0 && E.setSelectionRange(E.value.length, E.value.length);
        }));
    }, [
        I,
        e.comboboxState,
        D,
        e.isTyping
    ]), (0, $lEQT2.useWatch)(([a], [k])=>{
        if (a === 0 && k === 1) {
            if (e.isTyping) return;
            let C = R.current;
            if (!C) return;
            let H = C.value, { selectionStart: E, selectionEnd: L, selectionDirection: J } = C;
            C.value = "", C.value = H, J !== null ? C.setSelectionRange(E, L, J) : C.setSelectionRange(E, L);
        }
    }, [
        e.comboboxState
    ]);
    let O = (0, $acw62.useRef)(!1), P = (0, $114Mg.useEvent)(()=>{
        O.current = !0;
    }), g = (0, $114Mg.useEvent)(()=>{
        B.nextFrame(()=>{
            O.current = !1;
        });
    }), V = (0, $114Mg.useEvent)((a)=>{
        switch(o.setIsTyping(!0), a.key){
            case (0, $6AKlm.Keys).Enter:
                if (e.comboboxState !== 0 || O.current) return;
                if (a.preventDefault(), a.stopPropagation(), e.activeOptionIndex === null) {
                    o.closeCombobox();
                    return;
                }
                o.selectActiveOption(), e.mode === 0 && o.closeCombobox();
                break;
            case (0, $6AKlm.Keys).ArrowDown:
                return a.preventDefault(), a.stopPropagation(), (0, $6Ngq1.match)(e.comboboxState, {
                    [0]: ()=>o.goToOption((0, $fLrGx.Focus).Next),
                    [1]: ()=>o.openCombobox()
                });
            case (0, $6AKlm.Keys).ArrowUp:
                return a.preventDefault(), a.stopPropagation(), (0, $6Ngq1.match)(e.comboboxState, {
                    [0]: ()=>o.goToOption((0, $fLrGx.Focus).Previous),
                    [1]: ()=>{
                        (0, $1u0KT.flushSync)(()=>o.openCombobox()), e.value || o.goToOption((0, $fLrGx.Focus).Last);
                    }
                });
            case (0, $6AKlm.Keys).Home:
                if (a.shiftKey) break;
                return a.preventDefault(), a.stopPropagation(), o.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).PageUp:
                return a.preventDefault(), a.stopPropagation(), o.goToOption((0, $fLrGx.Focus).First);
            case (0, $6AKlm.Keys).End:
                if (a.shiftKey) break;
                return a.preventDefault(), a.stopPropagation(), o.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).PageDown:
                return a.preventDefault(), a.stopPropagation(), o.goToOption((0, $fLrGx.Focus).Last);
            case (0, $6AKlm.Keys).Escape:
                return e.comboboxState !== 0 ? void 0 : (a.preventDefault(), e.optionsElement && !e.optionsPropsRef.current.static && a.stopPropagation(), e.mode === 0 && e.value === null && _(), o.closeCombobox());
            case (0, $6AKlm.Keys).Tab:
                if (e.comboboxState !== 0) return;
                e.mode === 0 && e.activationTrigger !== 1 && o.selectActiveOption(), o.closeCombobox();
                break;
        }
    }), w = (0, $114Mg.useEvent)((a)=>{
        d == null || d(a), e.mode === 0 && a.target.value === "" && _(), o.openCombobox();
    }), T = (0, $114Mg.useEvent)((a)=>{
        var C, H, E;
        let k = (C = a.relatedTarget) != null ? C : (0, $2C9FE.history).find((L)=>L !== a.currentTarget);
        if (!((H = e.optionsElement) != null && H.contains(k)) && !((E = e.buttonElement) != null && E.contains(k)) && e.comboboxState === 0) return a.preventDefault(), e.mode === 0 && e.value === null && _(), o.closeCombobox();
    }), $ = (0, $114Mg.useEvent)((a)=>{
        var C, H, E;
        let k = (C = a.relatedTarget) != null ? C : (0, $2C9FE.history).find((L)=>L !== a.currentTarget);
        (H = e.buttonElement) != null && H.contains(k) || (E = e.optionsElement) != null && E.contains(k) || e.disabled || e.immediate && e.comboboxState !== 0 && B.microTask(()=>{
            (0, $1u0KT.flushSync)(()=>o.openCombobox()), o.setActivationTrigger(1);
        });
    }), K = (0, $5qg9U.useLabelledBy)(), Z = (0, $iGb09.useDescribedBy)(), { isFocused: u, focusProps: X } = (0, $kd7LS.useFocusRing)({
        autoFocus: r
    }), { isHovered: N, hoverProps: U } = (0, $6o6B3.useHover)({
        isDisabled: i
    }), y = (0, $acw62.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: i,
            hover: N,
            focus: u,
            autofocus: r
        }), [
        e,
        N,
        u,
        r,
        i
    ]), G = (0, $ebRQH.mergeProps)({
        ref: s,
        id: m,
        role: "combobox",
        type: l,
        "aria-controls": (Y = e.optionsElement) == null ? void 0 : Y.id,
        "aria-expanded": e.comboboxState === 0,
        "aria-activedescendant": e.activeOptionIndex === null ? void 0 : e.virtual ? (Q = e.options.find((a)=>!a.dataRef.current.disabled && e.compare(a.dataRef.current.value, e.virtual.options[e.activeOptionIndex]))) == null ? void 0 : Q.id : (j = e.options[e.activeOptionIndex]) == null ? void 0 : j.id,
        "aria-labelledby": K,
        "aria-describedby": Z,
        "aria-autocomplete": "list",
        defaultValue: (pe = (h = t.defaultValue) != null ? h : e.defaultValue !== void 0 ? x == null ? void 0 : x(e.defaultValue) : null) != null ? pe : e.defaultValue,
        disabled: i || void 0,
        autoFocus: r,
        onCompositionStart: P,
        onCompositionEnd: g,
        onKeyDown: V,
        onChange: w,
        onFocus: $,
        onBlur: T
    }, X, U);
    return (0, $ebRQH.useRender)()({
        ourProps: G,
        theirProps: S,
        slot: y,
        defaultTag: $eaec5fceb04f7d33$var$Mt,
        name: "Combobox.Input"
    });
}
let $eaec5fceb04f7d33$var$Ft = "button";
function $eaec5fceb04f7d33$var$Vt(t, n) {
    var w;
    let e = $eaec5fceb04f7d33$var$ne("Combobox.Button"), o = $eaec5fceb04f7d33$var$le("Combobox.Button"), f = (0, $6mpbl.useSyncRefs)(n, o.setButtonElement), b = (0, $acw62.useId)(), { id: m = `headlessui-combobox-button-${b}`, disabled: d = e.disabled || !1, autoFocus: x = !1, ...i } = t, r = (0, $a8HmZ.useRefocusableInput)(e.inputElement), l = (0, $114Mg.useEvent)((T)=>{
        switch(T.key){
            case (0, $6AKlm.Keys).Space:
            case (0, $6AKlm.Keys).Enter:
                T.preventDefault(), T.stopPropagation(), e.comboboxState === 1 && (0, $1u0KT.flushSync)(()=>o.openCombobox()), r();
                return;
            case (0, $6AKlm.Keys).ArrowDown:
                T.preventDefault(), T.stopPropagation(), e.comboboxState === 1 && ((0, $1u0KT.flushSync)(()=>o.openCombobox()), e.value || o.goToOption((0, $fLrGx.Focus).First)), r();
                return;
            case (0, $6AKlm.Keys).ArrowUp:
                T.preventDefault(), T.stopPropagation(), e.comboboxState === 1 && ((0, $1u0KT.flushSync)(()=>o.openCombobox()), e.value || o.goToOption((0, $fLrGx.Focus).Last)), r();
                return;
            case (0, $6AKlm.Keys).Escape:
                if (e.comboboxState !== 0) return;
                T.preventDefault(), e.optionsElement && !e.optionsPropsRef.current.static && T.stopPropagation(), (0, $1u0KT.flushSync)(()=>o.closeCombobox()), r();
                return;
            default:
                return;
        }
    }), S = (0, $114Mg.useEvent)((T)=>{
        T.preventDefault(), !(0, $5fYEB.isDisabledReactIssue7711)(T.currentTarget) && (T.button === (0, $6stYl.MouseButton).Left && (e.comboboxState === 0 ? o.closeCombobox() : o.openCombobox()), r());
    }), R = (0, $5qg9U.useLabelledBy)([
        m
    ]), { isFocusVisible: s, focusProps: D } = (0, $kd7LS.useFocusRing)({
        autoFocus: x
    }), { isHovered: B, hoverProps: _ } = (0, $6o6B3.useHover)({
        isDisabled: d
    }), { pressed: I, pressProps: O } = (0, $cE9hP.useActivePress)({
        disabled: d
    }), P = (0, $acw62.useMemo)(()=>({
            open: e.comboboxState === 0,
            active: I || e.comboboxState === 0,
            disabled: d,
            value: e.value,
            hover: B,
            focus: s
        }), [
        e,
        B,
        s,
        I,
        d
    ]), g = (0, $ebRQH.mergeProps)({
        ref: f,
        id: m,
        type: (0, $gm4XX.useResolveButtonType)(t, e.buttonElement),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (w = e.optionsElement) == null ? void 0 : w.id,
        "aria-expanded": e.comboboxState === 0,
        "aria-labelledby": R,
        disabled: d || void 0,
        autoFocus: x,
        onMouseDown: S,
        onKeyDown: l
    }, D, _, O);
    return (0, $ebRQH.useRender)()({
        ourProps: g,
        theirProps: i,
        slot: P,
        defaultTag: $eaec5fceb04f7d33$var$Ft,
        name: "Combobox.Button"
    });
}
let $eaec5fceb04f7d33$var$Lt = "div", $eaec5fceb04f7d33$var$Bt = (0, $ebRQH.RenderFeatures).RenderStrategy | (0, $ebRQH.RenderFeatures).Static;
function $eaec5fceb04f7d33$var$wt(t, n) {
    var Y, Q, j;
    let e = (0, $acw62.useId)(), { id: o = `headlessui-combobox-options-${e}`, hold: f = !1, anchor: b, portal: m = !1, modal: d = !0, transition: x = !1, ...i } = t, r = $eaec5fceb04f7d33$var$ne("Combobox.Options"), l = $eaec5fceb04f7d33$var$le("Combobox.Options"), S = (0, $34Str.useResolvedAnchor)(b);
    S && (m = !0);
    let [R, s] = (0, $34Str.useFloatingPanel)(S), [D, B] = (0, $acw62.useState)(null), _ = (0, $34Str.useFloatingPanelProps)(), I = (0, $6mpbl.useSyncRefs)(n, S ? R : null, l.setOptionsElement, B), O = (0, $5IEAk.useOwnerDocument)(r.optionsElement), P = (0, $auuNT.useOpenClosed)(), [g, V] = (0, $bdknl.useTransition)(x, D, P !== null ? (P & (0, $auuNT.State).Open) === (0, $auuNT.State).Open : r.comboboxState === 0);
    (0, $dcp2r.useOnDisappear)(g, r.inputElement, l.closeCombobox);
    let w = r.__demoMode ? !1 : d && r.comboboxState === 0;
    (0, $hZodg.useScrollLock)(w, O);
    let T = r.__demoMode ? !1 : d && r.comboboxState === 0;
    (0, $keKjn.useInertOthers)(T, {
        allowed: (0, $acw62.useCallback)(()=>[
                r.inputElement,
                r.buttonElement,
                r.optionsElement
            ], [
            r.inputElement,
            r.buttonElement,
            r.optionsElement
        ])
    }), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        var h;
        r.optionsPropsRef.current.static = (h = t.static) != null ? h : !1;
    }, [
        r.optionsPropsRef,
        t.static
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        r.optionsPropsRef.current.hold = f;
    }, [
        r.optionsPropsRef,
        f
    ]), (0, $1nOiu.useTreeWalker)(r.comboboxState === 0, {
        container: r.optionsElement,
        accept (h) {
            return h.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (h) {
            h.setAttribute("role", "none");
        }
    });
    let $ = (0, $5qg9U.useLabelledBy)([
        (Y = r.buttonElement) == null ? void 0 : Y.id
    ]), K = (0, $acw62.useMemo)(()=>({
            open: r.comboboxState === 0,
            option: void 0
        }), [
        r.comboboxState
    ]), Z = (0, $114Mg.useEvent)(()=>{
        l.setActivationTrigger(0);
    }), u = (0, $114Mg.useEvent)((h)=>{
        h.preventDefault(), l.setActivationTrigger(0);
    }), X = (0, $ebRQH.mergeProps)(S ? _() : {}, {
        "aria-labelledby": $,
        role: "listbox",
        "aria-multiselectable": r.mode === 1 ? !0 : void 0,
        id: o,
        ref: I,
        style: {
            ...i.style,
            ...s,
            "--input-width": (0, $dfvrc.useElementSize)(r.inputElement, !0).width,
            "--button-width": (0, $dfvrc.useElementSize)(r.buttonElement, !0).width
        },
        onWheel: r.activationTrigger === 0 ? void 0 : Z,
        onMouseDown: u,
        ...(0, $bdknl.transitionDataAttributes)(V)
    }), N = g && r.comboboxState === 1, U = (0, $9UPTU.useFrozenData)(N, (Q = r.virtual) == null ? void 0 : Q.options), y = (0, $9UPTU.useFrozenData)(N, r.value), G = (0, $114Mg.useEvent)((h)=>r.compare(y, h));
    if (r.virtual) {
        if (U === void 0) throw new Error("Missing `options` in virtual mode");
        Object.assign(i, {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ae.Provider, {
                value: U !== r.virtual.options ? {
                    ...r,
                    virtual: {
                        ...r.virtual,
                        options: U
                    }
                } : r
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$At, {
                slot: K
            }, i.children))
        });
    }
    let ue = (0, $ebRQH.useRender)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e9NTc.Portal), {
        enabled: m ? t.static || g : !1
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($eaec5fceb04f7d33$var$ae.Provider, {
        value: r.mode === 1 ? r : {
            ...r,
            isSelected: G
        }
    }, ue({
        ourProps: X,
        theirProps: {
            ...i,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9UPTU.Frozen), {
                freeze: N
            }, typeof i.children == "function" ? (j = i.children) == null ? void 0 : j.call(i, K) : i.children)
        },
        slot: K,
        defaultTag: $eaec5fceb04f7d33$var$Lt,
        features: $eaec5fceb04f7d33$var$Bt,
        visible: g,
        name: "Combobox.Options"
    })));
}
let $eaec5fceb04f7d33$var$Nt = "div";
function $eaec5fceb04f7d33$var$kt(t, n) {
    var u, X, N, U;
    let e = $eaec5fceb04f7d33$var$ne("Combobox.Option"), o = $eaec5fceb04f7d33$var$le("Combobox.Option"), f = (0, $acw62.useId)(), { id: b = `headlessui-combobox-option-${f}`, value: m, disabled: d = (N = (X = (u = e.virtual) == null ? void 0 : u.disabled) == null ? void 0 : X.call(u, m)) != null ? N : !1, order: x = null, ...i } = t, r = (0, $a8HmZ.useRefocusableInput)(e.inputElement), l = e.virtual ? e.activeOptionIndex === e.calculateIndex(m) : e.activeOptionIndex === null ? !1 : ((U = e.options[e.activeOptionIndex]) == null ? void 0 : U.id) === b, S = e.isSelected(m), R = (0, $acw62.useRef)(null), s = (0, $ltgxC.useLatestValue)({
        disabled: d,
        value: m,
        domRef: R,
        order: x
    }), D = (0, $acw62.useContext)($eaec5fceb04f7d33$var$Ne), B = (0, $6mpbl.useSyncRefs)(n, R, D ? D.measureElement : null), _ = (0, $114Mg.useEvent)(()=>{
        o.setIsTyping(!1), o.onChange(m);
    });
    (0, $8KgIp.useIsoMorphicEffect)(()=>o.registerOption(b, s), [
        s,
        b
    ]);
    let I = (0, $acw62.useRef)(!(e.virtual || e.__demoMode));
    (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (!e.virtual && !e.__demoMode) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            I.current = !0;
        });
    }, [
        e.virtual,
        e.__demoMode
    ]), (0, $8KgIp.useIsoMorphicEffect)(()=>{
        if (I.current && e.comboboxState === 0 && l && e.activationTrigger !== 0) return (0, $1COYr.disposables)().requestAnimationFrame(()=>{
            var y, G;
            (G = (y = R.current) == null ? void 0 : y.scrollIntoView) == null || G.call(y, {
                block: "nearest"
            });
        });
    }, [
        R,
        l,
        e.comboboxState,
        e.activationTrigger,
        e.activeOptionIndex
    ]);
    let O = (0, $114Mg.useEvent)((y)=>{
        y.preventDefault(), y.button === (0, $6stYl.MouseButton).Left && (d || (_(), (0, $8UjaS.isMobile)() || requestAnimationFrame(()=>r()), e.mode === 0 && o.closeCombobox()));
    }), P = (0, $114Mg.useEvent)(()=>{
        if (d) return o.goToOption((0, $fLrGx.Focus).Nothing);
        let y = e.calculateIndex(m);
        o.goToOption((0, $fLrGx.Focus).Specific, y);
    }), g = (0, $ipity.useTrackedPointer)(), V = (0, $114Mg.useEvent)((y)=>g.update(y)), w = (0, $114Mg.useEvent)((y)=>{
        if (!g.wasMoved(y) || d || l) return;
        let G = e.calculateIndex(m);
        o.goToOption((0, $fLrGx.Focus).Specific, G, 0);
    }), T = (0, $114Mg.useEvent)((y)=>{
        g.wasMoved(y) && (d || l && (e.optionsPropsRef.current.hold || o.goToOption((0, $fLrGx.Focus).Nothing)));
    }), $ = (0, $acw62.useMemo)(()=>({
            active: l,
            focus: l,
            selected: S,
            disabled: d
        }), [
        l,
        S,
        d
    ]), K = {
        id: b,
        ref: B,
        role: "option",
        tabIndex: d === !0 ? void 0 : -1,
        "aria-disabled": d === !0 ? !0 : void 0,
        "aria-selected": S,
        disabled: void 0,
        onMouseDown: O,
        onFocus: P,
        onPointerEnter: V,
        onMouseEnter: V,
        onPointerMove: w,
        onMouseMove: w,
        onPointerLeave: T,
        onMouseLeave: T
    };
    return (0, $ebRQH.useRender)()({
        ourProps: K,
        theirProps: i,
        slot: $,
        defaultTag: $eaec5fceb04f7d33$var$Nt,
        name: "Combobox.Option"
    });
}
let $eaec5fceb04f7d33$var$Ht = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$ht), $eaec5fceb04f7d33$export$756fe6c16147e11a = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$Vt), $eaec5fceb04f7d33$export$de5e47f31372e2e3 = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$Dt), $eaec5fceb04f7d33$export$3ca0d3769eaf5f66 = (0, $5qg9U.Label), $eaec5fceb04f7d33$export$47929aa3fb52fca2 = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$wt), $eaec5fceb04f7d33$export$7ce8df7790337ff4 = (0, $ebRQH.forwardRefWithAs)($eaec5fceb04f7d33$var$kt), $eaec5fceb04f7d33$export$27957ad87354dd7e = Object.assign($eaec5fceb04f7d33$var$Ht, {
    Input: $eaec5fceb04f7d33$export$de5e47f31372e2e3,
    Button: $eaec5fceb04f7d33$export$756fe6c16147e11a,
    Label: $eaec5fceb04f7d33$export$3ca0d3769eaf5f66,
    Options: $eaec5fceb04f7d33$export$47929aa3fb52fca2,
    Option: $eaec5fceb04f7d33$export$7ce8df7790337ff4
});

});
parcelRegister("8EDjv", function(module, exports) {

$parcel$export(module.exports, "useVirtualizer", () => $64d08e094a93fa77$export$dd6d526d88b5a137);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $eYRSY = parcelRequire("eYRSY");
const $64d08e094a93fa77$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $64d08e094a93fa77$var$useVirtualizerBase(options) {
    const rerender = $acw62.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $1u0KT.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $acw62.useState(()=>new (0, $eYRSY.Virtualizer)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $acw62.useEffect(()=>{
        return instance._didMount();
    }, []);
    $64d08e094a93fa77$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $64d08e094a93fa77$export$dd6d526d88b5a137(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        observeElementRect: $eYRSY.observeElementRect,
        observeElementOffset: $eYRSY.observeElementOffset,
        scrollToFn: (0, $eYRSY.elementScroll),
        ...options
    });
}
function $64d08e094a93fa77$export$645722dcac657cb9(options) {
    return $64d08e094a93fa77$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $eYRSY.observeWindowRect),
        observeElementOffset: (0, $eYRSY.observeWindowOffset),
        scrollToFn: (0, $eYRSY.windowScroll),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}

});
parcelRegister("eYRSY", function(module, exports) {

$parcel$export(module.exports, "observeElementRect", () => $ae8077da5dad972b$export$5a50ff2cde8c3802);
$parcel$export(module.exports, "observeWindowRect", () => $ae8077da5dad972b$export$e911b82c7a99311);
$parcel$export(module.exports, "observeElementOffset", () => $ae8077da5dad972b$export$fbc040aee017375a);
$parcel$export(module.exports, "observeWindowOffset", () => $ae8077da5dad972b$export$518998f8c5d09287);
$parcel$export(module.exports, "windowScroll", () => $ae8077da5dad972b$export$2162c5b3eeedd27);
$parcel$export(module.exports, "elementScroll", () => $ae8077da5dad972b$export$1cdb988e5ab69fe7);
$parcel$export(module.exports, "Virtualizer", () => $ae8077da5dad972b$export$89be5a243e59c4b2);

var $f2V6E = parcelRequire("f2V6E");
const $ae8077da5dad972b$export$76974b428a49f15b = (index)=>index;
const $ae8077da5dad972b$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $ae8077da5dad972b$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const entry = entries[0];
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                handler({
                    width: box.inlineSize,
                    height: box.blockSize
                });
                return;
            }
        }
        handler(element.getBoundingClientRect());
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $ae8077da5dad972b$var$addEventListenerOptions = {
    passive: true
};
const $ae8077da5dad972b$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $ae8077da5dad972b$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $ae8077da5dad972b$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $f2V6E.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = $ae8077da5dad972b$var$supportsScrollend ? ()=>void 0 : (0, $f2V6E.debounce)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $ae8077da5dad972b$var$addEventListenerOptions);
    element.addEventListener("scrollend", endHandler, $ae8077da5dad972b$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        element.removeEventListener("scrollend", endHandler);
    };
};
const $ae8077da5dad972b$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $ae8077da5dad972b$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $ae8077da5dad972b$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $ae8077da5dad972b$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        this._measureElement(entry.target, entry);
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $ae8077da5dad972b$export$76974b428a49f15b,
                rangeExtractor: $ae8077da5dad972b$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $ae8077da5dad972b$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $f2V6E.memo)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $f2V6E.memo)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $f2V6E.memo)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $f2V6E.memo)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset()
            ], (measurements, outerSize, scrollOffset)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $ae8077da5dad972b$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getIndexes = (0, $f2V6E.memo)(()=>[
                this.options.rangeExtractor,
                this.calculateRange(),
                this.options.overscan,
                this.options.count
            ], (rangeExtractor, range, overscan, count)=>{
            return range === null ? [] : rangeExtractor({
                startIndex: range.startIndex,
                endIndex: range.endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $f2V6E.memo)(()=>[
                this.getIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $f2V6E.notUndefined)(measurements[$ae8077da5dad972b$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $f2V6E.notUndefined)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (toOffset <= scrollOffset) align = "start";
                else if (toOffset >= scrollOffset + size) align = "end";
                else align = "start";
            }
            if (align === "start") toOffset;
            else if (align === "end") toOffset = toOffset - size;
            else if (align === "center") toOffset = toOffset - size / 2;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $f2V6E.notUndefined)(this.getOffsetForIndex(index, align));
                    if (!(0, $f2V6E.approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $ae8077da5dad972b$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $ae8077da5dad972b$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
    const count = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    const startIndex = $ae8077da5dad972b$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
    let endIndex = startIndex;
    while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}

});
parcelRegister("f2V6E", function(module, exports) {

$parcel$export(module.exports, "memo", () => $af43570ba0a8567e$export$7c73462e0d25e514);
$parcel$export(module.exports, "notUndefined", () => $af43570ba0a8567e$export$9a1adf421b69c6a);
$parcel$export(module.exports, "approxEqual", () => $af43570ba0a8567e$export$8a4f1dcc58a69dbd);
$parcel$export(module.exports, "debounce", () => $af43570ba0a8567e$export$61fc7d43ac8f84b0);
function $af43570ba0a8567e$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    return ()=>{
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    };
}
function $af43570ba0a8567e$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $af43570ba0a8567e$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $af43570ba0a8567e$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};

});



parcelRegister("ePQFN", function(module, exports) {

$parcel$export(module.exports, "useByComparator", () => $acceafe1d565f09b$export$988f0cf1b37580ae);

var $acw62 = parcelRequire("acw62");
function $acceafe1d565f09b$var$l(e, r) {
    return e !== null && r !== null && typeof e == "object" && typeof r == "object" && "id" in e && "id" in r ? e.id === r.id : e === r;
}
function $acceafe1d565f09b$export$988f0cf1b37580ae(e = $acceafe1d565f09b$var$l) {
    return (0, $acw62.useCallback)((r, t)=>{
        if (typeof e == "string") {
            let o = e;
            return (r == null ? void 0 : r[o]) === (t == null ? void 0 : t[o]);
        }
        return e(r, t);
    }, [
        e
    ]);
}

});

parcelRegister("h26ct", function(module, exports) {

$parcel$export(module.exports, "useControllable", () => $c6676ed1f400443a$export$454217e89aea72b);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");
function $c6676ed1f400443a$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $acw62.useState)(c), e = l !== void 0, t = (0, $acw62.useRef)(e), u = (0, $acw62.useRef)(!1), d = (0, $acw62.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $114Mg.useEvent)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}

});

parcelRegister("3X9lW", function(module, exports) {

$parcel$export(module.exports, "useDefaultValue", () => $2e0e230f066909d2$export$8a91ee242b6d0fe3);

var $acw62 = parcelRequire("acw62");
function $2e0e230f066909d2$export$8a91ee242b6d0fe3(e) {
    let [t] = (0, $acw62.useState)(e);
    return t;
}

});

parcelRegister("a8HmZ", function(module, exports) {

$parcel$export(module.exports, "useRefocusableInput", () => $761c4b102f5a7d93$export$9b49488873640feb);

var $acw62 = parcelRequire("acw62");

var $114Mg = parcelRequire("114Mg");

var $lwoRo = parcelRequire("lwoRo");
function $761c4b102f5a7d93$export$9b49488873640feb(e) {
    let n = (0, $acw62.useRef)({
        value: "",
        selectionStart: null,
        selectionEnd: null
    });
    return (0, $lwoRo.useEventListener)(e, "blur", (l)=>{
        let t = l.target;
        t instanceof HTMLInputElement && (n.current = {
            value: t.value,
            selectionStart: t.selectionStart,
            selectionEnd: t.selectionEnd
        });
    }), (0, $114Mg.useEvent)(()=>{
        if (document.activeElement !== e && e instanceof HTMLInputElement && e.isConnected) {
            if (e.focus({
                preventScroll: !0
            }), e.value !== n.current.value) e.setSelectionRange(e.value.length, e.value.length);
            else {
                let { selectionStart: l, selectionEnd: t } = n.current;
                l !== null && t !== null && e.setSelectionRange(l, t);
            }
            n.current = {
                value: "",
                selectionStart: null,
                selectionEnd: null
            };
        }
    });
}

});

parcelRegister("dBJH0", function(module, exports) {

$parcel$export(module.exports, "FormFields", () => $9e822caca6037577$export$125d0b248abd3e88);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $5Ai9V = parcelRequire("5Ai9V");

var $7FnlJ = parcelRequire("7FnlJ");

var $ebRQH = parcelRequire("ebRQH");

var $k9Al5 = parcelRequire("k9Al5");
let $9e822caca6037577$var$f = (0, $acw62.createContext)(null);
function $9e822caca6037577$export$172bce5caea3d96f(t) {
    let [e, r] = (0, $acw62.useState)(null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$f.Provider, {
        value: {
            target: e
        }
    }, t.children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        ref: r
    }));
}
function $9e822caca6037577$export$ddeacde93f925346({ children: t }) {
    let e = (0, $acw62.useContext)($9e822caca6037577$var$f);
    if (!e) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t);
    let { target: r } = e;
    return r ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, t), r) : null;
}
function $9e822caca6037577$export$125d0b248abd3e88({ data: t, form: e, disabled: r, onReset: n, overrides: F }) {
    let [i, a] = (0, $acw62.useState)(null), p = (0, $5Ai9V.useDisposables)();
    return (0, $acw62.useEffect)(()=>{
        if (n && i) return p.addEventListener(i, "reset", n);
    }, [
        i,
        e,
        n
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$export$ddeacde93f925346, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($9e822caca6037577$var$C, {
        setForm: a,
        formId: e
    }), (0, $7FnlJ.objectToFormEntries)(t).map(([s, v])=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
            features: (0, $k9Al5.HiddenFeatures).Hidden,
            ...(0, $ebRQH.compact)({
                key: s,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                form: e,
                disabled: r,
                name: s,
                value: v,
                ...F
            })
        })));
}
function $9e822caca6037577$var$C({ setForm: t, formId: e }) {
    return (0, $acw62.useEffect)(()=>{
        if (e) {
            let r = document.getElementById(e);
            r && t(r);
        }
    }, [
        t,
        e
    ]), e ? null : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $k9Al5.Hidden), {
        features: (0, $k9Al5.HiddenFeatures).Hidden,
        as: "input",
        type: "hidden",
        hidden: !0,
        readOnly: !0,
        ref: (r)=>{
            if (!r) return;
            let n = r.closest("form");
            n && t(n);
        }
    });
}

});
parcelRegister("7FnlJ", function(module, exports) {

$parcel$export(module.exports, "objectToFormEntries", () => $594e79751740d704$export$bc22b3e852574dab);
$parcel$export(module.exports, "attemptSubmit", () => $594e79751740d704$export$ee02894bdc79dd36);
function $594e79751740d704$export$bc22b3e852574dab(i = {}, s = null, t = []) {
    for (let [r, n] of Object.entries(i))$594e79751740d704$var$o(t, $594e79751740d704$var$f(s, r), n);
    return t;
}
function $594e79751740d704$var$f(i, s) {
    return i ? i + "[" + s + "]" : s;
}
function $594e79751740d704$var$o(i, s, t) {
    if (Array.isArray(t)) for (let [r, n] of t.entries())$594e79751740d704$var$o(i, $594e79751740d704$var$f(s, r.toString()), n);
    else t instanceof Date ? i.push([
        s,
        t.toISOString()
    ]) : typeof t == "boolean" ? i.push([
        s,
        t ? "1" : "0"
    ]) : typeof t == "string" ? i.push([
        s,
        t
    ]) : typeof t == "number" ? i.push([
        s,
        `${t}`
    ]) : t == null ? i.push([
        s,
        ""
    ]) : $594e79751740d704$export$bc22b3e852574dab(t, s, i);
}
function $594e79751740d704$export$ee02894bdc79dd36(i) {
    var t, r;
    let s = (t = i == null ? void 0 : i.form) != null ? t : i.closest("form");
    if (s) {
        for (let n of s.elements)if (n !== i && (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image")) {
            n.click();
            return;
        }
        (r = s.requestSubmit) == null || r.call(s);
    }
}

});


parcelRegister("9UPTU", function(module, exports) {

$parcel$export(module.exports, "Frozen", () => $73819a70e276dbaa$export$824932a86c309819);
$parcel$export(module.exports, "useFrozenData", () => $73819a70e276dbaa$export$1a771eb6e04a3c48);

var $acw62 = parcelRequire("acw62");
function $73819a70e276dbaa$export$824932a86c309819({ children: o, freeze: e }) {
    let n = $73819a70e276dbaa$export$1a771eb6e04a3c48(e, o);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, n);
}
function $73819a70e276dbaa$export$1a771eb6e04a3c48(o, e) {
    let [n, t] = (0, $acw62.useState)(e);
    return !o && n !== e && t(e), o ? n : e;
}

});

parcelRegister("6stYl", function(module, exports) {

$parcel$export(module.exports, "MouseButton", () => $4b3c9b76eee8a74d$export$92850d9476e00eee);
var $4b3c9b76eee8a74d$export$92850d9476e00eee = ((f)=>(f[f.Left = 0] = "Left", f[f.Right = 2] = "Right", f))($4b3c9b76eee8a74d$export$92850d9476e00eee || {});

});


parcelRegister("bo1Qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a35d80e3e9ca45$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $84a35d80e3e9ca45$var$MagnifyingGlassIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        fillRule: "evenodd",
        d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
        clipRule: "evenodd"
    }));
}
const $84a35d80e3e9ca45$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($84a35d80e3e9ca45$var$MagnifyingGlassIcon);
var $84a35d80e3e9ca45$export$2e2bcd8739ae039 = $84a35d80e3e9ca45$var$ForwardRef;

});

parcelRegister("56ycy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b780afa44ab6cf9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $3b780afa44ab6cf9$var$FolderIcon({ title: title, titleId: titleId, ...props }, svgRef) {
    return /*#__PURE__*/ $acw62.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor",
        "aria-hidden": "true",
        "data-slot": "icon",
        ref: svgRef,
        "aria-labelledby": titleId
    }, props), title ? /*#__PURE__*/ $acw62.createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ $acw62.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.25 12.75V12A2.25 2.25 0 0 1 4.5 9.75h15A2.25 2.25 0 0 1 21.75 12v.75m-8.69-6.44-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z"
    }));
}
const $3b780afa44ab6cf9$var$ForwardRef = /*#__PURE__*/ $acw62.forwardRef($3b780afa44ab6cf9$var$FolderIcon);
var $3b780afa44ab6cf9$export$2e2bcd8739ae039 = $3b780afa44ab6cf9$var$ForwardRef;

});

parcelRegister("h0N5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c6288371c14fb172$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $c6288371c14fb172$var$split = $c6288371c14fb172$var$_interopDefault((parcelRequire("gZGJt")));
const $c6288371c14fb172$var$splitUnicode = (str)=>str.normalize("NFKD").split("");
const $c6288371c14fb172$var$whitespaceRegex = /^\s+$/;
const $c6288371c14fb172$var$nonWordRegex = /^[`~!@#$%^&*()\-=_+{}[\]\|\\;':",./<>?]+$/;
const $c6288371c14fb172$var$sortKind = {
    insertOrder: "insertOrder",
    bestMatch: "bestMatch"
}; // the default options, which will be used for any unset option
const $c6288371c14fb172$var$defaultOptions = {
    keySelector: (s)=>s,
    threshold: .6,
    ignoreCase: true,
    ignoreSymbols: true,
    normalizeWhitespace: true,
    returnMatchData: false,
    useDamerau: true,
    useSellers: true,
    useSeparatedUnicode: false,
    sortBy: $c6288371c14fb172$var$sortKind.bestMatch
};
const $c6288371c14fb172$var$noop = ()=>{};
const $c6288371c14fb172$var$arrayWrap = (item)=>item instanceof Array ? item : [
        item
    ]; // return normalized string, with map included
function $c6288371c14fb172$var$normalize(string, options) {
    const lower = options.ignoreCase ? string.toLocaleLowerCase() : string; // track transformations
    const normal = [];
    const map = [];
    let lastWasWhitespace = true;
    let length = 0;
    const graphemeList = options.useSeparatedUnicode ? $c6288371c14fb172$var$splitUnicode(lower) : $c6288371c14fb172$var$split(lower);
    for (const grapheme of graphemeList){
        $c6288371c14fb172$var$whitespaceRegex.lastIndex = 0;
        $c6288371c14fb172$var$nonWordRegex.lastIndex = 0;
        if (options.normalizeWhitespace && $c6288371c14fb172$var$whitespaceRegex.test(grapheme)) {
            if (!lastWasWhitespace) {
                normal.push(" ");
                map.push(length);
                lastWasWhitespace = true;
            }
        } else if (!(options.ignoreSymbols && $c6288371c14fb172$var$nonWordRegex.test(grapheme))) {
            if (options.useSeparatedUnicode) normal.push(grapheme);
            else normal.push(grapheme.normalize());
            map.push(length);
            lastWasWhitespace = false;
        }
        length += grapheme.length;
    } // add the end of the string
    map.push(string.length);
    while(normal[normal.length - 1] === " "){
        normal.pop();
        map.pop();
    }
    return {
        original: string,
        normal: normal,
        map: map
    };
} // translates a match to the original string
function $c6288371c14fb172$var$denormalizeMatchPosition(match, map) {
    return {
        index: map[match.start],
        length: map[match.end + 1] - map[match.start]
    };
} // walks back up the matrix to find the match index and length
function $c6288371c14fb172$var$walkBack(rows, scoreIndex) {
    if (scoreIndex === 0) return {
        index: 0,
        length: 0
    };
    let start = scoreIndex;
    for(let i = rows.length - 2; i > 0 && start > 1; i--){
        const row = rows[i];
        start = row[start] < row[start - 1] ? start : start - 1;
    }
    return {
        start: start - 1,
        end: scoreIndex - 1
    };
} // walkback is a noop for non-sellers, but should still return an object
function $c6288371c14fb172$var$noopWalkback() {
    return {
        start: 0,
        end: 0
    };
}
const $c6288371c14fb172$var$levUpdateScore = ()=>true;
const $c6288371c14fb172$var$sellersUpdateScore = (cur, min)=>cur < min;
function $c6288371c14fb172$var$getLevScore(rows, length) {
    const lastRow = rows[rows.length - 1];
    const lastCell = lastRow[length - 1];
    const scoreLength = Math.max(rows.length, length);
    return {
        score: 1 - lastCell / (scoreLength - 1),
        scoreIndex: length - 1
    };
}
function $c6288371c14fb172$var$getSellersScore(rows, length) {
    // search term was empty string, return perfect score
    if (rows.length === 1) return {
        score: 1,
        scoreIndex: 0
    };
    const lastRow = rows[rows.length - 1];
    let minValue = lastRow[0];
    let minIndex = 0;
    for(let i = 1; i < length; i++){
        const val = lastRow[i];
        if (val < minValue) {
            minValue = val;
            minIndex = i;
        }
    }
    return {
        score: 1 - minValue / (rows.length - 1),
        scoreIndex: minIndex
    };
}
function $c6288371c14fb172$var$initLevRows(rowCount, columnCount) {
    const rows = new Array(rowCount);
    for(let i = 0; i < rowCount; i++){
        rows[i] = new Array(columnCount);
        rows[i][0] = i;
    }
    for(let i = 0; i < columnCount; i++)rows[0][i] = i;
    return rows;
}
function $c6288371c14fb172$var$initSellersRows(rowCount, columnCount) {
    const rows = new Array(rowCount);
    rows[0] = new Array(columnCount).fill(0);
    for(let i = 1; i < rowCount; i++){
        rows[i] = new Array(columnCount);
        rows[i][0] = i;
    }
    return rows;
} // the content of the innermost loop of levenshtein
function $c6288371c14fb172$var$levCore(term, candidate, rows, i, j) {
    const rowA = rows[i];
    const rowB = rows[i + 1];
    const cost = term[i] === candidate[j] ? 0 : 1;
    let m;
    let min = rowB[j] + 1; // insertion
    if ((m = rowA[j + 1] + 1) < min) min = m; // deletion
    if ((m = rowA[j] + cost) < min) min = m; // substitution
    rowB[j + 1] = min;
} // runtime complexity: O(mn) where m and n are the lengths of term and candidate, respectively
// Note: this method only runs on a single column
function $c6288371c14fb172$var$levenshtein(term, candidate, rows, j) {
    for(let i = 0; i < term.length; i++)$c6288371c14fb172$var$levCore(term, candidate, rows, i, j);
} // has all the runtime characteristics of the above, but punishes transpositions less,
// resulting in better tolerance to those types of typos
// Note: this method only runs on a single column
function $c6288371c14fb172$var$damerauLevenshtein(term, candidate, rows, j) {
    // if j === 0, we can't check for transpositions,
    // so use normal levenshtein instead
    if (j === 0) {
        $c6288371c14fb172$var$levenshtein(term, candidate, rows, j);
        return;
    } // for i === 0, we also can't check for transpositions, so calculate
    // the first row using normal levenshtein as well
    if (term.length > 0) $c6288371c14fb172$var$levCore(term, candidate, rows, 0, j);
    for(let i = 1; i < term.length; i++){
        const rowA = rows[i - 1];
        const rowB = rows[i];
        const rowC = rows[i + 1];
        const cost = term[i] === candidate[j] ? 0 : 1;
        let m; // insertion
        let min = rowC[j] + 1; // deletion
        if ((m = rowB[j + 1] + 1) < min) min = m; // substitution
        if ((m = rowB[j] + cost) < min) min = m; // transposition
        if (term[i] === candidate[j - 1] && term[i - 1] === candidate[j] && (m = rowA[j - 1] + cost) < min) min = m;
        rowC[j + 1] = min;
    }
} // method for creating a trie from search candidates
// using a trie can significantly improve search time
function $c6288371c14fb172$var$trieInsert(trie, string, item) {
    let walker = trie;
    for(let i = 0; i < string.length; i++){
        const char = string[i]; // add child node if not already present
        if (walker.children[char] == null) walker.children[char] = {
            children: {},
            candidates: [],
            depth: 0
        };
         // log max depth of this subtree
        walker.depth = Math.max(walker.depth, string.length - i); // step into child node
        walker = walker.children[char];
    }
    walker.candidates.push(item);
} // transforms a list of candidates into objects with normalized search keys,
// and inserts them into a trie
// the keySelector is used to pick strings from an object to search by
function $c6288371c14fb172$var$createSearchTrie(trie, index, items, options) {
    for (const item of items){
        const candidates = $c6288371c14fb172$var$arrayWrap(options.keySelector(item)).map((key, keyIndex)=>({
                index: index,
                keyIndex: keyIndex,
                item: item,
                normalized: $c6288371c14fb172$var$normalize(key, options)
            }));
        index++;
        for (const candidate of candidates)$c6288371c14fb172$var$trieInsert(trie, candidate.normalized.normal, candidate);
    }
} // scored item comparator
function $c6288371c14fb172$var$compareItemsBestScore(a, b) {
    // highest priority is raw levenshtein score
    const scoreDiff = b.score - a.score;
    if (scoreDiff !== 0) return scoreDiff;
     // ties are broken by earlier match positions
    const matchPosDiff = a.match.start - b.match.start;
    if (matchPosDiff !== 0) return matchPosDiff;
     // prioritize earlier keys
    const keyIndexDiff = a.keyIndex - b.keyIndex;
    if (keyIndexDiff !== 0) return keyIndexDiff;
     // lastly, break ties by preferring the closer length match
    const lengthDiff = a.lengthDiff - b.lengthDiff;
    if (lengthDiff !== 0) return lengthDiff;
     // if all else fails, resort to insertion order
    return $c6288371c14fb172$var$compareItemsInsertOrder(a, b);
}
function $c6288371c14fb172$var$compareItemsInsertOrder(a, b) {
    return a.index - b.index;
}
function $c6288371c14fb172$var$getCompareFunc(sortBy) {
    switch(sortBy){
        case $c6288371c14fb172$var$sortKind.bestMatch:
            return $c6288371c14fb172$var$compareItemsBestScore;
        case $c6288371c14fb172$var$sortKind.insertOrder:
            return $c6288371c14fb172$var$compareItemsInsertOrder;
        default:
            throw new Error(`unknown sortBy method ${sortBy}`);
    }
} // dedupes and adds results to the results list/map
function $c6288371c14fb172$var$addResult(results, resultMap, candidate, score, match, lengthDiff, compareItems) {
    const scoredItem = {
        item: candidate.item,
        normalized: candidate.normalized,
        score: score,
        match: match,
        index: candidate.index,
        keyIndex: candidate.keyIndex,
        lengthDiff: lengthDiff
    };
    if (resultMap[candidate.index] == null) {
        resultMap[candidate.index] = results.length;
        results.push(scoredItem);
    } else if (compareItems(scoredItem, results[resultMap[candidate.index]]) < 0) results[resultMap[candidate.index]] = scoredItem;
}
const $c6288371c14fb172$var$getLevLength = Math.max;
const $c6288371c14fb172$var$getSellersLength = (termLength)=>termLength; // skip any subtrees for which it is impossible to score >= threshold
function $c6288371c14fb172$var$levShouldContinue(node, pos, term, threshold, sValue) {
    // earliest point (length) at which sValue could return to 0
    const p1 = pos + sValue; // point (length) at which string lengths would match
    const p2 = Math.min(term.length, pos + node.depth + 1); // the best score possible is the string which minimizes the value
    // max(sValue, strLenDiff), which is always halfway between p1 and p2
    const length = Math.ceil((p1 + p2) / 2);
    const bestPossibleValue = length - p2;
    return 1 - bestPossibleValue / length >= threshold;
}
function $c6288371c14fb172$var$sellersShouldContinue(node, _, term, threshold, sValue, lastValue) {
    const bestPossibleValue = Math.min(sValue, lastValue - (node.depth + 1));
    return 1 - bestPossibleValue / term.length >= threshold;
} // (pseudo) recursively walk the trie
function $c6288371c14fb172$var$searchRecurse(trie, term, scoreMethods, rows, results, resultMap, options) {
    const stack = [];
    for(const key in trie.children){
        const node = trie.children[key];
        stack.push([
            node,
            1,
            key,
            0,
            term.length
        ]);
    }
    const acc = new Array(trie.depth);
    while(stack.length !== 0){
        const [node, len, char, si, sv] = stack.pop();
        acc[len - 1] = char; // build rows
        scoreMethods.score(term, acc, rows, len - 1); // track best score and position
        const lastIndex = len;
        const lastValue = rows[rows.length - 1][lastIndex];
        let sIndex = si, sValue = sv;
        if (scoreMethods.shouldUpdateScore(lastValue, sv)) {
            sIndex = lastIndex;
            sValue = lastValue;
        } // insert results
        if (node.candidates.length > 0) {
            const length = scoreMethods.getLength(term.length, len);
            const score = 1 - sValue / length;
            if (score >= options.threshold) {
                const match = $c6288371c14fb172$var$walkBack(rows, sIndex);
                const lengthDiff = Math.abs(len - term.length);
                for (const candidate of node.candidates)$c6288371c14fb172$var$addResult(results, resultMap, candidate, score, match, lengthDiff, scoreMethods.compareItems);
            }
        } // recurse for children
        for(const key in node.children){
            const child = node.children[key];
            if (scoreMethods.shouldContinue(child, len, term, options.threshold, sValue, lastValue)) stack.push([
                child,
                len + 1,
                key,
                sIndex,
                sValue
            ]);
        }
    }
} // the core match finder: returns a sorted, filtered list of matches
// this does not normalize input, requiring users to normalize themselves
function $c6288371c14fb172$var$searchCore(term, trie, options) {
    const initMethod = options.useSellers ? $c6288371c14fb172$var$initSellersRows : $c6288371c14fb172$var$initLevRows;
    const scoreMethods = {
        score: options.useDamerau ? $c6288371c14fb172$var$damerauLevenshtein : $c6288371c14fb172$var$levenshtein,
        getLength: options.useSellers ? $c6288371c14fb172$var$getSellersLength : $c6288371c14fb172$var$getLevLength,
        shouldUpdateScore: options.useSellers ? $c6288371c14fb172$var$sellersUpdateScore : $c6288371c14fb172$var$levUpdateScore,
        shouldContinue: options.useSellers ? $c6288371c14fb172$var$sellersShouldContinue : $c6288371c14fb172$var$levShouldContinue,
        walkBack: options.useSellers ? $c6288371c14fb172$var$walkBack : $c6288371c14fb172$var$noopWalkback,
        compareItems: $c6288371c14fb172$var$getCompareFunc(options.sortBy)
    }; // walk the trie, scoring and storing the candidates
    const resultMap = {};
    const results = [];
    const rows = initMethod(term.length + 1, trie.depth + 1);
    if (options.threshold <= 0 || term.length === 0) for (const candidate of trie.candidates)$c6288371c14fb172$var$addResult(results, resultMap, candidate, 0, {
        index: 0,
        length: 0
    }, term.length, scoreMethods.compareItems);
    $c6288371c14fb172$var$searchRecurse(trie, term, scoreMethods, rows, results, resultMap, options);
    const sorted = results.sort(scoreMethods.compareItems);
    if (options.returnMatchData) {
        const denormalize = options.useSellers ? $c6288371c14fb172$var$denormalizeMatchPosition : $c6288371c14fb172$var$noop;
        return sorted.map((candidate)=>({
                item: candidate.item,
                original: candidate.normalized.original,
                key: candidate.normalized.normal.join(""),
                score: candidate.score,
                match: denormalize(candidate.match, candidate.normalized.map)
            }));
    }
    return sorted.map((candidate)=>candidate.item);
} // wrapper for exporting sellers while allowing options to be passed in
function $c6288371c14fb172$var$fuzzy(term, candidate, options) {
    options = {
        ...$c6288371c14fb172$var$defaultOptions,
        ...options
    };
    const initMethod = options.useSellers ? $c6288371c14fb172$var$initSellersRows : $c6288371c14fb172$var$initLevRows;
    const scoreMethod = options.useDamerau ? $c6288371c14fb172$var$damerauLevenshtein : $c6288371c14fb172$var$levenshtein;
    const getScore = options.useSellers ? $c6288371c14fb172$var$getSellersScore : $c6288371c14fb172$var$getLevScore;
    term = $c6288371c14fb172$var$normalize(term, options).normal;
    const normalized = $c6288371c14fb172$var$normalize(candidate, options);
    const rows = initMethod(term.length + 1, normalized.normal.length + 1);
    for(let j = 0; j < normalized.normal.length; j++)scoreMethod(term, normalized.normal, rows, j);
    const scoreResult = getScore(rows, normalized.normal.length + 1);
    return options.returnMatchData ? {
        item: candidate,
        original: normalized.original,
        key: normalized.normal.join(""),
        score: scoreResult.score,
        match: options.useSellers ? $c6288371c14fb172$var$denormalizeMatchPosition($c6288371c14fb172$var$walkBack(rows, scoreResult.scoreIndex), normalized.map) : $c6288371c14fb172$var$noop()
    } : scoreResult.score;
} // simple one-off search. Useful if you don't expect to use the same candidate list again
function $c6288371c14fb172$var$search(term, candidates, options) {
    options = {
        ...$c6288371c14fb172$var$defaultOptions,
        ...options
    };
    const trie = {
        children: {},
        candidates: [],
        depth: 0
    };
    $c6288371c14fb172$var$createSearchTrie(trie, 0, candidates, options);
    return $c6288371c14fb172$var$searchCore($c6288371c14fb172$var$normalize(term, options).normal, trie, options);
} // class that improves performance of searching the same set multiple times
// normalizes the strings and caches the result for future calls
class $c6288371c14fb172$var$Searcher {
    constructor(candidates, options){
        this.options = Object.assign({}, $c6288371c14fb172$var$defaultOptions, options);
        this.trie = {
            children: {},
            candidates: [],
            depth: 0
        };
        $c6288371c14fb172$var$createSearchTrie(this.trie, 0, candidates, this.options);
        this.count = candidates.length;
    }
    add(...candidates) {
        $c6288371c14fb172$var$createSearchTrie(this.trie, this.count, candidates, this.options);
        this.count += candidates.length;
    }
    search(term, options) {
        options = Object.assign({}, this.options, options);
        return $c6288371c14fb172$var$searchCore($c6288371c14fb172$var$normalize(term, this.options).normal, this.trie, options);
    }
}
module.exports.Searcher = $c6288371c14fb172$var$Searcher;
module.exports.fuzzy = $c6288371c14fb172$var$fuzzy;
module.exports.search = $c6288371c14fb172$var$search;
module.exports.sortKind = $c6288371c14fb172$var$sortKind;

});
parcelRegister("gZGJt", function(module, exports) {

var $cM55u = parcelRequire("cM55u");

var $9zs2k = parcelRequire("9zs2k");
var $c5f37d9b08158d1e$require$typeTrieData = $9zs2k.data;

var $RVCs1 = parcelRequire("RVCs1");
var $c5f37d9b08158d1e$require$extPictData = $RVCs1.data;

var $9daMG = parcelRequire("9daMG");

var $a4eSS = parcelRequire("a4eSS");
var $c5f37d9b08158d1e$require$Base64 = $a4eSS.Base64;
const $c5f37d9b08158d1e$var$typeTrie = new $9daMG($c5f37d9b08158d1e$require$Base64.toUint8Array($c5f37d9b08158d1e$require$typeTrieData));
const $c5f37d9b08158d1e$var$extPict = new $9daMG($c5f37d9b08158d1e$require$Base64.toUint8Array($c5f37d9b08158d1e$require$extPictData));
function $c5f37d9b08158d1e$var$is(type, bit) {
    return (type & bit) !== 0;
}
const $c5f37d9b08158d1e$var$GB11State = {
    Initial: 0,
    ExtendOrZWJ: 1,
    NotBoundary: 2
};
function $c5f37d9b08158d1e$var$nextGraphemeClusterSize(ts, start) {
    const L = ts.length;
    let ri = 0;
    let gb11State = $c5f37d9b08158d1e$var$GB11State.Initial;
    // GB1: sot ÷ Any
    for(let i = start; i + 1 < L; i++){
        const curr = ts[i + 0];
        const next = ts[i + 1];
        // for GB12, GB13
        if (!$c5f37d9b08158d1e$var$is(curr, $cM55u.Regional_Indicator)) ri = 0;
        // for GB11: \p{Extended_Pictographic} Extend* ZWJ x \p{Extended_Pictographic}
        switch(gb11State){
            case $c5f37d9b08158d1e$var$GB11State.NotBoundary:
            case $c5f37d9b08158d1e$var$GB11State.Initial:
                if ($c5f37d9b08158d1e$var$is(curr, $cM55u.Extended_Pictographic)) gb11State = $c5f37d9b08158d1e$var$GB11State.ExtendOrZWJ;
                else gb11State = $c5f37d9b08158d1e$var$GB11State.Initial;
                break;
            case $c5f37d9b08158d1e$var$GB11State.ExtendOrZWJ:
                if ($c5f37d9b08158d1e$var$is(curr, $cM55u.Extend)) gb11State = $c5f37d9b08158d1e$var$GB11State.ExtendOrZWJ;
                else if ($c5f37d9b08158d1e$var$is(curr, $cM55u.ZWJ) && $c5f37d9b08158d1e$var$is(next, $cM55u.Extended_Pictographic)) gb11State = $c5f37d9b08158d1e$var$GB11State.NotBoundary;
                else gb11State = $c5f37d9b08158d1e$var$GB11State.Initial;
                break;
        }
        // GB3: CR x LF
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.CR) && $c5f37d9b08158d1e$var$is(next, $cM55u.LF)) continue;
        // GB4: (Control | CR | LF) ÷
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.Control | $cM55u.CR | $cM55u.LF)) return i + 1 - start;
        // GB5: ÷ (Control | CR | LF)
        if ($c5f37d9b08158d1e$var$is(next, $cM55u.Control | $cM55u.CR | $cM55u.LF)) return i + 1 - start;
        // GB6: L x (L | V | LV | LVT)
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.L) && $c5f37d9b08158d1e$var$is(next, $cM55u.L | $cM55u.V | $cM55u.LV | $cM55u.LVT)) continue;
        // GB7: (LV | V) x (V | T)
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.LV | $cM55u.V) && $c5f37d9b08158d1e$var$is(next, $cM55u.V | $cM55u.T)) continue;
        // GB8: (LVT | T) x T
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.LVT | $cM55u.T) && $c5f37d9b08158d1e$var$is(next, $cM55u.T)) continue;
        // GB9: x (Extend | ZWJ)
        if ($c5f37d9b08158d1e$var$is(next, $cM55u.Extend | $cM55u.ZWJ)) continue;
        // GB9a: x SpacingMark
        if ($c5f37d9b08158d1e$var$is(next, $cM55u.SpacingMark)) continue;
        // GB9b: Prepend x
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.Prepend)) continue;
        // GB11: \p{Extended_Pictographic} Extend* ZWJ x \p{Extended_Pictographic}
        if (gb11State === $c5f37d9b08158d1e$var$GB11State.NotBoundary) continue;
        // GB12: sot (RI RI)* RI x RI
        // GB13: [^RI] (RI RI)* RI x RI
        if ($c5f37d9b08158d1e$var$is(curr, $cM55u.Regional_Indicator) && $c5f37d9b08158d1e$var$is(next, $cM55u.Regional_Indicator) && ri % 2 === 0) {
            ri++;
            continue;
        }
        // GB999: Any ÷ Any
        return i + 1 - start;
    }
    // GB2: Any ÷ eot
    return L - start;
}
module.exports = function split(str) {
    const graphemeClusters = [];
    const map = [
        0
    ];
    const ts = [];
    for(let i = 0; i < str.length;){
        const code = str.codePointAt(i);
        ts.push($c5f37d9b08158d1e$var$typeTrie.get(code) | $c5f37d9b08158d1e$var$extPict.get(code));
        i += code > 65535 ? 2 : 1;
        map.push(i);
    }
    for(let offset = 0; offset < ts.length;){
        const size = $c5f37d9b08158d1e$var$nextGraphemeClusterSize(ts, offset);
        const start = map[offset];
        const end = map[offset + size];
        graphemeClusters.push(str.slice(start, end));
        offset += size;
    }
    return graphemeClusters;
};

});
parcelRegister("cM55u", function(module, exports) {
module.exports = {
    Other: 0,
    CR: 1,
    LF: 2,
    Control: 4,
    Extend: 8,
    ZWJ: 16,
    Regional_Indicator: 32,
    Prepend: 64,
    SpacingMark: 128,
    L: 256,
    V: 512,
    T: 1024,
    LV: 2048,
    LVT: 4096,
    Extended_Pictographic: 8192
};

});

parcelRegister("9zs2k", function(module, exports) {
module.exports = JSON.parse('{"data":"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"}');

});

parcelRegister("RVCs1", function(module, exports) {
module.exports = JSON.parse('{"data":"AAACAAAAAACAOAAAAbYBSf7t2S1IBEEYBuDVDZ7FYrQMNsFiu3hgEYOI0SCXRIUrB8JhEZtgs5gEg1GMFk02m82oGI02m+9xezCOczv/uwv3fvAwc/PzfXOzcdqzWdaBDdiGPdiHdjE+DS3RNDuCfsn8idQ/g3OH3BdwKf0e96/gumTfYcncLdzBPTzAo+RZ+f0Cr/AG7/AJX4738x1wtz9FO5PX/50n6UXMNdfg/0lERERERERERERERETpdedHBvDRql4nq0cXtW9af98qdRby0Vvp8K4W0V+C5Xw0t4J2bfjeBp3cnEu1brnnCTYNa7eKdz91XP7WO9Lb4GqRb7cY6xbtAdqeVOsY/QGcevw/tb6OT85YhvfKYEx9CMuxKsKnrs+eJtVInVvHJ0eVYVvTZk2siFVLOCjb61PTZX3MdVWEyP7fjzpmMxdzTyq2Ebue6x61nXRGnzndWpf1an7dXmGYE4Y1ptqqKsK1nu26Ju0ty+maV2Rpvk+qnDZjKUIobUiesdAQE/jmCTmHmsskpFZsVYbtmXRcaoSGUPomunW2derQhDPFjtT1Q/eb8vnm990fq35oHVt11bU9m89c7DNI8Qs="}');

});

parcelRegister("9daMG", function(module, exports) {

var $dHvIi = parcelRequire("dHvIi");

var $k8qkk = parcelRequire("k8qkk");
var $6b4db174c89ebdc9$require$swap32LE = $k8qkk.swap32LE;
// Shift size for getting the index-1 table offset.
const $6b4db174c89ebdc9$var$SHIFT_1 = 11;
// Shift size for getting the index-2 table offset.
const $6b4db174c89ebdc9$var$SHIFT_2 = 5;
// Difference between the two shift sizes,
// for getting an index-1 offset from an index-2 offset. 6=11-5
const $6b4db174c89ebdc9$var$SHIFT_1_2 = $6b4db174c89ebdc9$var$SHIFT_1 - $6b4db174c89ebdc9$var$SHIFT_2;
// Number of index-1 entries for the BMP. 32=0x20
// This part of the index-1 table is omitted from the serialized form.
const $6b4db174c89ebdc9$var$OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> $6b4db174c89ebdc9$var$SHIFT_1;
// Number of entries in an index-2 block. 64=0x40
const $6b4db174c89ebdc9$var$INDEX_2_BLOCK_LENGTH = 1 << $6b4db174c89ebdc9$var$SHIFT_1_2;
// Mask for getting the lower bits for the in-index-2-block offset. */
const $6b4db174c89ebdc9$var$INDEX_2_MASK = $6b4db174c89ebdc9$var$INDEX_2_BLOCK_LENGTH - 1;
// Shift size for shifting left the index array values.
// Increases possible data size with 16-bit index values at the cost
// of compactability.
// This requires data blocks to be aligned by DATA_GRANULARITY.
const $6b4db174c89ebdc9$var$INDEX_SHIFT = 2;
// Number of entries in a data block. 32=0x20
const $6b4db174c89ebdc9$var$DATA_BLOCK_LENGTH = 1 << $6b4db174c89ebdc9$var$SHIFT_2;
// Mask for getting the lower bits for the in-data-block offset.
const $6b4db174c89ebdc9$var$DATA_MASK = $6b4db174c89ebdc9$var$DATA_BLOCK_LENGTH - 1;
// The part of the index-2 table for U+D800..U+DBFF stores values for
// lead surrogate code _units_ not code _points_.
// Values for lead surrogate code _points_ are indexed with this portion of the table.
// Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
const $6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET = 0x10000 >> $6b4db174c89ebdc9$var$SHIFT_2;
const $6b4db174c89ebdc9$var$LSCP_INDEX_2_LENGTH = 0x400 >> $6b4db174c89ebdc9$var$SHIFT_2;
// Count the lengths of both BMP pieces. 2080=0x820
const $6b4db174c89ebdc9$var$INDEX_2_BMP_LENGTH = $6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET + $6b4db174c89ebdc9$var$LSCP_INDEX_2_LENGTH;
// The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
// Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
const $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_OFFSET = $6b4db174c89ebdc9$var$INDEX_2_BMP_LENGTH;
const $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_LENGTH = 32; // U+0800 is the first code point after 2-byte UTF-8
// The index-1 table, only used for supplementary code points, at offset 2112=0x840.
// Variable length, for code points up to highStart, where the last single-value range starts.
// Maximum length 512=0x200=0x100000>>SHIFT_1.
// (For 0x100000 supplementary code points U+10000..U+10ffff.)
//
// The part of the index-2 table for supplementary code points starts
// after this index-1 table.
//
// Both the index-1 table and the following part of the index-2 table
// are omitted completely if there is only BMP data.
const $6b4db174c89ebdc9$var$INDEX_1_OFFSET = $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_OFFSET + $6b4db174c89ebdc9$var$UTF8_2B_INDEX_2_LENGTH;
// The alignment size of a data block. Also the granularity for compaction.
const $6b4db174c89ebdc9$var$DATA_GRANULARITY = 1 << $6b4db174c89ebdc9$var$INDEX_SHIFT;
class $6b4db174c89ebdc9$var$UnicodeTrie {
    constructor(data){
        const isBuffer = typeof data.readUInt32BE === "function" && typeof data.slice === "function";
        if (isBuffer || data instanceof Uint8Array) {
            // read binary format
            let uncompressedLength;
            if (isBuffer) {
                this.highStart = data.readUInt32LE(0);
                this.errorValue = data.readUInt32LE(4);
                uncompressedLength = data.readUInt32LE(8);
                data = data.slice(12);
            } else {
                const view = new DataView(data.buffer);
                this.highStart = view.getUint32(0, true);
                this.errorValue = view.getUint32(4, true);
                uncompressedLength = view.getUint32(8, true);
                data = data.subarray(12);
            }
            // double inflate the actual trie data
            data = $dHvIi(data, new Uint8Array(uncompressedLength));
            data = $dHvIi(data, new Uint8Array(uncompressedLength));
            // swap bytes from little-endian
            $6b4db174c89ebdc9$require$swap32LE(data);
            this.data = new Uint32Array(data.buffer);
        } else // pre-parsed data
        ({ data: this.data, highStart: this.highStart, errorValue: this.errorValue } = data);
    }
    get(codePoint) {
        let index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            // Ordinary BMP code point, excluding leading surrogates.
            // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
            // data is stored in the index array itself.
            index = (this.data[codePoint >> $6b4db174c89ebdc9$var$SHIFT_2] << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            // Lead Surrogate Code Point.  A Separate index section is stored for
            // lead surrogate code units and code points.
            //   The main index has the code unit data.
            //   For this function, we need the code point data.
            index = (this.data[$6b4db174c89ebdc9$var$LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> $6b4db174c89ebdc9$var$SHIFT_2)] << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            // Supplemental code point, use two-level lookup.
            index = this.data[$6b4db174c89ebdc9$var$INDEX_1_OFFSET - $6b4db174c89ebdc9$var$OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> $6b4db174c89ebdc9$var$SHIFT_1)];
            index = this.data[index + (codePoint >> $6b4db174c89ebdc9$var$SHIFT_2 & $6b4db174c89ebdc9$var$INDEX_2_MASK)];
            index = (index << $6b4db174c89ebdc9$var$INDEX_SHIFT) + (codePoint & $6b4db174c89ebdc9$var$DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - $6b4db174c89ebdc9$var$DATA_GRANULARITY];
    }
}
module.exports = $6b4db174c89ebdc9$var$UnicodeTrie;

});
parcelRegister("dHvIi", function(module, exports) {
var $9f97e41f2448bce6$var$TINF_OK = 0;
var $9f97e41f2448bce6$var$TINF_DATA_ERROR = -3;
function $9f97e41f2448bce6$var$Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function $9f97e41f2448bce6$var$Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $9f97e41f2448bce6$var$Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new $9f97e41f2448bce6$var$Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $9f97e41f2448bce6$var$sltree = new $9f97e41f2448bce6$var$Tree();
var $9f97e41f2448bce6$var$sdtree = new $9f97e41f2448bce6$var$Tree();
/* extra bits and base tables for length codes */ var $9f97e41f2448bce6$var$length_bits = new Uint8Array(30);
var $9f97e41f2448bce6$var$length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $9f97e41f2448bce6$var$dist_bits = new Uint8Array(30);
var $9f97e41f2448bce6$var$dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var $9f97e41f2448bce6$var$clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $9f97e41f2448bce6$var$code_tree = new $9f97e41f2448bce6$var$Tree();
var $9f97e41f2448bce6$var$lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $9f97e41f2448bce6$var$tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $9f97e41f2448bce6$var$tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $9f97e41f2448bce6$var$offs = new Uint16Array(16);
function $9f97e41f2448bce6$var$tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $9f97e41f2448bce6$var$offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$9f97e41f2448bce6$var$offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $9f97e41f2448bce6$var$tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $9f97e41f2448bce6$var$tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $9f97e41f2448bce6$var$tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $9f97e41f2448bce6$var$tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $9f97e41f2448bce6$var$tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $9f97e41f2448bce6$var$tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $9f97e41f2448bce6$var$tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)$9f97e41f2448bce6$var$lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $9f97e41f2448bce6$var$tinf_read_bits(d, 3, 0);
        $9f97e41f2448bce6$var$lengths[$9f97e41f2448bce6$var$clcidx[i]] = clen;
    }
    /* build code length tree */ $9f97e41f2448bce6$var$tinf_build_tree($9f97e41f2448bce6$var$code_tree, $9f97e41f2448bce6$var$lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $9f97e41f2448bce6$var$tinf_decode_symbol(d, $9f97e41f2448bce6$var$code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $9f97e41f2448bce6$var$lengths[num - 1];
                for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 2, 3); length; --length)$9f97e41f2448bce6$var$lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 3, 3); length; --length)$9f97e41f2448bce6$var$lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $9f97e41f2448bce6$var$tinf_read_bits(d, 7, 11); length; --length)$9f97e41f2448bce6$var$lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $9f97e41f2448bce6$var$lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $9f97e41f2448bce6$var$tinf_build_tree(lt, $9f97e41f2448bce6$var$lengths, 0, hlit);
    $9f97e41f2448bce6$var$tinf_build_tree(dt, $9f97e41f2448bce6$var$lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $9f97e41f2448bce6$var$tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = $9f97e41f2448bce6$var$tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return $9f97e41f2448bce6$var$TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $9f97e41f2448bce6$var$tinf_read_bits(d, $9f97e41f2448bce6$var$length_bits[sym], $9f97e41f2448bce6$var$length_base[sym]);
            dist = $9f97e41f2448bce6$var$tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $9f97e41f2448bce6$var$tinf_read_bits(d, $9f97e41f2448bce6$var$dist_bits[dist], $9f97e41f2448bce6$var$dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $9f97e41f2448bce6$var$tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $9f97e41f2448bce6$var$TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $9f97e41f2448bce6$var$TINF_OK;
}
/* inflate stream from source to dest */ function $9f97e41f2448bce6$var$tinf_uncompress(source, dest) {
    var d = new $9f97e41f2448bce6$var$Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $9f97e41f2448bce6$var$tinf_getbit(d);
        /* read block type (2 bits) */ btype = $9f97e41f2448bce6$var$tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $9f97e41f2448bce6$var$tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $9f97e41f2448bce6$var$tinf_inflate_block_data(d, $9f97e41f2448bce6$var$sltree, $9f97e41f2448bce6$var$sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $9f97e41f2448bce6$var$tinf_decode_trees(d, d.ltree, d.dtree);
                res = $9f97e41f2448bce6$var$tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = $9f97e41f2448bce6$var$TINF_DATA_ERROR;
        }
        if (res !== $9f97e41f2448bce6$var$TINF_OK) throw new Error("Data error");
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === "function") return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $9f97e41f2448bce6$var$tinf_build_fixed_trees($9f97e41f2448bce6$var$sltree, $9f97e41f2448bce6$var$sdtree);
/* build extra bits and base tables */ $9f97e41f2448bce6$var$tinf_build_bits_base($9f97e41f2448bce6$var$length_bits, $9f97e41f2448bce6$var$length_base, 4, 3);
$9f97e41f2448bce6$var$tinf_build_bits_base($9f97e41f2448bce6$var$dist_bits, $9f97e41f2448bce6$var$dist_base, 2, 1);
/* fix a special case */ $9f97e41f2448bce6$var$length_bits[28] = 0;
$9f97e41f2448bce6$var$length_base[28] = 258;
module.exports = $9f97e41f2448bce6$var$tinf_uncompress;

});

parcelRegister("k8qkk", function(module, exports) {
const $03c86720e418ebc3$var$isBigEndian = new Uint8Array(new Uint32Array([
    0x12345678
]).buffer)[0] === 0x12;
const $03c86720e418ebc3$var$swap = (b, n, m)=>{
    let i = b[n];
    b[n] = b[m];
    b[m] = i;
};
const $03c86720e418ebc3$var$swap32 = (array)=>{
    const len = array.length;
    for(let i = 0; i < len; i += 4){
        $03c86720e418ebc3$var$swap(array, i, i + 3);
        $03c86720e418ebc3$var$swap(array, i + 1, i + 2);
    }
};
const $03c86720e418ebc3$var$swap32LE = (array)=>{
    if ($03c86720e418ebc3$var$isBigEndian) $03c86720e418ebc3$var$swap32(array);
};
module.exports = {
    swap32LE: $03c86720e418ebc3$var$swap32LE
};

});


parcelRegister("a4eSS", function(module, exports) {

$parcel$export(module.exports, "Base64", () => $7ca0d9e2d8e201da$export$f436b0c2107cbd35);
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $7ca0d9e2d8e201da$require$Buffer = $6ZWSX.Buffer;
const $7ca0d9e2d8e201da$export$83d89fbfd8236492 = "3.7.7";
/**
 * @deprecated use lowercase `version`.
 */ const $7ca0d9e2d8e201da$export$a4ad2735b021c132 = $7ca0d9e2d8e201da$export$83d89fbfd8236492;
const $7ca0d9e2d8e201da$var$_hasBuffer = typeof $7ca0d9e2d8e201da$require$Buffer === "function";
const $7ca0d9e2d8e201da$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $7ca0d9e2d8e201da$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $7ca0d9e2d8e201da$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $7ca0d9e2d8e201da$var$b64chs = Array.prototype.slice.call($7ca0d9e2d8e201da$var$b64ch);
const $7ca0d9e2d8e201da$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7ca0d9e2d8e201da$var$b64chs);
const $7ca0d9e2d8e201da$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7ca0d9e2d8e201da$var$_fromCC = String.fromCharCode.bind(String);
const $7ca0d9e2d8e201da$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $7ca0d9e2d8e201da$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $7ca0d9e2d8e201da$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $7ca0d9e2d8e201da$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7ca0d9e2d8e201da$var$b64chs[u32 >> 18 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 12 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 6 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7ca0d9e2d8e201da$export$a32219e24f8d1e2 = typeof btoa === "function" ? (bin)=>btoa(bin) : $7ca0d9e2d8e201da$var$_hasBuffer ? (bin)=>$7ca0d9e2d8e201da$require$Buffer.from(bin, "binary").toString("base64") : $7ca0d9e2d8e201da$export$ec0fb543302ee251;
const $7ca0d9e2d8e201da$var$_fromUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (u8a)=>$7ca0d9e2d8e201da$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7ca0d9e2d8e201da$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7ca0d9e2d8e201da$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_fromUint8Array(u8a)) : $7ca0d9e2d8e201da$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7ca0d9e2d8e201da$var$_fromCC(0xc0 | cc >>> 6) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f) : $7ca0d9e2d8e201da$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7ca0d9e2d8e201da$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7ca0d9e2d8e201da$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7ca0d9e2d8e201da$export$10d4b9bd20a66b0 = (u)=>u.replace($7ca0d9e2d8e201da$var$re_utob, $7ca0d9e2d8e201da$var$cb_utob);
//
const $7ca0d9e2d8e201da$var$_encode = $7ca0d9e2d8e201da$var$_hasBuffer ? (s)=>$7ca0d9e2d8e201da$require$Buffer.from(s, "utf8").toString("base64") : $7ca0d9e2d8e201da$var$_TE ? (s)=>$7ca0d9e2d8e201da$var$_fromUint8Array($7ca0d9e2d8e201da$var$_TE.encode(s)) : (s)=>$7ca0d9e2d8e201da$export$a32219e24f8d1e2($7ca0d9e2d8e201da$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_encode(src)) : $7ca0d9e2d8e201da$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$90c31d5baa78df44 = (src)=>$7ca0d9e2d8e201da$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7ca0d9e2d8e201da$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7ca0d9e2d8e201da$var$_fromCC((offset >>> 10) + 0xD800) + $7ca0d9e2d8e201da$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7ca0d9e2d8e201da$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7ca0d9e2d8e201da$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$67e9defdeac3dd95 = (b)=>b.replace($7ca0d9e2d8e201da$var$re_btou, $7ca0d9e2d8e201da$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7ca0d9e2d8e201da$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$7ca0d9e2d8e201da$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 18 | $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a = typeof atob === "function" ? (asc)=>atob($7ca0d9e2d8e201da$var$_tidyB64(asc)) : $7ca0d9e2d8e201da$var$_hasBuffer ? (asc)=>$7ca0d9e2d8e201da$require$Buffer.from(asc, "base64").toString("binary") : $7ca0d9e2d8e201da$export$7f16d8e674ddec24;
//
const $7ca0d9e2d8e201da$var$_toUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$require$Buffer.from(a, "base64")) : (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7ca0d9e2d8e201da$export$73470fd2221e6aef = (a)=>$7ca0d9e2d8e201da$var$_toUint8Array($7ca0d9e2d8e201da$var$_unURI(a));
//
const $7ca0d9e2d8e201da$var$_decode = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$require$Buffer.from(a, "base64").toString("utf8") : $7ca0d9e2d8e201da$var$_TD ? (a)=>$7ca0d9e2d8e201da$var$_TD.decode($7ca0d9e2d8e201da$var$_toUint8Array(a)) : (a)=>$7ca0d9e2d8e201da$export$67e9defdeac3dd95($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a));
const $7ca0d9e2d8e201da$var$_unURI = (a)=>$7ca0d9e2d8e201da$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$c537b38001c583b7 = (src)=>$7ca0d9e2d8e201da$var$_decode($7ca0d9e2d8e201da$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7ca0d9e2d8e201da$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7ca0d9e2d8e201da$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("fromBase64", function() {
        return $7ca0d9e2d8e201da$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $7ca0d9e2d8e201da$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245 = ()=>{
    $7ca0d9e2d8e201da$export$4678ebf2295c49b();
    $7ca0d9e2d8e201da$export$a105d6a15258bd2();
};
const $7ca0d9e2d8e201da$export$f436b0c2107cbd35 = {
    version: $7ca0d9e2d8e201da$export$83d89fbfd8236492,
    VERSION: $7ca0d9e2d8e201da$export$a4ad2735b021c132,
    atob: $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7ca0d9e2d8e201da$export$7f16d8e674ddec24,
    btoa: $7ca0d9e2d8e201da$export$a32219e24f8d1e2,
    btoaPolyfill: $7ca0d9e2d8e201da$export$ec0fb543302ee251,
    fromBase64: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    toBase64: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encode: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encodeURI: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    encodeURL: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    utob: $7ca0d9e2d8e201da$export$10d4b9bd20a66b0,
    btou: $7ca0d9e2d8e201da$export$67e9defdeac3dd95,
    decode: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    isValid: $7ca0d9e2d8e201da$export$1ea939691cdc45b8,
    fromUint8Array: $7ca0d9e2d8e201da$export$27bbb4e040978768,
    toUint8Array: $7ca0d9e2d8e201da$export$73470fd2221e6aef,
    extendString: $7ca0d9e2d8e201da$export$4678ebf2295c49b,
    extendUint8Array: $7ca0d9e2d8e201da$export$a105d6a15258bd2,
    extendBuiltins: $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245
};

});




parcelRegister("iYJzJ", function(module, exports) {

$parcel$export(module.exports, "useLocalStorageState", () => $dd112eecf66dbcc2$export$b313845ce8fd18ca);
$parcel$export(module.exports, "useSessionStorageState", () => $dd112eecf66dbcc2$export$a239b1d68a82bb27);

var $acw62 = parcelRequire("acw62");

var $jW3HH = parcelRequire("jW3HH");
var $dd112eecf66dbcc2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $dd112eecf66dbcc2$var$debug = (0, $jW3HH.default)("utils:storageValue");
function $dd112eecf66dbcc2$export$b313845ce8fd18ca(key, initialValue, options) {
    return $dd112eecf66dbcc2$var$useStorageState(localStorage, key, initialValue, options);
}
function $dd112eecf66dbcc2$export$a239b1d68a82bb27(key, initialValue, options) {
    return $dd112eecf66dbcc2$var$useStorageState(sessionStorage, key, initialValue, options);
}
function $dd112eecf66dbcc2$var$useStorageState(storage, key, initialValue, options) {
    var _a, _b, _c;
    var jsonEncode = (_a = options === null || options === void 0 ? void 0 : options.jsonEncode) !== null && _a !== void 0 ? _a : true;
    var fetch = (0, $acw62.useCallback)(function() {
        try {
            var stored = storage.getItem(key);
            if (!stored) return;
            if (jsonEncode) return JSON.parse(stored);
            return stored;
        // eslint-disable-next-line upscope/require-proper-error-handling
        } catch (err) {
            $dd112eecf66dbcc2$var$debug.warning("Error fetching storage %O", err);
        }
    }, [
        storage,
        key,
        jsonEncode
    ]);
    var valueRef = (0, $acw62.useRef)();
    var _d = $dd112eecf66dbcc2$var$__read((0, $acw62.useState)((_c = (_b = valueRef.current) !== null && _b !== void 0 ? _b : fetch()) !== null && _c !== void 0 ? _c : initialValue), 2), value = _d[0], setValue = _d[1];
    valueRef.current = value;
    (0, $acw62.useEffect)(function() {
        try {
            if (typeof value === "undefined") {
                storage.removeItem(key);
                return;
            }
            if (jsonEncode) {
                storage.setItem(key, JSON.stringify(value));
                return;
            }
            storage.setItem(key, value);
        // eslint-disable-next-line upscope/require-proper-error-handling
        } catch (err) {
            $dd112eecf66dbcc2$var$debug.warning("Error fetching storage %O", err);
        }
    }, [
        key,
        value,
        jsonEncode,
        storage
    ]);
    return [
        value,
        setValue
    ];
}

});


parcelRegister("UNZ1Z", function(module, exports) {

$parcel$export(module.exports, "useSlideOver", () => $0aac00bbd422c019$export$83de82a58dfb4ba0);
$parcel$export(module.exports, "SlideOverProvider", () => $0aac00bbd422c019$export$6fa1c918a237be3f);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $6AFxv = parcelRequire("6AFxv");
var $0aac00bbd422c019$var$__assign = undefined && undefined.__assign || function() {
    $0aac00bbd422c019$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0aac00bbd422c019$var$__assign.apply(this, arguments);
};
var $0aac00bbd422c019$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0aac00bbd422c019$var$SlideOverContext = /*#__PURE__*/ (0, $acw62.createContext)({
    addSlideOver: function(slideOver) {
        return false;
    },
    removeSlideOver: function() {}
});
function $0aac00bbd422c019$export$83de82a58dfb4ba0() {
    return (0, $acw62.useContext)($0aac00bbd422c019$var$SlideOverContext);
}
function $0aac00bbd422c019$export$6fa1c918a237be3f(_a) {
    var children = _a.children;
    var _b = $0aac00bbd422c019$var$__read((0, $acw62.useState)(undefined), 2), slideOverDetails = _b[0], setSlideOverDetails = _b[1];
    var _c = $0aac00bbd422c019$var$__read((0, $acw62.useState)(false), 2), slideOverOpen = _c[0], setSlideOverOpen = _c[1];
    var slideOverDetailsRef = (0, $acw62.useRef)();
    slideOverDetailsRef.current = slideOverDetails;
    var currentSlideOverId = (0, $acw62.useRef)(0);
    var removeTimeoutRef = (0, $acw62.useRef)(undefined);
    var removeSlideOver = (0, $acw62.useCallback)(function() {
        setSlideOverOpen(false);
        removeTimeoutRef.current = setTimeout(function() {
            setSlideOverDetails(undefined);
        }, 300);
    }, []);
    var addSlideOver = (0, $acw62.useCallback)(function(slideOver) {
        if (slideOverDetailsRef.current && !slideOver.replace) return false;
        setSlideOverDetails(slideOver);
        setSlideOverOpen(false);
        currentSlideOverId.current++;
        clearTimeout(removeTimeoutRef.current);
        setTimeout(function() {
            setSlideOverOpen(true);
        });
        return true;
    }, []);
    return (0, $ayMG0.jsxs)($0aac00bbd422c019$var$SlideOverContext.Provider, {
        value: {
            addSlideOver: addSlideOver,
            removeSlideOver: removeSlideOver
        },
        children: [
            slideOverDetails && (0, $ayMG0.jsx)((0, $6AFxv.default), $0aac00bbd422c019$var$__assign({}, slideOverDetails, {
                open: slideOverOpen,
                setOpen: removeSlideOver,
                children: slideOverDetails.content
            })),
            children
        ]
    });
}
function $0aac00bbd422c019$export$7fe28cb29e71bf10() {
    var removeSlideOver = $0aac00bbd422c019$export$83de82a58dfb4ba0().removeSlideOver;
    (0, $acw62.useEffect)(function() {
        removeSlideOver();
    }, [
        removeSlideOver
    ]);
    return null;
}

});
parcelRegister("6AFxv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc653ba68479e69$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lLzDP = parcelRequire("lLzDP");
var $iymfR = parcelRequire("iymfR");

var $cVodR = parcelRequire("cVodR");

var $dtKoB = parcelRequire("dtKoB");
var $4cc653ba68479e69$var$__assign = undefined && undefined.__assign || function() {
    $4cc653ba68479e69$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4cc653ba68479e69$var$__assign.apply(this, arguments);
};
var $4cc653ba68479e69$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $4cc653ba68479e69$export$2e2bcd8739ae039(props) {
    return (0, $ayMG0.jsx)((0, $iymfR.Transition), {
        show: props.open,
        as: (0, $acw62.Fragment),
        children: (0, $ayMG0.jsxs)((0, $lLzDP.Dialog), {
            as: "div",
            className: "relative z-50",
            onClose: props.setOpen,
            children: [
                (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                    as: (0, $acw62.Fragment),
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: (0, $ayMG0.jsx)("div", {
                        className: "fixed inset-0 bg-black bg-opacity-60 transition-opacity"
                    })
                }),
                (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0"
                }),
                (0, $ayMG0.jsx)("div", {
                    className: "fixed inset-0 overflow-hidden",
                    children: (0, $ayMG0.jsx)("div", {
                        className: "absolute inset-0 overflow-hidden",
                        children: (0, $ayMG0.jsx)("div", {
                            className: "pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16",
                            children: (0, $ayMG0.jsx)((0, $iymfR.TransitionChild), {
                                as: (0, $acw62.Fragment),
                                enter: "transform transition ease-in-out duration-500 sm:duration-700",
                                enterFrom: "translate-x-full",
                                enterTo: "translate-x-0",
                                leave: "transform transition ease-in-out duration-500 sm:duration-700",
                                leaveFrom: "translate-x-0",
                                leaveTo: "translate-x-full",
                                children: (0, $ayMG0.jsxs)((0, $lLzDP.DialogPanel), {
                                    "data-role": "slideover",
                                    className: "pointer-events-auto w-screen max-w-md flex flex-col h-full",
                                    children: [
                                        (0, $ayMG0.jsxs)("div", {
                                            className: "bg-primary-700 dark:bg-black px-4 py-6 sm:px-6",
                                            children: [
                                                (0, $ayMG0.jsxs)("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        (0, $ayMG0.jsx)((0, $lLzDP.DialogTitle), {
                                                            className: "text-base font-semibold leading-6 text-white",
                                                            children: props.title
                                                        }),
                                                        (0, $ayMG0.jsx)("div", {
                                                            className: "ml-3 flex h-7 items-center",
                                                            children: (0, $ayMG0.jsxs)("button", {
                                                                type: "button",
                                                                className: "rounded-md text-primary-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white",
                                                                onClick: function() {
                                                                    return props.setOpen(false);
                                                                },
                                                                children: [
                                                                    (0, $ayMG0.jsx)("span", {
                                                                        className: "sr-only",
                                                                        children: (0, $dtKoB.default)("Close panel")
                                                                    }),
                                                                    (0, $ayMG0.jsx)((0, $cVodR.default), {
                                                                        className: "h-6 w-6",
                                                                        "aria-hidden": "true"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                props.description && (0, $ayMG0.jsx)("div", {
                                                    className: "mt-1",
                                                    children: (0, $ayMG0.jsx)("p", {
                                                        className: "text-sm text-primary-300 dark:text-white/80",
                                                        children: props.description
                                                    })
                                                })
                                            ]
                                        }),
                                        props.children
                                    ]
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
}
$4cc653ba68479e69$export$2e2bcd8739ae039.Footer = function SlideOverFooter(props) {
    return (0, $ayMG0.jsx)("div", {
        className: "flex flex-shrink-0 justify-between -px-4 pt-4",
        children: props.children
    });
};
$4cc653ba68479e69$export$2e2bcd8739ae039.Content = function SlideOverContent(_a) {
    var children = _a.children, asProp = _a.as, rest = $4cc653ba68479e69$var$__rest(_a, [
        "children",
        "as"
    ]);
    var As = asProp || "div";
    return (0, $ayMG0.jsx)(As, $4cc653ba68479e69$var$__assign({
        className: "flex-1 flex flex-col justify-between divide-y divide-neutral-200 dark:divide-neutral-800 bg-white dark:bg-neutral-900\n        dark:text-white shadow-xl p-4 overflow-auto"
    }, rest, {
        children: children
    }));
};

});


parcelRegister("4EnWU", function(module, exports) {

$parcel$export(module.exports, "getRoutes", () => $362d79ad4e0b158b$export$2f7745f2f5ab3897);

var $acw62 = parcelRequire("acw62");

var $hmJ39 = parcelRequire("hmJ39");
var $362d79ad4e0b158b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $362d79ad4e0b158b$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $362d79ad4e0b158b$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $362d79ad4e0b158b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

















































































































var $362d79ad4e0b158b$var$routeList = [
    [
        [
            "up.root",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("TH1vB"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.auth.login",
            {}
        ],
        {
            auth: "guest",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1YtWd"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.auth.signUp",
            {}
        ],
        {
            auth: "guest",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("55V9C"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.auth.join",
            {
                teamDomain: ":teamDomain",
                teamUniqueIdentifier: ":teamUniqueIdentifier"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("aA96t"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.auth.mfa.enable"
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("16p1h"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.auth.invites.show",
            {
                inviteToken: ":inviteToken"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6P0TL"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.notifications.confirmation"
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7pyZN"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.shortCuts.purchase"
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("2Ogjy"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.shortCuts.install"
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("czMM3"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.onboarding",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            children: [
                [
                    [
                        "up.onboarding.questions",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "owner",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("90mug"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.onboarding.bookCall",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "owner",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("kIYG4"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.onboarding.inviteTeam",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageUsers",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("7rg1J"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.onboarding.purchase",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canPurchase",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("11PNs"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.onboarding.installCobrowsing",
                        {
                            teamDomain: ":teamDomain",
                            teamUniqueIdentifier: ":teamUniqueIdentifier"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("gztUr"))
                                    ];
                                });
                            });
                        })
                    }
                ]
            ],
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("2uv0f"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.invoice.showFailed",
            {
                invoiceId: ":invoiceId"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("fHW07"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.extension.welcome"
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("at4wx"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.extension.uninstall",
            {}
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("aXqzT"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("fAtrp"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {
                searchTerm: ":searchTerm"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8zJHo"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {
                searchTerm: ""
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8zJHo"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {
                isEmbedded: true
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8zJHo"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {
                isEmbedded: true,
                searchTerm: ":searchTerm"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8zJHo"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.visitorsList",
            {
                isEmbedded: true,
                searchTerm: ""
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8zJHo"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.go",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7Jwws"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.go",
            {
                isEmbedded: true
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7Jwws"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.cobrowse",
            {
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("9RFCh"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.cobrowse",
            {
                isEmbedded: true,
                visitorId: ":visitorId"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("9RFCh"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.cobrowse",
            {
                onPremiseTeamUniqueIdentifier: ":onPremiseTeamUniqueIdentifier",
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("lhkBN"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {
                searchTerm: ":searchTerm"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {
                searchTerm: ""
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {
                isEmbedded: true
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {
                isEmbedded: true,
                searchTerm: ":searchTerm"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.visitorsList",
            {
                isEmbedded: true,
                searchTerm: ""
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4WmD4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.go",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("2AbR3"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.go",
            {
                isEmbedded: true
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("2AbR3"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.cobrowse",
            {
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("eJclI"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.cobrowse",
            {
                isEmbedded: true,
                visitorId: ":visitorId"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("eJclI"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "uv.cobrowse",
            {
                onPremiseTeamUniqueIdentifier: ":onPremiseTeamUniqueIdentifier",
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("K7GIf"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.reporting.usage",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canViewReporting",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("iwAIf"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.visitorData",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canManageContent",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("h2vpa"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.personal"
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("b9whO"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.manageTeams",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("dAFRC"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.members",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canManageUsers",
            children: [
                [
                    [
                        "up.members",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageUsers",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("1YAje"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.members.invites",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageUsers",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("deEQ4"))
                                    ];
                                });
                            });
                        })
                    }
                ]
            ],
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("iPzt0"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.history",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4tw16"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.activity.activityLog",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canViewReporting",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("aMkhy"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.general",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8D2PL"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.quickEnable",
            {
                setting: ":setting",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("eShVu"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.authTokens.new"
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("b7cGo"))
                        ];
                    });
                });
            })
        }
    ],
    // Further /settings/teams/:teamDomain/xyz routes need to be added here
    [
        [
            "up.integrations",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("lbFxf"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.zapier",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("658n5"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.zendesk",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("3wQza"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.freshchat",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7qfWP"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.intercom.connect",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("4pODl"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.front",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("jyDFD"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.front",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("jyDFD"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.intercom.settings",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("5m0H6"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.integrations.salesforce.settings",
            {
                integrationId: ":integrationId",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("c6Wm7"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.general",
            {
                section: ":section",
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8D2PL"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.billing",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canManageBilling",
            children: [
                [
                    [
                        "up.settings.billing",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageBilling",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("64Bi4"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.settings.billing.sessionCredit",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageBilling",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("i3PuV"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.settings.billing.subaccounts",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageBilling",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("bramS"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "up.settings.billing.history",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        auth: "canManageBilling",
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("8E8PP"))
                                    ];
                                });
                            });
                        })
                    }
                ]
            ],
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1k8xJ"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.settings.billing.upgrade",
            {
                feature: null,
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canManageBilling",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7WkDi"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "co.root",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("52s4c"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "co.cobrowse",
            {
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("iTqOj"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "co.dashboard",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "canAccessSettings",
            children: [
                [
                    [
                        "co.dashboard.restKeys",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("1i6yo"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "co.dashboard.requestHistory",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("lvRCz"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "co.dashboard.webhookHistory",
                        {
                            teamDomain: ":teamDomain"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("5fBE7"))
                                    ];
                                });
                            });
                        })
                    }
                ]
            ],
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("fAyqy"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.root"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("e2yQ2"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.emailRedirect"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1TOZ5"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.accounts.index",
            {}
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1XDMZ"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.accounts.show",
            {
                companyId: ":companyId"
            }
        ],
        {
            auth: "admin",
            children: [
                [
                    [
                        "hq.accounts.show",
                        {
                            companyId: ":companyId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("cGowV"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.team",
                        {
                            companyId: ":companyId",
                            teamId: ":teamId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("h8X8T"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.members",
                        {
                            companyId: ":companyId",
                            teamId: ":teamId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("eZGUQ"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.usage",
                        {
                            companyId: ":companyId",
                            teamId: ":teamId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("gDkJH"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.emails",
                        {
                            companyId: ":companyId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("jMWtn"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.contacts",
                        {
                            companyId: ":companyId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("i7ra9"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.companyDocuments",
                        {
                            companyId: ":companyId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("hjqlQ"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.activityLog",
                        {
                            companyId: ":companyId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("h2a3k"))
                                    ];
                                });
                            });
                        })
                    }
                ],
                [
                    [
                        "hq.accounts.show.charges",
                        {
                            companyId: ":companyId",
                            teamId: ":teamId"
                        }
                    ],
                    {
                        component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                            return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                                return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        (parcelRequire("ePGVP"))
                                    ];
                                });
                            });
                        })
                    }
                ]
            ],
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6WYOc"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.customerSuccess.index"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("9Ass4"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.customerSuccess.list",
            {
                stage: ":stage"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("lWVWz"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.aiChanges"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("47cQI"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.index"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("cgFzw"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.activities"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6B1xm"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.opportunities.index"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("9QmPD"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.opportunities.show",
            {
                opportunityId: ":opportunityId"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("huYix"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.tasks"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("c8KNO"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.sales.leads"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("46kwn"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.quotes.index"
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("8jKkS"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.quotes.show",
            {
                quotePublicKey: ":quotePublicKey"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("5YPo5"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "up.quotes.show",
            {
                quotePublicKey: ":quotePublicKey"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1QITT"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.quotes.transfer.new",
            {
                quotePublicKey: ":quotePublicKey"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("1IChg"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.users.show",
            {
                userId: ":userId"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("h7UkV"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.root",
            {}
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("fukSa"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.leads.index",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("iOSAV"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.links.list",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("aUYNK"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.links.create",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("eWGgS"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.templates.index",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7oDJz"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.templates.create",
            {
                teamDomain: ":teamDomain"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("30DYK"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.templates.show",
            {
                teamDomain: ":teamDomain",
                templateId: ":templateId"
            }
        ],
        {
            auth: "user",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("7gppy"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.links.show",
            {
                linkSlug: ":linkSlug"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6UHt2"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "ld.links.show",
            {
                linkSlug: ":linkSlug",
                section: ":section"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6UHt2"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.globalActivityLog",
            {}
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("6EIX0"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hq.debug.show",
            {
                visitorId: ":visitorId"
            }
        ],
        {
            auth: "admin",
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("84Gre"))
                        ];
                    });
                });
            })
        }
    ],
    [
        [
            "hs.extension.view",
            {
                sessionCode: ":sessionCode"
            }
        ],
        {
            component: /*#__PURE__*/ (0, $acw62.lazy)(function() {
                return $362d79ad4e0b158b$var$__awaiter(void 0, void 0, void 0, function() {
                    return $362d79ad4e0b158b$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            (parcelRequire("crO2W"))
                        ];
                    });
                });
            })
        }
    ]
];
function $362d79ad4e0b158b$export$2f7745f2f5ab3897() {
    return $362d79ad4e0b158b$var$routeList.filter(function(_a) {
        var _b = $362d79ad4e0b158b$var$__read(_a, 2), path = _b[0], route = _b[1];
        return (0, $hmJ39.getRouteOrigin)(path[0]) === location.origin;
    }).map(function(_a) {
        var _b = $362d79ad4e0b158b$var$__read(_a, 2), pathParam = _b[0], route = _b[1];
        return [
            (0, $hmJ39.path).apply(void 0, $362d79ad4e0b158b$var$__spreadArray([], $362d79ad4e0b158b$var$__read(pathParam), false)).split("?")[0],
            route
        ];
    });
}

});
parcelRegister("TH1vB", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("26g1i").then(()=>parcelRequire("bs4rl"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("1YtWd", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("cEGXZ")
]).then(()=>parcelRequire("9rJL0"));

});

parcelRegister("55V9C", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("3UjsV")
]).then(()=>parcelRequire("ZA4S4"));

});

parcelRegister("aA96t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("dP9up")
]).then(()=>parcelRequire("9ZpIV"));

});

parcelRegister("16p1h", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kXWHC").then(()=>parcelRequire("cHiFW"));

});

parcelRegister("6P0TL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gQSgL").then(()=>parcelRequire("3C717"));

});

parcelRegister("7pyZN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("koF4Z").then(()=>parcelRequire("8Cu3Q"));

});

parcelRegister("2Ogjy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("e01wV").then(()=>parcelRequire("3GdCb"));

});

parcelRegister("czMM3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("6rwKJ").then(()=>parcelRequire("2NbdJ"));

});

parcelRegister("90mug", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8urCa").then(()=>parcelRequire("jKXFV"));

});

parcelRegister("kIYG4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fEATN").then(()=>parcelRequire("153dY"));

});

parcelRegister("7rg1J", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("5cjYh")
]).then(()=>parcelRequire("biKU8"));

});

parcelRegister("11PNs", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("g6G0R")
]).then(()=>parcelRequire("aNhwL"));

});

parcelRegister("gztUr", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hI5Pk"),
    $Gr8vk("cMKIL")
]).then(()=>parcelRequire("kKFb3"));

});

parcelRegister("2uv0f", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aAk8i").then(()=>parcelRequire("5X5n5"));

});

parcelRegister("fHW07", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("5Ilth").then(()=>parcelRequire("lRr5d"));

});

parcelRegister("at4wx", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3upTg").then(()=>parcelRequire("8RJMJ"));

});

parcelRegister("aXqzT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ak04Q").then(()=>parcelRequire("8LFW3"));

});

parcelRegister("fAtrp", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("adCzN"),
    $Gr8vk("2jGMe"),
    $Gr8vk("lw1cs")
]).then(()=>parcelRequire("hiXS7"));

});

parcelRegister("8zJHo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("adCzN"),
    $Gr8vk("2jGMe")
]).then(()=>parcelRequire("eToXU"));

});

parcelRegister("7Jwws", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fPhbw").then(()=>parcelRequire("hHiui"));

});

parcelRegister("9RFCh", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dDwEZ"),
    $Gr8vk("9jan7"),
    $Gr8vk("2ZRGS"),
    $Gr8vk("2jqGI"),
    $Gr8vk("kchmV"),
    $Gr8vk("6TanF")
]).then(()=>parcelRequire("9Szim"));

});

parcelRegister("lhkBN", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("3vvSh").then(()=>parcelRequire("7EztE"));

});

parcelRegister("4WmD4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("adCzN"),
    $Gr8vk("fVt1W")
]).then(()=>parcelRequire("6gDLz"));

});

parcelRegister("2AbR3", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("Bdxj3").then(()=>parcelRequire("gM86x"));

});

parcelRegister("eJclI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dDwEZ"),
    $Gr8vk("9jan7"),
    $Gr8vk("2ZRGS"),
    $Gr8vk("2jqGI"),
    $Gr8vk("kchmV"),
    $Gr8vk("jpfsz")
]).then(()=>parcelRequire("jNdNB"));

});

parcelRegister("K7GIf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ggwJy").then(()=>parcelRequire("65VUA"));

});

parcelRegister("iwAIf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("j9hPC")
]).then(()=>parcelRequire("e3GgT"));

});

parcelRegister("h2vpa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4tyFx").then(()=>parcelRequire("dLePC"));

});

parcelRegister("b9whO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("cb2FH")
]).then(()=>parcelRequire("21IPP"));

});

parcelRegister("dAFRC", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4tqAr").then(()=>parcelRequire("7YZnR"));

});

parcelRegister("1YAje", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("kLzWL").then(()=>parcelRequire("53QVn"));

});

parcelRegister("deEQ4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("hBIh6")
]).then(()=>parcelRequire("gnLzh"));

});

parcelRegister("iPzt0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("auWZO").then(()=>parcelRequire("3BrGv"));

});

parcelRegister("4tw16", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("agMQM")
]).then(()=>parcelRequire("bKfZZ"));

});

parcelRegister("aMkhy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("cwcoO")
]).then(()=>parcelRequire("1wfzY"));

});

parcelRegister("8D2PL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("73tGl"),
    $Gr8vk("dWaws"),
    $Gr8vk("boyGW")
]).then(()=>parcelRequire("1c9Qe"));

});

parcelRegister("eShVu", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("akKRc").then(()=>parcelRequire("jZccx"));

});

parcelRegister("b7cGo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("gwwAt").then(()=>parcelRequire("i0XRI"));

});

parcelRegister("lbFxf", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("4Vk0I")
]).then(()=>parcelRequire("8xd8j"));

});

parcelRegister("658n5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("aqhu3").then(()=>parcelRequire("6cRc4"));

});

parcelRegister("3wQza", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ebjt1").then(()=>parcelRequire("dXRKt"));

});

parcelRegister("7qfWP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("a6fZ3").then(()=>parcelRequire("iU0KE"));

});

parcelRegister("4pODl", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2l9Qq").then(()=>parcelRequire("jJyya"));

});

parcelRegister("jyDFD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("7u21b")
]).then(()=>parcelRequire("gQ8xi"));

});

parcelRegister("5m0H6", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("73tGl"),
    $Gr8vk("dWaws"),
    $Gr8vk("rYNvl")
]).then(()=>parcelRequire("duLvl"));

});

parcelRegister("c6Wm7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hI5Pk"),
    $Gr8vk("dWaws"),
    $Gr8vk("hGDg2")
]).then(()=>parcelRequire("aBr88"));

});

parcelRegister("64Bi4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("5JRy7")
]).then(()=>parcelRequire("lpr1L"));

});

parcelRegister("i3PuV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("8mGhF")
]).then(()=>parcelRequire("bVSFl"));

});

parcelRegister("bramS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("hstt4").then(()=>parcelRequire("9K8DU"));

});

parcelRegister("8E8PP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cbxp8").then(()=>parcelRequire("dzT9C"));

});

parcelRegister("1k8xJ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("cTnv7")
]).then(()=>parcelRequire("gRLhf"));

});

parcelRegister("7WkDi", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("i5rM5").then(()=>parcelRequire("l1koE"));

});

parcelRegister("52s4c", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jtXvi").then(()=>parcelRequire("bCdSC"));

});

parcelRegister("iTqOj", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hI5Pk"),
    $Gr8vk("93XvJ")
]).then(()=>parcelRequire("8CPII"));

});

parcelRegister("1i6yo", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fyePX").then(()=>parcelRequire("lfXxs"));

});

parcelRegister("lvRCz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hI5Pk"),
    $Gr8vk("hQrzd")
]).then(()=>parcelRequire("fWXeY"));

});

parcelRegister("5fBE7", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dHj1E").then(()=>parcelRequire("17rJq"));

});

parcelRegister("fAyqy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bfA3A").then(()=>parcelRequire("c8e9X"));

});

parcelRegister("e2yQ2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("lkJNx"),
    $Gr8vk("dWaws"),
    $Gr8vk("6Fqtz")
]).then(()=>parcelRequire("k13Km"));

});

parcelRegister("1TOZ5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("1yEgj").then(()=>parcelRequire("kEmC2"));

});

parcelRegister("1XDMZ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("3OWCc")
]).then(()=>parcelRequire("6fTPA"));

});

parcelRegister("cGowV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("52cff"),
    $Gr8vk("l6NNC"),
    $Gr8vk("6Whg2"),
    $Gr8vk("lGalw"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("fBpct")
]).then(()=>parcelRequire("3cBoa"));

});

parcelRegister("h8X8T", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("bsLKD"),
    $Gr8vk("l6NNC"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("jUTIv")
]).then(()=>parcelRequire("4iusd"));

});

parcelRegister("eZGUQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("aqrmm")
]).then(()=>parcelRequire("eGpGX"));

});

parcelRegister("gDkJH", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("j9hPC"),
    $Gr8vk("gpDzv")
]).then(()=>parcelRequire("kbHXo"));

});

parcelRegister("jMWtn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("8SmOL").then(()=>parcelRequire("7hqY2"));

});

parcelRegister("i7ra9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("2LeFl")
]).then(()=>parcelRequire("2W0DL"));

});

parcelRegister("hjqlQ", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("6CSYd")
]).then(()=>parcelRequire("cMV6a"));

});

parcelRegister("h2a3k", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("f8ZVM"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("g8lWT")
]).then(()=>parcelRequire("bgUSx"));

});

parcelRegister("ePGVP", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("7ei72")
]).then(()=>parcelRequire("gibpF"));

});

parcelRegister("6WYOc", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("lkJNx"),
    $Gr8vk("dWaws"),
    $Gr8vk("cyI3V")
]).then(()=>parcelRequire("g6WWI"));

});

parcelRegister("9Ass4", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("lcp5O").then(()=>parcelRequire("hKQLN"));

});

parcelRegister("lWVWz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("l6NNC"),
    $Gr8vk("lkJNx"),
    $Gr8vk("dWaws"),
    $Gr8vk("D12uZ")
]).then(()=>parcelRequire("1CIQQ"));

});

parcelRegister("47cQI", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("eiX79").then(()=>parcelRequire("dtKTo"));

});

parcelRegister("cgFzw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("cjSd4").then(()=>parcelRequire("1cO6X"));

});

parcelRegister("6B1xm", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("l6NNC"),
    $Gr8vk("lkJNx"),
    $Gr8vk("dWaws"),
    $Gr8vk("6fdER")
]).then(()=>parcelRequire("4htV5"));

});

parcelRegister("9QmPD", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("hEG03"),
    $Gr8vk("52cff"),
    $Gr8vk("l6NNC"),
    $Gr8vk("lkJNx"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("gUT8m")
]).then(()=>parcelRequire("fuBAO"));

});

parcelRegister("huYix", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("52cff"),
    $Gr8vk("l6NNC"),
    $Gr8vk("6Whg2"),
    $Gr8vk("lGalw"),
    $Gr8vk("lkJNx"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("8SmOL"),
    $Gr8vk("dWaws"),
    $Gr8vk("2LeFl"),
    $Gr8vk("dbgMG")
]).then(()=>parcelRequire("doPH2"));

});

parcelRegister("c8KNO", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("l6NNC"),
    $Gr8vk("6Whg2"),
    $Gr8vk("lkJNx"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("kvN71")
]).then(()=>parcelRequire("6yuiI"));

});

parcelRegister("46kwn", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("52cff"),
    $Gr8vk("l6NNC"),
    $Gr8vk("lkJNx"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("8QL9K")
]).then(()=>parcelRequire("2MeDL"));

});

parcelRegister("8jKkS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2trjs").then(()=>parcelRequire("glzvr"));

});

parcelRegister("5YPo5", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("bsLKD"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("6AGm2")
]).then(()=>parcelRequire("1oZ8d"));

});

parcelRegister("1QITT", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("jToRd")
]).then(()=>parcelRequire("5mCjA"));

});

parcelRegister("1IChg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("fPlzG")
]).then(()=>parcelRequire("3kK7t"));

});

parcelRegister("h7UkV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("l6NNC"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("aLMv1")
]).then(()=>parcelRequire("l2RPW"));

});

parcelRegister("fukSa", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fE86S").then(()=>parcelRequire("jg97Z"));

});

parcelRegister("iOSAV", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("dWaws"),
    $Gr8vk("kKuAo")
]).then(()=>parcelRequire("8igvv"));

});

parcelRegister("aUYNK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("7T551")
]).then(()=>parcelRequire("f1q2w"));

});

parcelRegister("eWGgS", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("h9S2C"),
    $Gr8vk("dgHXh"),
    $Gr8vk("eIkiy"),
    $Gr8vk("hEG03"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("hvGVA")
]).then(()=>parcelRequire("83634"));

});

parcelRegister("7oDJz", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("fCG34").then(()=>parcelRequire("7XZu2"));

});

parcelRegister("30DYK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("feYM5").then(()=>parcelRequire("7yl2G"));

});

parcelRegister("7gppy", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("khl2I").then(()=>parcelRequire("4mDTB"));

});

parcelRegister("6UHt2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("6SUYZ")),
    $Gr8vk("bvs3H"),
    $Gr8vk("h9S2C"),
    $Gr8vk("dgHXh"),
    $Gr8vk("eIkiy"),
    $Gr8vk("hEG03"),
    $Gr8vk("l6NNC"),
    $Gr8vk("8wMZO"),
    $Gr8vk("113SW"),
    $Gr8vk("9jan7"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("7T551"),
    $Gr8vk("ggVBM")
]).then(()=>parcelRequire("iSmtd"));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case "preload":
            return $f9345ad2c034f768$var$cachedPreloads;
        case "prefetch":
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6EIX0", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("f8ZVM"),
    $Gr8vk("17Qwb"),
    $Gr8vk("dWaws"),
    $Gr8vk("PNMmE")
]).then(()=>parcelRequire("cxX4J"));

});

parcelRegister("84Gre", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("igSTh").then(()=>parcelRequire("bZgu0"));

});

parcelRegister("crO2W", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = Promise.all([
    $Gr8vk("9jan7"),
    $Gr8vk("2ZRGS"),
    $Gr8vk("2jqGI"),
    $Gr8vk("hewtk")
]).then(()=>parcelRequire("7UumO"));

});


parcelRegister("dJ9dH", function(module, exports) {

$parcel$export(module.exports, "LogRoute", () => $9fe6a13f344e25ec$export$4805d6e0a4f2ea0d);
$parcel$export(module.exports, "trackEvent", () => $9fe6a13f344e25ec$export$73d0a139caca1fee);

var $2cUZ4 = parcelRequire("2cUZ4");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $jW3HH = parcelRequire("jW3HH");

var $9HNzc = parcelRequire("9HNzc");
var $9fe6a13f344e25ec$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $9fe6a13f344e25ec$var$plausible = (0, $2cUZ4.default)({
    domain: "app.upscope.io,all-upscope.com",
    apiHost: "https://data.upscope.com"
});
var $9fe6a13f344e25ec$var$debug = (0, $jW3HH.default)("app:router");
function $9fe6a13f344e25ec$export$4805d6e0a4f2ea0d(_a) {
    var children = _a.children;
    var detectedParams = (0, $aphAM.useParams)();
    var pathname = (0, $lzNIT.useLocation)().pathname;
    var cachedParams = (0, $9HNzc.default)(detectedParams);
    (0, $acw62.useEffect)(function() {
        var route = "/".concat($9fe6a13f344e25ec$var$routePrefix(location.hostname), ":").concat(pathname);
        Object.entries(cachedParams).forEach(function(_a) {
            var _b = $9fe6a13f344e25ec$var$__read(_a, 2), key = _b[0], value = _b[1];
            if (value) route = route.replace(value, ":".concat(key));
        });
        $9fe6a13f344e25ec$var$trackPageview(route);
    }, [
        pathname,
        cachedParams
    ]);
    return children;
}
function $9fe6a13f344e25ec$var$routePrefix(hostname) {
    if (hostname.startsWith("hq.")) return "hq";
    if (hostname.includes("helloscreen")) return "hs";
    if (hostname.includes("userview")) return "uv";
    if (hostname.includes("livedocument")) return "ld";
    if (hostname.includes("cobrowsingapi")) return "co";
    return "up";
}
function $9fe6a13f344e25ec$var$trackPageview(route) {
    $9fe6a13f344e25ec$var$debug("Pageview: %s", route);
    $9fe6a13f344e25ec$var$plausible === null || $9fe6a13f344e25ec$var$plausible === void 0 || $9fe6a13f344e25ec$var$plausible.trackPageview({
        url: location.origin + route + location.search + location.hash
    });
}
function $9fe6a13f344e25ec$export$73d0a139caca1fee(eventName, props) {
    $9fe6a13f344e25ec$var$debug("Event: %s", eventName);
    $9fe6a13f344e25ec$var$plausible === null || $9fe6a13f344e25ec$var$plausible === void 0 || $9fe6a13f344e25ec$var$plausible.trackEvent(eventName, {
        props: props
    });
}

});
parcelRegister("2cUZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $19b8e79cf71a665c$export$2e2bcd8739ae039);

var $c31Ud = parcelRequire("c31Ud");
var $19b8e79cf71a665c$export$2e2bcd8739ae039 = (0, $c31Ud.default);

});
parcelRegister("c31Ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c573e453e47b630$export$2e2bcd8739ae039);

var $djJbQ = parcelRequire("djJbQ");

var $hPtJY = parcelRequire("hPtJY");
function $8c573e453e47b630$export$2e2bcd8739ae039(defaults) {
    const getConfig = ()=>({
            hashMode: false,
            trackLocalhost: false,
            url: location.href,
            domain: location.hostname,
            referrer: document.referrer || null,
            deviceWidth: window.innerWidth,
            apiHost: "https://plausible.io",
            ...defaults
        });
    const trackEvent = (eventName, options, eventData)=>{
        (0, $djJbQ.sendEvent)(eventName, {
            ...getConfig(),
            ...eventData
        }, options);
    };
    const trackPageview = (eventData, options)=>{
        trackEvent("pageview", options, eventData);
    };
    const enableAutoPageviews = ()=>{
        const page = ()=>trackPageview();
        // Attach pushState and popState listeners
        const originalPushState = history.pushState;
        if (originalPushState) {
            // eslint-disable-next-line functional/immutable-data
            history.pushState = function(data, title, url) {
                originalPushState.apply(this, [
                    data,
                    title,
                    url
                ]);
                page();
            };
            addEventListener("popstate", page);
        }
        // Attach hashchange listener
        if (defaults && defaults.hashMode) addEventListener("hashchange", page);
        // Trigger first page view
        trackPageview();
        return function cleanup() {
            if (originalPushState) {
                // eslint-disable-next-line functional/immutable-data
                history.pushState = originalPushState;
                removeEventListener("popstate", page);
            }
            if (defaults && defaults.hashMode) removeEventListener("hashchange", page);
        };
    };
    const enableAutoOutboundTracking = (targetNode = document, observerInit = {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
            "href"
        ]
    })=>{
        function trackClick(event) {
            trackEvent("Outbound Link: Click", {
                props: {
                    url: this.href
                }
            });
            /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            typeof $hPtJY !== "undefined" && $hPtJY;
            setTimeout(()=>{
                // eslint-disable-next-line functional/immutable-data
                location.href = this.href;
            }, 150);
            event.preventDefault();
        }
        // eslint-disable-next-line functional/prefer-readonly-type
        const tracked = new Set();
        function addNode(node) {
            if (node instanceof HTMLAnchorElement) {
                if (node.host !== location.host) {
                    node.addEventListener("click", trackClick);
                    tracked.add(node);
                }
            } else if ("querySelectorAll" in node) node.querySelectorAll("a").forEach(addNode);
        }
        function removeNode(node) {
            if (node instanceof HTMLAnchorElement) {
                node.removeEventListener("click", trackClick);
                tracked.delete(node);
            } else if ("querySelectorAll" in node) node.querySelectorAll("a").forEach(removeNode);
        }
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "attributes") {
                    // Handle changed href
                    removeNode(mutation.target);
                    addNode(mutation.target);
                } else if (mutation.type === "childList") {
                    // Handle added nodes
                    mutation.addedNodes.forEach(addNode);
                    // Handle removed nodes
                    mutation.removedNodes.forEach(removeNode);
                }
            });
        });
        // Track existing nodes
        targetNode.querySelectorAll("a").forEach(addNode);
        // Observe mutations
        observer.observe(targetNode, observerInit);
        return function cleanup() {
            tracked.forEach((a)=>{
                a.removeEventListener("click", trackClick);
            });
            tracked.clear();
            observer.disconnect();
        };
    };
    return {
        trackEvent: trackEvent,
        trackPageview: trackPageview,
        enableAutoPageviews: enableAutoPageviews,
        enableAutoOutboundTracking: enableAutoOutboundTracking
    };
}

});
parcelRegister("djJbQ", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $9b201a8334d6edcb$export$7329bcdc3edcd90e);
/**
 * @internal
 * Sends an event to Plausible's API
 *
 * @param data - Event data to send
 * @param options - Event options
 */ function $9b201a8334d6edcb$export$7329bcdc3edcd90e(eventName, data, options) {
    const isLocalhost = /^localhost$|^127(?:\.[0-9]+){0,2}\.[0-9]+$|^(?:0*:)*?:?0*1$/.test(location.hostname) || location.protocol === "file:";
    if (!data.trackLocalhost && isLocalhost) return console.warn("[Plausible] Ignoring event because website is running locally");
    try {
        if (window.localStorage.plausible_ignore === "true") return console.warn('[Plausible] Ignoring event because "plausible_ignore" is set to "true" in localStorage');
    } catch (e) {}
    const payload = {
        n: eventName,
        u: data.url,
        d: data.domain,
        r: data.referrer,
        w: data.deviceWidth,
        h: data.hashMode ? 1 : 0,
        p: options && options.props ? JSON.stringify(options.props) : undefined
    };
    const req = new XMLHttpRequest();
    req.open("POST", `${data.apiHost}/api/event`, true);
    req.setRequestHeader("Content-Type", "text/plain");
    req.send(JSON.stringify(payload));
    // eslint-disable-next-line functional/immutable-data
    req.onreadystatechange = ()=>{
        if (req.readyState !== 4) return;
        if (options && options.callback) options.callback();
    };
}

});






var $ayMG0 = parcelRequire("ayMG0");

var $cA8mQ = parcelRequire("cA8mQ");

var $8Nbse = parcelRequire("8Nbse");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $kQ0sT = parcelRequire("kQ0sT");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
const $f52e2ccccb0d538f$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null);
const $f52e2ccccb0d538f$var$initialState = {
    didCatch: false,
    error: null
};
class $f52e2ccccb0d538f$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $f52e2ccccb0d538f$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $f52e2ccccb0d538f$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($f52e2ccccb0d538f$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $acw62.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $acw62.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $acw62.createElement)($f52e2ccccb0d538f$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $f52e2ccccb0d538f$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $f52e2ccccb0d538f$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $f52e2ccccb0d538f$export$c052f6604b7d51fe() {
    const context = (0, $acw62.useContext)($f52e2ccccb0d538f$export$b16d9fb1a22de840);
    $f52e2ccccb0d538f$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $acw62.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $acw62.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $f52e2ccccb0d538f$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $acw62.forwardRef)((props, ref)=>(0, $acw62.createElement)($f52e2ccccb0d538f$export$e926676385687eaf, errorBoundaryProps, (0, $acw62.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $dtKoB = parcelRequire("dtKoB");

var $jW3HH = parcelRequire("jW3HH");

var $ebuIP = parcelRequire("ebuIP");

var $iCMjC = parcelRequire("iCMjC");

var $1PKHz = parcelRequire("1PKHz");

var $5aE2v = parcelRequire("5aE2v");

var $hpDFD = parcelRequire("hpDFD");

var $f72r9 = parcelRequire("f72r9");

var $2IoLL = parcelRequire("2IoLL");

var $5jxhC = parcelRequire("5jxhC");
var $2ac565fa7e46aabb$var$debug = (0, $jW3HH.default)("app:main");
function $2ac565fa7e46aabb$export$2e2bcd8739ae039() {
    (0, $acw62.useEffect)(function() {
        var _a, _b, _c;
        // If reloaded page
        if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        ((_c = (_b = (_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType("navigation")) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.type) === "reload" && sessionStorage.getItem("reload") !== "true") $2ac565fa7e46aabb$var$debug("Detected manual reload on %s", location.href);
        sessionStorage.removeItem("reload");
    }, []);
    return (0, $ayMG0.jsx)((0, $ebuIP.default), {
        children: (0, $ayMG0.jsx)((0, $hpDFD.PreloadProvider), {
            children: (0, $ayMG0.jsx)((0, $1PKHz.default), {
                children: (0, $ayMG0.jsx)((0, $2IoLL.ToastProvider), {
                    children: (0, $ayMG0.jsx)((0, $5aE2v.ModalProvider), {
                        children: (0, $ayMG0.jsx)((0, $f52e2ccccb0d538f$export$e926676385687eaf), {
                            FallbackComponent: $2ac565fa7e46aabb$export$eb435fa4136c47cc,
                            children: (0, $ayMG0.jsx)((0, $iCMjC.default), {
                                children: (0, $ayMG0.jsx)((0, $f72r9.StripeProvider), {
                                    children: (0, $ayMG0.jsx)((0, $5jxhC.default), {})
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
function $2ac565fa7e46aabb$export$eb435fa4136c47cc(_a) {
    var error = _a.error;
    var addModal = (0, $5aE2v.useModal)().addModal;
    var _b = (0, $ebuIP.useApiCache)(), newVersionAvailable = _b.newVersionAvailable, interactedWithOldVersion = _b.interactedWithOldVersion;
    (0, $acw62.useEffect)(function() {
        if (typeof error === "undefined" || error === null) return;
        if (newVersionAvailable) {
            $2ac565fa7e46aabb$var$debug("New version available, ignoring error %o", error);
            return;
        }
        if (interactedWithOldVersion) {
            $2ac565fa7e46aabb$var$debug("Interacted with legacy version, ignoring error %o", error);
            sessionStorage.setItem("canary_only", "true");
            return;
        }
        if (error instanceof Error) {
            // This happens when a new version of the app is deployed and we try to
            // load a script with an invalid hash
            if (error.message.match(/dynamically imported module/i)) return window.reload();
            if (error.message.match(/could not resolve bundle with/i)) return window.reload();
        }
        $kQ0sT.captureException(error);
    }, [
        error,
        newVersionAvailable,
        interactedWithOldVersion
    ]);
    (0, $acw62.useEffect)(function() {
        if (newVersionAvailable || interactedWithOldVersion) addModal({
            title: (0, $dtKoB.default)("A new version is available"),
            content: (0, $dtKoB.default)("A new version of the application is available and we need to reload the page for it to work."),
            onClick: function() {
                return window.reload();
            },
            confirmText: (0, $dtKoB.default)("Reload application")
        });
        else addModal({
            title: (0, $dtKoB.default)("You just found a bug!"),
            content: (0, $dtKoB.default)("It looks like you found a bug with our system. Our team has been alerted."),
            onClick: function() {
                return window.reload();
            },
            confirmText: (0, $dtKoB.default)("Try again")
        });
    }, [
        addModal,
        newVersionAvailable,
        interactedWithOldVersion
    ]);
    return null;
}



var $dtKoB = parcelRequire("dtKoB");

var $jW3HH = parcelRequire("jW3HH");
var $6cdee70c942d403a$var$_a;
var $6cdee70c942d403a$var$errorLogger = (0, $jW3HH.default)("app:errors");
$cA8mQ.init({
    dsn: "https://5657ddafdf314975895cc564eb17315f@sentry.io/157375",
    release: "2025.11.10",
    environment: "production",
    maxValueLength: 2500,
    beforeSend: function(event, hint) {
        var _a, _b;
        var error = (_b = (_a = hint.originalException) !== null && _a !== void 0 ? _a : hint.syntheticException) !== null && _b !== void 0 ? _b : event.message;
        if (error) $6cdee70c942d403a$var$errorLogger("Error: %s", error);
        return event;
    }
});
window.reload = function() {
    sessionStorage.setItem("reload", "true");
    location.reload();
};
var $6cdee70c942d403a$var$language = ($6cdee70c942d403a$var$_a = (0, (/*@__PURE__*/$parcel$interopDefault($8Nbse))).get("upscope_locale")) !== null && $6cdee70c942d403a$var$_a !== void 0 ? $6cdee70c942d403a$var$_a : navigator.language;
(0, $dtKoB.initI18n)($6cdee70c942d403a$var$language).then(function() {
    var root = (0, $aRPiL.createRoot)(document.querySelector("#root"));
    root.render((0, $ayMG0.jsx)((0, $2ac565fa7e46aabb$export$2e2bcd8739ae039), {}));
});


//# sourceMappingURL=index.d91a9ab2.js.map
